//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AbsenceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getNew( cancelToken?: CancelToken): Promise<AbsenceEditModel> {
        let url_ = this.baseUrl + "/Absence/new";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNew(_response);
        });
    }

    protected processGetNew(response: AxiosResponse): Promise<AbsenceEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AbsenceEditModel.fromJS(resultData200);
            return Promise.resolve<AbsenceEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AbsenceEditModel>(null as any);
    }

    getNewForDay(day: string, cancelToken?: CancelToken): Promise<AbsenceEditModel> {
        let url_ = this.baseUrl + "/Absence/new/{day}";
        if (day === undefined || day === null)
            throw new Error("The parameter 'day' must be defined.");
        url_ = url_.replace("{day}", encodeURIComponent("" + day));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewForDay(_response);
        });
    }

    protected processGetNewForDay(response: AxiosResponse): Promise<AbsenceEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AbsenceEditModel.fromJS(resultData200);
            return Promise.resolve<AbsenceEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AbsenceEditModel>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<AbsenceEditModel> {
        let url_ = this.baseUrl + "/Absence/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<AbsenceEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AbsenceEditModel.fromJS(resultData200);
            return Promise.resolve<AbsenceEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AbsenceEditModel>(null as any);
    }

    delete(id: number, confirmed: boolean | undefined, cancelToken?: CancelToken): Promise<DeleteResultModel> {
        let url_ = this.baseUrl + "/Absence/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (confirmed === null)
            throw new Error("The parameter 'confirmed' cannot be null.");
        else if (confirmed !== undefined)
            url_ += "confirmed=" + encodeURIComponent("" + confirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<DeleteResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteResultModel.fromJS(resultData200);
            return Promise.resolve<DeleteResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteResultModel>(null as any);
    }

    getListAbsenceType( cancelToken?: CancelToken): Promise<AbsenceTypeViewModel[]> {
        let url_ = this.baseUrl + "/Absence/absencetypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListAbsenceType(_response);
        });
    }

    protected processGetListAbsenceType(response: AxiosResponse): Promise<AbsenceTypeViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AbsenceTypeViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AbsenceTypeViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AbsenceTypeViewModel[]>(null as any);
    }

    getListAbsenceTypeForUser(appUserId: number, cancelToken?: CancelToken): Promise<AbsenceTypeViewModel[]> {
        let url_ = this.baseUrl + "/Absence/GetListAbsenceTypeForUser/{appUserId}";
        if (appUserId === undefined || appUserId === null)
            throw new Error("The parameter 'appUserId' must be defined.");
        url_ = url_.replace("{appUserId}", encodeURIComponent("" + appUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListAbsenceTypeForUser(_response);
        });
    }

    protected processGetListAbsenceTypeForUser(response: AxiosResponse): Promise<AbsenceTypeViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AbsenceTypeViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AbsenceTypeViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AbsenceTypeViewModel[]>(null as any);
    }

    getListForAllActiveUsers(year: number, displayOnlyOwnTeam: boolean | undefined, cancelToken?: CancelToken): Promise<AbsenceUserViewModel[]> {
        let url_ = this.baseUrl + "/Absence/getlistforallactiveusers/{year}?";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (displayOnlyOwnTeam === null)
            throw new Error("The parameter 'displayOnlyOwnTeam' cannot be null.");
        else if (displayOnlyOwnTeam !== undefined)
            url_ += "displayOnlyOwnTeam=" + encodeURIComponent("" + displayOnlyOwnTeam) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListForAllActiveUsers(_response);
        });
    }

    protected processGetListForAllActiveUsers(response: AxiosResponse): Promise<AbsenceUserViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AbsenceUserViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AbsenceUserViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AbsenceUserViewModel[]>(null as any);
    }

    getOpenAbsenceRequests( cancelToken?: CancelToken): Promise<AbsenceViewModel[]> {
        let url_ = this.baseUrl + "/Absence/getopenabsencerequests";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOpenAbsenceRequests(_response);
        });
    }

    protected processGetOpenAbsenceRequests(response: AxiosResponse): Promise<AbsenceViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AbsenceViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AbsenceViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AbsenceViewModel[]>(null as any);
    }

    getOpenAbsenceRequestCount( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Absence/getopenabsencerequestcount";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOpenAbsenceRequestCount(_response);
        });
    }

    protected processGetOpenAbsenceRequestCount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getVacationStatsCurrentUser(year: number, cancelToken?: CancelToken): Promise<VacationStatsViewModel> {
        let url_ = this.baseUrl + "/Absence/getvacationstats/{year}";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVacationStatsCurrentUser(_response);
        });
    }

    protected processGetVacationStatsCurrentUser(response: AxiosResponse): Promise<VacationStatsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VacationStatsViewModel.fromJS(resultData200);
            return Promise.resolve<VacationStatsViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VacationStatsViewModel>(null as any);
    }

    getVacationStatsForUser(year: number, appUserId: number, cancelToken?: CancelToken): Promise<VacationStatsViewModel> {
        let url_ = this.baseUrl + "/Absence/getvacationstats/{year}/{appUserId}";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (appUserId === undefined || appUserId === null)
            throw new Error("The parameter 'appUserId' must be defined.");
        url_ = url_.replace("{appUserId}", encodeURIComponent("" + appUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetVacationStatsForUser(_response);
        });
    }

    protected processGetVacationStatsForUser(response: AxiosResponse): Promise<VacationStatsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VacationStatsViewModel.fromJS(resultData200);
            return Promise.resolve<VacationStatsViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VacationStatsViewModel>(null as any);
    }

    getList(filter: AbsenceFilter, cancelToken?: CancelToken): Promise<AbsenceViewModel[]> {
        let url_ = this.baseUrl + "/Absence/getlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<AbsenceViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AbsenceViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AbsenceViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AbsenceViewModel[]>(null as any);
    }

    validateAbsence(model: AbsenceEditModel, cancelToken?: CancelToken): Promise<AbsenceValidationResultViewModel> {
        let url_ = this.baseUrl + "/Absence/validateAbsence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processValidateAbsence(_response);
        });
    }

    protected processValidateAbsence(response: AxiosResponse): Promise<AbsenceValidationResultViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AbsenceValidationResultViewModel.fromJS(resultData200);
            return Promise.resolve<AbsenceValidationResultViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AbsenceValidationResultViewModel>(null as any);
    }

    post(editModel: AbsenceEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Absence";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(id: number | undefined, editModel: AbsenceEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Absence?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    approve(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Absence/approve/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApprove(_response);
        });
    }

    protected processApprove(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    reject(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Absence/reject/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReject(_response);
        });
    }

    protected processReject(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    exportExcel(year: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Absence/ExportExcel/{year}";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportExcel(_response);
        });
    }

    protected processExportExcel(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class AbsenceTypeClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getList(showArchive: boolean | undefined, cancelToken?: CancelToken): Promise<AbsenceTypeViewModel[]> {
        let url_ = this.baseUrl + "/AbsenceType/GetList?";
        if (showArchive === null)
            throw new Error("The parameter 'showArchive' cannot be null.");
        else if (showArchive !== undefined)
            url_ += "showArchive=" + encodeURIComponent("" + showArchive) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<AbsenceTypeViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AbsenceTypeViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AbsenceTypeViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AbsenceTypeViewModel[]>(null as any);
    }

    getViewModelById(id: number, cancelToken?: CancelToken): Promise<AbsenceTypeViewModel> {
        let url_ = this.baseUrl + "/AbsenceType/GetViewModelById/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetViewModelById(_response);
        });
    }

    protected processGetViewModelById(response: AxiosResponse): Promise<AbsenceTypeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AbsenceTypeViewModel.fromJS(resultData200);
            return Promise.resolve<AbsenceTypeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AbsenceTypeViewModel>(null as any);
    }

    getNewEditModel( cancelToken?: CancelToken): Promise<AbsenceTypeEditModel> {
        let url_ = this.baseUrl + "/AbsenceType/GetNewEditModel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewEditModel(_response);
        });
    }

    protected processGetNewEditModel(response: AxiosResponse): Promise<AbsenceTypeEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AbsenceTypeEditModel.fromJS(resultData200);
            return Promise.resolve<AbsenceTypeEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AbsenceTypeEditModel>(null as any);
    }

    getEditModel(id: number, cancelToken?: CancelToken): Promise<AbsenceTypeEditModel> {
        let url_ = this.baseUrl + "/AbsenceType/GetEditModel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEditModel(_response);
        });
    }

    protected processGetEditModel(response: AxiosResponse): Promise<AbsenceTypeEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AbsenceTypeEditModel.fromJS(resultData200);
            return Promise.resolve<AbsenceTypeEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AbsenceTypeEditModel>(null as any);
    }

    put(editModel: AbsenceTypeEditModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/AbsenceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    insert(editModel: AbsenceTypeEditModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/AbsenceType";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInsert(_response);
        });
    }

    protected processInsert(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    toggleArchived(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/AbsenceType/ToggleArchived";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(id);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleArchived(_response);
        });
    }

    protected processToggleArchived(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    delete(id: number, confirmed: boolean | undefined, cancelToken?: CancelToken): Promise<DeleteResultModel> {
        let url_ = this.baseUrl + "/AbsenceType/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (confirmed === null)
            throw new Error("The parameter 'confirmed' cannot be null.");
        else if (confirmed !== undefined)
            url_ += "confirmed=" + encodeURIComponent("" + confirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<DeleteResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteResultModel.fromJS(resultData200);
            return Promise.resolve<DeleteResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteResultModel>(null as any);
    }
}

export class AccountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    get(id: number, cancelToken?: CancelToken): Promise<AccountEditModel> {
        let url_ = this.baseUrl + "/Account/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<AccountEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountEditModel.fromJS(resultData200);
            return Promise.resolve<AccountEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountEditModel>(null as any);
    }

    getTimeTrackingSettings(id: number, cancelToken?: CancelToken): Promise<AccountTimeTrackingSettingsEditModel> {
        let url_ = this.baseUrl + "/Account/timetrackingsettings/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeTrackingSettings(_response);
        });
    }

    protected processGetTimeTrackingSettings(response: AxiosResponse): Promise<AccountTimeTrackingSettingsEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountTimeTrackingSettingsEditModel.fromJS(resultData200);
            return Promise.resolve<AccountTimeTrackingSettingsEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountTimeTrackingSettingsEditModel>(null as any);
    }

    updateTimeTrackingSettings(id: number | undefined, accountTimeTrackingSettingsEditModel: AccountTimeTrackingSettingsEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Account/updatetimetrackingsettings?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountTimeTrackingSettingsEditModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateTimeTrackingSettings(_response);
        });
    }

    protected processUpdateTimeTrackingSettings(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getAccountInvoiceDataEditModel( cancelToken?: CancelToken): Promise<AccountInvoiceDataEditModel> {
        let url_ = this.baseUrl + "/Account/invoicedata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAccountInvoiceDataEditModel(_response);
        });
    }

    protected processGetAccountInvoiceDataEditModel(response: AxiosResponse): Promise<AccountInvoiceDataEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountInvoiceDataEditModel.fromJS(resultData200);
            return Promise.resolve<AccountInvoiceDataEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountInvoiceDataEditModel>(null as any);
    }

    saveAccountInvoiceDataEditModel(model: AccountInvoiceDataEditModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Account/invoicedata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAccountInvoiceDataEditModel(_response);
        });
    }

    protected processSaveAccountInvoiceDataEditModel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getLicenseDataEditModel( cancelToken?: CancelToken): Promise<LicenseDataEditModel> {
        let url_ = this.baseUrl + "/Account/licensedata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLicenseDataEditModel(_response);
        });
    }

    protected processGetLicenseDataEditModel(response: AxiosResponse): Promise<LicenseDataEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LicenseDataEditModel.fromJS(resultData200);
            return Promise.resolve<LicenseDataEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LicenseDataEditModel>(null as any);
    }

    saveLicenseData(model: LicenseDataEditModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Account/licensedata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveLicenseData(_response);
        });
    }

    protected processSaveLicenseData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getLicenseDataViewModel( cancelToken?: CancelToken): Promise<LicenseDataViewModel> {
        let url_ = this.baseUrl + "/Account/licensedataview";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLicenseDataViewModel(_response);
        });
    }

    protected processGetLicenseDataViewModel(response: AxiosResponse): Promise<LicenseDataViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LicenseDataViewModel.fromJS(resultData200);
            return Promise.resolve<LicenseDataViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LicenseDataViewModel>(null as any);
    }

    calculateNewAmount(addedUserCount: number, addedUserCountBasic: number, cancelToken?: CancelToken): Promise<PaymentAmountModel> {
        let url_ = this.baseUrl + "/Account/CalculateNewAmount/{addedUserCount}/{addedUserCountBasic}";
        if (addedUserCount === undefined || addedUserCount === null)
            throw new Error("The parameter 'addedUserCount' must be defined.");
        url_ = url_.replace("{addedUserCount}", encodeURIComponent("" + addedUserCount));
        if (addedUserCountBasic === undefined || addedUserCountBasic === null)
            throw new Error("The parameter 'addedUserCountBasic' must be defined.");
        url_ = url_.replace("{addedUserCountBasic}", encodeURIComponent("" + addedUserCountBasic));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateNewAmount(_response);
        });
    }

    protected processCalculateNewAmount(response: AxiosResponse): Promise<PaymentAmountModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PaymentAmountModel.fromJS(resultData200);
            return Promise.resolve<PaymentAmountModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PaymentAmountModel>(null as any);
    }

    getContractData( cancelToken?: CancelToken): Promise<ContractDataViewModel> {
        let url_ = this.baseUrl + "/Account/contractdata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContractData(_response);
        });
    }

    protected processGetContractData(response: AxiosResponse): Promise<ContractDataViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContractDataViewModel.fromJS(resultData200);
            return Promise.resolve<ContractDataViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContractDataViewModel>(null as any);
    }

    getAdvEditModel( cancelToken?: CancelToken): Promise<AccountAdvEditModel> {
        let url_ = this.baseUrl + "/Account/advdata";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdvEditModel(_response);
        });
    }

    protected processGetAdvEditModel(response: AxiosResponse): Promise<AccountAdvEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccountAdvEditModel.fromJS(resultData200);
            return Promise.resolve<AccountAdvEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccountAdvEditModel>(null as any);
    }

    saveAdvData(model: AccountAdvEditModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Account/advdata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAdvData(_response);
        });
    }

    protected processSaveAdvData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteAccount(model: DeleteAccountEditModel, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/Account/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAccount(_response);
        });
    }

    protected processDeleteAccount(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getAdvContractPdf( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Account/advdata/pdf";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAdvContractPdf(_response);
        });
    }

    protected processGetAdvContractPdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getInvoicePdf(id: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Account/invoicepdf/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoicePdf(_response);
        });
    }

    protected processGetInvoicePdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getLogo( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Account/logo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLogo(_response);
        });
    }

    protected processGetLogo(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    upgradeAccount( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Account/upgrade";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpgradeAccount(_response);
        });
    }

    protected processUpgradeAccount(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    put(id: number | undefined, accountEditModel: AccountEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Account?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountEditModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    deleteLogo( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Account";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLogo(_response);
        });
    }

    protected processDeleteLogo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    uploadLogo(file: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Account/uploadlogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadLogo(_response);
        });
    }

    protected processUploadLogo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getOnboardingEditModel( cancelToken?: CancelToken): Promise<OnBoardingEditModel> {
        let url_ = this.baseUrl + "/Account/onboarding";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOnboardingEditModel(_response);
        });
    }

    protected processGetOnboardingEditModel(response: AxiosResponse): Promise<OnBoardingEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OnBoardingEditModel.fromJS(resultData200);
            return Promise.resolve<OnBoardingEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OnBoardingEditModel>(null as any);
    }

    saveOnboardingEditModel(model: OnBoardingEditModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Account/onboarding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveOnboardingEditModel(_response);
        });
    }

    protected processSaveOnboardingEditModel(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    skipOnBoarding( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Account/onboarding/skip";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSkipOnBoarding(_response);
        });
    }

    protected processSkipOnBoarding(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AdminClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    sendTestMail( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Admin";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendTestMail(_response);
        });
    }

    protected processSendTestMail(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    throwException( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Admin/exception";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processThrowException(_response);
        });
    }

    protected processThrowException(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getLogs( cancelToken?: CancelToken): Promise<Log[]> {
        let url_ = this.baseUrl + "/Admin/logs";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLogs(_response);
        });
    }

    protected processGetLogs(response: AxiosResponse): Promise<Log[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Log.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<Log[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Log[]>(null as any);
    }

    getTableData(query: string | null | undefined, cancelToken?: CancelToken): Promise<any[]> {
        let url_ = this.baseUrl + "/Admin/tabledata?";
        if (query !== undefined && query !== null)
            url_ += "query=" + encodeURIComponent("" + query) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTableData(_response);
        });
    }

    protected processGetTableData(response: AxiosResponse): Promise<any[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<any[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<any[]>(null as any);
    }

    getLeuteUndGeld( cancelToken?: CancelToken): Promise<LeuteUndGeldViewModel> {
        let url_ = this.baseUrl + "/Admin/lug";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLeuteUndGeld(_response);
        });
    }

    protected processGetLeuteUndGeld(response: AxiosResponse): Promise<LeuteUndGeldViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LeuteUndGeldViewModel.fromJS(resultData200);
            return Promise.resolve<LeuteUndGeldViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LeuteUndGeldViewModel>(null as any);
    }

    getLeuteUndGeldBesser(lostDays: number | undefined, cancelToken?: CancelToken): Promise<LeuteUndGeldReportModel> {
        let url_ = this.baseUrl + "/Admin/lugbesser?";
        if (lostDays === null)
            throw new Error("The parameter 'lostDays' cannot be null.");
        else if (lostDays !== undefined)
            url_ += "lostDays=" + encodeURIComponent("" + lostDays) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLeuteUndGeldBesser(_response);
        });
    }

    protected processGetLeuteUndGeldBesser(response: AxiosResponse): Promise<LeuteUndGeldReportModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LeuteUndGeldReportModel.fromJS(resultData200);
            return Promise.resolve<LeuteUndGeldReportModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LeuteUndGeldReportModel>(null as any);
    }

    getUnpaidInvoices( cancelToken?: CancelToken): Promise<UnpaidInvoiceViewModel[]> {
        let url_ = this.baseUrl + "/Admin/unpaidinvoices";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUnpaidInvoices(_response);
        });
    }

    protected processGetUnpaidInvoices(response: AxiosResponse): Promise<UnpaidInvoiceViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UnpaidInvoiceViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UnpaidInvoiceViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnpaidInvoiceViewModel[]>(null as any);
    }

    sendInvoiceReminder(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Admin/unpaidinvoices/remind/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendInvoiceReminder(_response);
        });
    }

    protected processSendInvoiceReminder(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    retryCardPayment(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Admin/unpaidinvoices/retry/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRetryCardPayment(_response);
        });
    }

    protected processRetryCardPayment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    setInvoicePaid(model: SetInvoicePaidEditModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Admin/unpaidinvoices/setpaid";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetInvoicePaid(_response);
        });
    }

    protected processSetInvoicePaid(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    writeOffInvoice(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Admin/unpaidinvoices/writeoff/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processWriteOffInvoice(_response);
        });
    }

    protected processWriteOffInvoice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    regenerateInvoice(invoiceId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Admin/RegenerateInvoice/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegenerateInvoice(_response);
        });
    }

    protected processRegenerateInvoice(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeAccount(guid: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Admin/rma/{guid}";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveAccount(_response);
        });
    }

    protected processRemoveAccount(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    lockAccount(model: LockAccountEditModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Admin/lockaccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLockAccount(_response);
        });
    }

    protected processLockAccount(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    unlockAccount(model: LockAccountEditModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Admin/unlockaccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUnlockAccount(_response);
        });
    }

    protected processUnlockAccount(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    syncBambooHr( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Admin/syncbamboohr";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSyncBambooHr(_response);
        });
    }

    protected processSyncBambooHr(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    calculateAll( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Admin/calcall";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCalculateAll(_response);
        });
    }

    protected processCalculateAll(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getUpcomingPaymentsViewModel( cancelToken?: CancelToken): Promise<UpcomingPaymentsViewModel> {
        let url_ = this.baseUrl + "/Admin/upcoming";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUpcomingPaymentsViewModel(_response);
        });
    }

    protected processGetUpcomingPaymentsViewModel(response: AxiosResponse): Promise<UpcomingPaymentsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UpcomingPaymentsViewModel.fromJS(resultData200);
            return Promise.resolve<UpcomingPaymentsViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UpcomingPaymentsViewModel>(null as any);
    }
}

export class AppUserBillableTargetHistoryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getNew(appUserId: number, cancelToken?: CancelToken): Promise<AppUserBillableTargetHistoryEditModel> {
        let url_ = this.baseUrl + "/AppUserBillableTargetHistory/new/{appUserId}";
        if (appUserId === undefined || appUserId === null)
            throw new Error("The parameter 'appUserId' must be defined.");
        url_ = url_.replace("{appUserId}", encodeURIComponent("" + appUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNew(_response);
        });
    }

    protected processGetNew(response: AxiosResponse): Promise<AppUserBillableTargetHistoryEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppUserBillableTargetHistoryEditModel.fromJS(resultData200);
            return Promise.resolve<AppUserBillableTargetHistoryEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUserBillableTargetHistoryEditModel>(null as any);
    }

    getList(filter: AppUserBillableTargetHistoryFilter, cancelToken?: CancelToken): Promise<AppUserBillableTargetHistoryEditModel[]> {
        let url_ = this.baseUrl + "/AppUserBillableTargetHistory/getlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<AppUserBillableTargetHistoryEditModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppUserBillableTargetHistoryEditModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AppUserBillableTargetHistoryEditModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUserBillableTargetHistoryEditModel[]>(null as any);
    }

    merge(appUserId: number | undefined, appUserEditModels: AppUserBillableTargetHistoryEditModel[], cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/AppUserBillableTargetHistory?";
        if (appUserId === null)
            throw new Error("The parameter 'appUserId' cannot be null.");
        else if (appUserId !== undefined)
            url_ += "appUserId=" + encodeURIComponent("" + appUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appUserEditModels);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMerge(_response);
        });
    }

    protected processMerge(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class AppUserClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getCurrentUser( cancelToken?: CancelToken): Promise<AppUserViewModel> {
        let url_ = this.baseUrl + "/AppUser/Current";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentUser(_response);
        });
    }

    protected processGetCurrentUser(response: AxiosResponse): Promise<AppUserViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppUserViewModel.fromJS(resultData200);
            return Promise.resolve<AppUserViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUserViewModel>(null as any);
    }

    getCurrentUserApiKey( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/AppUser/ApiKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentUserApiKey(_response);
        });
    }

    protected processGetCurrentUserApiKey(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getCurrentUserSettings( cancelToken?: CancelToken): Promise<AppUserSettings> {
        let url_ = this.baseUrl + "/AppUser/GetCurrentUserSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentUserSettings(_response);
        });
    }

    protected processGetCurrentUserSettings(response: AxiosResponse): Promise<AppUserSettings> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppUserSettings.fromJS(resultData200);
            return Promise.resolve<AppUserSettings>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUserSettings>(null as any);
    }

    getAppUserSettingsEditModel( cancelToken?: CancelToken): Promise<AppUserSettingsEditModel> {
        let url_ = this.baseUrl + "/AppUser/settingsedit";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAppUserSettingsEditModel(_response);
        });
    }

    protected processGetAppUserSettingsEditModel(response: AxiosResponse): Promise<AppUserSettingsEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppUserSettingsEditModel.fromJS(resultData200);
            return Promise.resolve<AppUserSettingsEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUserSettingsEditModel>(null as any);
    }

    storeAppUserSettings(model: AppUserSettingsEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/AppUser/settingsedit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStoreAppUserSettings(_response);
        });
    }

    protected processStoreAppUserSettings(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    changePassword(model: AppUserChangePasswordEditModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/AppUser/changepassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processChangePassword(_response);
        });
    }

    protected processChangePassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getSelectListForListTimeEntry(appUserId: number, cancelToken?: CancelToken): Promise<StSelectListItem[]> {
        let url_ = this.baseUrl + "/AppUser/SelectlistForListTimeEntry/{appUserId}";
        if (appUserId === undefined || appUserId === null)
            throw new Error("The parameter 'appUserId' must be defined.");
        url_ = url_.replace("{appUserId}", encodeURIComponent("" + appUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectListForListTimeEntry(_response);
        });
    }

    protected processGetSelectListForListTimeEntry(response: AxiosResponse): Promise<StSelectListItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StSelectListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StSelectListItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StSelectListItem[]>(null as any);
    }

    getSelectList(filter: AppUserFilter | undefined, cancelToken?: CancelToken): Promise<StSelectListItem[]> {
        let url_ = this.baseUrl + "/AppUser/Selectlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectList(_response);
        });
    }

    protected processGetSelectList(response: AxiosResponse): Promise<StSelectListItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StSelectListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StSelectListItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StSelectListItem[]>(null as any);
    }

    getSelectListForFilter(filter: AppUserFilter | undefined, cancelToken?: CancelToken): Promise<StSelectListItemGroup[]> {
        let url_ = this.baseUrl + "/AppUser/SelectlistForFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectListForFilter(_response);
        });
    }

    protected processGetSelectListForFilter(response: AxiosResponse): Promise<StSelectListItemGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StSelectListItemGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StSelectListItemGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StSelectListItemGroup[]>(null as any);
    }

    getNew( cancelToken?: CancelToken): Promise<AppUserEditModel> {
        let url_ = this.baseUrl + "/AppUser/new";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNew(_response);
        });
    }

    protected processGetNew(response: AxiosResponse): Promise<AppUserEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppUserEditModel.fromJS(resultData200);
            return Promise.resolve<AppUserEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUserEditModel>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<AppUserEditModel> {
        let url_ = this.baseUrl + "/AppUser/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<AppUserEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppUserEditModel.fromJS(resultData200);
            return Promise.resolve<AppUserEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUserEditModel>(null as any);
    }

    delete(id: number, confirmed: boolean | undefined, cancelToken?: CancelToken): Promise<DeleteResultModel> {
        let url_ = this.baseUrl + "/AppUser/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (confirmed === null)
            throw new Error("The parameter 'confirmed' cannot be null.");
        else if (confirmed !== undefined)
            url_ += "confirmed=" + encodeURIComponent("" + confirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<DeleteResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteResultModel.fromJS(resultData200);
            return Promise.resolve<DeleteResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteResultModel>(null as any);
    }

    getList(filter: AppUserFilter, cancelToken?: CancelToken): Promise<AppUserViewModel[]> {
        let url_ = this.baseUrl + "/AppUser/getlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<AppUserViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppUserViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AppUserViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUserViewModel[]>(null as any);
    }

    getManagerList(id: number, cancelToken?: CancelToken): Promise<AppUserViewModel[]> {
        let url_ = this.baseUrl + "/AppUser/getmanagerlist/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetManagerList(_response);
        });
    }

    protected processGetManagerList(response: AxiosResponse): Promise<AppUserViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppUserViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AppUserViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUserViewModel[]>(null as any);
    }

    post(appUserEditModel: AppUserEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/AppUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appUserEditModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(id: number | undefined, appUserEditModel: AppUserEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/AppUser?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appUserEditModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    resendInvitation(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/AppUser/resendInvitation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendInvitation(_response);
        });
    }

    protected processResendInvitation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resendAccountActivation( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/AppUser/resendActivation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResendAccountActivation(_response);
        });
    }

    protected processResendAccountActivation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    payAppStore( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/AppUser/payappstore";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPayAppStore(_response);
        });
    }

    protected processPayAppStore(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    storeTimeAccountDisplayDetails(value: boolean, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/AppUser/storeTimeAccountDisplayDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(value);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStoreTimeAccountDisplayDetails(_response);
        });
    }

    protected processStoreTimeAccountDisplayDetails(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AppUserHistoryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getNew(appUserId: number, cancelToken?: CancelToken): Promise<AppUserHistoryEditModel> {
        let url_ = this.baseUrl + "/AppUserHistory/new/{appUserId}";
        if (appUserId === undefined || appUserId === null)
            throw new Error("The parameter 'appUserId' must be defined.");
        url_ = url_.replace("{appUserId}", encodeURIComponent("" + appUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNew(_response);
        });
    }

    protected processGetNew(response: AxiosResponse): Promise<AppUserHistoryEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppUserHistoryEditModel.fromJS(resultData200);
            return Promise.resolve<AppUserHistoryEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUserHistoryEditModel>(null as any);
    }

    get(id: string, cancelToken?: CancelToken): Promise<AppUserHistoryEditModel> {
        let url_ = this.baseUrl + "/AppUserHistory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<AppUserHistoryEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppUserHistoryEditModel.fromJS(resultData200);
            return Promise.resolve<AppUserHistoryEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUserHistoryEditModel>(null as any);
    }

    delete(id: string, confirmed: boolean | undefined, cancelToken?: CancelToken): Promise<DeleteResultModel> {
        let url_ = this.baseUrl + "/AppUserHistory/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (confirmed === null)
            throw new Error("The parameter 'confirmed' cannot be null.");
        else if (confirmed !== undefined)
            url_ += "confirmed=" + encodeURIComponent("" + confirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<DeleteResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteResultModel.fromJS(resultData200);
            return Promise.resolve<DeleteResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteResultModel>(null as any);
    }

    getList(filter: AppUserHistoryFilter, cancelToken?: CancelToken): Promise<AppUserHistoryEditModel[]> {
        let url_ = this.baseUrl + "/AppUserHistory/getlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<AppUserHistoryEditModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppUserHistoryEditModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AppUserHistoryEditModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUserHistoryEditModel[]>(null as any);
    }

    merge(appUserId: number | undefined, appUserEditModels: AppUserHistoryEditModel[], cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/AppUserHistory?";
        if (appUserId === null)
            throw new Error("The parameter 'appUserId' cannot be null.");
        else if (appUserId !== undefined)
            url_ += "appUserId=" + encodeURIComponent("" + appUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appUserEditModels);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMerge(_response);
        });
    }

    protected processMerge(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class AppUserInternalCostHistoryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getNew(appUserId: number, cancelToken?: CancelToken): Promise<AppUserInternalCostHistoryEditModel> {
        let url_ = this.baseUrl + "/AppUserInternalCostHistory/new/{appUserId}";
        if (appUserId === undefined || appUserId === null)
            throw new Error("The parameter 'appUserId' must be defined.");
        url_ = url_.replace("{appUserId}", encodeURIComponent("" + appUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNew(_response);
        });
    }

    protected processGetNew(response: AxiosResponse): Promise<AppUserInternalCostHistoryEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppUserInternalCostHistoryEditModel.fromJS(resultData200);
            return Promise.resolve<AppUserInternalCostHistoryEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUserInternalCostHistoryEditModel>(null as any);
    }

    get(id: string, cancelToken?: CancelToken): Promise<AppUserInternalCostHistoryEditModel> {
        let url_ = this.baseUrl + "/AppUserInternalCostHistory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<AppUserInternalCostHistoryEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppUserInternalCostHistoryEditModel.fromJS(resultData200);
            return Promise.resolve<AppUserInternalCostHistoryEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUserInternalCostHistoryEditModel>(null as any);
    }

    delete(id: string, confirmed: boolean | undefined, cancelToken?: CancelToken): Promise<DeleteResultModel> {
        let url_ = this.baseUrl + "/AppUserInternalCostHistory/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (confirmed === null)
            throw new Error("The parameter 'confirmed' cannot be null.");
        else if (confirmed !== undefined)
            url_ += "confirmed=" + encodeURIComponent("" + confirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<DeleteResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteResultModel.fromJS(resultData200);
            return Promise.resolve<DeleteResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteResultModel>(null as any);
    }

    getList(filter: AppUserInternalCostHistoryFilter, cancelToken?: CancelToken): Promise<AppUserInternalCostHistoryEditModel[]> {
        let url_ = this.baseUrl + "/AppUserInternalCostHistory/getlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<AppUserInternalCostHistoryEditModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppUserInternalCostHistoryEditModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AppUserInternalCostHistoryEditModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUserInternalCostHistoryEditModel[]>(null as any);
    }

    merge(appUserId: number | undefined, appUserEditModels: AppUserInternalCostHistoryEditModel[], cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/AppUserInternalCostHistory?";
        if (appUserId === null)
            throw new Error("The parameter 'appUserId' cannot be null.");
        else if (appUserId !== undefined)
            url_ += "appUserId=" + encodeURIComponent("" + appUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appUserEditModels);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMerge(_response);
        });
    }

    protected processMerge(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class AppUserRightClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getEditModels(appUserId: number, cancelToken?: CancelToken): Promise<AppUserRightEditModel[]> {
        let url_ = this.baseUrl + "/AppUserRight/getlist/{appUserId}";
        if (appUserId === undefined || appUserId === null)
            throw new Error("The parameter 'appUserId' must be defined.");
        url_ = url_.replace("{appUserId}", encodeURIComponent("" + appUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEditModels(_response);
        });
    }

    protected processGetEditModels(response: AxiosResponse): Promise<AppUserRightEditModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppUserRightEditModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AppUserRightEditModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUserRightEditModel[]>(null as any);
    }

    merge(appUserId: number | undefined, editModels: AppUserRightEditModel[], cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/AppUserRight?";
        if (appUserId === null)
            throw new Error("The parameter 'appUserId' cannot be null.");
        else if (appUserId !== undefined)
            url_ += "appUserId=" + encodeURIComponent("" + appUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModels);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMerge(_response);
        });
    }

    protected processMerge(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class AppUserVacationHistoryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getNew(appUserId: number, cancelToken?: CancelToken): Promise<AppUserVacationHistoryEditModel> {
        let url_ = this.baseUrl + "/AppUserVacationHistory/new/{appUserId}";
        if (appUserId === undefined || appUserId === null)
            throw new Error("The parameter 'appUserId' must be defined.");
        url_ = url_.replace("{appUserId}", encodeURIComponent("" + appUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNew(_response);
        });
    }

    protected processGetNew(response: AxiosResponse): Promise<AppUserVacationHistoryEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppUserVacationHistoryEditModel.fromJS(resultData200);
            return Promise.resolve<AppUserVacationHistoryEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUserVacationHistoryEditModel>(null as any);
    }

    getList(filter: AppUserVacationHistoryFilter, cancelToken?: CancelToken): Promise<AppUserVacationHistoryEditModel[]> {
        let url_ = this.baseUrl + "/AppUserVacationHistory/getlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<AppUserVacationHistoryEditModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppUserVacationHistoryEditModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AppUserVacationHistoryEditModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUserVacationHistoryEditModel[]>(null as any);
    }

    merge(appUserId: number | undefined, appUserEditModels: AppUserVacationHistoryEditModel[], cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/AppUserVacationHistory?";
        if (appUserId === null)
            throw new Error("The parameter 'appUserId' cannot be null.");
        else if (appUserId !== undefined)
            url_ += "appUserId=" + encodeURIComponent("" + appUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(appUserEditModels);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMerge(_response);
        });
    }

    protected processMerge(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class AuthenticationClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    registerApp(accountRegisterModel: AppAccountRegisterModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Authentication/registerapp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountRegisterModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterApp(_response);
        });
    }

    protected processRegisterApp(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    register(accountRegisterModel: AccountRegisterModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Authentication/register";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountRegisterModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegister(_response);
        });
    }

    protected processRegister(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    registerHp(email: string | null | undefined, registrationSource: string | null | undefined, name: string | null | undefined, url: string | null | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/Authentication/registerhp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (email !== null && email !== undefined)
            content_.append("Email", email.toString());
        if (registrationSource !== null && registrationSource !== undefined)
            content_.append("RegistrationSource", registrationSource.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (url !== null && url !== undefined)
            content_.append("Url", url.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRegisterHp(_response);
        });
    }

    protected processRegisterHp(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    loginViaApiKey(apiKey: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Authentication/loginviaapikey/{apiKey}";
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginViaApiKey(_response);
        });
    }

    protected processLoginViaApiKey(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    prelogin(email: string, cancelToken?: CancelToken): Promise<PreloginCheckModel> {
        let url_ = this.baseUrl + "/Authentication/prelogin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(email);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPrelogin(_response);
        });
    }

    protected processPrelogin(response: AxiosResponse): Promise<PreloginCheckModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PreloginCheckModel.fromJS(resultData200);
            return Promise.resolve<PreloginCheckModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PreloginCheckModel>(null as any);
    }

    login(model: AppUserLoginModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Authentication/Login";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogin(_response);
        });
    }

    protected processLogin(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    loginApp(model: AppUserLoginModel, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Authentication/LoginApp";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoginApp(_response);
        });
    }

    protected processLoginApp(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    logout( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Authentication/Logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLogout(_response);
        });
    }

    protected processLogout(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    forgotPassword(forgotPasswordModel: ForgotPasswordModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Authentication/ForgotPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(forgotPasswordModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processForgotPassword(_response);
        });
    }

    protected processForgotPassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    resetPassword(resetPasswordModel: ResetPasswordModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Authentication/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(resetPasswordModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPassword(_response);
        });
    }

    protected processResetPassword(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ConcurrencyClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getMaxRowVersionTimeEntries(dateFrom: string | undefined, dateTo: string | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Concurrency/getmaxrowversiontimeentries?";
        if (dateFrom === null)
            throw new Error("The parameter 'dateFrom' cannot be null.");
        else if (dateFrom !== undefined)
            url_ += "dateFrom=" + encodeURIComponent("" + dateFrom) + "&";
        if (dateTo === null)
            throw new Error("The parameter 'dateTo' cannot be null.");
        else if (dateTo !== undefined)
            url_ += "dateTo=" + encodeURIComponent("" + dateTo) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMaxRowVersionTimeEntries(_response);
        });
    }

    protected processGetMaxRowVersionTimeEntries(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class CustomerClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getNew( cancelToken?: CancelToken): Promise<CustomerEditModel> {
        let url_ = this.baseUrl + "/Customer/new";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNew(_response);
        });
    }

    protected processGetNew(response: AxiosResponse): Promise<CustomerEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerEditModel.fromJS(resultData200);
            return Promise.resolve<CustomerEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerEditModel>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<CustomerEditModel> {
        let url_ = this.baseUrl + "/Customer/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<CustomerEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CustomerEditModel.fromJS(resultData200);
            return Promise.resolve<CustomerEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerEditModel>(null as any);
    }

    delete(id: number, confirmed: boolean | undefined, cancelToken?: CancelToken): Promise<DeleteResultModel> {
        let url_ = this.baseUrl + "/Customer/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (confirmed === null)
            throw new Error("The parameter 'confirmed' cannot be null.");
        else if (confirmed !== undefined)
            url_ += "confirmed=" + encodeURIComponent("" + confirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<DeleteResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteResultModel.fromJS(resultData200);
            return Promise.resolve<DeleteResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteResultModel>(null as any);
    }

    getNoOfActiveProjects(id: number, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Customer/noofactiveprojects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNoOfActiveProjects(_response);
        });
    }

    protected processGetNoOfActiveProjects(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getList(filter: CustomerFilter, cancelToken?: CancelToken): Promise<CustomerViewModel[]> {
        let url_ = this.baseUrl + "/Customer/getlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<CustomerViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CustomerViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CustomerViewModel[]>(null as any);
    }

    getSelectList(filter: CustomerFilter | undefined, cancelToken?: CancelToken): Promise<StSelectListItem[]> {
        let url_ = this.baseUrl + "/Customer/Selectlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectList(_response);
        });
    }

    protected processGetSelectList(response: AxiosResponse): Promise<StSelectListItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StSelectListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StSelectListItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StSelectListItem[]>(null as any);
    }

    getSelectListForFilter(filter: CustomerFilter | undefined, cancelToken?: CancelToken): Promise<StSelectListItemGroup[]> {
        let url_ = this.baseUrl + "/Customer/SelectlistForFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectListForFilter(_response);
        });
    }

    protected processGetSelectListForFilter(response: AxiosResponse): Promise<StSelectListItemGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StSelectListItemGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StSelectListItemGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StSelectListItemGroup[]>(null as any);
    }

    post(customerEditModel: CustomerEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Customer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerEditModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(id: number | undefined, customerEditModel: CustomerEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Customer?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerEditModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    toggleArchiveCustomer(command: CustomerArchiveToggleCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Customer/ToggleArchiveCustomer";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleArchiveCustomer(_response);
        });
    }

    protected processToggleArchiveCustomer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ImpersonateClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    impersonateUser(userId: number | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Impersonate/Impersonate?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImpersonateUser(_response);
        });
    }

    protected processImpersonateUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getUsersForImpersonation( cancelToken?: CancelToken): Promise<AppUserViewModel[]> {
        let url_ = this.baseUrl + "/Impersonate/GetUserForImpersonation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUsersForImpersonation(_response);
        });
    }

    protected processGetUsersForImpersonation(response: AxiosResponse): Promise<AppUserViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AppUserViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<AppUserViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppUserViewModel[]>(null as any);
    }

    stopImpersonation( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Impersonate/StopImpersonation";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStopImpersonation(_response);
        });
    }

    protected processStopImpersonation(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class InvoiceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getInvoice(id: number, cancelToken?: CancelToken): Promise<InvoiceViewModel> {
        let url_ = this.baseUrl + "/Invoice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInvoice(_response);
        });
    }

    protected processGetInvoice(response: AxiosResponse): Promise<InvoiceViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InvoiceViewModel.fromJS(resultData200);
            return Promise.resolve<InvoiceViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InvoiceViewModel>(null as any);
    }
}

export class ListClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    get(listParameters: ListParameters, cancelToken?: CancelToken): Promise<ListResult> {
        let url_ = this.baseUrl + "/List";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listParameters);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ListResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResult.fromJS(resultData200);
            return Promise.resolve<ListResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResult>(null as any);
    }

    getListByGuid(guid: string | null | undefined, cancelToken?: CancelToken): Promise<ListResult> {
        let url_ = this.baseUrl + "/List/GetListByGuid?";
        if (guid !== undefined && guid !== null)
            url_ += "guid=" + encodeURIComponent("" + guid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListByGuid(_response);
        });
    }

    protected processGetListByGuid(response: AxiosResponse): Promise<ListResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResult.fromJS(resultData200);
            return Promise.resolve<ListResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResult>(null as any);
    }

    getDefaultListParams( cancelToken?: CancelToken): Promise<ListParameters> {
        let url_ = this.baseUrl + "/List/GetDefaultListParams";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDefaultListParams(_response);
        });
    }

    protected processGetDefaultListParams(response: AxiosResponse): Promise<ListParameters> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListParameters.fromJS(resultData200);
            return Promise.resolve<ListParameters>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListParameters>(null as any);
    }

    getExternal(guid: string, cancelToken?: CancelToken): Promise<ListResult> {
        let url_ = this.baseUrl + "/List/external/{guid}";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetExternal(_response);
        });
    }

    protected processGetExternal(response: AxiosResponse): Promise<ListResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListResult.fromJS(resultData200);
            return Promise.resolve<ListResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListResult>(null as any);
    }

    generatePdf(fileName: string, listParameters: ListParameters, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/List/pdf/{fileName}";
        if (fileName === undefined || fileName === null)
            throw new Error("The parameter 'fileName' must be defined.");
        url_ = url_.replace("{fileName}", encodeURIComponent("" + fileName));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listParameters);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGeneratePdf(_response);
        });
    }

    protected processGeneratePdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    saveListPreset(presetEditModel: ListPresetEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/List/SaveListPreset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(presetEditModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveListPreset(_response);
        });
    }

    protected processSaveListPreset(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListPresets( cancelToken?: CancelToken): Promise<ListPresetListViewModel[]> {
        let url_ = this.baseUrl + "/List/GetListPresets";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListPresets(_response);
        });
    }

    protected processGetListPresets(response: AxiosResponse): Promise<ListPresetListViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ListPresetListViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ListPresetListViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPresetListViewModel[]>(null as any);
    }

    getListPreset(id: number, cancelToken?: CancelToken): Promise<ListPresetViewModel> {
        let url_ = this.baseUrl + "/List/GetListPreset/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListPreset(_response);
        });
    }

    protected processGetListPreset(response: AxiosResponse): Promise<ListPresetViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListPresetViewModel.fromJS(resultData200);
            return Promise.resolve<ListPresetViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListPresetViewModel>(null as any);
    }

    deleteListPreset(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/List/ListPreset/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteListPreset(_response);
        });
    }

    protected processDeleteListPreset(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    toggleClearedAll(newvalue: boolean, filter: TimeEntryFilter, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/List/ToggleAll/{newvalue}";
        if (newvalue === undefined || newvalue === null)
            throw new Error("The parameter 'newvalue' must be defined.");
        url_ = url_.replace("{newvalue}", encodeURIComponent("" + newvalue));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleClearedAll(_response);
        });
    }

    protected processToggleClearedAll(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    exportExcel(listParameters: ListParameters, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/List/ExportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(listParameters);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportExcel(_response);
        });
    }

    protected processExportExcel(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class ListSharedClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    checkPreset(guid: string, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/ListShared/check/{guid}";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckPreset(_response);
        });
    }

    protected processCheckPreset(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    preauthenticateSharedFilter(guid: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/ListShared/html/preauthenticate/{guid}";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPreauthenticateSharedFilter(_response);
        });
    }

    protected processPreauthenticateSharedFilter(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getHtml(guid: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/ListShared/html/{guid}";
        if (guid === undefined || guid === null)
            throw new Error("The parameter 'guid' must be defined.");
        url_ = url_.replace("{guid}", encodeURIComponent("" + guid));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHtml(_response);
        });
    }

    protected processGetHtml(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class LookupClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getTimeEntryTypes( cancelToken?: CancelToken): Promise<TimeEntryTypeViewModel[]> {
        let url_ = this.baseUrl + "/Lookup/TimeEntryType";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeEntryTypes(_response);
        });
    }

    protected processGetTimeEntryTypes(response: AxiosResponse): Promise<TimeEntryTypeViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeEntryTypeViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TimeEntryTypeViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeEntryTypeViewModel[]>(null as any);
    }

    getTimeZoneIds( cancelToken?: CancelToken): Promise<StSelectListItem[]> {
        let url_ = this.baseUrl + "/Lookup/TimeZones";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeZoneIds(_response);
        });
    }

    protected processGetTimeZoneIds(response: AxiosResponse): Promise<StSelectListItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StSelectListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StSelectListItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StSelectListItem[]>(null as any);
    }

    getDatePattern( cancelToken?: CancelToken): Promise<StStringSelectListItem[]> {
        let url_ = this.baseUrl + "/Lookup/DatePatterns";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDatePattern(_response);
        });
    }

    protected processGetDatePattern(response: AxiosResponse): Promise<StStringSelectListItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StStringSelectListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StStringSelectListItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StStringSelectListItem[]>(null as any);
    }

    getTimePattern( cancelToken?: CancelToken): Promise<StStringSelectListItem[]> {
        let url_ = this.baseUrl + "/Lookup/TimePattern";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimePattern(_response);
        });
    }

    protected processGetTimePattern(response: AxiosResponse): Promise<StStringSelectListItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StStringSelectListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StStringSelectListItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StStringSelectListItem[]>(null as any);
    }

    getUserNowDateTime( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Lookup/UserNowDateTime";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserNowDateTime(_response);
        });
    }

    protected processGetUserNowDateTime(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class NewsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getNews( cancelToken?: CancelToken): Promise<NewsModel> {
        let url_ = this.baseUrl + "/News";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNews(_response);
        });
    }

    protected processGetNews(response: AxiosResponse): Promise<NewsModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = NewsModel.fromJS(resultData200);
            return Promise.resolve<NewsModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<NewsModel>(null as any);
    }

    newsClicked( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/News";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processNewsClicked(_response);
        });
    }

    protected processNewsClicked(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class OutgoingInvoiceClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getSettingsViewModel( cancelToken?: CancelToken): Promise<OutgoingInvoiceSettingsViewModel> {
        let url_ = this.baseUrl + "/OutgoingInvoice/settings/viewmodel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettingsViewModel(_response);
        });
    }

    protected processGetSettingsViewModel(response: AxiosResponse): Promise<OutgoingInvoiceSettingsViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OutgoingInvoiceSettingsViewModel.fromJS(resultData200);
            return Promise.resolve<OutgoingInvoiceSettingsViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OutgoingInvoiceSettingsViewModel>(null as any);
    }

    getSettingsEditModel( cancelToken?: CancelToken): Promise<OutgoingInvoiceSettingsEditModel> {
        let url_ = this.baseUrl + "/OutgoingInvoice/settings/editmodel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettingsEditModel(_response);
        });
    }

    protected processGetSettingsEditModel(response: AxiosResponse): Promise<OutgoingInvoiceSettingsEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OutgoingInvoiceSettingsEditModel.fromJS(resultData200);
            return Promise.resolve<OutgoingInvoiceSettingsEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OutgoingInvoiceSettingsEditModel>(null as any);
    }

    getCurrentLocalIncrementValue(prefix: string, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/OutgoingInvoice/GetCurrentLocalIncrementValue/{prefix}";
        if (prefix === undefined || prefix === null)
            throw new Error("The parameter 'prefix' must be defined.");
        url_ = url_.replace("{prefix}", encodeURIComponent("" + prefix));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCurrentLocalIncrementValue(_response);
        });
    }

    protected processGetCurrentLocalIncrementValue(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    updateSettings(model: OutgoingInvoiceSettingsEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/OutgoingInvoice/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSettings(_response);
        });
    }

    protected processUpdateSettings(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getNewPositionEditModel( cancelToken?: CancelToken): Promise<OutgoingInvoicePositionEditModel> {
        let url_ = this.baseUrl + "/OutgoingInvoice/positions/new";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewPositionEditModel(_response);
        });
    }

    protected processGetNewPositionEditModel(response: AxiosResponse): Promise<OutgoingInvoicePositionEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OutgoingInvoicePositionEditModel.fromJS(resultData200);
            return Promise.resolve<OutgoingInvoicePositionEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OutgoingInvoicePositionEditModel>(null as any);
    }

    getPdfViaApiKey(id: number, apiKey: string, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/OutgoingInvoice/pdfviaapikey/{id}/{apiKey}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPdfViaApiKey(_response);
        });
    }

    protected processGetPdfViaApiKey(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getPdf(id: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/OutgoingInvoice/pdf/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPdf(_response);
        });
    }

    protected processGetPdf(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getXml(id: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/OutgoingInvoice/xml/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetXml(_response);
        });
    }

    protected processGetXml(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getActivityReportViaApiKey(id: number, apiKey: string, showEmployees: boolean, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/OutgoingInvoice/activityreportviaapikey/{id}/{apiKey}/{showEmployees}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (apiKey === undefined || apiKey === null)
            throw new Error("The parameter 'apiKey' must be defined.");
        url_ = url_.replace("{apiKey}", encodeURIComponent("" + apiKey));
        if (showEmployees === undefined || showEmployees === null)
            throw new Error("The parameter 'showEmployees' must be defined.");
        url_ = url_.replace("{showEmployees}", encodeURIComponent("" + showEmployees));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityReportViaApiKey(_response);
        });
    }

    protected processGetActivityReportViaApiKey(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getActivityReport(id: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/OutgoingInvoice/activityreport/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetActivityReport(_response);
        });
    }

    protected processGetActivityReport(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getLogo(id: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/OutgoingInvoice/logo/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLogo(_response);
        });
    }

    protected processGetLogo(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getSettingsLogo( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/OutgoingInvoice/settingslogo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSettingsLogo(_response);
        });
    }

    protected processGetSettingsLogo(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    deleteLogo( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/OutgoingInvoice";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteLogo(_response);
        });
    }

    protected processDeleteLogo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    post(editModel: OutgoingInvoiceEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/OutgoingInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(editModel: OutgoingInvoiceEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/OutgoingInvoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    uploadLogo(file: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/OutgoingInvoice/uploadlogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("file", file.data, file.fileName ? file.fileName : "file");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadLogo(_response);
        });
    }

    protected processUploadLogo(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    sendEmail(invoiceId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/OutgoingInvoice/sendemail/{invoiceId}";
        if (invoiceId === undefined || invoiceId === null)
            throw new Error("The parameter 'invoiceId' must be defined.");
        url_ = url_.replace("{invoiceId}", encodeURIComponent("" + invoiceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendEmail(_response);
        });
    }

    protected processSendEmail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getNew(customerId: number, filter: OutgoingInvoiceTimeEntryGroupFilter, cancelToken?: CancelToken): Promise<OutgoingInvoiceEditModel> {
        let url_ = this.baseUrl + "/OutgoingInvoice/new/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNew(_response);
        });
    }

    protected processGetNew(response: AxiosResponse): Promise<OutgoingInvoiceEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OutgoingInvoiceEditModel.fromJS(resultData200);
            return Promise.resolve<OutgoingInvoiceEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OutgoingInvoiceEditModel>(null as any);
    }

    getPositionsByTimeEntries(filter: OutgoingInvoiceTimeEntryGroupFilter, cancelToken?: CancelToken): Promise<OutgoingInvoicePositionEditModel[]> {
        let url_ = this.baseUrl + "/OutgoingInvoice/positionsbytimeentries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPositionsByTimeEntries(_response);
        });
    }

    protected processGetPositionsByTimeEntries(response: AxiosResponse): Promise<OutgoingInvoicePositionEditModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutgoingInvoicePositionEditModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OutgoingInvoicePositionEditModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OutgoingInvoicePositionEditModel[]>(null as any);
    }

    getOutgoingInvoiceTimeEntries(outgoingInvoiceId: number, filter: TimeEntryFilter, cancelToken?: CancelToken): Promise<OutgoingInvoiceTimeEntryModel[]> {
        let url_ = this.baseUrl + "/OutgoingInvoice/timeentries/{outgoingInvoiceId}";
        if (outgoingInvoiceId === undefined || outgoingInvoiceId === null)
            throw new Error("The parameter 'outgoingInvoiceId' must be defined.");
        url_ = url_.replace("{outgoingInvoiceId}", encodeURIComponent("" + outgoingInvoiceId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOutgoingInvoiceTimeEntries(_response);
        });
    }

    protected processGetOutgoingInvoiceTimeEntries(response: AxiosResponse): Promise<OutgoingInvoiceTimeEntryModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutgoingInvoiceTimeEntryModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OutgoingInvoiceTimeEntryModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OutgoingInvoiceTimeEntryModel[]>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<OutgoingInvoiceEditModel> {
        let url_ = this.baseUrl + "/OutgoingInvoice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<OutgoingInvoiceEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OutgoingInvoiceEditModel.fromJS(resultData200);
            return Promise.resolve<OutgoingInvoiceEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OutgoingInvoiceEditModel>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/OutgoingInvoice/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getViewModel(id: number, cancelToken?: CancelToken): Promise<OutgoingInvoiceViewModel> {
        let url_ = this.baseUrl + "/OutgoingInvoice/viewmodel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetViewModel(_response);
        });
    }

    protected processGetViewModel(response: AxiosResponse): Promise<OutgoingInvoiceViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OutgoingInvoiceViewModel.fromJS(resultData200);
            return Promise.resolve<OutgoingInvoiceViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OutgoingInvoiceViewModel>(null as any);
    }

    getViewModelFromEditModel(editModel: OutgoingInvoiceEditModel, cancelToken?: CancelToken): Promise<OutgoingInvoiceViewModel> {
        let url_ = this.baseUrl + "/OutgoingInvoice/viewmodelfromeditmodel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetViewModelFromEditModel(_response);
        });
    }

    protected processGetViewModelFromEditModel(response: AxiosResponse): Promise<OutgoingInvoiceViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = OutgoingInvoiceViewModel.fromJS(resultData200);
            return Promise.resolve<OutgoingInvoiceViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OutgoingInvoiceViewModel>(null as any);
    }

    getList(filter: OutgoingInvoiceFilter, cancelToken?: CancelToken): Promise<OutgoingInvoiceViewModel[]> {
        let url_ = this.baseUrl + "/OutgoingInvoice/getlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<OutgoingInvoiceViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(OutgoingInvoiceViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<OutgoingInvoiceViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<OutgoingInvoiceViewModel[]>(null as any);
    }
}

export class PaymentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    createSetupIntent( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Payment/createSetupIntent";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateSetupIntent(_response);
        });
    }

    protected processCreateSetupIntent(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    confirmSetupIntent(setupIntentId: string | null | undefined, cancelToken?: CancelToken): Promise<SetupIntentConfirmationModel> {
        let url_ = this.baseUrl + "/Payment/confirmSetupIntent?";
        if (setupIntentId !== undefined && setupIntentId !== null)
            url_ += "setupIntentId=" + encodeURIComponent("" + setupIntentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processConfirmSetupIntent(_response);
        });
    }

    protected processConfirmSetupIntent(response: AxiosResponse): Promise<SetupIntentConfirmationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SetupIntentConfirmationModel.fromJS(resultData200);
            return Promise.resolve<SetupIntentConfirmationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SetupIntentConfirmationModel>(null as any);
    }

    getStripePublicKey( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Payment/getStripePublicKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStripePublicKey(_response);
        });
    }

    protected processGetStripePublicKey(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PingClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    get( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/Ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getDb( cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/te";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDb(_response);
        });
    }

    protected processGetDb(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ProjectClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getNew(customerId: number, cancelToken?: CancelToken): Promise<ProjectEditModel> {
        let url_ = this.baseUrl + "/Project/new/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNew(_response);
        });
    }

    protected processGetNew(response: AxiosResponse): Promise<ProjectEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectEditModel.fromJS(resultData200);
            return Promise.resolve<ProjectEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectEditModel>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<ProjectEditModel> {
        let url_ = this.baseUrl + "/Project/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ProjectEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectEditModel.fromJS(resultData200);
            return Promise.resolve<ProjectEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectEditModel>(null as any);
    }

    delete(id: number, confirmed: boolean | undefined, cancelToken?: CancelToken): Promise<DeleteResultModel> {
        let url_ = this.baseUrl + "/Project/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (confirmed === null)
            throw new Error("The parameter 'confirmed' cannot be null.");
        else if (confirmed !== undefined)
            url_ += "confirmed=" + encodeURIComponent("" + confirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<DeleteResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteResultModel.fromJS(resultData200);
            return Promise.resolve<DeleteResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteResultModel>(null as any);
    }

    getProjectAsCustomerEditModel(customerId: number, cancelToken?: CancelToken): Promise<ProjectAsCustomerEditModel> {
        let url_ = this.baseUrl + "/Project/GetProjectAsCustomerEditModel/{customerId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectAsCustomerEditModel(_response);
        });
    }

    protected processGetProjectAsCustomerEditModel(response: AxiosResponse): Promise<ProjectAsCustomerEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectAsCustomerEditModel.fromJS(resultData200);
            return Promise.resolve<ProjectAsCustomerEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectAsCustomerEditModel>(null as any);
    }

    getViewModel(id: number, cancelToken?: CancelToken): Promise<ProjectViewModel> {
        let url_ = this.baseUrl + "/Project/viewmodel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetViewModel(_response);
        });
    }

    protected processGetViewModel(response: AxiosResponse): Promise<ProjectViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectViewModel.fromJS(resultData200);
            return Promise.resolve<ProjectViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectViewModel>(null as any);
    }

    getAuthorizedProjectListByAppUser(appUserId: number, cancelToken?: CancelToken): Promise<AuthorizedProjectList> {
        let url_ = this.baseUrl + "/Project/AuthorizedProjectListByAppUser/{appUserId}";
        if (appUserId === undefined || appUserId === null)
            throw new Error("The parameter 'appUserId' must be defined.");
        url_ = url_.replace("{appUserId}", encodeURIComponent("" + appUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuthorizedProjectListByAppUser(_response);
        });
    }

    protected processGetAuthorizedProjectListByAppUser(response: AxiosResponse): Promise<AuthorizedProjectList> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuthorizedProjectList.fromJS(resultData200);
            return Promise.resolve<AuthorizedProjectList>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuthorizedProjectList>(null as any);
    }

    getTimeEntryViewModel(id: number, cancelToken?: CancelToken): Promise<ProjectTimeEntryViewModel> {
        let url_ = this.baseUrl + "/Project/timeentryviewmodel/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeEntryViewModel(_response);
        });
    }

    protected processGetTimeEntryViewModel(response: AxiosResponse): Promise<ProjectTimeEntryViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectTimeEntryViewModel.fromJS(resultData200);
            return Promise.resolve<ProjectTimeEntryViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectTimeEntryViewModel>(null as any);
    }

    checkFixedPriceChange(command: ProjectCheckFixedPriceChangeCommand, cancelToken?: CancelToken): Promise<ProjectCheckFixedPriceChangeResult> {
        let url_ = this.baseUrl + "/Project/checkfixedpricechange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckFixedPriceChange(_response);
        });
    }

    protected processCheckFixedPriceChange(response: AxiosResponse): Promise<ProjectCheckFixedPriceChangeResult> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectCheckFixedPriceChangeResult.fromJS(resultData200);
            return Promise.resolve<ProjectCheckFixedPriceChangeResult>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectCheckFixedPriceChangeResult>(null as any);
    }

    getList(filter: ProjectFilter, cancelToken?: CancelToken): Promise<ProjectViewModel[]> {
        let url_ = this.baseUrl + "/Project/getlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<ProjectViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectViewModel[]>(null as any);
    }

    getProjectBudgets(filter: ProjectFilter, cancelToken?: CancelToken): Promise<ProjectBudgetViewModel[]> {
        let url_ = this.baseUrl + "/Project/getbudgets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectBudgets(_response);
        });
    }

    protected processGetProjectBudgets(response: AxiosResponse): Promise<ProjectBudgetViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectBudgetViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectBudgetViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectBudgetViewModel[]>(null as any);
    }

    getBudgetConsumption(projectId: number, cancelToken?: CancelToken): Promise<ProjectBudgetViewModel> {
        let url_ = this.baseUrl + "/Project/getbudget/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBudgetConsumption(_response);
        });
    }

    protected processGetBudgetConsumption(response: AxiosResponse): Promise<ProjectBudgetViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectBudgetViewModel.fromJS(resultData200);
            return Promise.resolve<ProjectBudgetViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectBudgetViewModel>(null as any);
    }

    getSelectList(filter: ProjectFilter, cancelToken?: CancelToken): Promise<StSelectListItemGroup[]> {
        let url_ = this.baseUrl + "/Project/selectlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectList(_response);
        });
    }

    protected processGetSelectList(response: AxiosResponse): Promise<StSelectListItemGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StSelectListItemGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StSelectListItemGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StSelectListItemGroup[]>(null as any);
    }

    getSelectListLastUsed(filter: ProjectFilter | undefined, cancelToken?: CancelToken): Promise<StSelectListItemGroup[]> {
        let url_ = this.baseUrl + "/Project/selectlistlastused";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectListLastUsed(_response);
        });
    }

    protected processGetSelectListLastUsed(response: AxiosResponse): Promise<StSelectListItemGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StSelectListItemGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StSelectListItemGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StSelectListItemGroup[]>(null as any);
    }

    getSelectListForTimeTracking( cancelToken?: CancelToken): Promise<StSelectListItemGroup[]> {
        let url_ = this.baseUrl + "/Project/GetSelectListForTimeTracking";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectListForTimeTracking(_response);
        });
    }

    protected processGetSelectListForTimeTracking(response: AxiosResponse): Promise<StSelectListItemGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StSelectListItemGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StSelectListItemGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StSelectListItemGroup[]>(null as any);
    }

    getSelectListForProjectReport( cancelToken?: CancelToken): Promise<StSelectListItemGroup[]> {
        let url_ = this.baseUrl + "/Project/GetSelectListForProjectReport";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectListForProjectReport(_response);
        });
    }

    protected processGetSelectListForProjectReport(response: AxiosResponse): Promise<StSelectListItemGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StSelectListItemGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StSelectListItemGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StSelectListItemGroup[]>(null as any);
    }

    getSelectListForFilter(filter: ProjectFilter, cancelToken?: CancelToken): Promise<StSelectListItemGroup[]> {
        let url_ = this.baseUrl + "/Project/selectlistforfilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectListForFilter(_response);
        });
    }

    protected processGetSelectListForFilter(response: AxiosResponse): Promise<StSelectListItemGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StSelectListItemGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StSelectListItemGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StSelectListItemGroup[]>(null as any);
    }

    getSelectListForProjectAssignment(filter: ProjectFilter, cancelToken?: CancelToken): Promise<StSelectListItemGroup[]> {
        let url_ = this.baseUrl + "/Project/GetSelectListForProjectAssignment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectListForProjectAssignment(_response);
        });
    }

    protected processGetSelectListForProjectAssignment(response: AxiosResponse): Promise<StSelectListItemGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StSelectListItemGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StSelectListItemGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StSelectListItemGroup[]>(null as any);
    }

    getSelectListOnlyLastUsed(topX: number | undefined, includeFillerProjects: boolean | undefined, cancelToken?: CancelToken): Promise<StSelectListItemGroup[]> {
        let url_ = this.baseUrl + "/Project/selectlistonlylastused?";
        if (topX === null)
            throw new Error("The parameter 'topX' cannot be null.");
        else if (topX !== undefined)
            url_ += "topX=" + encodeURIComponent("" + topX) + "&";
        if (includeFillerProjects === null)
            throw new Error("The parameter 'includeFillerProjects' cannot be null.");
        else if (includeFillerProjects !== undefined)
            url_ += "includeFillerProjects=" + encodeURIComponent("" + includeFillerProjects) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectListOnlyLastUsed(_response);
        });
    }

    protected processGetSelectListOnlyLastUsed(response: AxiosResponse): Promise<StSelectListItemGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StSelectListItemGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StSelectListItemGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StSelectListItemGroup[]>(null as any);
    }

    post(projectEditModel: ProjectEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Project";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(projectEditModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(id: number | undefined, projectEditModel: ProjectEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Project?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(projectEditModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    toggleFinishProject(command: ProjectFinishToggleCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Project/ToggleFinishProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleFinishProject(_response);
        });
    }

    protected processToggleFinishProject(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    toggleArchiveProject(command: ProjectArchiveToggleCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Project/ToggleArchiveProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleArchiveProject(_response);
        });
    }

    protected processToggleArchiveProject(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getProjectReport(projectId: number, cancelToken?: CancelToken): Promise<ProjectReportViewModel> {
        let url_ = this.baseUrl + "/Project/report/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProjectReport(_response);
        });
    }

    protected processGetProjectReport(response: AxiosResponse): Promise<ProjectReportViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectReportViewModel.fromJS(resultData200);
            return Promise.resolve<ProjectReportViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectReportViewModel>(null as any);
    }
}

export class ProjectFixedPriceReportClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getUserOverviewReport(query: ProjectFixedPriceUserOverviewQuery, cancelToken?: CancelToken): Promise<ProjectFixedPriceUserOverviewModel[]> {
        let url_ = this.baseUrl + "/ProjectFixedPriceReport/GetUserOverviewReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserOverviewReport(_response);
        });
    }

    protected processGetUserOverviewReport(response: AxiosResponse): Promise<ProjectFixedPriceUserOverviewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectFixedPriceUserOverviewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectFixedPriceUserOverviewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectFixedPriceUserOverviewModel[]>(null as any);
    }

    getRevenueFteReport(query: ProjectFixedPriceRevenueFteQuery, cancelToken?: CancelToken): Promise<ProjectFixedPriceRevenueFteModel[]> {
        let url_ = this.baseUrl + "/ProjectFixedPriceReport/GetRevenueFteReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRevenueFteReport(_response);
        });
    }

    protected processGetRevenueFteReport(response: AxiosResponse): Promise<ProjectFixedPriceRevenueFteModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectFixedPriceRevenueFteModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectFixedPriceRevenueFteModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectFixedPriceRevenueFteModel[]>(null as any);
    }

    getDailyRateReport(query: ProjectFixedPriceDailyRateReportQuery, cancelToken?: CancelToken): Promise<ProjectFixedPriceDailyRateReportModel[]> {
        let url_ = this.baseUrl + "/ProjectFixedPriceReport/GetDailyRateReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDailyRateReport(_response);
        });
    }

    protected processGetDailyRateReport(response: AxiosResponse): Promise<ProjectFixedPriceDailyRateReportModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectFixedPriceDailyRateReportModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectFixedPriceDailyRateReportModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectFixedPriceDailyRateReportModel[]>(null as any);
    }
}

export class ProjectStaffClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getEditModels(filter: ProjectStaffFilter, cancelToken?: CancelToken): Promise<ProjectStaffEditModel[]> {
        let url_ = this.baseUrl + "/ProjectStaff/geteditmodels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEditModels(_response);
        });
    }

    protected processGetEditModels(response: AxiosResponse): Promise<ProjectStaffEditModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectStaffEditModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectStaffEditModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectStaffEditModel[]>(null as any);
    }

    getEmployees(projectId: number, cancelToken?: CancelToken): Promise<ProjectStaffAppUserViewModel[]> {
        let url_ = this.baseUrl + "/ProjectStaff/employees/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployees(_response);
        });
    }

    protected processGetEmployees(response: AxiosResponse): Promise<ProjectStaffAppUserViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectStaffAppUserViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectStaffAppUserViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectStaffAppUserViewModel[]>(null as any);
    }

    mergeByProject(projectId: number, editModels: ProjectStaffEditModel[], cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ProjectStaff/mergebyproject/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModels);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMergeByProject(_response);
        });
    }

    protected processMergeByProject(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    mergeByAppUser(appUserId: number, editModels: ProjectStaffEditModel[], cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ProjectStaff/mergebyappuser/{appUserId}";
        if (appUserId === undefined || appUserId === null)
            throw new Error("The parameter 'appUserId' must be defined.");
        url_ = url_.replace("{appUserId}", encodeURIComponent("" + appUserId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModels);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMergeByAppUser(_response);
        });
    }

    protected processMergeByAppUser(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class ProjectTaskClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getNew( cancelToken?: CancelToken): Promise<ProjectTaskEditModel> {
        let url_ = this.baseUrl + "/ProjectTask/new";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNew(_response);
        });
    }

    protected processGetNew(response: AxiosResponse): Promise<ProjectTaskEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectTaskEditModel.fromJS(resultData200);
            return Promise.resolve<ProjectTaskEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectTaskEditModel>(null as any);
    }

    getNewWithProjectId(customerId: number, projectId: number, cancelToken?: CancelToken): Promise<ProjectTaskEditModel> {
        let url_ = this.baseUrl + "/ProjectTask/new/{customerId}/{projectId}";
        if (customerId === undefined || customerId === null)
            throw new Error("The parameter 'customerId' must be defined.");
        url_ = url_.replace("{customerId}", encodeURIComponent("" + customerId));
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewWithProjectId(_response);
        });
    }

    protected processGetNewWithProjectId(response: AxiosResponse): Promise<ProjectTaskEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectTaskEditModel.fromJS(resultData200);
            return Promise.resolve<ProjectTaskEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectTaskEditModel>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<ProjectTaskEditModel> {
        let url_ = this.baseUrl + "/ProjectTask/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ProjectTaskEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProjectTaskEditModel.fromJS(resultData200);
            return Promise.resolve<ProjectTaskEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectTaskEditModel>(null as any);
    }

    delete(id: number, confirmed: boolean | undefined, dryRun: boolean | undefined, cancelToken?: CancelToken): Promise<DeleteResultModel> {
        let url_ = this.baseUrl + "/ProjectTask/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (confirmed === null)
            throw new Error("The parameter 'confirmed' cannot be null.");
        else if (confirmed !== undefined)
            url_ += "confirmed=" + encodeURIComponent("" + confirmed) + "&";
        if (dryRun === null)
            throw new Error("The parameter 'dryRun' cannot be null.");
        else if (dryRun !== undefined)
            url_ += "dryRun=" + encodeURIComponent("" + dryRun) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<DeleteResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteResultModel.fromJS(resultData200);
            return Promise.resolve<DeleteResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteResultModel>(null as any);
    }

    getList(filter: ProjectTaskFilter, cancelToken?: CancelToken): Promise<ProjectTaskViewModel[]> {
        let url_ = this.baseUrl + "/ProjectTask/getlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<ProjectTaskViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectTaskViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectTaskViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectTaskViewModel[]>(null as any);
    }

    getSelectList(filter: ProjectTaskFilter, cancelToken?: CancelToken): Promise<StSelectListItem[]> {
        let url_ = this.baseUrl + "/ProjectTask/Selectlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectList(_response);
        });
    }

    protected processGetSelectList(response: AxiosResponse): Promise<StSelectListItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StSelectListItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StSelectListItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StSelectListItem[]>(null as any);
    }

    getSelectListForFilter(filter: ProjectTaskFilter | undefined, cancelToken?: CancelToken): Promise<StSelectListItemGroup[]> {
        let url_ = this.baseUrl + "/ProjectTask/SelectlistForFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectListForFilter(_response);
        });
    }

    protected processGetSelectListForFilter(response: AxiosResponse): Promise<StSelectListItemGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StSelectListItemGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StSelectListItemGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StSelectListItemGroup[]>(null as any);
    }

    getSelectListGrouped(filter: ProjectTaskFilter, cancelToken?: CancelToken): Promise<StSelectListItemGroup[]> {
        let url_ = this.baseUrl + "/ProjectTask/selectlistgrouped";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectListGrouped(_response);
        });
    }

    protected processGetSelectListGrouped(response: AxiosResponse): Promise<StSelectListItemGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StSelectListItemGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StSelectListItemGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StSelectListItemGroup[]>(null as any);
    }

    getSelectListForProject(query: ProjectTaskSelectListForProjectQuery, cancelToken?: CancelToken): Promise<StSelectListItemGroup[]> {
        let url_ = this.baseUrl + "/ProjectTask/GetSelectListForProject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectListForProject(_response);
        });
    }

    protected processGetSelectListForProject(response: AxiosResponse): Promise<StSelectListItemGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StSelectListItemGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StSelectListItemGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StSelectListItemGroup[]>(null as any);
    }

    post(projectTaskEditModel: ProjectTaskEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ProjectTask";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(projectTaskEditModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(id: number | undefined, projectTaskEditModel: ProjectTaskEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/ProjectTask?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(projectTaskEditModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class PublicHolidayClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getNew(date: string, publicHolidayGroupId: number, cancelToken?: CancelToken): Promise<PublicHolidayEditModel> {
        let url_ = this.baseUrl + "/PublicHoliday/new/{date}/{publicHolidayGroupId}";
        if (date === undefined || date === null)
            throw new Error("The parameter 'date' must be defined.");
        url_ = url_.replace("{date}", encodeURIComponent("" + date));
        if (publicHolidayGroupId === undefined || publicHolidayGroupId === null)
            throw new Error("The parameter 'publicHolidayGroupId' must be defined.");
        url_ = url_.replace("{publicHolidayGroupId}", encodeURIComponent("" + publicHolidayGroupId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNew(_response);
        });
    }

    protected processGetNew(response: AxiosResponse): Promise<PublicHolidayEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicHolidayEditModel.fromJS(resultData200);
            return Promise.resolve<PublicHolidayEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicHolidayEditModel>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<PublicHolidayEditModel> {
        let url_ = this.baseUrl + "/PublicHoliday/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<PublicHolidayEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicHolidayEditModel.fromJS(resultData200);
            return Promise.resolve<PublicHolidayEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicHolidayEditModel>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/PublicHoliday/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getList(filter: PublicHolidayFilter, cancelToken?: CancelToken): Promise<PublicHolidayViewModel[]> {
        let url_ = this.baseUrl + "/PublicHoliday/getlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<PublicHolidayViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicHolidayViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PublicHolidayViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicHolidayViewModel[]>(null as any);
    }

    getListForCurrentUser(filter: PublicHolidayFilter, cancelToken?: CancelToken): Promise<PublicHolidayViewModel[]> {
        let url_ = this.baseUrl + "/PublicHoliday/getlistForCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListForCurrentUser(_response);
        });
    }

    protected processGetListForCurrentUser(response: AxiosResponse): Promise<PublicHolidayViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicHolidayViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PublicHolidayViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicHolidayViewModel[]>(null as any);
    }

    getOverwrittenAsWorkdayDates(filter: PublicHolidayFilter, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/PublicHoliday/GetOverwrittenAsWorkdayDates";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOverwrittenAsWorkdayDates(_response);
        });
    }

    protected processGetOverwrittenAsWorkdayDates(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    post(editModel: PublicHolidayEditModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/PublicHoliday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    put(editModel: PublicHolidayEditModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/PublicHoliday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    overwriteAsWorkday(editModel: PublicHolidayEditModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/PublicHoliday/overwriteasworkday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processOverwriteAsWorkday(_response);
        });
    }

    protected processOverwriteAsWorkday(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class PublicHolidayGroupClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getNew( cancelToken?: CancelToken): Promise<PublicHolidayGroupEditModel> {
        let url_ = this.baseUrl + "/PublicHolidayGroup/new";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNew(_response);
        });
    }

    protected processGetNew(response: AxiosResponse): Promise<PublicHolidayGroupEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicHolidayGroupEditModel.fromJS(resultData200);
            return Promise.resolve<PublicHolidayGroupEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicHolidayGroupEditModel>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<PublicHolidayGroupEditModel> {
        let url_ = this.baseUrl + "/PublicHolidayGroup/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<PublicHolidayGroupEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicHolidayGroupEditModel.fromJS(resultData200);
            return Promise.resolve<PublicHolidayGroupEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicHolidayGroupEditModel>(null as any);
    }

    delete(id: number, confirmed: boolean | undefined, cancelToken?: CancelToken): Promise<DeleteResultModel> {
        let url_ = this.baseUrl + "/PublicHolidayGroup/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (confirmed === null)
            throw new Error("The parameter 'confirmed' cannot be null.");
        else if (confirmed !== undefined)
            url_ += "confirmed=" + encodeURIComponent("" + confirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<DeleteResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteResultModel.fromJS(resultData200);
            return Promise.resolve<DeleteResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteResultModel>(null as any);
    }

    getGroupedSelectList( cancelToken?: CancelToken): Promise<StSelectListItemGroup[]> {
        let url_ = this.baseUrl + "/PublicHolidayGroup/getgroupedselectlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGroupedSelectList(_response);
        });
    }

    protected processGetGroupedSelectList(response: AxiosResponse): Promise<StSelectListItemGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StSelectListItemGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StSelectListItemGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StSelectListItemGroup[]>(null as any);
    }

    getList(filter: PublicHolidayGroupFilter, cancelToken?: CancelToken): Promise<PublicHolidayGroupViewModel[]> {
        let url_ = this.baseUrl + "/PublicHolidayGroup/getlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<PublicHolidayGroupViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicHolidayGroupViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PublicHolidayGroupViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicHolidayGroupViewModel[]>(null as any);
    }

    post(editModel: PublicHolidayGroupEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/PublicHolidayGroup";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(id: number | undefined, editModel: PublicHolidayGroupEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/PublicHolidayGroup?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class RateRuleClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getNew(parentRateRuleId: number, cancelToken?: CancelToken): Promise<RateRuleEditModel> {
        let url_ = this.baseUrl + "/RateRule/new/{parentRateRuleId}";
        if (parentRateRuleId === undefined || parentRateRuleId === null)
            throw new Error("The parameter 'parentRateRuleId' must be defined.");
        url_ = url_.replace("{parentRateRuleId}", encodeURIComponent("" + parentRateRuleId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNew(_response);
        });
    }

    protected processGetNew(response: AxiosResponse): Promise<RateRuleEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RateRuleEditModel.fromJS(resultData200);
            return Promise.resolve<RateRuleEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RateRuleEditModel>(null as any);
    }

    getLookpus(parentRateRuleId: number | undefined, rateRuleId: number | undefined, cancelToken?: CancelToken): Promise<RateRuleLookupModel> {
        let url_ = this.baseUrl + "/RateRule/getlookups?";
        if (parentRateRuleId === null)
            throw new Error("The parameter 'parentRateRuleId' cannot be null.");
        else if (parentRateRuleId !== undefined)
            url_ += "parentRateRuleId=" + encodeURIComponent("" + parentRateRuleId) + "&";
        if (rateRuleId === null)
            throw new Error("The parameter 'rateRuleId' cannot be null.");
        else if (rateRuleId !== undefined)
            url_ += "rateRuleId=" + encodeURIComponent("" + rateRuleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLookpus(_response);
        });
    }

    protected processGetLookpus(response: AxiosResponse): Promise<RateRuleLookupModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RateRuleLookupModel.fromJS(resultData200);
            return Promise.resolve<RateRuleLookupModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RateRuleLookupModel>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<RateRuleEditModel> {
        let url_ = this.baseUrl + "/RateRule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<RateRuleEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RateRuleEditModel.fromJS(resultData200);
            return Promise.resolve<RateRuleEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RateRuleEditModel>(null as any);
    }

    delete(id: number, cancelToken?: CancelToken): Promise<DeleteResultModel> {
        let url_ = this.baseUrl + "/RateRule/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<DeleteResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteResultModel.fromJS(resultData200);
            return Promise.resolve<DeleteResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteResultModel>(null as any);
    }

    getRules( cancelToken?: CancelToken): Promise<RateRuleViewModel> {
        let url_ = this.baseUrl + "/RateRule/getrules";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRules(_response);
        });
    }

    protected processGetRules(response: AxiosResponse): Promise<RateRuleViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RateRuleViewModel.fromJS(resultData200);
            return Promise.resolve<RateRuleViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RateRuleViewModel>(null as any);
    }

    getCustomerProjectRates( cancelToken?: CancelToken): Promise<RateRuleAmountListModel[]> {
        let url_ = this.baseUrl + "/RateRule/getcustomerprojectrates";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerProjectRates(_response);
        });
    }

    protected processGetCustomerProjectRates(response: AxiosResponse): Promise<RateRuleAmountListModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RateRuleAmountListModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RateRuleAmountListModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RateRuleAmountListModel[]>(null as any);
    }

    getCustomerProjectRateRuleAmount(filter: RateRuleAmountFilter, cancelToken?: CancelToken): Promise<RateRuleAmountModel> {
        let url_ = this.baseUrl + "/RateRule/getcustomerprojectamount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCustomerProjectRateRuleAmount(_response);
        });
    }

    protected processGetCustomerProjectRateRuleAmount(response: AxiosResponse): Promise<RateRuleAmountModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RateRuleAmountModel.fromJS(resultData200);
            return Promise.resolve<RateRuleAmountModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RateRuleAmountModel>(null as any);
    }

    getRateRuleAmount(filter: RateRuleAmountFilter, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/RateRule/getamount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRateRuleAmount(_response);
        });
    }

    protected processGetRateRuleAmount(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    post(editModel: RateRuleEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/RateRule";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(id: number | undefined, editModel: RateRuleEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/RateRule?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    updateSortOrder(editModels: RateRuleSortOrderEditModel[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/RateRule/updatesortorder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModels);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateSortOrder(_response);
        });
    }

    protected processUpdateSortOrder(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteAll( cancelToken?: CancelToken): Promise<DeleteResultModel> {
        let url_ = this.baseUrl + "/RateRule/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteAll(_response);
        });
    }

    protected processDeleteAll(response: AxiosResponse): Promise<DeleteResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteResultModel.fromJS(resultData200);
            return Promise.resolve<DeleteResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteResultModel>(null as any);
    }
}

export class ReportContollerClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    get(filter: TimeEntryFilter, cancelToken?: CancelToken): Promise<ReportViewModel> {
        let url_ = this.baseUrl + "/ReportContoller";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<ReportViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReportViewModel.fromJS(resultData200);
            return Promise.resolve<ReportViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReportViewModel>(null as any);
    }

    getBillableTargetReport(year: number | undefined, last12Months: boolean | undefined, cancelToken?: CancelToken): Promise<BillableTargetReportModel> {
        let url_ = this.baseUrl + "/billabletarget?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (last12Months === null)
            throw new Error("The parameter 'last12Months' cannot be null.");
        else if (last12Months !== undefined)
            url_ += "last12Months=" + encodeURIComponent("" + last12Months) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBillableTargetReport(_response);
        });
    }

    protected processGetBillableTargetReport(response: AxiosResponse): Promise<BillableTargetReportModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BillableTargetReportModel.fromJS(resultData200);
            return Promise.resolve<BillableTargetReportModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BillableTargetReportModel>(null as any);
    }
}

export class RoleClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getList( cancelToken?: CancelToken): Promise<RoleViewModel[]> {
        let url_ = this.baseUrl + "/Role/getlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<RoleViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<RoleViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RoleViewModel[]>(null as any);
    }
}

export class StopwatchClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getRunning( cancelToken?: CancelToken): Promise<StopwatchViewModel> {
        let url_ = this.baseUrl + "/Stopwatch/getrunning";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRunning(_response);
        });
    }

    protected processGetRunning(response: AxiosResponse): Promise<StopwatchViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StopwatchViewModel.fromJS(resultData200);
            return Promise.resolve<StopwatchViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StopwatchViewModel>(null as any);
    }

    getEditModel( cancelToken?: CancelToken): Promise<StopwatchEditModel> {
        let url_ = this.baseUrl + "/Stopwatch/editmodel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEditModel(_response);
        });
    }

    protected processGetEditModel(response: AxiosResponse): Promise<StopwatchEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StopwatchEditModel.fromJS(resultData200);
            return Promise.resolve<StopwatchEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StopwatchEditModel>(null as any);
    }

    getNewEditModel( cancelToken?: CancelToken): Promise<StopwatchEditModel> {
        let url_ = this.baseUrl + "/Stopwatch/new";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNewEditModel(_response);
        });
    }

    protected processGetNewEditModel(response: AxiosResponse): Promise<StopwatchEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StopwatchEditModel.fromJS(resultData200);
            return Promise.resolve<StopwatchEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StopwatchEditModel>(null as any);
    }

    getServerDiff(clientDateTime: string | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Stopwatch/getserverdiff?";
        if (clientDateTime === null)
            throw new Error("The parameter 'clientDateTime' cannot be null.");
        else if (clientDateTime !== undefined)
            url_ += "clientDateTime=" + encodeURIComponent("" + clientDateTime) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServerDiff(_response);
        });
    }

    protected processGetServerDiff(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    start(editModel: StopwatchEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Stopwatch/start";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStart(_response);
        });
    }

    protected processStart(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    startForProject(projectId: number, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Stopwatch/startforproject/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStartForProject(_response);
        });
    }

    protected processStartForProject(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    resume(timeEntryId: number | undefined, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Stopwatch/resume?";
        if (timeEntryId === null)
            throw new Error("The parameter 'timeEntryId' cannot be null.");
        else if (timeEntryId !== undefined)
            url_ += "timeEntryId=" + encodeURIComponent("" + timeEntryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResume(_response);
        });
    }

    protected processResume(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    edit(editModel: StopwatchEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Stopwatch/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEdit(_response);
        });
    }

    protected processEdit(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    stop( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Stopwatch/stop";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStop(_response);
        });
    }

    protected processStop(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    stopAndGetTimeEntryEditModel( cancelToken?: CancelToken): Promise<TimeEntryEditModel> {
        let url_ = this.baseUrl + "/Stopwatch/StopAndGetTimeEntryEditModel";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStopAndGetTimeEntryEditModel(_response);
        });
    }

    protected processStopAndGetTimeEntryEditModel(response: AxiosResponse): Promise<TimeEntryEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TimeEntryEditModel.fromJS(resultData200);
            return Promise.resolve<TimeEntryEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeEntryEditModel>(null as any);
    }

    delete( cancelToken?: CancelToken): Promise<DeleteResultModel> {
        let url_ = this.baseUrl + "/Stopwatch/delete";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<DeleteResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteResultModel.fromJS(resultData200);
            return Promise.resolve<DeleteResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteResultModel>(null as any);
    }
}

export class SupportClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    sendSupportRequest(supportRequestModel: SupportRequestModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/Support";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(supportRequestModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendSupportRequest(_response);
        });
    }

    protected processSendSupportRequest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TagClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getNew( cancelToken?: CancelToken): Promise<TagEditModel> {
        let url_ = this.baseUrl + "/Tag/new";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNew(_response);
        });
    }

    protected processGetNew(response: AxiosResponse): Promise<TagEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TagEditModel.fromJS(resultData200);
            return Promise.resolve<TagEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagEditModel>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<TagEditModel> {
        let url_ = this.baseUrl + "/Tag/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<TagEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TagEditModel.fromJS(resultData200);
            return Promise.resolve<TagEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagEditModel>(null as any);
    }

    delete(id: number, confirmed: boolean | undefined, cancelToken?: CancelToken): Promise<DeleteResultModel> {
        let url_ = this.baseUrl + "/Tag/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (confirmed === null)
            throw new Error("The parameter 'confirmed' cannot be null.");
        else if (confirmed !== undefined)
            url_ += "confirmed=" + encodeURIComponent("" + confirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<DeleteResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteResultModel.fromJS(resultData200);
            return Promise.resolve<DeleteResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteResultModel>(null as any);
    }

    getList(filter: TagFilter, cancelToken?: CancelToken): Promise<TagViewModel[]> {
        let url_ = this.baseUrl + "/Tag/getlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<TagViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TagViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TagViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagViewModel[]>(null as any);
    }

    getListForTimeEntry(timeEntryId: number, cancelToken?: CancelToken): Promise<TagViewModel[]> {
        let url_ = this.baseUrl + "/Tag/GetListForTimeEntry/{timeEntryId}";
        if (timeEntryId === undefined || timeEntryId === null)
            throw new Error("The parameter 'timeEntryId' must be defined.");
        url_ = url_.replace("{timeEntryId}", encodeURIComponent("" + timeEntryId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListForTimeEntry(_response);
        });
    }

    protected processGetListForTimeEntry(response: AxiosResponse): Promise<TagViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TagViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TagViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TagViewModel[]>(null as any);
    }

    getSelectListForFilter(filter: TagFilter | undefined, cancelToken?: CancelToken): Promise<StSelectListItemGroup[]> {
        let url_ = this.baseUrl + "/Tag/SelectlistForFilter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectListForFilter(_response);
        });
    }

    protected processGetSelectListForFilter(response: AxiosResponse): Promise<StSelectListItemGroup[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(StSelectListItemGroup.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<StSelectListItemGroup[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StSelectListItemGroup[]>(null as any);
    }

    post(editModel: TagEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Tag";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(id: number | undefined, editModel: TagEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/Tag?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class TeamOverviewClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getTimeEntryStats(year: number | undefined, cancelToken?: CancelToken): Promise<TeamOverviewTimeValidationModel> {
        let url_ = this.baseUrl + "/TeamOverview/GetTimeEntryStats?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeEntryStats(_response);
        });
    }

    protected processGetTimeEntryStats(response: AxiosResponse): Promise<TeamOverviewTimeValidationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TeamOverviewTimeValidationModel.fromJS(resultData200);
            return Promise.resolve<TeamOverviewTimeValidationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TeamOverviewTimeValidationModel>(null as any);
    }

    getTimeEntryStatsMonth(year: number | undefined, month: number | undefined, showOverallBalance: boolean | undefined, cancelToken?: CancelToken): Promise<TeamOverviewTimeValidationModel> {
        let url_ = this.baseUrl + "/TeamOverview/GetTimeEntryStatsMonth?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "month=" + encodeURIComponent("" + month) + "&";
        if (showOverallBalance === null)
            throw new Error("The parameter 'showOverallBalance' cannot be null.");
        else if (showOverallBalance !== undefined)
            url_ += "showOverallBalance=" + encodeURIComponent("" + showOverallBalance) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeEntryStatsMonth(_response);
        });
    }

    protected processGetTimeEntryStatsMonth(response: AxiosResponse): Promise<TeamOverviewTimeValidationModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TeamOverviewTimeValidationModel.fromJS(resultData200);
            return Promise.resolve<TeamOverviewTimeValidationModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TeamOverviewTimeValidationModel>(null as any);
    }

    getPauseRules(date: string | undefined, cancelToken?: CancelToken): Promise<TeamOverviewApprovalModel> {
        let url_ = this.baseUrl + "/TeamOverview/GetPauseRules?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPauseRules(_response);
        });
    }

    protected processGetPauseRules(response: AxiosResponse): Promise<TeamOverviewApprovalModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TeamOverviewApprovalModel.fromJS(resultData200);
            return Promise.resolve<TeamOverviewApprovalModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TeamOverviewApprovalModel>(null as any);
    }

    sendTimeEntrySummaryMail( cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/sendtimeentrysummarymail";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSendTimeEntrySummaryMail(_response);
        });
    }

    protected processSendTimeEntrySummaryMail(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    downloadMonthData(year: number, month: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/downloadmonthdata/{year}/{month}";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined.");
        url_ = url_.replace("{month}", encodeURIComponent("" + month));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadMonthData(_response);
        });
    }

    protected processDownloadMonthData(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadYearData(year: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/downloadyeardata/{year}";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadYearData(_response);
        });
    }

    protected processDownloadYearData(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    downloadNightWorkData(year: number, month: number, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/downloadnightworkdata/{year}/{month}";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        if (month === undefined || month === null)
            throw new Error("The parameter 'month' must be defined.");
        url_ = url_.replace("{month}", encodeURIComponent("" + month));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDownloadNightWorkData(_response);
        });
    }

    protected processDownloadNightWorkData(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export class TimeAccountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getTimeAccount(year: number | undefined, appUserId: number | null | undefined, cancelToken?: CancelToken): Promise<TimeAccountYearViewModel> {
        let url_ = this.baseUrl + "/TimeAccount?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (appUserId !== undefined && appUserId !== null)
            url_ += "appUserId=" + encodeURIComponent("" + appUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeAccount(_response);
        });
    }

    protected processGetTimeAccount(response: AxiosResponse): Promise<TimeAccountYearViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TimeAccountYearViewModel.fromJS(resultData200);
            return Promise.resolve<TimeAccountYearViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeAccountYearViewModel>(null as any);
    }

    approveOverTimeWeek(command: TimeAccountWeekOvertimeApproveCommand, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/TimeAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processApproveOverTimeWeek(_response);
        });
    }

    protected processApproveOverTimeWeek(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getTimeAccountSummary(year: number | undefined, appUserId: number | null | undefined, cancelToken?: CancelToken): Promise<TimeAccountSummaryModel> {
        let url_ = this.baseUrl + "/TimeAccount/summary?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (appUserId !== undefined && appUserId !== null)
            url_ += "appUserId=" + encodeURIComponent("" + appUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeAccountSummary(_response);
        });
    }

    protected processGetTimeAccountSummary(response: AxiosResponse): Promise<TimeAccountSummaryModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TimeAccountSummaryModel.fromJS(resultData200);
            return Promise.resolve<TimeAccountSummaryModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeAccountSummaryModel>(null as any);
    }

    getTimeAccountUserViewModel(appUserId: number | null | undefined, cancelToken?: CancelToken): Promise<TimeAccountUserViewModel> {
        let url_ = this.baseUrl + "/TimeAccount/usermodel?";
        if (appUserId !== undefined && appUserId !== null)
            url_ += "appUserId=" + encodeURIComponent("" + appUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeAccountUserViewModel(_response);
        });
    }

    protected processGetTimeAccountUserViewModel(response: AxiosResponse): Promise<TimeAccountUserViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TimeAccountUserViewModel.fromJS(resultData200);
            return Promise.resolve<TimeAccountUserViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeAccountUserViewModel>(null as any);
    }

    getTimeAccountSummaryForTimeEntriesPage(query: TimeAccountSummaryQuery, cancelToken?: CancelToken): Promise<TimeAccountSummaryTimeEntryPageModel> {
        let url_ = this.baseUrl + "/TimeAccount/timeaccount-summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeAccountSummaryForTimeEntriesPage(_response);
        });
    }

    protected processGetTimeAccountSummaryForTimeEntriesPage(response: AxiosResponse): Promise<TimeAccountSummaryTimeEntryPageModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TimeAccountSummaryTimeEntryPageModel.fromJS(resultData200);
            return Promise.resolve<TimeAccountSummaryTimeEntryPageModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeAccountSummaryTimeEntryPageModel>(null as any);
    }

    getTimeAccountTeamWeeklyOverview(query: TimeAccountTeamWeeklyOverviewQuery, cancelToken?: CancelToken): Promise<TimeAccountTeamWeeklyOverviewModel> {
        let url_ = this.baseUrl + "/TimeAccount/timeaccount-team-weekly-overview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeAccountTeamWeeklyOverview(_response);
        });
    }

    protected processGetTimeAccountTeamWeeklyOverview(response: AxiosResponse): Promise<TimeAccountTeamWeeklyOverviewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TimeAccountTeamWeeklyOverviewModel.fromJS(resultData200);
            return Promise.resolve<TimeAccountTeamWeeklyOverviewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeAccountTeamWeeklyOverviewModel>(null as any);
    }
}

export class TimeAdjustmentClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getNew(appUserId: number | undefined, date: string | null | undefined, cancelToken?: CancelToken): Promise<TimeAdjustmentEditModel> {
        let url_ = this.baseUrl + "/TimeAdjustment/new?";
        if (appUserId === null)
            throw new Error("The parameter 'appUserId' cannot be null.");
        else if (appUserId !== undefined)
            url_ += "appUserId=" + encodeURIComponent("" + appUserId) + "&";
        if (date !== undefined && date !== null)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNew(_response);
        });
    }

    protected processGetNew(response: AxiosResponse): Promise<TimeAdjustmentEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TimeAdjustmentEditModel.fromJS(resultData200);
            return Promise.resolve<TimeAdjustmentEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeAdjustmentEditModel>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<TimeAdjustmentEditModel> {
        let url_ = this.baseUrl + "/TimeAdjustment/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<TimeAdjustmentEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TimeAdjustmentEditModel.fromJS(resultData200);
            return Promise.resolve<TimeAdjustmentEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeAdjustmentEditModel>(null as any);
    }

    delete(id: number, confirmed: boolean | undefined, cancelToken?: CancelToken): Promise<DeleteResultModel> {
        let url_ = this.baseUrl + "/TimeAdjustment/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (confirmed === null)
            throw new Error("The parameter 'confirmed' cannot be null.");
        else if (confirmed !== undefined)
            url_ += "confirmed=" + encodeURIComponent("" + confirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<DeleteResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteResultModel.fromJS(resultData200);
            return Promise.resolve<DeleteResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteResultModel>(null as any);
    }

    getList(filter: TimeAdjustmentFilter, cancelToken?: CancelToken): Promise<TimeAdjustmentViewModel[]> {
        let url_ = this.baseUrl + "/TimeAdjustment/getlist";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(filter);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<TimeAdjustmentViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeAdjustmentViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TimeAdjustmentViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeAdjustmentViewModel[]>(null as any);
    }

    post(editModel: TimeAdjustmentEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TimeAdjustment";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(id: number | undefined, editModel: TimeAdjustmentEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TimeAdjustment?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class TimeEntryClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    get(id: number, cancelToken?: CancelToken): Promise<TimeEntryEditModel> {
        let url_ = this.baseUrl + "/TimeEntry/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<TimeEntryEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TimeEntryEditModel.fromJS(resultData200);
            return Promise.resolve<TimeEntryEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeEntryEditModel>(null as any);
    }

    delete(id: number, confirmed: boolean | undefined, cancelToken?: CancelToken): Promise<DeleteResultModel> {
        let url_ = this.baseUrl + "/TimeEntry/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (confirmed === null)
            throw new Error("The parameter 'confirmed' cannot be null.");
        else if (confirmed !== undefined)
            url_ += "confirmed=" + encodeURIComponent("" + confirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<DeleteResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteResultModel.fromJS(resultData200);
            return Promise.resolve<DeleteResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteResultModel>(null as any);
    }

    getSelectLists( cancelToken?: CancelToken): Promise<TimeEntrySelectLists> {
        let url_ = this.baseUrl + "/TimeEntry/SelectLists";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectLists(_response);
        });
    }

    protected processGetSelectLists(response: AxiosResponse): Promise<TimeEntrySelectLists> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TimeEntrySelectLists.fromJS(resultData200);
            return Promise.resolve<TimeEntrySelectLists>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeEntrySelectLists>(null as any);
    }

    getPauseRulesForCurrentUser( cancelToken?: CancelToken): Promise<TimeEntryPauseRuleModel> {
        let url_ = this.baseUrl + "/TimeEntry/GetPauseRulesForCurrentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPauseRulesForCurrentUser(_response);
        });
    }

    protected processGetPauseRulesForCurrentUser(response: AxiosResponse): Promise<TimeEntryPauseRuleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TimeEntryPauseRuleModel.fromJS(resultData200);
            return Promise.resolve<TimeEntryPauseRuleModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeEntryPauseRuleModel>(null as any);
    }

    getPauseRules(appUserId: number, cancelToken?: CancelToken): Promise<TimeEntryPauseRuleModel> {
        let url_ = this.baseUrl + "/TimeEntry/GetPauseRules/{appUserId}";
        if (appUserId === undefined || appUserId === null)
            throw new Error("The parameter 'appUserId' must be defined.");
        url_ = url_.replace("{appUserId}", encodeURIComponent("" + appUserId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPauseRules(_response);
        });
    }

    protected processGetPauseRules(response: AxiosResponse): Promise<TimeEntryPauseRuleModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TimeEntryPauseRuleModel.fromJS(resultData200);
            return Promise.resolve<TimeEntryPauseRuleModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeEntryPauseRuleModel>(null as any);
    }

    getIsTimeFromToByProject(projectId: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/TimeEntry/istimefromto/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIsTimeFromToByProject(_response);
        });
    }

    protected processGetIsTimeFromToByProject(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    getPreviousDescriptions(entryDate: string | undefined, projectId: number | undefined, cancelToken?: CancelToken): Promise<string[]> {
        let url_ = this.baseUrl + "/TimeEntry/previousdescriptions?";
        if (entryDate === null)
            throw new Error("The parameter 'entryDate' cannot be null.");
        else if (entryDate !== undefined)
            url_ += "entryDate=" + encodeURIComponent("" + entryDate) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPreviousDescriptions(_response);
        });
    }

    protected processGetPreviousDescriptions(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }

    getNew(type: TimeEntryTypeEnum | undefined, selectedDate: string | undefined, cancelToken?: CancelToken): Promise<TimeEntryEditModel> {
        let url_ = this.baseUrl + "/TimeEntry/new?";
        if (type === null)
            throw new Error("The parameter 'type' cannot be null.");
        else if (type !== undefined)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        if (selectedDate === null)
            throw new Error("The parameter 'selectedDate' cannot be null.");
        else if (selectedDate !== undefined)
            url_ += "selectedDate=" + encodeURIComponent("" + selectedDate) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNew(_response);
        });
    }

    protected processGetNew(response: AxiosResponse): Promise<TimeEntryEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TimeEntryEditModel.fromJS(resultData200);
            return Promise.resolve<TimeEntryEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeEntryEditModel>(null as any);
    }

    getList(cw: number | undefined, year: number | undefined, cancelToken?: CancelToken): Promise<TimeEntryDay[]> {
        let url_ = this.baseUrl + "/TimeEntry?";
        if (cw === null)
            throw new Error("The parameter 'cw' cannot be null.");
        else if (cw !== undefined)
            url_ += "cw=" + encodeURIComponent("" + cw) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<TimeEntryDay[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeEntryDay.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TimeEntryDay[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeEntryDay[]>(null as any);
    }

    post(timeEntryEditModel: TimeEntryEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TimeEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(timeEntryEditModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(id: number | undefined, timeEntryEditModel: TimeEntryEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TimeEntry?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(timeEntryEditModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getListForUser(cw: number | undefined, year: number | undefined, appUserId: number | undefined, cancelToken?: CancelToken): Promise<TimeEntryDay[]> {
        let url_ = this.baseUrl + "/TimeEntry/GetListForUser?";
        if (cw === null)
            throw new Error("The parameter 'cw' cannot be null.");
        else if (cw !== undefined)
            url_ += "cw=" + encodeURIComponent("" + cw) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "year=" + encodeURIComponent("" + year) + "&";
        if (appUserId === null)
            throw new Error("The parameter 'appUserId' cannot be null.");
        else if (appUserId !== undefined)
            url_ += "appUserId=" + encodeURIComponent("" + appUserId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetListForUser(_response);
        });
    }

    protected processGetListForUser(response: AxiosResponse): Promise<TimeEntryDay[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeEntryDay.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TimeEntryDay[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeEntryDay[]>(null as any);
    }

    toggleCleared(id: number, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/TimeEntry/clear/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processToggleCleared(_response);
        });
    }

    protected processToggleCleared(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    moveTimeEntry(id: number, newDate: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/TimeEntry/move/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newDate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMoveTimeEntry(_response);
        });
    }

    protected processMoveTimeEntry(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    copyTimeEntry(id: number, newDate: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/TimeEntry/copy/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(newDate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyTimeEntry(_response);
        });
    }

    protected processCopyTimeEntry(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    copyLastWorkday(userId: number | undefined, selectedDate: string, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TimeEntry/copylastworkday?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selectedDate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyLastWorkday(_response);
        });
    }

    protected processCopyLastWorkday(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    copyDayPreviousWeek(userId: number | undefined, selectedDate: string, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TimeEntry/copydaypreviousweek?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(selectedDate);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCopyDayPreviousWeek(_response);
        });
    }

    protected processCopyDayPreviousWeek(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    undelete(id: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/TimeEntry/undelete/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUndelete(_response);
        });
    }

    protected processUndelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TimeEntryDayApprovalClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getTeamOverviewApprovalModel(date: string | undefined, cancelToken?: CancelToken): Promise<TeamOverviewApprovalModel> {
        let url_ = this.baseUrl + "/teamoverviewapprovals?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTeamOverviewApprovalModel(_response);
        });
    }

    protected processGetTeamOverviewApprovalModel(response: AxiosResponse): Promise<TeamOverviewApprovalModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TeamOverviewApprovalModel.fromJS(resultData200);
            return Promise.resolve<TeamOverviewApprovalModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TeamOverviewApprovalModel>(null as any);
    }

    getTimeEntryDayApprovalEditModel(appUserId: number | undefined, date: string | undefined, mode: string | null | undefined, cancelToken?: CancelToken): Promise<TimeEntryDayApprovalEditModel> {
        let url_ = this.baseUrl + "/TimeEntryDayApproval?";
        if (appUserId === null)
            throw new Error("The parameter 'appUserId' cannot be null.");
        else if (appUserId !== undefined)
            url_ += "appUserId=" + encodeURIComponent("" + appUserId) + "&";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "date=" + encodeURIComponent("" + date) + "&";
        if (mode !== undefined && mode !== null)
            url_ += "mode=" + encodeURIComponent("" + mode) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeEntryDayApprovalEditModel(_response);
        });
    }

    protected processGetTimeEntryDayApprovalEditModel(response: AxiosResponse): Promise<TimeEntryDayApprovalEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TimeEntryDayApprovalEditModel.fromJS(resultData200);
            return Promise.resolve<TimeEntryDayApprovalEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeEntryDayApprovalEditModel>(null as any);
    }

    setTimeEntryDayApproval(editModel: TimeEntryDayApprovalEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TimeEntryDayApproval";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetTimeEntryDayApproval(_response);
        });
    }

    protected processSetTimeEntryDayApproval(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getNoOfOpenApprovals( cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/GetNoOfOpenApprovals";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNoOfOpenApprovals(_response);
        });
    }

    protected processGetNoOfOpenApprovals(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class TimeEntryExtraFieldMetadataClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    getSelectList( cancelToken?: CancelToken): Promise<TimeEntryExtraFieldDataTypeSelectItem[]> {
        let url_ = this.baseUrl + "/TimeEntryExtraFieldMetadata/selectlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSelectList(_response);
        });
    }

    protected processGetSelectList(response: AxiosResponse): Promise<TimeEntryExtraFieldDataTypeSelectItem[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeEntryExtraFieldDataTypeSelectItem.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TimeEntryExtraFieldDataTypeSelectItem[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeEntryExtraFieldDataTypeSelectItem[]>(null as any);
    }

    getNew( cancelToken?: CancelToken): Promise<TimeEntryExtraFieldMetadataEditModel> {
        let url_ = this.baseUrl + "/TimeEntryExtraFieldMetadata/new";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetNew(_response);
        });
    }

    protected processGetNew(response: AxiosResponse): Promise<TimeEntryExtraFieldMetadataEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TimeEntryExtraFieldMetadataEditModel.fromJS(resultData200);
            return Promise.resolve<TimeEntryExtraFieldMetadataEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeEntryExtraFieldMetadataEditModel>(null as any);
    }

    get(id: number, cancelToken?: CancelToken): Promise<TimeEntryExtraFieldMetadataEditModel> {
        let url_ = this.baseUrl + "/TimeEntryExtraFieldMetadata/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<TimeEntryExtraFieldMetadataEditModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TimeEntryExtraFieldMetadataEditModel.fromJS(resultData200);
            return Promise.resolve<TimeEntryExtraFieldMetadataEditModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeEntryExtraFieldMetadataEditModel>(null as any);
    }

    delete(id: number, confirmed: boolean | undefined, cancelToken?: CancelToken): Promise<DeleteResultModel> {
        let url_ = this.baseUrl + "/TimeEntryExtraFieldMetadata/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (confirmed === null)
            throw new Error("The parameter 'confirmed' cannot be null.");
        else if (confirmed !== undefined)
            url_ += "confirmed=" + encodeURIComponent("" + confirmed) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<DeleteResultModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteResultModel.fromJS(resultData200);
            return Promise.resolve<DeleteResultModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteResultModel>(null as any);
    }

    getList( cancelToken?: CancelToken): Promise<TimeEntryExtraFieldMetadataViewModel[]> {
        let url_ = this.baseUrl + "/TimeEntryExtraFieldMetadata/getlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<TimeEntryExtraFieldMetadataViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeEntryExtraFieldMetadataViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TimeEntryExtraFieldMetadataViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeEntryExtraFieldMetadataViewModel[]>(null as any);
    }

    post(editModel: TimeEntryExtraFieldMetadataEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TimeEntryExtraFieldMetadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(editModel: TimeEntryExtraFieldMetadataEditModel, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/TimeEntryExtraFieldMetadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class TransferAccountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    transferAccount(transferAccountModel: TransferAccountModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/TransferAccount/transferaccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(transferAccountModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTransferAccount(_response);
        });
    }

    protected processTransferAccount(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ApiLogClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "http://localhost:5000";

    }

    log(logModel: LogModel, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/v3/log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(logModel);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLog(_response);
        });
    }

    protected processLog(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class AbsenceEditModel implements IAbsenceEditModel {
    id?: number;
    description?: string | undefined;
    dateFrom?: string;
    dateTo?: string;
    isHalfDay?: boolean;
    absenceTypeId?: number;
    appUserId?: number;
    isReadOnly?: boolean;
    insertedFromApi?: boolean;

    constructor(data?: IAbsenceEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
            this.isHalfDay = _data["isHalfDay"];
            this.absenceTypeId = _data["absenceTypeId"];
            this.appUserId = _data["appUserId"];
            this.isReadOnly = _data["isReadOnly"];
            this.insertedFromApi = _data["insertedFromApi"];
        }
    }

    static fromJS(data: any): AbsenceEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        data["isHalfDay"] = this.isHalfDay;
        data["absenceTypeId"] = this.absenceTypeId;
        data["appUserId"] = this.appUserId;
        data["isReadOnly"] = this.isReadOnly;
        data["insertedFromApi"] = this.insertedFromApi;
        return data;
    }
}

export interface IAbsenceEditModel {
    id?: number;
    description?: string | undefined;
    dateFrom?: string;
    dateTo?: string;
    isHalfDay?: boolean;
    absenceTypeId?: number;
    appUserId?: number;
    isReadOnly?: boolean;
    insertedFromApi?: boolean;
}

export class AbsenceTypeViewModel implements IAbsenceTypeViewModel {
    id?: number;
    approvalNeeded?: boolean;
    allowHalfDay?: boolean;
    useOvertime?: boolean;
    isVacation?: boolean;
    description?: string | undefined;
    badgeText?: string | undefined;
    isUserAddable?: boolean;
    absenceTypeEnum?: AbsenceTypeEnum;
    isArchived?: boolean;

    constructor(data?: IAbsenceTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.approvalNeeded = _data["approvalNeeded"];
            this.allowHalfDay = _data["allowHalfDay"];
            this.useOvertime = _data["useOvertime"];
            this.isVacation = _data["isVacation"];
            this.description = _data["description"];
            this.badgeText = _data["badgeText"];
            this.isUserAddable = _data["isUserAddable"];
            this.absenceTypeEnum = _data["absenceTypeEnum"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): AbsenceTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["approvalNeeded"] = this.approvalNeeded;
        data["allowHalfDay"] = this.allowHalfDay;
        data["useOvertime"] = this.useOvertime;
        data["isVacation"] = this.isVacation;
        data["description"] = this.description;
        data["badgeText"] = this.badgeText;
        data["isUserAddable"] = this.isUserAddable;
        data["absenceTypeEnum"] = this.absenceTypeEnum;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface IAbsenceTypeViewModel {
    id?: number;
    approvalNeeded?: boolean;
    allowHalfDay?: boolean;
    useOvertime?: boolean;
    isVacation?: boolean;
    description?: string | undefined;
    badgeText?: string | undefined;
    isUserAddable?: boolean;
    absenceTypeEnum?: AbsenceTypeEnum;
    isArchived?: boolean;
}

export enum AbsenceTypeEnum {
    Vacation = "Vacation",
    Overtime = "Overtime",
    Sick = "Sick",
    Other = "Other",
}

export class AbsenceUserViewModel implements IAbsenceUserViewModel {
    appUser?: AppUserViewModel | undefined;
    absences?: AbsenceViewModel[] | undefined;
    publicHolidays?: PublicHolidayViewModel[] | undefined;

    constructor(data?: IAbsenceUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appUser = _data["appUser"] ? AppUserViewModel.fromJS(_data["appUser"]) : <any>undefined;
            if (Array.isArray(_data["absences"])) {
                this.absences = [] as any;
                for (let item of _data["absences"])
                    this.absences!.push(AbsenceViewModel.fromJS(item));
            }
            if (Array.isArray(_data["publicHolidays"])) {
                this.publicHolidays = [] as any;
                for (let item of _data["publicHolidays"])
                    this.publicHolidays!.push(PublicHolidayViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AbsenceUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appUser"] = this.appUser ? this.appUser.toJSON() : <any>undefined;
        if (Array.isArray(this.absences)) {
            data["absences"] = [];
            for (let item of this.absences)
                data["absences"].push(item.toJSON());
        }
        if (Array.isArray(this.publicHolidays)) {
            data["publicHolidays"] = [];
            for (let item of this.publicHolidays)
                data["publicHolidays"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAbsenceUserViewModel {
    appUser?: AppUserViewModel | undefined;
    absences?: AbsenceViewModel[] | undefined;
    publicHolidays?: PublicHolidayViewModel[] | undefined;
}

export class AppUserViewModel implements IAppUserViewModel {
    id?: number;
    guid?: string;
    name?: string | undefined;
    email?: string | undefined;
    isArchived?: boolean;
    timeEntriesShowFullWeek?: boolean;
    firstDayOfWeek?: DayOfWeek;
    datePattern?: string | undefined;
    timePattern?: string | undefined;
    stopWatchNotficationEnabled?: boolean;
    timeEntryNotificationEnabled?: boolean;
    useWorkHours?: boolean;
    timeRoundingInterval?: number;
    isAdmin?: boolean;
    isActive?: boolean;
    roleName?: string | undefined;
    timeAccountDisplayDetails?: boolean;
    managerName?: string | undefined;
    managerId?: number | undefined;
    isPassiveUser?: boolean;
    isPassiveUserManager?: boolean;
    isBasicTimeTrackingUser?: boolean;
    tempUseNewTimeAccountSummary?: boolean;

    constructor(data?: IAppUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.isArchived = _data["isArchived"];
            this.timeEntriesShowFullWeek = _data["timeEntriesShowFullWeek"];
            this.firstDayOfWeek = _data["firstDayOfWeek"];
            this.datePattern = _data["datePattern"];
            this.timePattern = _data["timePattern"];
            this.stopWatchNotficationEnabled = _data["stopWatchNotficationEnabled"];
            this.timeEntryNotificationEnabled = _data["timeEntryNotificationEnabled"];
            this.useWorkHours = _data["useWorkHours"];
            this.timeRoundingInterval = _data["timeRoundingInterval"];
            this.isAdmin = _data["isAdmin"];
            this.isActive = _data["isActive"];
            this.roleName = _data["roleName"];
            this.timeAccountDisplayDetails = _data["timeAccountDisplayDetails"];
            this.managerName = _data["managerName"];
            this.managerId = _data["managerId"];
            this.isPassiveUser = _data["isPassiveUser"];
            this.isPassiveUserManager = _data["isPassiveUserManager"];
            this.isBasicTimeTrackingUser = _data["isBasicTimeTrackingUser"];
            this.tempUseNewTimeAccountSummary = _data["tempUseNewTimeAccountSummary"];
        }
    }

    static fromJS(data: any): AppUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["email"] = this.email;
        data["isArchived"] = this.isArchived;
        data["timeEntriesShowFullWeek"] = this.timeEntriesShowFullWeek;
        data["firstDayOfWeek"] = this.firstDayOfWeek;
        data["datePattern"] = this.datePattern;
        data["timePattern"] = this.timePattern;
        data["stopWatchNotficationEnabled"] = this.stopWatchNotficationEnabled;
        data["timeEntryNotificationEnabled"] = this.timeEntryNotificationEnabled;
        data["useWorkHours"] = this.useWorkHours;
        data["timeRoundingInterval"] = this.timeRoundingInterval;
        data["isAdmin"] = this.isAdmin;
        data["isActive"] = this.isActive;
        data["roleName"] = this.roleName;
        data["timeAccountDisplayDetails"] = this.timeAccountDisplayDetails;
        data["managerName"] = this.managerName;
        data["managerId"] = this.managerId;
        data["isPassiveUser"] = this.isPassiveUser;
        data["isPassiveUserManager"] = this.isPassiveUserManager;
        data["isBasicTimeTrackingUser"] = this.isBasicTimeTrackingUser;
        data["tempUseNewTimeAccountSummary"] = this.tempUseNewTimeAccountSummary;
        return data;
    }
}

export interface IAppUserViewModel {
    id?: number;
    guid?: string;
    name?: string | undefined;
    email?: string | undefined;
    isArchived?: boolean;
    timeEntriesShowFullWeek?: boolean;
    firstDayOfWeek?: DayOfWeek;
    datePattern?: string | undefined;
    timePattern?: string | undefined;
    stopWatchNotficationEnabled?: boolean;
    timeEntryNotificationEnabled?: boolean;
    useWorkHours?: boolean;
    timeRoundingInterval?: number;
    isAdmin?: boolean;
    isActive?: boolean;
    roleName?: string | undefined;
    timeAccountDisplayDetails?: boolean;
    managerName?: string | undefined;
    managerId?: number | undefined;
    isPassiveUser?: boolean;
    isPassiveUserManager?: boolean;
    isBasicTimeTrackingUser?: boolean;
    tempUseNewTimeAccountSummary?: boolean;
}

export enum DayOfWeek {
    Sunday = "Sunday",
    Monday = "Monday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
    Thursday = "Thursday",
    Friday = "Friday",
    Saturday = "Saturday",
}

export class AbsenceViewModel implements IAbsenceViewModel {
    id?: number;
    description?: string | undefined;
    dateFrom?: string;
    dateTo?: string;
    isVacationDay?: boolean;
    useOvertime?: boolean;
    isApprovalDecided?: boolean;
    isApproved?: boolean;
    isDeclined?: boolean;
    absenceType?: AbsenceTypeViewModel | undefined;
    isHalfDay?: boolean;
    appUserName?: string | undefined;
    appUserId?: number;
    isReadOnly?: boolean;
    startDayOfYear?: number;
    durationDays?: number;
    startsLastYear?: boolean;
    endsNextYear?: boolean;

    constructor(data?: IAbsenceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
            this.isVacationDay = _data["isVacationDay"];
            this.useOvertime = _data["useOvertime"];
            this.isApprovalDecided = _data["isApprovalDecided"];
            this.isApproved = _data["isApproved"];
            this.isDeclined = _data["isDeclined"];
            this.absenceType = _data["absenceType"] ? AbsenceTypeViewModel.fromJS(_data["absenceType"]) : <any>undefined;
            this.isHalfDay = _data["isHalfDay"];
            this.appUserName = _data["appUserName"];
            this.appUserId = _data["appUserId"];
            this.isReadOnly = _data["isReadOnly"];
            this.startDayOfYear = _data["startDayOfYear"];
            this.durationDays = _data["durationDays"];
            this.startsLastYear = _data["startsLastYear"];
            this.endsNextYear = _data["endsNextYear"];
        }
    }

    static fromJS(data: any): AbsenceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        data["isVacationDay"] = this.isVacationDay;
        data["useOvertime"] = this.useOvertime;
        data["isApprovalDecided"] = this.isApprovalDecided;
        data["isApproved"] = this.isApproved;
        data["isDeclined"] = this.isDeclined;
        data["absenceType"] = this.absenceType ? this.absenceType.toJSON() : <any>undefined;
        data["isHalfDay"] = this.isHalfDay;
        data["appUserName"] = this.appUserName;
        data["appUserId"] = this.appUserId;
        data["isReadOnly"] = this.isReadOnly;
        data["startDayOfYear"] = this.startDayOfYear;
        data["durationDays"] = this.durationDays;
        data["startsLastYear"] = this.startsLastYear;
        data["endsNextYear"] = this.endsNextYear;
        return data;
    }
}

export interface IAbsenceViewModel {
    id?: number;
    description?: string | undefined;
    dateFrom?: string;
    dateTo?: string;
    isVacationDay?: boolean;
    useOvertime?: boolean;
    isApprovalDecided?: boolean;
    isApproved?: boolean;
    isDeclined?: boolean;
    absenceType?: AbsenceTypeViewModel | undefined;
    isHalfDay?: boolean;
    appUserName?: string | undefined;
    appUserId?: number;
    isReadOnly?: boolean;
    startDayOfYear?: number;
    durationDays?: number;
    startsLastYear?: boolean;
    endsNextYear?: boolean;
}

export class PublicHolidayViewModel implements IPublicHolidayViewModel {
    id?: number;
    publicHolidayDate?: string;
    description?: string | undefined;
    isHalfDay?: boolean;
    isGlobal?: boolean;
    dayOfYear?: number;

    constructor(data?: IPublicHolidayViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.publicHolidayDate = _data["publicHolidayDate"];
            this.description = _data["description"];
            this.isHalfDay = _data["isHalfDay"];
            this.isGlobal = _data["isGlobal"];
            this.dayOfYear = _data["dayOfYear"];
        }
    }

    static fromJS(data: any): PublicHolidayViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicHolidayViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["publicHolidayDate"] = this.publicHolidayDate;
        data["description"] = this.description;
        data["isHalfDay"] = this.isHalfDay;
        data["isGlobal"] = this.isGlobal;
        data["dayOfYear"] = this.dayOfYear;
        return data;
    }
}

export interface IPublicHolidayViewModel {
    id?: number;
    publicHolidayDate?: string;
    description?: string | undefined;
    isHalfDay?: boolean;
    isGlobal?: boolean;
    dayOfYear?: number;
}

export class VacationStatsViewModel implements IVacationStatsViewModel {
    approvedVacationDays?: number;
    requestedVacationDays?: number;
    restVacationDays?: number;
    carryOverVactionDays?: number;
    nextVacation?: AbsenceViewModel | undefined;
    nextVacationInDays?: number;
    currentYearNewVacationDays?: number;
    totalVacationDaysThisYear?: number;

    constructor(data?: IVacationStatsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.approvedVacationDays = _data["approvedVacationDays"];
            this.requestedVacationDays = _data["requestedVacationDays"];
            this.restVacationDays = _data["restVacationDays"];
            this.carryOverVactionDays = _data["carryOverVactionDays"];
            this.nextVacation = _data["nextVacation"] ? AbsenceViewModel.fromJS(_data["nextVacation"]) : <any>undefined;
            this.nextVacationInDays = _data["nextVacationInDays"];
            this.currentYearNewVacationDays = _data["currentYearNewVacationDays"];
            this.totalVacationDaysThisYear = _data["totalVacationDaysThisYear"];
        }
    }

    static fromJS(data: any): VacationStatsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VacationStatsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["approvedVacationDays"] = this.approvedVacationDays;
        data["requestedVacationDays"] = this.requestedVacationDays;
        data["restVacationDays"] = this.restVacationDays;
        data["carryOverVactionDays"] = this.carryOverVactionDays;
        data["nextVacation"] = this.nextVacation ? this.nextVacation.toJSON() : <any>undefined;
        data["nextVacationInDays"] = this.nextVacationInDays;
        data["currentYearNewVacationDays"] = this.currentYearNewVacationDays;
        data["totalVacationDaysThisYear"] = this.totalVacationDaysThisYear;
        return data;
    }
}

export interface IVacationStatsViewModel {
    approvedVacationDays?: number;
    requestedVacationDays?: number;
    restVacationDays?: number;
    carryOverVactionDays?: number;
    nextVacation?: AbsenceViewModel | undefined;
    nextVacationInDays?: number;
    currentYearNewVacationDays?: number;
    totalVacationDaysThisYear?: number;
}

export class AbsenceFilter implements IAbsenceFilter {
    id?: number | undefined;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
    year?: number | undefined;
    approvalNeeded?: boolean | undefined;
    isApproved?: boolean | undefined;
    appUserId?: number | undefined;
    appUserIds?: number[] | undefined;
    displayAllUsers?: boolean | undefined;
    isApprovalDecided?: boolean | undefined;
    absenceTypeId?: number | undefined;

    constructor(data?: IAbsenceFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
            this.year = _data["year"];
            this.approvalNeeded = _data["approvalNeeded"];
            this.isApproved = _data["isApproved"];
            this.appUserId = _data["appUserId"];
            if (Array.isArray(_data["appUserIds"])) {
                this.appUserIds = [] as any;
                for (let item of _data["appUserIds"])
                    this.appUserIds!.push(item);
            }
            this.displayAllUsers = _data["displayAllUsers"];
            this.isApprovalDecided = _data["isApprovalDecided"];
            this.absenceTypeId = _data["absenceTypeId"];
        }
    }

    static fromJS(data: any): AbsenceFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        data["year"] = this.year;
        data["approvalNeeded"] = this.approvalNeeded;
        data["isApproved"] = this.isApproved;
        data["appUserId"] = this.appUserId;
        if (Array.isArray(this.appUserIds)) {
            data["appUserIds"] = [];
            for (let item of this.appUserIds)
                data["appUserIds"].push(item);
        }
        data["displayAllUsers"] = this.displayAllUsers;
        data["isApprovalDecided"] = this.isApprovalDecided;
        data["absenceTypeId"] = this.absenceTypeId;
        return data;
    }
}

export interface IAbsenceFilter {
    id?: number | undefined;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
    year?: number | undefined;
    approvalNeeded?: boolean | undefined;
    isApproved?: boolean | undefined;
    appUserId?: number | undefined;
    appUserIds?: number[] | undefined;
    displayAllUsers?: boolean | undefined;
    isApprovalDecided?: boolean | undefined;
    absenceTypeId?: number | undefined;
}

export class AbsenceValidationResultViewModel implements IAbsenceValidationResultViewModel {
    neededVacationDays?: number;
    isOverlappingAbsence?: boolean;
    notEnoughVacationDaysRemaining?: boolean;
    neededVacationDaysPerYear?: YearDay[] | undefined;
    remainingVacationDaysPerYear?: YearDay[] | undefined;

    constructor(data?: IAbsenceValidationResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.neededVacationDays = _data["neededVacationDays"];
            this.isOverlappingAbsence = _data["isOverlappingAbsence"];
            this.notEnoughVacationDaysRemaining = _data["notEnoughVacationDaysRemaining"];
            if (Array.isArray(_data["neededVacationDaysPerYear"])) {
                this.neededVacationDaysPerYear = [] as any;
                for (let item of _data["neededVacationDaysPerYear"])
                    this.neededVacationDaysPerYear!.push(YearDay.fromJS(item));
            }
            if (Array.isArray(_data["remainingVacationDaysPerYear"])) {
                this.remainingVacationDaysPerYear = [] as any;
                for (let item of _data["remainingVacationDaysPerYear"])
                    this.remainingVacationDaysPerYear!.push(YearDay.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AbsenceValidationResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceValidationResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["neededVacationDays"] = this.neededVacationDays;
        data["isOverlappingAbsence"] = this.isOverlappingAbsence;
        data["notEnoughVacationDaysRemaining"] = this.notEnoughVacationDaysRemaining;
        if (Array.isArray(this.neededVacationDaysPerYear)) {
            data["neededVacationDaysPerYear"] = [];
            for (let item of this.neededVacationDaysPerYear)
                data["neededVacationDaysPerYear"].push(item.toJSON());
        }
        if (Array.isArray(this.remainingVacationDaysPerYear)) {
            data["remainingVacationDaysPerYear"] = [];
            for (let item of this.remainingVacationDaysPerYear)
                data["remainingVacationDaysPerYear"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAbsenceValidationResultViewModel {
    neededVacationDays?: number;
    isOverlappingAbsence?: boolean;
    notEnoughVacationDaysRemaining?: boolean;
    neededVacationDaysPerYear?: YearDay[] | undefined;
    remainingVacationDaysPerYear?: YearDay[] | undefined;
}

export class YearDay implements IYearDay {
    year?: number;
    number?: number;

    constructor(data?: IYearDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.number = _data["number"];
        }
    }

    static fromJS(data: any): YearDay {
        data = typeof data === 'object' ? data : {};
        let result = new YearDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["number"] = this.number;
        return data;
    }
}

export interface IYearDay {
    year?: number;
    number?: number;
}

export class DeleteResultModel implements IDeleteResultModel {
    confirmationNeeded?: boolean;
    success?: boolean;
    message?: string | undefined;

    constructor(data?: IDeleteResultModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.confirmationNeeded = _data["confirmationNeeded"];
            this.success = _data["success"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): DeleteResultModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteResultModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["confirmationNeeded"] = this.confirmationNeeded;
        data["success"] = this.success;
        data["message"] = this.message;
        return data;
    }
}

export interface IDeleteResultModel {
    confirmationNeeded?: boolean;
    success?: boolean;
    message?: string | undefined;
}

export class AbsenceTypeEditModel implements IAbsenceTypeEditModel {
    id?: number;
    approvalNeeded?: boolean;
    allowHalfDay?: boolean;
    description?: string | undefined;
    absenceTypeEnum?: AbsenceTypeEnum;
    isHiddenForEmployees?: boolean;

    constructor(data?: IAbsenceTypeEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.approvalNeeded = _data["approvalNeeded"];
            this.allowHalfDay = _data["allowHalfDay"];
            this.description = _data["description"];
            this.absenceTypeEnum = _data["absenceTypeEnum"];
            this.isHiddenForEmployees = _data["isHiddenForEmployees"];
        }
    }

    static fromJS(data: any): AbsenceTypeEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new AbsenceTypeEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["approvalNeeded"] = this.approvalNeeded;
        data["allowHalfDay"] = this.allowHalfDay;
        data["description"] = this.description;
        data["absenceTypeEnum"] = this.absenceTypeEnum;
        data["isHiddenForEmployees"] = this.isHiddenForEmployees;
        return data;
    }
}

export interface IAbsenceTypeEditModel {
    id?: number;
    approvalNeeded?: boolean;
    allowHalfDay?: boolean;
    description?: string | undefined;
    absenceTypeEnum?: AbsenceTypeEnum;
    isHiddenForEmployees?: boolean;
}

export class AccountEditModel implements IAccountEditModel {
    featureFlagInvoiceEmail?: boolean;
    featureFlagInternalUserCost?: boolean;
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    currency?: string | undefined;
    useRateRules?: boolean;
    useAbsences?: boolean;
    disableVacationCarryOver?: boolean;
    useTags?: boolean;
    useProjectTasks?: boolean;
    mainColor?: string | undefined;
    secondaryColor?: string | undefined;
    logoBytes?: string | undefined;
    logoMimeType?: string | undefined;
    logoFileName?: string | undefined;
    globalRate?: number;
    noRates?: boolean;
    noOutgoingInvoices?: boolean;
    useEmailSending?: boolean;
    useTimeAccount?: boolean;
    useInternalUserCost?: boolean;
    useBasicTimeTracking?: boolean;
    useFixedPriceProjects?: boolean;

    constructor(data?: IAccountEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.featureFlagInvoiceEmail = _data["featureFlagInvoiceEmail"];
            this.featureFlagInternalUserCost = _data["featureFlagInternalUserCost"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.currency = _data["currency"];
            this.useRateRules = _data["useRateRules"];
            this.useAbsences = _data["useAbsences"];
            this.disableVacationCarryOver = _data["disableVacationCarryOver"];
            this.useTags = _data["useTags"];
            this.useProjectTasks = _data["useProjectTasks"];
            this.mainColor = _data["mainColor"];
            this.secondaryColor = _data["secondaryColor"];
            this.logoBytes = _data["logoBytes"];
            this.logoMimeType = _data["logoMimeType"];
            this.logoFileName = _data["logoFileName"];
            this.globalRate = _data["globalRate"];
            this.noRates = _data["noRates"];
            this.noOutgoingInvoices = _data["noOutgoingInvoices"];
            this.useEmailSending = _data["useEmailSending"];
            this.useTimeAccount = _data["useTimeAccount"];
            this.useInternalUserCost = _data["useInternalUserCost"];
            this.useBasicTimeTracking = _data["useBasicTimeTracking"];
            this.useFixedPriceProjects = _data["useFixedPriceProjects"];
        }
    }

    static fromJS(data: any): AccountEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureFlagInvoiceEmail"] = this.featureFlagInvoiceEmail;
        data["featureFlagInternalUserCost"] = this.featureFlagInternalUserCost;
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["currency"] = this.currency;
        data["useRateRules"] = this.useRateRules;
        data["useAbsences"] = this.useAbsences;
        data["disableVacationCarryOver"] = this.disableVacationCarryOver;
        data["useTags"] = this.useTags;
        data["useProjectTasks"] = this.useProjectTasks;
        data["mainColor"] = this.mainColor;
        data["secondaryColor"] = this.secondaryColor;
        data["logoBytes"] = this.logoBytes;
        data["logoMimeType"] = this.logoMimeType;
        data["logoFileName"] = this.logoFileName;
        data["globalRate"] = this.globalRate;
        data["noRates"] = this.noRates;
        data["noOutgoingInvoices"] = this.noOutgoingInvoices;
        data["useEmailSending"] = this.useEmailSending;
        data["useTimeAccount"] = this.useTimeAccount;
        data["useInternalUserCost"] = this.useInternalUserCost;
        data["useBasicTimeTracking"] = this.useBasicTimeTracking;
        data["useFixedPriceProjects"] = this.useFixedPriceProjects;
        return data;
    }
}

export interface IAccountEditModel {
    featureFlagInvoiceEmail?: boolean;
    featureFlagInternalUserCost?: boolean;
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    currency?: string | undefined;
    useRateRules?: boolean;
    useAbsences?: boolean;
    disableVacationCarryOver?: boolean;
    useTags?: boolean;
    useProjectTasks?: boolean;
    mainColor?: string | undefined;
    secondaryColor?: string | undefined;
    logoBytes?: string | undefined;
    logoMimeType?: string | undefined;
    logoFileName?: string | undefined;
    globalRate?: number;
    noRates?: boolean;
    noOutgoingInvoices?: boolean;
    useEmailSending?: boolean;
    useTimeAccount?: boolean;
    useInternalUserCost?: boolean;
    useBasicTimeTracking?: boolean;
    useFixedPriceProjects?: boolean;
}

export class AccountTimeTrackingSettingsEditModel implements IAccountTimeTrackingSettingsEditModel {
    timeEntryMode?: TimeEntryModeEnum;
    pauseMode?: PauseMode;
    tagsRequired?: boolean;
    projectTaskRequired?: boolean;
    descriptionMinChars?: number;
    timeEntryIsBillableNotChangeable?: boolean;
    showConsumedBudgetOnSave?: boolean;
    usePauseRuleWarnings?: boolean;
    enforcePauseRules?: boolean;
    restrictTimeEntryInPast?: boolean;
    restrictTimeEntryInPastNoOfDays?: number;
    restrictTimeEntryInFuture?: boolean;
    restrictTimeEntryInFutureNoOfDays?: number;
    showAdditionalInsertAppUserSelect?: boolean;
    basicTimeTrackingDefaultProjectId?: number | undefined;
    openTimeEntryWhenStopStopwatch?: boolean;

    constructor(data?: IAccountTimeTrackingSettingsEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeEntryMode = _data["timeEntryMode"];
            this.pauseMode = _data["pauseMode"];
            this.tagsRequired = _data["tagsRequired"];
            this.projectTaskRequired = _data["projectTaskRequired"];
            this.descriptionMinChars = _data["descriptionMinChars"];
            this.timeEntryIsBillableNotChangeable = _data["timeEntryIsBillableNotChangeable"];
            this.showConsumedBudgetOnSave = _data["showConsumedBudgetOnSave"];
            this.usePauseRuleWarnings = _data["usePauseRuleWarnings"];
            this.enforcePauseRules = _data["enforcePauseRules"];
            this.restrictTimeEntryInPast = _data["restrictTimeEntryInPast"];
            this.restrictTimeEntryInPastNoOfDays = _data["restrictTimeEntryInPastNoOfDays"];
            this.restrictTimeEntryInFuture = _data["restrictTimeEntryInFuture"];
            this.restrictTimeEntryInFutureNoOfDays = _data["restrictTimeEntryInFutureNoOfDays"];
            this.showAdditionalInsertAppUserSelect = _data["showAdditionalInsertAppUserSelect"];
            this.basicTimeTrackingDefaultProjectId = _data["basicTimeTrackingDefaultProjectId"];
            this.openTimeEntryWhenStopStopwatch = _data["openTimeEntryWhenStopStopwatch"];
        }
    }

    static fromJS(data: any): AccountTimeTrackingSettingsEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTimeTrackingSettingsEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeEntryMode"] = this.timeEntryMode;
        data["pauseMode"] = this.pauseMode;
        data["tagsRequired"] = this.tagsRequired;
        data["projectTaskRequired"] = this.projectTaskRequired;
        data["descriptionMinChars"] = this.descriptionMinChars;
        data["timeEntryIsBillableNotChangeable"] = this.timeEntryIsBillableNotChangeable;
        data["showConsumedBudgetOnSave"] = this.showConsumedBudgetOnSave;
        data["usePauseRuleWarnings"] = this.usePauseRuleWarnings;
        data["enforcePauseRules"] = this.enforcePauseRules;
        data["restrictTimeEntryInPast"] = this.restrictTimeEntryInPast;
        data["restrictTimeEntryInPastNoOfDays"] = this.restrictTimeEntryInPastNoOfDays;
        data["restrictTimeEntryInFuture"] = this.restrictTimeEntryInFuture;
        data["restrictTimeEntryInFutureNoOfDays"] = this.restrictTimeEntryInFutureNoOfDays;
        data["showAdditionalInsertAppUserSelect"] = this.showAdditionalInsertAppUserSelect;
        data["basicTimeTrackingDefaultProjectId"] = this.basicTimeTrackingDefaultProjectId;
        data["openTimeEntryWhenStopStopwatch"] = this.openTimeEntryWhenStopStopwatch;
        return data;
    }
}

export interface IAccountTimeTrackingSettingsEditModel {
    timeEntryMode?: TimeEntryModeEnum;
    pauseMode?: PauseMode;
    tagsRequired?: boolean;
    projectTaskRequired?: boolean;
    descriptionMinChars?: number;
    timeEntryIsBillableNotChangeable?: boolean;
    showConsumedBudgetOnSave?: boolean;
    usePauseRuleWarnings?: boolean;
    enforcePauseRules?: boolean;
    restrictTimeEntryInPast?: boolean;
    restrictTimeEntryInPastNoOfDays?: number;
    restrictTimeEntryInFuture?: boolean;
    restrictTimeEntryInFutureNoOfDays?: number;
    showAdditionalInsertAppUserSelect?: boolean;
    basicTimeTrackingDefaultProjectId?: number | undefined;
    openTimeEntryWhenStopStopwatch?: boolean;
}

export enum TimeEntryModeEnum {
    DurationAndTimeFromTo = "DurationAndTimeFromTo",
    Duration = "Duration",
    TimeFromTo = "TimeFromTo",
}

export enum PauseMode {
    None = "None",
    Manual = "Manual",
    Auto = "Auto",
    TimeEntry = "TimeEntry",
}

export class AccountInvoiceDataEditModel implements IAccountInvoiceDataEditModel {
    paymentRecipient?: string | undefined;
    paymentCompany?: string | undefined;
    paymentStreet?: string | undefined;
    paymentZip?: string | undefined;
    paymentCity?: string | undefined;
    paymentCountry?: string | undefined;
    paymentVatId?: string | undefined;
    invoiceEmail?: string | undefined;

    constructor(data?: IAccountInvoiceDataEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentRecipient = _data["paymentRecipient"];
            this.paymentCompany = _data["paymentCompany"];
            this.paymentStreet = _data["paymentStreet"];
            this.paymentZip = _data["paymentZip"];
            this.paymentCity = _data["paymentCity"];
            this.paymentCountry = _data["paymentCountry"];
            this.paymentVatId = _data["paymentVatId"];
            this.invoiceEmail = _data["invoiceEmail"];
        }
    }

    static fromJS(data: any): AccountInvoiceDataEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountInvoiceDataEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentRecipient"] = this.paymentRecipient;
        data["paymentCompany"] = this.paymentCompany;
        data["paymentStreet"] = this.paymentStreet;
        data["paymentZip"] = this.paymentZip;
        data["paymentCity"] = this.paymentCity;
        data["paymentCountry"] = this.paymentCountry;
        data["paymentVatId"] = this.paymentVatId;
        data["invoiceEmail"] = this.invoiceEmail;
        return data;
    }
}

export interface IAccountInvoiceDataEditModel {
    paymentRecipient?: string | undefined;
    paymentCompany?: string | undefined;
    paymentStreet?: string | undefined;
    paymentZip?: string | undefined;
    paymentCity?: string | undefined;
    paymentCountry?: string | undefined;
    paymentVatId?: string | undefined;
    invoiceEmail?: string | undefined;
}

export class LicenseDataEditModel implements ILicenseDataEditModel {
    userCount?: number;
    userCountBasic?: number;
    minUserCount?: number;
    minUserCountBasic?: number;
    payedUserCount?: number;
    payedUserCountBasic?: number;
    paidTill?: string | undefined;
    paymentInterval?: string | undefined;
    isUserCountUpdate?: boolean;

    constructor(data?: ILicenseDataEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userCount = _data["userCount"];
            this.userCountBasic = _data["userCountBasic"];
            this.minUserCount = _data["minUserCount"];
            this.minUserCountBasic = _data["minUserCountBasic"];
            this.payedUserCount = _data["payedUserCount"];
            this.payedUserCountBasic = _data["payedUserCountBasic"];
            this.paidTill = _data["paidTill"];
            this.paymentInterval = _data["paymentInterval"];
            this.isUserCountUpdate = _data["isUserCountUpdate"];
        }
    }

    static fromJS(data: any): LicenseDataEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseDataEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userCount"] = this.userCount;
        data["userCountBasic"] = this.userCountBasic;
        data["minUserCount"] = this.minUserCount;
        data["minUserCountBasic"] = this.minUserCountBasic;
        data["payedUserCount"] = this.payedUserCount;
        data["payedUserCountBasic"] = this.payedUserCountBasic;
        data["paidTill"] = this.paidTill;
        data["paymentInterval"] = this.paymentInterval;
        data["isUserCountUpdate"] = this.isUserCountUpdate;
        return data;
    }
}

export interface ILicenseDataEditModel {
    userCount?: number;
    userCountBasic?: number;
    minUserCount?: number;
    minUserCountBasic?: number;
    payedUserCount?: number;
    payedUserCountBasic?: number;
    paidTill?: string | undefined;
    paymentInterval?: string | undefined;
    isUserCountUpdate?: boolean;
}

export class LicenseDataViewModel implements ILicenseDataViewModel {
    userCount?: number;
    userCountBasic?: number;
    minUserCount?: number;
    minUserCountBasic?: number;
    basePriceCent?: number;
    basePriceCentBasic?: number;
    basePriceCentYearly?: number;
    basePriceCentYearlyBasic?: number;
    paymentInterval?: string | undefined;

    constructor(data?: ILicenseDataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userCount = _data["userCount"];
            this.userCountBasic = _data["userCountBasic"];
            this.minUserCount = _data["minUserCount"];
            this.minUserCountBasic = _data["minUserCountBasic"];
            this.basePriceCent = _data["basePriceCent"];
            this.basePriceCentBasic = _data["basePriceCentBasic"];
            this.basePriceCentYearly = _data["basePriceCentYearly"];
            this.basePriceCentYearlyBasic = _data["basePriceCentYearlyBasic"];
            this.paymentInterval = _data["paymentInterval"];
        }
    }

    static fromJS(data: any): LicenseDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LicenseDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userCount"] = this.userCount;
        data["userCountBasic"] = this.userCountBasic;
        data["minUserCount"] = this.minUserCount;
        data["minUserCountBasic"] = this.minUserCountBasic;
        data["basePriceCent"] = this.basePriceCent;
        data["basePriceCentBasic"] = this.basePriceCentBasic;
        data["basePriceCentYearly"] = this.basePriceCentYearly;
        data["basePriceCentYearlyBasic"] = this.basePriceCentYearlyBasic;
        data["paymentInterval"] = this.paymentInterval;
        return data;
    }
}

export interface ILicenseDataViewModel {
    userCount?: number;
    userCountBasic?: number;
    minUserCount?: number;
    minUserCountBasic?: number;
    basePriceCent?: number;
    basePriceCentBasic?: number;
    basePriceCentYearly?: number;
    basePriceCentYearlyBasic?: number;
    paymentInterval?: string | undefined;
}

export class PaymentAmountModel implements IPaymentAmountModel {
    userCount?: number;
    userCountBasic?: number;
    amount?: number;
    amountFull?: number;
    amountBasic?: number;
    monthsToPay?: number;
    basePrice?: number;
    basePriceBasic?: number;
    reverseCharge?: boolean;
    vat?: number;
    paidTill?: string | undefined;
    noInvoiceNeeded?: boolean;

    constructor(data?: IPaymentAmountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userCount = _data["userCount"];
            this.userCountBasic = _data["userCountBasic"];
            this.amount = _data["amount"];
            this.amountFull = _data["amountFull"];
            this.amountBasic = _data["amountBasic"];
            this.monthsToPay = _data["monthsToPay"];
            this.basePrice = _data["basePrice"];
            this.basePriceBasic = _data["basePriceBasic"];
            this.reverseCharge = _data["reverseCharge"];
            this.vat = _data["vat"];
            this.paidTill = _data["paidTill"];
            this.noInvoiceNeeded = _data["noInvoiceNeeded"];
        }
    }

    static fromJS(data: any): PaymentAmountModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentAmountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userCount"] = this.userCount;
        data["userCountBasic"] = this.userCountBasic;
        data["amount"] = this.amount;
        data["amountFull"] = this.amountFull;
        data["amountBasic"] = this.amountBasic;
        data["monthsToPay"] = this.monthsToPay;
        data["basePrice"] = this.basePrice;
        data["basePriceBasic"] = this.basePriceBasic;
        data["reverseCharge"] = this.reverseCharge;
        data["vat"] = this.vat;
        data["paidTill"] = this.paidTill;
        data["noInvoiceNeeded"] = this.noInvoiceNeeded;
        return data;
    }
}

export interface IPaymentAmountModel {
    userCount?: number;
    userCountBasic?: number;
    amount?: number;
    amountFull?: number;
    amountBasic?: number;
    monthsToPay?: number;
    basePrice?: number;
    basePriceBasic?: number;
    reverseCharge?: boolean;
    vat?: number;
    paidTill?: string | undefined;
    noInvoiceNeeded?: boolean;
}

export class ContractDataViewModel implements IContractDataViewModel {
    invoiceData?: AccountInvoiceDataEditModel | undefined;
    licenseData?: LicenseDataEditModel | undefined;
    paymentData?: PaymentDataViewModel | undefined;
    invoices?: InvoiceListViewModel[] | undefined;
    contractStatus?: ContractStatusEnum;

    constructor(data?: IContractDataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceData = _data["invoiceData"] ? AccountInvoiceDataEditModel.fromJS(_data["invoiceData"]) : <any>undefined;
            this.licenseData = _data["licenseData"] ? LicenseDataEditModel.fromJS(_data["licenseData"]) : <any>undefined;
            this.paymentData = _data["paymentData"] ? PaymentDataViewModel.fromJS(_data["paymentData"]) : <any>undefined;
            if (Array.isArray(_data["invoices"])) {
                this.invoices = [] as any;
                for (let item of _data["invoices"])
                    this.invoices!.push(InvoiceListViewModel.fromJS(item));
            }
            this.contractStatus = _data["contractStatus"];
        }
    }

    static fromJS(data: any): ContractDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContractDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceData"] = this.invoiceData ? this.invoiceData.toJSON() : <any>undefined;
        data["licenseData"] = this.licenseData ? this.licenseData.toJSON() : <any>undefined;
        data["paymentData"] = this.paymentData ? this.paymentData.toJSON() : <any>undefined;
        if (Array.isArray(this.invoices)) {
            data["invoices"] = [];
            for (let item of this.invoices)
                data["invoices"].push(item.toJSON());
        }
        data["contractStatus"] = this.contractStatus;
        return data;
    }
}

export interface IContractDataViewModel {
    invoiceData?: AccountInvoiceDataEditModel | undefined;
    licenseData?: LicenseDataEditModel | undefined;
    paymentData?: PaymentDataViewModel | undefined;
    invoices?: InvoiceListViewModel[] | undefined;
    contractStatus?: ContractStatusEnum;
}

export class PaymentDataViewModel implements IPaymentDataViewModel {
    paymentIsSetup?: boolean;
    paymentMethod?: string | undefined;
    paymentLastDigits?: string | undefined;
    paymentInterval?: string | undefined;
    paymentPaidTill?: string;

    constructor(data?: IPaymentDataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.paymentIsSetup = _data["paymentIsSetup"];
            this.paymentMethod = _data["paymentMethod"];
            this.paymentLastDigits = _data["paymentLastDigits"];
            this.paymentInterval = _data["paymentInterval"];
            this.paymentPaidTill = _data["paymentPaidTill"];
        }
    }

    static fromJS(data: any): PaymentDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["paymentIsSetup"] = this.paymentIsSetup;
        data["paymentMethod"] = this.paymentMethod;
        data["paymentLastDigits"] = this.paymentLastDigits;
        data["paymentInterval"] = this.paymentInterval;
        data["paymentPaidTill"] = this.paymentPaidTill;
        return data;
    }
}

export interface IPaymentDataViewModel {
    paymentIsSetup?: boolean;
    paymentMethod?: string | undefined;
    paymentLastDigits?: string | undefined;
    paymentInterval?: string | undefined;
    paymentPaidTill?: string;
}

export class InvoiceListViewModel implements IInvoiceListViewModel {
    id?: number;
    invoiceNumber?: string | undefined;
    paymentId?: string | undefined;
    createdDate?: string;
    amountCent?: number;
    userCount?: number;
    isPaid?: boolean;
    paymentMethod?: string | undefined;
    paymentStatus?: PaymentStatusEnum;

    constructor(data?: IInvoiceListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.paymentId = _data["paymentId"];
            this.createdDate = _data["createdDate"];
            this.amountCent = _data["amountCent"];
            this.userCount = _data["userCount"];
            this.isPaid = _data["isPaid"];
            this.paymentMethod = _data["paymentMethod"];
            this.paymentStatus = _data["paymentStatus"];
        }
    }

    static fromJS(data: any): InvoiceListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["paymentId"] = this.paymentId;
        data["createdDate"] = this.createdDate;
        data["amountCent"] = this.amountCent;
        data["userCount"] = this.userCount;
        data["isPaid"] = this.isPaid;
        data["paymentMethod"] = this.paymentMethod;
        data["paymentStatus"] = this.paymentStatus;
        return data;
    }
}

export interface IInvoiceListViewModel {
    id?: number;
    invoiceNumber?: string | undefined;
    paymentId?: string | undefined;
    createdDate?: string;
    amountCent?: number;
    userCount?: number;
    isPaid?: boolean;
    paymentMethod?: string | undefined;
    paymentStatus?: PaymentStatusEnum;
}

export enum PaymentStatusEnum {
    Open = "Open",
    Processing = "Processing",
    Succeeded = "Succeeded",
    Failed = "Failed",
    Error = "Error",
    WrittenOff = "WrittenOff",
}

export enum ContractStatusEnum {
    Trial = "Trial",
    Unpaid = "Unpaid",
    Active = "Active",
    AwaitingPayment = "AwaitingPayment",
    Cancelled = "Cancelled",
}

export class AccountAdvEditModel implements IAccountAdvEditModel {
    advContactName?: string | undefined;
    advContactPhone?: string | undefined;
    advContactEmail?: string | undefined;
    advCompany?: string | undefined;
    advCompanyAddress?: string | undefined;
    advConclusionDate?: string | undefined;
    hasAdv?: boolean;

    constructor(data?: IAccountAdvEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.advContactName = _data["advContactName"];
            this.advContactPhone = _data["advContactPhone"];
            this.advContactEmail = _data["advContactEmail"];
            this.advCompany = _data["advCompany"];
            this.advCompanyAddress = _data["advCompanyAddress"];
            this.advConclusionDate = _data["advConclusionDate"];
            this.hasAdv = _data["hasAdv"];
        }
    }

    static fromJS(data: any): AccountAdvEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountAdvEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["advContactName"] = this.advContactName;
        data["advContactPhone"] = this.advContactPhone;
        data["advContactEmail"] = this.advContactEmail;
        data["advCompany"] = this.advCompany;
        data["advCompanyAddress"] = this.advCompanyAddress;
        data["advConclusionDate"] = this.advConclusionDate;
        data["hasAdv"] = this.hasAdv;
        return data;
    }
}

export interface IAccountAdvEditModel {
    advContactName?: string | undefined;
    advContactPhone?: string | undefined;
    advContactEmail?: string | undefined;
    advCompany?: string | undefined;
    advCompanyAddress?: string | undefined;
    advConclusionDate?: string | undefined;
    hasAdv?: boolean;
}

export class DeleteAccountEditModel implements IDeleteAccountEditModel {
    checkPhrase?: string | undefined;
    reason?: string | undefined;

    constructor(data?: IDeleteAccountEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.checkPhrase = _data["checkPhrase"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): DeleteAccountEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAccountEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["checkPhrase"] = this.checkPhrase;
        data["reason"] = this.reason;
        return data;
    }
}

export interface IDeleteAccountEditModel {
    checkPhrase?: string | undefined;
    reason?: string | undefined;
}

export class OnBoardingEditModel implements IOnBoardingEditModel {
    customerName?: string | undefined;
    projectName?: string | undefined;
    useRates?: boolean;
    useOutgoingInvoice?: boolean;
    useOutgoingInvoiceEmails?: boolean;
    useAbsences?: boolean;
    useTimeAccount?: boolean;
    useBasicTimeTracking?: boolean;

    constructor(data?: IOnBoardingEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerName = _data["customerName"];
            this.projectName = _data["projectName"];
            this.useRates = _data["useRates"];
            this.useOutgoingInvoice = _data["useOutgoingInvoice"];
            this.useOutgoingInvoiceEmails = _data["useOutgoingInvoiceEmails"];
            this.useAbsences = _data["useAbsences"];
            this.useTimeAccount = _data["useTimeAccount"];
            this.useBasicTimeTracking = _data["useBasicTimeTracking"];
        }
    }

    static fromJS(data: any): OnBoardingEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new OnBoardingEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerName"] = this.customerName;
        data["projectName"] = this.projectName;
        data["useRates"] = this.useRates;
        data["useOutgoingInvoice"] = this.useOutgoingInvoice;
        data["useOutgoingInvoiceEmails"] = this.useOutgoingInvoiceEmails;
        data["useAbsences"] = this.useAbsences;
        data["useTimeAccount"] = this.useTimeAccount;
        data["useBasicTimeTracking"] = this.useBasicTimeTracking;
        return data;
    }
}

export interface IOnBoardingEditModel {
    customerName?: string | undefined;
    projectName?: string | undefined;
    useRates?: boolean;
    useOutgoingInvoice?: boolean;
    useOutgoingInvoiceEmails?: boolean;
    useAbsences?: boolean;
    useTimeAccount?: boolean;
    useBasicTimeTracking?: boolean;
}

export class Log implements ILog {
    id?: number;
    logger?: string | undefined;
    level?: string | undefined;
    message?: string | undefined;
    requestUrl?: string | undefined;
    action?: string | undefined;
    exception?: string | undefined;
    userIdentity?: string | undefined;
    callSite?: string | undefined;
    sentToAdmins?: boolean;
    sentToAdminsDateTime?: string | undefined;
    insertDate?: string;

    constructor(data?: ILog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.logger = _data["logger"];
            this.level = _data["level"];
            this.message = _data["message"];
            this.requestUrl = _data["requestUrl"];
            this.action = _data["action"];
            this.exception = _data["exception"];
            this.userIdentity = _data["userIdentity"];
            this.callSite = _data["callSite"];
            this.sentToAdmins = _data["sentToAdmins"];
            this.sentToAdminsDateTime = _data["sentToAdminsDateTime"];
            this.insertDate = _data["insertDate"];
        }
    }

    static fromJS(data: any): Log {
        data = typeof data === 'object' ? data : {};
        let result = new Log();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["logger"] = this.logger;
        data["level"] = this.level;
        data["message"] = this.message;
        data["requestUrl"] = this.requestUrl;
        data["action"] = this.action;
        data["exception"] = this.exception;
        data["userIdentity"] = this.userIdentity;
        data["callSite"] = this.callSite;
        data["sentToAdmins"] = this.sentToAdmins;
        data["sentToAdminsDateTime"] = this.sentToAdminsDateTime;
        data["insertDate"] = this.insertDate;
        return data;
    }
}

export interface ILog {
    id?: number;
    logger?: string | undefined;
    level?: string | undefined;
    message?: string | undefined;
    requestUrl?: string | undefined;
    action?: string | undefined;
    exception?: string | undefined;
    userIdentity?: string | undefined;
    callSite?: string | undefined;
    sentToAdmins?: boolean;
    sentToAdminsDateTime?: string | undefined;
    insertDate?: string;
}

export class LeuteUndGeldViewModel implements ILeuteUndGeldViewModel {
    leuteFull?: number;
    leuteBasis?: number;
    leuteGesamt?: number;
    geldFull?: number;
    geldBasis?: number;
    geldGesamt?: number;
    geldGesamtJahr?: number;

    constructor(data?: ILeuteUndGeldViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.leuteFull = _data["leuteFull"];
            this.leuteBasis = _data["leuteBasis"];
            this.leuteGesamt = _data["leuteGesamt"];
            this.geldFull = _data["geldFull"];
            this.geldBasis = _data["geldBasis"];
            this.geldGesamt = _data["geldGesamt"];
            this.geldGesamtJahr = _data["geldGesamtJahr"];
        }
    }

    static fromJS(data: any): LeuteUndGeldViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LeuteUndGeldViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["leuteFull"] = this.leuteFull;
        data["leuteBasis"] = this.leuteBasis;
        data["leuteGesamt"] = this.leuteGesamt;
        data["geldFull"] = this.geldFull;
        data["geldBasis"] = this.geldBasis;
        data["geldGesamt"] = this.geldGesamt;
        data["geldGesamtJahr"] = this.geldGesamtJahr;
        return data;
    }
}

export interface ILeuteUndGeldViewModel {
    leuteFull?: number;
    leuteBasis?: number;
    leuteGesamt?: number;
    geldFull?: number;
    geldBasis?: number;
    geldGesamt?: number;
    geldGesamtJahr?: number;
}

export class LeuteUndGeldReportModel implements ILeuteUndGeldReportModel {
    realLeuteUndGeld?: LeuteUndGeldViewModel | undefined;
    leuteUndGeld?: LeuteUndGeldViewModel | undefined;
    leuteUndGeldLost?: LeuteUndGeldViewModel | undefined;
    accounts?: LeuteUndGeldBaseModel[] | undefined;

    constructor(data?: ILeuteUndGeldReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.realLeuteUndGeld = _data["realLeuteUndGeld"] ? LeuteUndGeldViewModel.fromJS(_data["realLeuteUndGeld"]) : <any>undefined;
            this.leuteUndGeld = _data["leuteUndGeld"] ? LeuteUndGeldViewModel.fromJS(_data["leuteUndGeld"]) : <any>undefined;
            this.leuteUndGeldLost = _data["leuteUndGeldLost"] ? LeuteUndGeldViewModel.fromJS(_data["leuteUndGeldLost"]) : <any>undefined;
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(LeuteUndGeldBaseModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LeuteUndGeldReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new LeuteUndGeldReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["realLeuteUndGeld"] = this.realLeuteUndGeld ? this.realLeuteUndGeld.toJSON() : <any>undefined;
        data["leuteUndGeld"] = this.leuteUndGeld ? this.leuteUndGeld.toJSON() : <any>undefined;
        data["leuteUndGeldLost"] = this.leuteUndGeldLost ? this.leuteUndGeldLost.toJSON() : <any>undefined;
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item.toJSON());
        }
        return data;
    }
}

export interface ILeuteUndGeldReportModel {
    realLeuteUndGeld?: LeuteUndGeldViewModel | undefined;
    leuteUndGeld?: LeuteUndGeldViewModel | undefined;
    leuteUndGeldLost?: LeuteUndGeldViewModel | undefined;
    accounts?: LeuteUndGeldBaseModel[] | undefined;
}

export class LeuteUndGeldBaseModel implements ILeuteUndGeldBaseModel {
    version?: number;
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    licensedUserCount?: number;
    licensedUserCountBasic?: number;
    paymentFreeUsers?: number;
    paymentIntervalMonths?: number;
    paymentBasePriceCent?: number;
    paymentBasePriceCentYearly?: number;
    paymentPaidTill?: string | undefined;
    paymentType?: string | undefined;
    lastEntry?: string;
    paymentBasePriceCentBasic?: number;
    paymentBasePriceCentYearlyBasic?: number;
    useBasicTimeTracking?: boolean;
    basicUserCount?: number;
    accountPaymentBasicPerMonth?: number;
    fullUserCount?: number;
    accountPaymentFullPerMonth?: number;
    accountPaymentPerMonth?: number;
    accountPaymentPerYear?: number;

    constructor(data?: ILeuteUndGeldBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.version = _data["version"];
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.licensedUserCount = _data["licensedUserCount"];
            this.licensedUserCountBasic = _data["licensedUserCountBasic"];
            this.paymentFreeUsers = _data["paymentFreeUsers"];
            this.paymentIntervalMonths = _data["paymentIntervalMonths"];
            this.paymentBasePriceCent = _data["paymentBasePriceCent"];
            this.paymentBasePriceCentYearly = _data["paymentBasePriceCentYearly"];
            this.paymentPaidTill = _data["paymentPaidTill"];
            this.paymentType = _data["paymentType"];
            this.lastEntry = _data["lastEntry"];
            this.paymentBasePriceCentBasic = _data["paymentBasePriceCentBasic"];
            this.paymentBasePriceCentYearlyBasic = _data["paymentBasePriceCentYearlyBasic"];
            this.useBasicTimeTracking = _data["useBasicTimeTracking"];
            this.basicUserCount = _data["basicUserCount"];
            this.accountPaymentBasicPerMonth = _data["accountPaymentBasicPerMonth"];
            this.fullUserCount = _data["fullUserCount"];
            this.accountPaymentFullPerMonth = _data["accountPaymentFullPerMonth"];
            this.accountPaymentPerMonth = _data["accountPaymentPerMonth"];
            this.accountPaymentPerYear = _data["accountPaymentPerYear"];
        }
    }

    static fromJS(data: any): LeuteUndGeldBaseModel {
        data = typeof data === 'object' ? data : {};
        let result = new LeuteUndGeldBaseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["version"] = this.version;
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["licensedUserCount"] = this.licensedUserCount;
        data["licensedUserCountBasic"] = this.licensedUserCountBasic;
        data["paymentFreeUsers"] = this.paymentFreeUsers;
        data["paymentIntervalMonths"] = this.paymentIntervalMonths;
        data["paymentBasePriceCent"] = this.paymentBasePriceCent;
        data["paymentBasePriceCentYearly"] = this.paymentBasePriceCentYearly;
        data["paymentPaidTill"] = this.paymentPaidTill;
        data["paymentType"] = this.paymentType;
        data["lastEntry"] = this.lastEntry;
        data["paymentBasePriceCentBasic"] = this.paymentBasePriceCentBasic;
        data["paymentBasePriceCentYearlyBasic"] = this.paymentBasePriceCentYearlyBasic;
        data["useBasicTimeTracking"] = this.useBasicTimeTracking;
        data["basicUserCount"] = this.basicUserCount;
        data["accountPaymentBasicPerMonth"] = this.accountPaymentBasicPerMonth;
        data["fullUserCount"] = this.fullUserCount;
        data["accountPaymentFullPerMonth"] = this.accountPaymentFullPerMonth;
        data["accountPaymentPerMonth"] = this.accountPaymentPerMonth;
        data["accountPaymentPerYear"] = this.accountPaymentPerYear;
        return data;
    }
}

export interface ILeuteUndGeldBaseModel {
    version?: number;
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    licensedUserCount?: number;
    licensedUserCountBasic?: number;
    paymentFreeUsers?: number;
    paymentIntervalMonths?: number;
    paymentBasePriceCent?: number;
    paymentBasePriceCentYearly?: number;
    paymentPaidTill?: string | undefined;
    paymentType?: string | undefined;
    lastEntry?: string;
    paymentBasePriceCentBasic?: number;
    paymentBasePriceCentYearlyBasic?: number;
    useBasicTimeTracking?: boolean;
    basicUserCount?: number;
    accountPaymentBasicPerMonth?: number;
    fullUserCount?: number;
    accountPaymentFullPerMonth?: number;
    accountPaymentPerMonth?: number;
    accountPaymentPerYear?: number;
}

export class UnpaidInvoiceViewModel implements IUnpaidInvoiceViewModel {
    id?: number;
    invoiceNumber?: string | undefined;
    createdDate?: string;
    daysOld?: number;
    basePriceCent?: number;
    amountCent?: number;
    vatAmountCent?: number;
    vatReverseCharge?: boolean;
    grossAmountCent?: number;
    grossAmountEuro?: number;
    account?: UnpaidInvoiceAccountViewModel | undefined;
    userCount?: number;
    isPaid?: boolean;
    paymentMethod?: string | undefined;
    paidTill?: string;
    paymentReminderSentDateTime?: string | undefined;
    paidAt?: string | undefined;
    paymentError?: string | undefined;
    paymentStatus?: PaymentStatusEnum;
    lastStatusCheck?: string | undefined;
    emailSentDateTime?: string | undefined;
    isMigratedFromSt2?: boolean;

    constructor(data?: IUnpaidInvoiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.createdDate = _data["createdDate"];
            this.daysOld = _data["daysOld"];
            this.basePriceCent = _data["basePriceCent"];
            this.amountCent = _data["amountCent"];
            this.vatAmountCent = _data["vatAmountCent"];
            this.vatReverseCharge = _data["vatReverseCharge"];
            this.grossAmountCent = _data["grossAmountCent"];
            this.grossAmountEuro = _data["grossAmountEuro"];
            this.account = _data["account"] ? UnpaidInvoiceAccountViewModel.fromJS(_data["account"]) : <any>undefined;
            this.userCount = _data["userCount"];
            this.isPaid = _data["isPaid"];
            this.paymentMethod = _data["paymentMethod"];
            this.paidTill = _data["paidTill"];
            this.paymentReminderSentDateTime = _data["paymentReminderSentDateTime"];
            this.paidAt = _data["paidAt"];
            this.paymentError = _data["paymentError"];
            this.paymentStatus = _data["paymentStatus"];
            this.lastStatusCheck = _data["lastStatusCheck"];
            this.emailSentDateTime = _data["emailSentDateTime"];
            this.isMigratedFromSt2 = _data["isMigratedFromSt2"];
        }
    }

    static fromJS(data: any): UnpaidInvoiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UnpaidInvoiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["createdDate"] = this.createdDate;
        data["daysOld"] = this.daysOld;
        data["basePriceCent"] = this.basePriceCent;
        data["amountCent"] = this.amountCent;
        data["vatAmountCent"] = this.vatAmountCent;
        data["vatReverseCharge"] = this.vatReverseCharge;
        data["grossAmountCent"] = this.grossAmountCent;
        data["grossAmountEuro"] = this.grossAmountEuro;
        data["account"] = this.account ? this.account.toJSON() : <any>undefined;
        data["userCount"] = this.userCount;
        data["isPaid"] = this.isPaid;
        data["paymentMethod"] = this.paymentMethod;
        data["paidTill"] = this.paidTill;
        data["paymentReminderSentDateTime"] = this.paymentReminderSentDateTime;
        data["paidAt"] = this.paidAt;
        data["paymentError"] = this.paymentError;
        data["paymentStatus"] = this.paymentStatus;
        data["lastStatusCheck"] = this.lastStatusCheck;
        data["emailSentDateTime"] = this.emailSentDateTime;
        data["isMigratedFromSt2"] = this.isMigratedFromSt2;
        return data;
    }
}

export interface IUnpaidInvoiceViewModel {
    id?: number;
    invoiceNumber?: string | undefined;
    createdDate?: string;
    daysOld?: number;
    basePriceCent?: number;
    amountCent?: number;
    vatAmountCent?: number;
    vatReverseCharge?: boolean;
    grossAmountCent?: number;
    grossAmountEuro?: number;
    account?: UnpaidInvoiceAccountViewModel | undefined;
    userCount?: number;
    isPaid?: boolean;
    paymentMethod?: string | undefined;
    paidTill?: string;
    paymentReminderSentDateTime?: string | undefined;
    paidAt?: string | undefined;
    paymentError?: string | undefined;
    paymentStatus?: PaymentStatusEnum;
    lastStatusCheck?: string | undefined;
    emailSentDateTime?: string | undefined;
    isMigratedFromSt2?: boolean;
}

export class UnpaidInvoiceAccountViewModel implements IUnpaidInvoiceAccountViewModel {
    email?: string | undefined;
    invoiceEmail?: string | undefined;
    licensedUserCount?: number;
    payedUserCount?: number;
    paymentIsSetup?: boolean;
    firstAdminUserEmail?: string | undefined;

    constructor(data?: IUnpaidInvoiceAccountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.invoiceEmail = _data["invoiceEmail"];
            this.licensedUserCount = _data["licensedUserCount"];
            this.payedUserCount = _data["payedUserCount"];
            this.paymentIsSetup = _data["paymentIsSetup"];
            this.firstAdminUserEmail = _data["firstAdminUserEmail"];
        }
    }

    static fromJS(data: any): UnpaidInvoiceAccountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UnpaidInvoiceAccountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["invoiceEmail"] = this.invoiceEmail;
        data["licensedUserCount"] = this.licensedUserCount;
        data["payedUserCount"] = this.payedUserCount;
        data["paymentIsSetup"] = this.paymentIsSetup;
        data["firstAdminUserEmail"] = this.firstAdminUserEmail;
        return data;
    }
}

export interface IUnpaidInvoiceAccountViewModel {
    email?: string | undefined;
    invoiceEmail?: string | undefined;
    licensedUserCount?: number;
    payedUserCount?: number;
    paymentIsSetup?: boolean;
    firstAdminUserEmail?: string | undefined;
}

export class SetInvoicePaidEditModel implements ISetInvoicePaidEditModel {
    invoiceId?: number;
    date?: string;

    constructor(data?: ISetInvoicePaidEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.invoiceId = _data["invoiceId"];
            this.date = _data["date"];
        }
    }

    static fromJS(data: any): SetInvoicePaidEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetInvoicePaidEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["invoiceId"] = this.invoiceId;
        data["date"] = this.date;
        return data;
    }
}

export interface ISetInvoicePaidEditModel {
    invoiceId?: number;
    date?: string;
}

export class LockAccountEditModel implements ILockAccountEditModel {
    accountGuid?: string;
    reason?: string | undefined;

    constructor(data?: ILockAccountEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountGuid = _data["accountGuid"];
            this.reason = _data["reason"];
        }
    }

    static fromJS(data: any): LockAccountEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new LockAccountEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountGuid"] = this.accountGuid;
        data["reason"] = this.reason;
        return data;
    }
}

export interface ILockAccountEditModel {
    accountGuid?: string;
    reason?: string | undefined;
}

export class UpcomingPaymentsViewModel implements IUpcomingPaymentsViewModel {
    payments?: AccountPayment[] | undefined;
    yearlyPayments?: UpcomingPaymentYearModel[] | undefined;
    dailyPayments?: UpcomingPaymentDayModel[] | undefined;
    monthlyPayments?: UpcomingPaymentMonthModel[] | undefined;

    constructor(data?: IUpcomingPaymentsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["payments"])) {
                this.payments = [] as any;
                for (let item of _data["payments"])
                    this.payments!.push(AccountPayment.fromJS(item));
            }
            if (Array.isArray(_data["yearlyPayments"])) {
                this.yearlyPayments = [] as any;
                for (let item of _data["yearlyPayments"])
                    this.yearlyPayments!.push(UpcomingPaymentYearModel.fromJS(item));
            }
            if (Array.isArray(_data["dailyPayments"])) {
                this.dailyPayments = [] as any;
                for (let item of _data["dailyPayments"])
                    this.dailyPayments!.push(UpcomingPaymentDayModel.fromJS(item));
            }
            if (Array.isArray(_data["monthlyPayments"])) {
                this.monthlyPayments = [] as any;
                for (let item of _data["monthlyPayments"])
                    this.monthlyPayments!.push(UpcomingPaymentMonthModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UpcomingPaymentsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpcomingPaymentsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payments)) {
            data["payments"] = [];
            for (let item of this.payments)
                data["payments"].push(item.toJSON());
        }
        if (Array.isArray(this.yearlyPayments)) {
            data["yearlyPayments"] = [];
            for (let item of this.yearlyPayments)
                data["yearlyPayments"].push(item.toJSON());
        }
        if (Array.isArray(this.dailyPayments)) {
            data["dailyPayments"] = [];
            for (let item of this.dailyPayments)
                data["dailyPayments"].push(item.toJSON());
        }
        if (Array.isArray(this.monthlyPayments)) {
            data["monthlyPayments"] = [];
            for (let item of this.monthlyPayments)
                data["monthlyPayments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUpcomingPaymentsViewModel {
    payments?: AccountPayment[] | undefined;
    yearlyPayments?: UpcomingPaymentYearModel[] | undefined;
    dailyPayments?: UpcomingPaymentDayModel[] | undefined;
    monthlyPayments?: UpcomingPaymentMonthModel[] | undefined;
}

export class AccountPayment implements IAccountPayment {
    date?: string;
    accountId?: number;
    email?: string | undefined;
    amount?: number;
    amountFull?: number;
    amountBasic?: number;
    paymentMethod?: string | undefined;
    licensedUserCount?: number;
    paymentInterval?: string | undefined;
    invoiceDate?: string;
    paymentDate?: string;

    constructor(data?: IAccountPayment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.accountId = _data["accountId"];
            this.email = _data["email"];
            this.amount = _data["amount"];
            this.amountFull = _data["amountFull"];
            this.amountBasic = _data["amountBasic"];
            this.paymentMethod = _data["paymentMethod"];
            this.licensedUserCount = _data["licensedUserCount"];
            this.paymentInterval = _data["paymentInterval"];
            this.invoiceDate = _data["invoiceDate"];
            this.paymentDate = _data["paymentDate"];
        }
    }

    static fromJS(data: any): AccountPayment {
        data = typeof data === 'object' ? data : {};
        let result = new AccountPayment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["accountId"] = this.accountId;
        data["email"] = this.email;
        data["amount"] = this.amount;
        data["amountFull"] = this.amountFull;
        data["amountBasic"] = this.amountBasic;
        data["paymentMethod"] = this.paymentMethod;
        data["licensedUserCount"] = this.licensedUserCount;
        data["paymentInterval"] = this.paymentInterval;
        data["invoiceDate"] = this.invoiceDate;
        data["paymentDate"] = this.paymentDate;
        return data;
    }
}

export interface IAccountPayment {
    date?: string;
    accountId?: number;
    email?: string | undefined;
    amount?: number;
    amountFull?: number;
    amountBasic?: number;
    paymentMethod?: string | undefined;
    licensedUserCount?: number;
    paymentInterval?: string | undefined;
    invoiceDate?: string;
    paymentDate?: string;
}

export class UpcomingPaymentYearModel implements IUpcomingPaymentYearModel {
    year?: number;
    amount?: number;
    amountFull?: number;
    amountBasic?: number;

    constructor(data?: IUpcomingPaymentYearModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.amount = _data["amount"];
            this.amountFull = _data["amountFull"];
            this.amountBasic = _data["amountBasic"];
        }
    }

    static fromJS(data: any): UpcomingPaymentYearModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpcomingPaymentYearModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["amount"] = this.amount;
        data["amountFull"] = this.amountFull;
        data["amountBasic"] = this.amountBasic;
        return data;
    }
}

export interface IUpcomingPaymentYearModel {
    year?: number;
    amount?: number;
    amountFull?: number;
    amountBasic?: number;
}

export class UpcomingPaymentDayModel implements IUpcomingPaymentDayModel {
    date?: string;
    amount?: number;
    amountFull?: number;
    amountBasic?: number;

    constructor(data?: IUpcomingPaymentDayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.amount = _data["amount"];
            this.amountFull = _data["amountFull"];
            this.amountBasic = _data["amountBasic"];
        }
    }

    static fromJS(data: any): UpcomingPaymentDayModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpcomingPaymentDayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["amount"] = this.amount;
        data["amountFull"] = this.amountFull;
        data["amountBasic"] = this.amountBasic;
        return data;
    }
}

export interface IUpcomingPaymentDayModel {
    date?: string;
    amount?: number;
    amountFull?: number;
    amountBasic?: number;
}

export class UpcomingPaymentMonthModel implements IUpcomingPaymentMonthModel {
    date?: string;
    amount?: number;
    amountFull?: number;
    amountBasic?: number;

    constructor(data?: IUpcomingPaymentMonthModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.amount = _data["amount"];
            this.amountFull = _data["amountFull"];
            this.amountBasic = _data["amountBasic"];
        }
    }

    static fromJS(data: any): UpcomingPaymentMonthModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpcomingPaymentMonthModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["amount"] = this.amount;
        data["amountFull"] = this.amountFull;
        data["amountBasic"] = this.amountBasic;
        return data;
    }
}

export interface IUpcomingPaymentMonthModel {
    date?: string;
    amount?: number;
    amountFull?: number;
    amountBasic?: number;
}

export class AppUserBillableTargetHistoryEditModel implements IAppUserBillableTargetHistoryEditModel {
    id?: string;
    appUserId?: number;
    validFrom?: string;
    billableTargetPercent?: number;
    editMode?: boolean;

    constructor(data?: IAppUserBillableTargetHistoryEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appUserId = _data["appUserId"];
            this.validFrom = _data["validFrom"];
            this.billableTargetPercent = _data["billableTargetPercent"];
            this.editMode = _data["editMode"];
        }
    }

    static fromJS(data: any): AppUserBillableTargetHistoryEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserBillableTargetHistoryEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appUserId"] = this.appUserId;
        data["validFrom"] = this.validFrom;
        data["billableTargetPercent"] = this.billableTargetPercent;
        data["editMode"] = this.editMode;
        return data;
    }
}

export interface IAppUserBillableTargetHistoryEditModel {
    id?: string;
    appUserId?: number;
    validFrom?: string;
    billableTargetPercent?: number;
    editMode?: boolean;
}

export class AppUserBillableTargetHistoryFilter implements IAppUserBillableTargetHistoryFilter {
    id?: string | undefined;
    appUserId?: number | undefined;

    constructor(data?: IAppUserBillableTargetHistoryFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appUserId = _data["appUserId"];
        }
    }

    static fromJS(data: any): AppUserBillableTargetHistoryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserBillableTargetHistoryFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appUserId"] = this.appUserId;
        return data;
    }
}

export interface IAppUserBillableTargetHistoryFilter {
    id?: string | undefined;
    appUserId?: number | undefined;
}

export class AppUserSettings implements IAppUserSettings {
    featureFlagInvoiceEmail?: boolean;
    featureFlagInternalUserCost?: boolean;
    featureFlagTeamOverview?: boolean;
    featureFlagEmployeeData?: boolean;
    featureFlagDisableVacationCarryOver?: boolean;
    featureFlagNightWorkReport?: boolean;
    featureFlagTimeApproval?: boolean;
    featureFlagPassiveUsers?: boolean;
    featureFlagMixedUsers?: boolean;
    featureFlagLastUsedProjects?: boolean;
    featureFlagBillableTarget?: boolean;
    featureFlagHideTimeAccount?: boolean;
    featureFlagFixedPriceProjects?: boolean;
    featureFlagTimeAccountSummaryOnTimeEntryPage?: boolean;
    featureFlagTimeAccountTeamOverview?: boolean;
    featureFlagAppUserDepartmentInfo?: boolean;
    featureFlagCustomerProjectId?: boolean;
    featureFlagTeamOverviewPauseRules?: boolean;
    hasValidSetup?: boolean;
    setupErrors?: SetupError[] | undefined;
    userRights?: RightEnum[] | undefined;
    appUserId?: number;
    appUserName?: string | undefined;
    accountId?: number;
    accountEmail?: string | undefined;
    accountName?: string | undefined;
    currency?: string | undefined;
    firstDayOfWeek?: DayOfWeek;
    firstDayOfWeekInt?: number;
    useRateRules?: boolean;
    tagsRequired?: boolean;
    useProjectTasks?: boolean;
    projectTaskRequired?: boolean;
    descriptionMinChars?: number;
    useTags?: boolean;
    allowEntriesOnFreeDays?: boolean;
    useWorkHours?: boolean;
    timeRoundingInterval?: number;
    timeEntriesShowFullWeek?: boolean;
    mainColor?: string | undefined;
    secondaryColor?: string | undefined;
    templateName?: string | undefined;
    menuColor?: MenuColorEnum;
    successButtonColor?: SuccessButtonColorEnum;
    useAbsences?: boolean;
    useTimeAccount?: boolean;
    datePattern?: string | undefined;
    timePattern?: string | undefined;
    timeEntryIsBillableNotChangeable?: boolean;
    userNowDateTime?: string;
    hasActiveProjectTasks?: boolean;
    hasProjectTasks?: boolean;
    hasRates?: boolean;
    hasOutgoingInvoices?: boolean;
    hasTags?: boolean;
    paymentStatus?: PaymentStatusViewModel | undefined;
    isMigratedFromSt2?: boolean;
    isFullyMigratedFromSt2?: boolean;
    onboardingCompleted?: boolean;
    accountIsConfirmed?: boolean;
    noRates?: boolean;
    appColorPrimary?: AppColorEnum;
    appColorSecondary?: AppColorEnum;
    timeEntryMode?: TimeEntryModeEnum;
    stopwatchUseLastDescription?: boolean;
    noOutgoingInvoices?: boolean;
    useInvoiceEmailSending?: boolean;
    timeAccountDisplayDetails?: boolean;
    useInternalUserCost?: boolean;
    accountIsLocked?: boolean;
    accountIsLockedAdminReason?: string | undefined;
    showConsumedBudgetOnSave?: boolean;
    language?: string | undefined;
    useBasicTimeTracking?: boolean;
    isBasicTimeTrackingUser?: boolean;
    pauseMode?: PauseMode;
    usePauseRuleWarnings?: boolean;
    enforcePauseRules?: boolean;
    restrictDateFrom?: string | undefined;
    restrictDateTo?: string | undefined;
    showAdditionalInsertAppUserSelect?: boolean;
    needsTimeEntryApproval?: boolean;
    isPassiveUser?: boolean;
    hasBillableTarget?: boolean;
    useFixedPriceProjects?: boolean;
    hasDirectManagedTeam?: boolean;
    hasIndirectManagedTeam?: boolean;
    useEInvoice?: boolean;
    openTimeEntryWhenStopStopwatch?: boolean;

    constructor(data?: IAppUserSettings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.featureFlagInvoiceEmail = _data["featureFlagInvoiceEmail"];
            this.featureFlagInternalUserCost = _data["featureFlagInternalUserCost"];
            this.featureFlagTeamOverview = _data["featureFlagTeamOverview"];
            this.featureFlagEmployeeData = _data["featureFlagEmployeeData"];
            this.featureFlagDisableVacationCarryOver = _data["featureFlagDisableVacationCarryOver"];
            this.featureFlagNightWorkReport = _data["featureFlagNightWorkReport"];
            this.featureFlagTimeApproval = _data["featureFlagTimeApproval"];
            this.featureFlagPassiveUsers = _data["featureFlagPassiveUsers"];
            this.featureFlagMixedUsers = _data["featureFlagMixedUsers"];
            this.featureFlagLastUsedProjects = _data["featureFlagLastUsedProjects"];
            this.featureFlagBillableTarget = _data["featureFlagBillableTarget"];
            this.featureFlagHideTimeAccount = _data["featureFlagHideTimeAccount"];
            this.featureFlagFixedPriceProjects = _data["featureFlagFixedPriceProjects"];
            this.featureFlagTimeAccountSummaryOnTimeEntryPage = _data["featureFlagTimeAccountSummaryOnTimeEntryPage"];
            this.featureFlagTimeAccountTeamOverview = _data["featureFlagTimeAccountTeamOverview"];
            this.featureFlagAppUserDepartmentInfo = _data["featureFlagAppUserDepartmentInfo"];
            this.featureFlagCustomerProjectId = _data["featureFlagCustomerProjectId"];
            this.featureFlagTeamOverviewPauseRules = _data["featureFlagTeamOverviewPauseRules"];
            this.hasValidSetup = _data["hasValidSetup"];
            if (Array.isArray(_data["setupErrors"])) {
                this.setupErrors = [] as any;
                for (let item of _data["setupErrors"])
                    this.setupErrors!.push(item);
            }
            if (Array.isArray(_data["userRights"])) {
                this.userRights = [] as any;
                for (let item of _data["userRights"])
                    this.userRights!.push(item);
            }
            this.appUserId = _data["appUserId"];
            this.appUserName = _data["appUserName"];
            this.accountId = _data["accountId"];
            this.accountEmail = _data["accountEmail"];
            this.accountName = _data["accountName"];
            this.currency = _data["currency"];
            this.firstDayOfWeek = _data["firstDayOfWeek"];
            this.firstDayOfWeekInt = _data["firstDayOfWeekInt"];
            this.useRateRules = _data["useRateRules"];
            this.tagsRequired = _data["tagsRequired"];
            this.useProjectTasks = _data["useProjectTasks"];
            this.projectTaskRequired = _data["projectTaskRequired"];
            this.descriptionMinChars = _data["descriptionMinChars"];
            this.useTags = _data["useTags"];
            this.allowEntriesOnFreeDays = _data["allowEntriesOnFreeDays"];
            this.useWorkHours = _data["useWorkHours"];
            this.timeRoundingInterval = _data["timeRoundingInterval"];
            this.timeEntriesShowFullWeek = _data["timeEntriesShowFullWeek"];
            this.mainColor = _data["mainColor"];
            this.secondaryColor = _data["secondaryColor"];
            this.templateName = _data["templateName"];
            this.menuColor = _data["menuColor"];
            this.successButtonColor = _data["successButtonColor"];
            this.useAbsences = _data["useAbsences"];
            this.useTimeAccount = _data["useTimeAccount"];
            this.datePattern = _data["datePattern"];
            this.timePattern = _data["timePattern"];
            this.timeEntryIsBillableNotChangeable = _data["timeEntryIsBillableNotChangeable"];
            this.userNowDateTime = _data["userNowDateTime"];
            this.hasActiveProjectTasks = _data["hasActiveProjectTasks"];
            this.hasProjectTasks = _data["hasProjectTasks"];
            this.hasRates = _data["hasRates"];
            this.hasOutgoingInvoices = _data["hasOutgoingInvoices"];
            this.hasTags = _data["hasTags"];
            this.paymentStatus = _data["paymentStatus"] ? PaymentStatusViewModel.fromJS(_data["paymentStatus"]) : <any>undefined;
            this.isMigratedFromSt2 = _data["isMigratedFromSt2"];
            this.isFullyMigratedFromSt2 = _data["isFullyMigratedFromSt2"];
            this.onboardingCompleted = _data["onboardingCompleted"];
            this.accountIsConfirmed = _data["accountIsConfirmed"];
            this.noRates = _data["noRates"];
            this.appColorPrimary = _data["appColorPrimary"];
            this.appColorSecondary = _data["appColorSecondary"];
            this.timeEntryMode = _data["timeEntryMode"];
            this.stopwatchUseLastDescription = _data["stopwatchUseLastDescription"];
            this.noOutgoingInvoices = _data["noOutgoingInvoices"];
            this.useInvoiceEmailSending = _data["useInvoiceEmailSending"];
            this.timeAccountDisplayDetails = _data["timeAccountDisplayDetails"];
            this.useInternalUserCost = _data["useInternalUserCost"];
            this.accountIsLocked = _data["accountIsLocked"];
            this.accountIsLockedAdminReason = _data["accountIsLockedAdminReason"];
            this.showConsumedBudgetOnSave = _data["showConsumedBudgetOnSave"];
            this.language = _data["language"];
            this.useBasicTimeTracking = _data["useBasicTimeTracking"];
            this.isBasicTimeTrackingUser = _data["isBasicTimeTrackingUser"];
            this.pauseMode = _data["pauseMode"];
            this.usePauseRuleWarnings = _data["usePauseRuleWarnings"];
            this.enforcePauseRules = _data["enforcePauseRules"];
            this.restrictDateFrom = _data["restrictDateFrom"];
            this.restrictDateTo = _data["restrictDateTo"];
            this.showAdditionalInsertAppUserSelect = _data["showAdditionalInsertAppUserSelect"];
            this.needsTimeEntryApproval = _data["needsTimeEntryApproval"];
            this.isPassiveUser = _data["isPassiveUser"];
            this.hasBillableTarget = _data["hasBillableTarget"];
            this.useFixedPriceProjects = _data["useFixedPriceProjects"];
            this.hasDirectManagedTeam = _data["hasDirectManagedTeam"];
            this.hasIndirectManagedTeam = _data["hasIndirectManagedTeam"];
            this.useEInvoice = _data["useEInvoice"];
            this.openTimeEntryWhenStopStopwatch = _data["openTimeEntryWhenStopStopwatch"];
        }
    }

    static fromJS(data: any): AppUserSettings {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["featureFlagInvoiceEmail"] = this.featureFlagInvoiceEmail;
        data["featureFlagInternalUserCost"] = this.featureFlagInternalUserCost;
        data["featureFlagTeamOverview"] = this.featureFlagTeamOverview;
        data["featureFlagEmployeeData"] = this.featureFlagEmployeeData;
        data["featureFlagDisableVacationCarryOver"] = this.featureFlagDisableVacationCarryOver;
        data["featureFlagNightWorkReport"] = this.featureFlagNightWorkReport;
        data["featureFlagTimeApproval"] = this.featureFlagTimeApproval;
        data["featureFlagPassiveUsers"] = this.featureFlagPassiveUsers;
        data["featureFlagMixedUsers"] = this.featureFlagMixedUsers;
        data["featureFlagLastUsedProjects"] = this.featureFlagLastUsedProjects;
        data["featureFlagBillableTarget"] = this.featureFlagBillableTarget;
        data["featureFlagHideTimeAccount"] = this.featureFlagHideTimeAccount;
        data["featureFlagFixedPriceProjects"] = this.featureFlagFixedPriceProjects;
        data["featureFlagTimeAccountSummaryOnTimeEntryPage"] = this.featureFlagTimeAccountSummaryOnTimeEntryPage;
        data["featureFlagTimeAccountTeamOverview"] = this.featureFlagTimeAccountTeamOverview;
        data["featureFlagAppUserDepartmentInfo"] = this.featureFlagAppUserDepartmentInfo;
        data["featureFlagCustomerProjectId"] = this.featureFlagCustomerProjectId;
        data["featureFlagTeamOverviewPauseRules"] = this.featureFlagTeamOverviewPauseRules;
        data["hasValidSetup"] = this.hasValidSetup;
        if (Array.isArray(this.setupErrors)) {
            data["setupErrors"] = [];
            for (let item of this.setupErrors)
                data["setupErrors"].push(item);
        }
        if (Array.isArray(this.userRights)) {
            data["userRights"] = [];
            for (let item of this.userRights)
                data["userRights"].push(item);
        }
        data["appUserId"] = this.appUserId;
        data["appUserName"] = this.appUserName;
        data["accountId"] = this.accountId;
        data["accountEmail"] = this.accountEmail;
        data["accountName"] = this.accountName;
        data["currency"] = this.currency;
        data["firstDayOfWeek"] = this.firstDayOfWeek;
        data["firstDayOfWeekInt"] = this.firstDayOfWeekInt;
        data["useRateRules"] = this.useRateRules;
        data["tagsRequired"] = this.tagsRequired;
        data["useProjectTasks"] = this.useProjectTasks;
        data["projectTaskRequired"] = this.projectTaskRequired;
        data["descriptionMinChars"] = this.descriptionMinChars;
        data["useTags"] = this.useTags;
        data["allowEntriesOnFreeDays"] = this.allowEntriesOnFreeDays;
        data["useWorkHours"] = this.useWorkHours;
        data["timeRoundingInterval"] = this.timeRoundingInterval;
        data["timeEntriesShowFullWeek"] = this.timeEntriesShowFullWeek;
        data["mainColor"] = this.mainColor;
        data["secondaryColor"] = this.secondaryColor;
        data["templateName"] = this.templateName;
        data["menuColor"] = this.menuColor;
        data["successButtonColor"] = this.successButtonColor;
        data["useAbsences"] = this.useAbsences;
        data["useTimeAccount"] = this.useTimeAccount;
        data["datePattern"] = this.datePattern;
        data["timePattern"] = this.timePattern;
        data["timeEntryIsBillableNotChangeable"] = this.timeEntryIsBillableNotChangeable;
        data["userNowDateTime"] = this.userNowDateTime;
        data["hasActiveProjectTasks"] = this.hasActiveProjectTasks;
        data["hasProjectTasks"] = this.hasProjectTasks;
        data["hasRates"] = this.hasRates;
        data["hasOutgoingInvoices"] = this.hasOutgoingInvoices;
        data["hasTags"] = this.hasTags;
        data["paymentStatus"] = this.paymentStatus ? this.paymentStatus.toJSON() : <any>undefined;
        data["isMigratedFromSt2"] = this.isMigratedFromSt2;
        data["isFullyMigratedFromSt2"] = this.isFullyMigratedFromSt2;
        data["onboardingCompleted"] = this.onboardingCompleted;
        data["accountIsConfirmed"] = this.accountIsConfirmed;
        data["noRates"] = this.noRates;
        data["appColorPrimary"] = this.appColorPrimary;
        data["appColorSecondary"] = this.appColorSecondary;
        data["timeEntryMode"] = this.timeEntryMode;
        data["stopwatchUseLastDescription"] = this.stopwatchUseLastDescription;
        data["noOutgoingInvoices"] = this.noOutgoingInvoices;
        data["useInvoiceEmailSending"] = this.useInvoiceEmailSending;
        data["timeAccountDisplayDetails"] = this.timeAccountDisplayDetails;
        data["useInternalUserCost"] = this.useInternalUserCost;
        data["accountIsLocked"] = this.accountIsLocked;
        data["accountIsLockedAdminReason"] = this.accountIsLockedAdminReason;
        data["showConsumedBudgetOnSave"] = this.showConsumedBudgetOnSave;
        data["language"] = this.language;
        data["useBasicTimeTracking"] = this.useBasicTimeTracking;
        data["isBasicTimeTrackingUser"] = this.isBasicTimeTrackingUser;
        data["pauseMode"] = this.pauseMode;
        data["usePauseRuleWarnings"] = this.usePauseRuleWarnings;
        data["enforcePauseRules"] = this.enforcePauseRules;
        data["restrictDateFrom"] = this.restrictDateFrom;
        data["restrictDateTo"] = this.restrictDateTo;
        data["showAdditionalInsertAppUserSelect"] = this.showAdditionalInsertAppUserSelect;
        data["needsTimeEntryApproval"] = this.needsTimeEntryApproval;
        data["isPassiveUser"] = this.isPassiveUser;
        data["hasBillableTarget"] = this.hasBillableTarget;
        data["useFixedPriceProjects"] = this.useFixedPriceProjects;
        data["hasDirectManagedTeam"] = this.hasDirectManagedTeam;
        data["hasIndirectManagedTeam"] = this.hasIndirectManagedTeam;
        data["useEInvoice"] = this.useEInvoice;
        data["openTimeEntryWhenStopStopwatch"] = this.openTimeEntryWhenStopStopwatch;
        return data;
    }
}

export interface IAppUserSettings {
    featureFlagInvoiceEmail?: boolean;
    featureFlagInternalUserCost?: boolean;
    featureFlagTeamOverview?: boolean;
    featureFlagEmployeeData?: boolean;
    featureFlagDisableVacationCarryOver?: boolean;
    featureFlagNightWorkReport?: boolean;
    featureFlagTimeApproval?: boolean;
    featureFlagPassiveUsers?: boolean;
    featureFlagMixedUsers?: boolean;
    featureFlagLastUsedProjects?: boolean;
    featureFlagBillableTarget?: boolean;
    featureFlagHideTimeAccount?: boolean;
    featureFlagFixedPriceProjects?: boolean;
    featureFlagTimeAccountSummaryOnTimeEntryPage?: boolean;
    featureFlagTimeAccountTeamOverview?: boolean;
    featureFlagAppUserDepartmentInfo?: boolean;
    featureFlagCustomerProjectId?: boolean;
    featureFlagTeamOverviewPauseRules?: boolean;
    hasValidSetup?: boolean;
    setupErrors?: SetupError[] | undefined;
    userRights?: RightEnum[] | undefined;
    appUserId?: number;
    appUserName?: string | undefined;
    accountId?: number;
    accountEmail?: string | undefined;
    accountName?: string | undefined;
    currency?: string | undefined;
    firstDayOfWeek?: DayOfWeek;
    firstDayOfWeekInt?: number;
    useRateRules?: boolean;
    tagsRequired?: boolean;
    useProjectTasks?: boolean;
    projectTaskRequired?: boolean;
    descriptionMinChars?: number;
    useTags?: boolean;
    allowEntriesOnFreeDays?: boolean;
    useWorkHours?: boolean;
    timeRoundingInterval?: number;
    timeEntriesShowFullWeek?: boolean;
    mainColor?: string | undefined;
    secondaryColor?: string | undefined;
    templateName?: string | undefined;
    menuColor?: MenuColorEnum;
    successButtonColor?: SuccessButtonColorEnum;
    useAbsences?: boolean;
    useTimeAccount?: boolean;
    datePattern?: string | undefined;
    timePattern?: string | undefined;
    timeEntryIsBillableNotChangeable?: boolean;
    userNowDateTime?: string;
    hasActiveProjectTasks?: boolean;
    hasProjectTasks?: boolean;
    hasRates?: boolean;
    hasOutgoingInvoices?: boolean;
    hasTags?: boolean;
    paymentStatus?: PaymentStatusViewModel | undefined;
    isMigratedFromSt2?: boolean;
    isFullyMigratedFromSt2?: boolean;
    onboardingCompleted?: boolean;
    accountIsConfirmed?: boolean;
    noRates?: boolean;
    appColorPrimary?: AppColorEnum;
    appColorSecondary?: AppColorEnum;
    timeEntryMode?: TimeEntryModeEnum;
    stopwatchUseLastDescription?: boolean;
    noOutgoingInvoices?: boolean;
    useInvoiceEmailSending?: boolean;
    timeAccountDisplayDetails?: boolean;
    useInternalUserCost?: boolean;
    accountIsLocked?: boolean;
    accountIsLockedAdminReason?: string | undefined;
    showConsumedBudgetOnSave?: boolean;
    language?: string | undefined;
    useBasicTimeTracking?: boolean;
    isBasicTimeTrackingUser?: boolean;
    pauseMode?: PauseMode;
    usePauseRuleWarnings?: boolean;
    enforcePauseRules?: boolean;
    restrictDateFrom?: string | undefined;
    restrictDateTo?: string | undefined;
    showAdditionalInsertAppUserSelect?: boolean;
    needsTimeEntryApproval?: boolean;
    isPassiveUser?: boolean;
    hasBillableTarget?: boolean;
    useFixedPriceProjects?: boolean;
    hasDirectManagedTeam?: boolean;
    hasIndirectManagedTeam?: boolean;
    useEInvoice?: boolean;
    openTimeEntryWhenStopStopwatch?: boolean;
}

export enum SetupError {
    NoCustomer = "NoCustomer",
}

export enum RightEnum {
    CanEnterTimeEntriesOnFreeDays = "CanEnterTimeEntriesOnFreeDays",
    CanViewRates = "CanViewRates",
    CanOverwriteRates = "CanOverwriteRates",
    CanOverwriteIsBillable = "CanOverwriteIsBillable",
    CanEditCustomersAndProjects = "CanEditCustomersAndProjects",
    CanEditProjectTasks = "CanEditProjectTasks",
    CanEditRateRules = "CanEditRateRules",
    CanEditTags = "CanEditTags",
    CanEditPublicHolidays = "CanEditPublicHolidays",
    CanApproveAbsences = "CanApproveAbsences",
    CanViewAbsencesForEmployees = "CanViewAbsencesForEmployees",
    CanEditAbsencesForEmployees = "CanEditAbsencesForEmployees",
    CanViewTimeEntriesForEmployees = "CanViewTimeEntriesForEmployees",
    CanEditTimeEntriesForEmployees = "CanEditTimeEntriesForEmployees",
    CanEditUsers = "CanEditUsers",
    CanEditAccount = "CanEditAccount",
    CanEditInvoices = "CanEditInvoices",
    CanEditTimeEntryExtraFields = "CanEditTimeEntryExtraFields",
    CanClearEntries = "CanClearEntries",
    CanViewInvoices = "CanViewInvoices",
    CanEditTimeEntriesForAllProjects = "CanEditTimeEntriesForAllProjects",
    CanChangeTimeFromTo = "CanChangeTimeFromTo",
    CanManageAbsences = "CanManageAbsences",
    CanManageTimeAdjustment = "CanManageTimeAdjustment",
    CanDeleteAccount = "CanDeleteAccount",
    CanGetNotifiedOnBudgetOverrun = "CanGetNotifiedOnBudgetOverrun",
    CanManageOwnSickDays = "CanManageOwnSickDays",
    CanViewTeamOverview = "CanViewTeamOverview",
    CanApproveTimeEntryDays = "CanApproveTimeEntryDays",
    CanViewCustomerAndProjects = "CanViewCustomerAndProjects",
    CanApproveTimeAccountWeeklyOvertime = "CanApproveTimeAccountWeeklyOvertime",
}

export enum MenuColorEnum {
    Dark = "Dark",
    Light = "Light",
    Primary = "Primary",
    Secondary = "Secondary",
}

export enum SuccessButtonColorEnum {
    Green = "Green",
    Primary = "Primary",
    Secondary = "Secondary",
}

export class PaymentStatusViewModel implements IPaymentStatusViewModel {
    isInTrial?: boolean;
    paymentIsSetup?: boolean;
    licensedUserCount?: number;
    licensedUserCountBasic?: number;
    hasPaidInAppStoreUntil?: string | undefined;
    trialUntil?: string;

    constructor(data?: IPaymentStatusViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isInTrial = _data["isInTrial"];
            this.paymentIsSetup = _data["paymentIsSetup"];
            this.licensedUserCount = _data["licensedUserCount"];
            this.licensedUserCountBasic = _data["licensedUserCountBasic"];
            this.hasPaidInAppStoreUntil = _data["hasPaidInAppStoreUntil"];
            this.trialUntil = _data["trialUntil"];
        }
    }

    static fromJS(data: any): PaymentStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PaymentStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isInTrial"] = this.isInTrial;
        data["paymentIsSetup"] = this.paymentIsSetup;
        data["licensedUserCount"] = this.licensedUserCount;
        data["licensedUserCountBasic"] = this.licensedUserCountBasic;
        data["hasPaidInAppStoreUntil"] = this.hasPaidInAppStoreUntil;
        data["trialUntil"] = this.trialUntil;
        return data;
    }
}

export interface IPaymentStatusViewModel {
    isInTrial?: boolean;
    paymentIsSetup?: boolean;
    licensedUserCount?: number;
    licensedUserCountBasic?: number;
    hasPaidInAppStoreUntil?: string | undefined;
    trialUntil?: string;
}

export enum AppColorEnum {
    SpikeTime = "SpikeTime",
    Primary = "Primary",
    Secondary = "Secondary",
}

export class AppUserSettingsEditModel implements IAppUserSettingsEditModel {
    username?: string | undefined;
    name?: string | undefined;
    templateName?: string | undefined;
    timeZoneId?: number;
    datePattern?: string | undefined;
    timePattern?: string | undefined;
    timeEntriesShowFullWeek?: boolean;
    stopWatchNotficationEnabled?: boolean;
    timeEntryNotificationEnabled?: boolean;
    absenceRequestNotificationEnabled?: boolean;
    timeRoundingInterval?: number;
    menuColor?: MenuColorEnum;
    successButtonColor?: SuccessButtonColorEnum;
    appColorPrimary?: AppColorEnum;
    appColorSecondary?: AppColorEnum;
    stopwatchUseLastDescription?: boolean;
    language?: string | undefined;

    constructor(data?: IAppUserSettingsEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.username = _data["username"];
            this.name = _data["name"];
            this.templateName = _data["templateName"];
            this.timeZoneId = _data["timeZoneId"];
            this.datePattern = _data["datePattern"];
            this.timePattern = _data["timePattern"];
            this.timeEntriesShowFullWeek = _data["timeEntriesShowFullWeek"];
            this.stopWatchNotficationEnabled = _data["stopWatchNotficationEnabled"];
            this.timeEntryNotificationEnabled = _data["timeEntryNotificationEnabled"];
            this.absenceRequestNotificationEnabled = _data["absenceRequestNotificationEnabled"];
            this.timeRoundingInterval = _data["timeRoundingInterval"];
            this.menuColor = _data["menuColor"];
            this.successButtonColor = _data["successButtonColor"];
            this.appColorPrimary = _data["appColorPrimary"];
            this.appColorSecondary = _data["appColorSecondary"];
            this.stopwatchUseLastDescription = _data["stopwatchUseLastDescription"];
            this.language = _data["language"];
        }
    }

    static fromJS(data: any): AppUserSettingsEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserSettingsEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["username"] = this.username;
        data["name"] = this.name;
        data["templateName"] = this.templateName;
        data["timeZoneId"] = this.timeZoneId;
        data["datePattern"] = this.datePattern;
        data["timePattern"] = this.timePattern;
        data["timeEntriesShowFullWeek"] = this.timeEntriesShowFullWeek;
        data["stopWatchNotficationEnabled"] = this.stopWatchNotficationEnabled;
        data["timeEntryNotificationEnabled"] = this.timeEntryNotificationEnabled;
        data["absenceRequestNotificationEnabled"] = this.absenceRequestNotificationEnabled;
        data["timeRoundingInterval"] = this.timeRoundingInterval;
        data["menuColor"] = this.menuColor;
        data["successButtonColor"] = this.successButtonColor;
        data["appColorPrimary"] = this.appColorPrimary;
        data["appColorSecondary"] = this.appColorSecondary;
        data["stopwatchUseLastDescription"] = this.stopwatchUseLastDescription;
        data["language"] = this.language;
        return data;
    }
}

export interface IAppUserSettingsEditModel {
    username?: string | undefined;
    name?: string | undefined;
    templateName?: string | undefined;
    timeZoneId?: number;
    datePattern?: string | undefined;
    timePattern?: string | undefined;
    timeEntriesShowFullWeek?: boolean;
    stopWatchNotficationEnabled?: boolean;
    timeEntryNotificationEnabled?: boolean;
    absenceRequestNotificationEnabled?: boolean;
    timeRoundingInterval?: number;
    menuColor?: MenuColorEnum;
    successButtonColor?: SuccessButtonColorEnum;
    appColorPrimary?: AppColorEnum;
    appColorSecondary?: AppColorEnum;
    stopwatchUseLastDescription?: boolean;
    language?: string | undefined;
}

export class AppUserChangePasswordEditModel implements IAppUserChangePasswordEditModel {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    newPasswordConfirm?: string | undefined;

    constructor(data?: IAppUserChangePasswordEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.oldPassword = _data["oldPassword"];
            this.newPassword = _data["newPassword"];
            this.newPasswordConfirm = _data["newPasswordConfirm"];
        }
    }

    static fromJS(data: any): AppUserChangePasswordEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserChangePasswordEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["oldPassword"] = this.oldPassword;
        data["newPassword"] = this.newPassword;
        data["newPasswordConfirm"] = this.newPasswordConfirm;
        return data;
    }
}

export interface IAppUserChangePasswordEditModel {
    oldPassword?: string | undefined;
    newPassword?: string | undefined;
    newPasswordConfirm?: string | undefined;
}

export class StSelectListItem implements IStSelectListItem {
    id?: number;
    description?: string | undefined;
    childItems?: StSelectListItem[] | undefined;

    constructor(data?: IStSelectListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            if (Array.isArray(_data["childItems"])) {
                this.childItems = [] as any;
                for (let item of _data["childItems"])
                    this.childItems!.push(StSelectListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StSelectListItem {
        data = typeof data === 'object' ? data : {};
        let result = new StSelectListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        if (Array.isArray(this.childItems)) {
            data["childItems"] = [];
            for (let item of this.childItems)
                data["childItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStSelectListItem {
    id?: number;
    description?: string | undefined;
    childItems?: StSelectListItem[] | undefined;
}

export class AppUserFilter implements IAppUserFilter {
    id?: number | undefined;
    ids?: number[] | undefined;
    isArchived?: boolean | undefined;
    roleEnum?: RoleEnum | undefined;
    isPassiveUser?: boolean | undefined;
    isBasicTimeTrackingUser?: boolean | undefined;

    constructor(data?: IAppUserFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.isArchived = _data["isArchived"];
            this.roleEnum = _data["roleEnum"];
            this.isPassiveUser = _data["isPassiveUser"];
            this.isBasicTimeTrackingUser = _data["isBasicTimeTrackingUser"];
        }
    }

    static fromJS(data: any): AppUserFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["isArchived"] = this.isArchived;
        data["roleEnum"] = this.roleEnum;
        data["isPassiveUser"] = this.isPassiveUser;
        data["isBasicTimeTrackingUser"] = this.isBasicTimeTrackingUser;
        return data;
    }
}

export interface IAppUserFilter {
    id?: number | undefined;
    ids?: number[] | undefined;
    isArchived?: boolean | undefined;
    roleEnum?: RoleEnum | undefined;
    isPassiveUser?: boolean | undefined;
    isBasicTimeTrackingUser?: boolean | undefined;
}

export enum RoleEnum {
    Administrator = "Administrator",
    Manager = "Manager",
    Employee = "Employee",
}

export class StSelectListItemGroup implements IStSelectListItemGroup {
    groupName?: string | undefined;
    items?: StSelectListItem[] | undefined;

    constructor(data?: IStSelectListItemGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(StSelectListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StSelectListItemGroup {
        data = typeof data === 'object' ? data : {};
        let result = new StSelectListItemGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStSelectListItemGroup {
    groupName?: string | undefined;
    items?: StSelectListItem[] | undefined;
}

export class AppUserEditModel implements IAppUserEditModel {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    isArchived?: boolean;
    employeeNumber?: string | undefined;
    managerId?: number | undefined;
    useWorkHours?: boolean;
    publicHolidayGroupId?: number | undefined;
    roleId?: number;
    timeRoundingInterval?: number;
    isPassiveUser?: boolean;
    isPassiveUserManager?: boolean;
    isBasicTimeTrackingUser?: boolean;
    externalUserId?: string | undefined;
    featureFlagAppUserDepartmentInfoString?: string | undefined;

    constructor(data?: IAppUserEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.isArchived = _data["isArchived"];
            this.employeeNumber = _data["employeeNumber"];
            this.managerId = _data["managerId"];
            this.useWorkHours = _data["useWorkHours"];
            this.publicHolidayGroupId = _data["publicHolidayGroupId"];
            this.roleId = _data["roleId"];
            this.timeRoundingInterval = _data["timeRoundingInterval"];
            this.isPassiveUser = _data["isPassiveUser"];
            this.isPassiveUserManager = _data["isPassiveUserManager"];
            this.isBasicTimeTrackingUser = _data["isBasicTimeTrackingUser"];
            this.externalUserId = _data["externalUserId"];
            this.featureFlagAppUserDepartmentInfoString = _data["featureFlagAppUserDepartmentInfoString"];
        }
    }

    static fromJS(data: any): AppUserEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["isArchived"] = this.isArchived;
        data["employeeNumber"] = this.employeeNumber;
        data["managerId"] = this.managerId;
        data["useWorkHours"] = this.useWorkHours;
        data["publicHolidayGroupId"] = this.publicHolidayGroupId;
        data["roleId"] = this.roleId;
        data["timeRoundingInterval"] = this.timeRoundingInterval;
        data["isPassiveUser"] = this.isPassiveUser;
        data["isPassiveUserManager"] = this.isPassiveUserManager;
        data["isBasicTimeTrackingUser"] = this.isBasicTimeTrackingUser;
        data["externalUserId"] = this.externalUserId;
        data["featureFlagAppUserDepartmentInfoString"] = this.featureFlagAppUserDepartmentInfoString;
        return data;
    }
}

export interface IAppUserEditModel {
    id?: number;
    name?: string | undefined;
    email?: string | undefined;
    isArchived?: boolean;
    employeeNumber?: string | undefined;
    managerId?: number | undefined;
    useWorkHours?: boolean;
    publicHolidayGroupId?: number | undefined;
    roleId?: number;
    timeRoundingInterval?: number;
    isPassiveUser?: boolean;
    isPassiveUserManager?: boolean;
    isBasicTimeTrackingUser?: boolean;
    externalUserId?: string | undefined;
    featureFlagAppUserDepartmentInfoString?: string | undefined;
}

export class AppUserHistoryEditModel implements IAppUserHistoryEditModel {
    id?: string;
    appUserId?: number;
    weeklyWorkHours?: number;
    dailyWorkHours?: WorkHoursDay[] | undefined;
    useDailyWorkHours?: boolean;
    validFrom?: string;
    isDeleted?: boolean;
    editMode?: boolean;

    constructor(data?: IAppUserHistoryEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appUserId = _data["appUserId"];
            this.weeklyWorkHours = _data["weeklyWorkHours"];
            if (Array.isArray(_data["dailyWorkHours"])) {
                this.dailyWorkHours = [] as any;
                for (let item of _data["dailyWorkHours"])
                    this.dailyWorkHours!.push(WorkHoursDay.fromJS(item));
            }
            this.useDailyWorkHours = _data["useDailyWorkHours"];
            this.validFrom = _data["validFrom"];
            this.isDeleted = _data["isDeleted"];
            this.editMode = _data["editMode"];
        }
    }

    static fromJS(data: any): AppUserHistoryEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserHistoryEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appUserId"] = this.appUserId;
        data["weeklyWorkHours"] = this.weeklyWorkHours;
        if (Array.isArray(this.dailyWorkHours)) {
            data["dailyWorkHours"] = [];
            for (let item of this.dailyWorkHours)
                data["dailyWorkHours"].push(item.toJSON());
        }
        data["useDailyWorkHours"] = this.useDailyWorkHours;
        data["validFrom"] = this.validFrom;
        data["isDeleted"] = this.isDeleted;
        data["editMode"] = this.editMode;
        return data;
    }
}

export interface IAppUserHistoryEditModel {
    id?: string;
    appUserId?: number;
    weeklyWorkHours?: number;
    dailyWorkHours?: WorkHoursDay[] | undefined;
    useDailyWorkHours?: boolean;
    validFrom?: string;
    isDeleted?: boolean;
    editMode?: boolean;
}

export class WorkHoursDay implements IWorkHoursDay {
    dayOfWeek?: DayOfWeek;
    workingHours?: number;

    constructor(data?: IWorkHoursDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dayOfWeek = _data["dayOfWeek"];
            this.workingHours = _data["workingHours"];
        }
    }

    static fromJS(data: any): WorkHoursDay {
        data = typeof data === 'object' ? data : {};
        let result = new WorkHoursDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dayOfWeek"] = this.dayOfWeek;
        data["workingHours"] = this.workingHours;
        return data;
    }
}

export interface IWorkHoursDay {
    dayOfWeek?: DayOfWeek;
    workingHours?: number;
}

export class AppUserHistoryFilter implements IAppUserHistoryFilter {
    id?: string | undefined;
    appUserId?: number | undefined;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;

    constructor(data?: IAppUserHistoryFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appUserId = _data["appUserId"];
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
        }
    }

    static fromJS(data: any): AppUserHistoryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserHistoryFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appUserId"] = this.appUserId;
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        return data;
    }
}

export interface IAppUserHistoryFilter {
    id?: string | undefined;
    appUserId?: number | undefined;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
}

export class AppUserInternalCostHistoryEditModel implements IAppUserInternalCostHistoryEditModel {
    id?: string;
    appUserId?: number;
    costPerHour?: number;
    validFrom?: string;
    isDeleted?: boolean;
    editMode?: boolean;

    constructor(data?: IAppUserInternalCostHistoryEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appUserId = _data["appUserId"];
            this.costPerHour = _data["costPerHour"];
            this.validFrom = _data["validFrom"];
            this.isDeleted = _data["isDeleted"];
            this.editMode = _data["editMode"];
        }
    }

    static fromJS(data: any): AppUserInternalCostHistoryEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserInternalCostHistoryEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appUserId"] = this.appUserId;
        data["costPerHour"] = this.costPerHour;
        data["validFrom"] = this.validFrom;
        data["isDeleted"] = this.isDeleted;
        data["editMode"] = this.editMode;
        return data;
    }
}

export interface IAppUserInternalCostHistoryEditModel {
    id?: string;
    appUserId?: number;
    costPerHour?: number;
    validFrom?: string;
    isDeleted?: boolean;
    editMode?: boolean;
}

export class AppUserInternalCostHistoryFilter implements IAppUserInternalCostHistoryFilter {
    id?: string | undefined;
    appUserId?: number | undefined;
    dateFrom?: string | undefined;

    constructor(data?: IAppUserInternalCostHistoryFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appUserId = _data["appUserId"];
            this.dateFrom = _data["dateFrom"];
        }
    }

    static fromJS(data: any): AppUserInternalCostHistoryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserInternalCostHistoryFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appUserId"] = this.appUserId;
        data["dateFrom"] = this.dateFrom;
        return data;
    }
}

export interface IAppUserInternalCostHistoryFilter {
    id?: string | undefined;
    appUserId?: number | undefined;
    dateFrom?: string | undefined;
}

export class AppUserRightEditModel implements IAppUserRightEditModel {
    appUserId?: number;
    rightId?: number;
    rightDescription?: string | undefined;
    isAllowed?: boolean;
    isMasterDataRight?: boolean;
    rightEnum?: RightEnum;
    sort?: number;
    hidden?: boolean;

    constructor(data?: IAppUserRightEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appUserId = _data["appUserId"];
            this.rightId = _data["rightId"];
            this.rightDescription = _data["rightDescription"];
            this.isAllowed = _data["isAllowed"];
            this.isMasterDataRight = _data["isMasterDataRight"];
            this.rightEnum = _data["rightEnum"];
            this.sort = _data["sort"];
            this.hidden = _data["hidden"];
        }
    }

    static fromJS(data: any): AppUserRightEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserRightEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appUserId"] = this.appUserId;
        data["rightId"] = this.rightId;
        data["rightDescription"] = this.rightDescription;
        data["isAllowed"] = this.isAllowed;
        data["isMasterDataRight"] = this.isMasterDataRight;
        data["rightEnum"] = this.rightEnum;
        data["sort"] = this.sort;
        data["hidden"] = this.hidden;
        return data;
    }
}

export interface IAppUserRightEditModel {
    appUserId?: number;
    rightId?: number;
    rightDescription?: string | undefined;
    isAllowed?: boolean;
    isMasterDataRight?: boolean;
    rightEnum?: RightEnum;
    sort?: number;
    hidden?: boolean;
}

export class AppUserVacationHistoryEditModel implements IAppUserVacationHistoryEditModel {
    id?: string;
    appUserId?: number;
    validFromYear?: number;
    vacationDaysPerYear?: number;
    editMode?: boolean;

    constructor(data?: IAppUserVacationHistoryEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appUserId = _data["appUserId"];
            this.validFromYear = _data["validFromYear"];
            this.vacationDaysPerYear = _data["vacationDaysPerYear"];
            this.editMode = _data["editMode"];
        }
    }

    static fromJS(data: any): AppUserVacationHistoryEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserVacationHistoryEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appUserId"] = this.appUserId;
        data["validFromYear"] = this.validFromYear;
        data["vacationDaysPerYear"] = this.vacationDaysPerYear;
        data["editMode"] = this.editMode;
        return data;
    }
}

export interface IAppUserVacationHistoryEditModel {
    id?: string;
    appUserId?: number;
    validFromYear?: number;
    vacationDaysPerYear?: number;
    editMode?: boolean;
}

export class AppUserVacationHistoryFilter implements IAppUserVacationHistoryFilter {
    id?: string | undefined;
    appUserId?: number | undefined;

    constructor(data?: IAppUserVacationHistoryFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.appUserId = _data["appUserId"];
        }
    }

    static fromJS(data: any): AppUserVacationHistoryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserVacationHistoryFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["appUserId"] = this.appUserId;
        return data;
    }
}

export interface IAppUserVacationHistoryFilter {
    id?: string | undefined;
    appUserId?: number | undefined;
}

export class AppAccountRegisterModel implements IAppAccountRegisterModel {
    email?: string | undefined;
    password?: string | undefined;
    passwordAgain?: string | undefined;

    constructor(data?: IAppAccountRegisterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
            this.passwordAgain = _data["passwordAgain"];
        }
    }

    static fromJS(data: any): AppAccountRegisterModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppAccountRegisterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        data["passwordAgain"] = this.passwordAgain;
        return data;
    }
}

export interface IAppAccountRegisterModel {
    email?: string | undefined;
    password?: string | undefined;
    passwordAgain?: string | undefined;
}

export class AccountRegisterModel implements IAccountRegisterModel {
    email?: string | undefined;
    registrationSource?: string | undefined;
    name?: string | undefined;
    url?: string | undefined;

    constructor(data?: IAccountRegisterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.registrationSource = _data["registrationSource"];
            this.name = _data["name"];
            this.url = _data["url"];
        }
    }

    static fromJS(data: any): AccountRegisterModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountRegisterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["registrationSource"] = this.registrationSource;
        data["name"] = this.name;
        data["url"] = this.url;
        return data;
    }
}

export interface IAccountRegisterModel {
    email?: string | undefined;
    registrationSource?: string | undefined;
    name?: string | undefined;
    url?: string | undefined;
}

export class PreloginCheckModel implements IPreloginCheckModel {
    st2AccountName?: string | undefined;
    st3UserPresent?: boolean;
    st2Email?: string | undefined;

    constructor(data?: IPreloginCheckModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.st2AccountName = _data["st2AccountName"];
            this.st3UserPresent = _data["st3UserPresent"];
            this.st2Email = _data["st2Email"];
        }
    }

    static fromJS(data: any): PreloginCheckModel {
        data = typeof data === 'object' ? data : {};
        let result = new PreloginCheckModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["st2AccountName"] = this.st2AccountName;
        data["st3UserPresent"] = this.st3UserPresent;
        data["st2Email"] = this.st2Email;
        return data;
    }
}

export interface IPreloginCheckModel {
    st2AccountName?: string | undefined;
    st3UserPresent?: boolean;
    st2Email?: string | undefined;
}

export class AppUserLoginModel implements IAppUserLoginModel {
    email?: string | undefined;
    password?: string | undefined;

    constructor(data?: IAppUserLoginModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.password = _data["password"];
        }
    }

    static fromJS(data: any): AppUserLoginModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserLoginModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["password"] = this.password;
        return data;
    }
}

export interface IAppUserLoginModel {
    email?: string | undefined;
    password?: string | undefined;
}

export class ForgotPasswordModel implements IForgotPasswordModel {
    email?: string | undefined;

    constructor(data?: IForgotPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): ForgotPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ForgotPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        return data;
    }
}

export interface IForgotPasswordModel {
    email?: string | undefined;
}

export class ResetPasswordModel implements IResetPasswordModel {
    id?: string | undefined;
    token?: string | undefined;
    password?: string | undefined;
    passwordAgain?: string | undefined;

    constructor(data?: IResetPasswordModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.token = _data["token"];
            this.password = _data["password"];
            this.passwordAgain = _data["passwordAgain"];
        }
    }

    static fromJS(data: any): ResetPasswordModel {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["token"] = this.token;
        data["password"] = this.password;
        data["passwordAgain"] = this.passwordAgain;
        return data;
    }
}

export interface IResetPasswordModel {
    id?: string | undefined;
    token?: string | undefined;
    password?: string | undefined;
    passwordAgain?: string | undefined;
}

export class CustomerEditModel implements ICustomerEditModel {
    id?: number;
    name!: string;
    contactName?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    streetAddress?: string | undefined;
    country?: string | undefined;
    taxNumberDe?: string | undefined;
    vatId?: string | undefined;
    address?: string | undefined;
    eInvoiceAddressCalculated?: string | undefined;
    comment?: string | undefined;
    commentForTimeTracking?: string | undefined;
    amountModel?: RateRuleAmountModel | undefined;
    invoiceEmail?: string | undefined;
    invoiceEmailText?: string | undefined;
    invoiceEmailTextSettings?: string | undefined;
    invoiceEmailSubject?: string | undefined;
    invoiceEmailSubjectSettings?: string | undefined;
    invoiceTitle?: string | undefined;
    invoiceTitleSettings?: string | undefined;
    invoiceDescription?: string | undefined;
    invoiceDescriptionSettings?: string | undefined;
    invoicePaymentTerms?: string | undefined;
    invoicePaymentTermsSettings?: string | undefined;
    invoicePaymentTermsOverwritten?: boolean;
    invoiceEmailTextOverwritten?: boolean;
    invoiceEmailSubjectOverwritten?: boolean;
    invoiceTitleOverwritten?: boolean;
    invoiceDescriptionOverwritten?: boolean;
    hasNoProjects?: boolean;
    projectEditModel?: ProjectAsCustomerEditModel | undefined;
    isArchived?: boolean;

    constructor(data?: ICustomerEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.contactName = _data["contactName"];
            this.city = _data["city"];
            this.zip = _data["zip"];
            this.streetAddress = _data["streetAddress"];
            this.country = _data["country"];
            this.taxNumberDe = _data["taxNumberDe"];
            this.vatId = _data["vatId"];
            this.address = _data["address"];
            this.eInvoiceAddressCalculated = _data["eInvoiceAddressCalculated"];
            this.comment = _data["comment"];
            this.commentForTimeTracking = _data["commentForTimeTracking"];
            this.amountModel = _data["amountModel"] ? RateRuleAmountModel.fromJS(_data["amountModel"]) : <any>undefined;
            this.invoiceEmail = _data["invoiceEmail"];
            this.invoiceEmailText = _data["invoiceEmailText"];
            this.invoiceEmailTextSettings = _data["invoiceEmailTextSettings"];
            this.invoiceEmailSubject = _data["invoiceEmailSubject"];
            this.invoiceEmailSubjectSettings = _data["invoiceEmailSubjectSettings"];
            this.invoiceTitle = _data["invoiceTitle"];
            this.invoiceTitleSettings = _data["invoiceTitleSettings"];
            this.invoiceDescription = _data["invoiceDescription"];
            this.invoiceDescriptionSettings = _data["invoiceDescriptionSettings"];
            this.invoicePaymentTerms = _data["invoicePaymentTerms"];
            this.invoicePaymentTermsSettings = _data["invoicePaymentTermsSettings"];
            this.invoicePaymentTermsOverwritten = _data["invoicePaymentTermsOverwritten"];
            this.invoiceEmailTextOverwritten = _data["invoiceEmailTextOverwritten"];
            this.invoiceEmailSubjectOverwritten = _data["invoiceEmailSubjectOverwritten"];
            this.invoiceTitleOverwritten = _data["invoiceTitleOverwritten"];
            this.invoiceDescriptionOverwritten = _data["invoiceDescriptionOverwritten"];
            this.hasNoProjects = _data["hasNoProjects"];
            this.projectEditModel = _data["projectEditModel"] ? ProjectAsCustomerEditModel.fromJS(_data["projectEditModel"]) : <any>undefined;
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): CustomerEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["contactName"] = this.contactName;
        data["city"] = this.city;
        data["zip"] = this.zip;
        data["streetAddress"] = this.streetAddress;
        data["country"] = this.country;
        data["taxNumberDe"] = this.taxNumberDe;
        data["vatId"] = this.vatId;
        data["address"] = this.address;
        data["eInvoiceAddressCalculated"] = this.eInvoiceAddressCalculated;
        data["comment"] = this.comment;
        data["commentForTimeTracking"] = this.commentForTimeTracking;
        data["amountModel"] = this.amountModel ? this.amountModel.toJSON() : <any>undefined;
        data["invoiceEmail"] = this.invoiceEmail;
        data["invoiceEmailText"] = this.invoiceEmailText;
        data["invoiceEmailTextSettings"] = this.invoiceEmailTextSettings;
        data["invoiceEmailSubject"] = this.invoiceEmailSubject;
        data["invoiceEmailSubjectSettings"] = this.invoiceEmailSubjectSettings;
        data["invoiceTitle"] = this.invoiceTitle;
        data["invoiceTitleSettings"] = this.invoiceTitleSettings;
        data["invoiceDescription"] = this.invoiceDescription;
        data["invoiceDescriptionSettings"] = this.invoiceDescriptionSettings;
        data["invoicePaymentTerms"] = this.invoicePaymentTerms;
        data["invoicePaymentTermsSettings"] = this.invoicePaymentTermsSettings;
        data["invoicePaymentTermsOverwritten"] = this.invoicePaymentTermsOverwritten;
        data["invoiceEmailTextOverwritten"] = this.invoiceEmailTextOverwritten;
        data["invoiceEmailSubjectOverwritten"] = this.invoiceEmailSubjectOverwritten;
        data["invoiceTitleOverwritten"] = this.invoiceTitleOverwritten;
        data["invoiceDescriptionOverwritten"] = this.invoiceDescriptionOverwritten;
        data["hasNoProjects"] = this.hasNoProjects;
        data["projectEditModel"] = this.projectEditModel ? this.projectEditModel.toJSON() : <any>undefined;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface ICustomerEditModel {
    id?: number;
    name: string;
    contactName?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    streetAddress?: string | undefined;
    country?: string | undefined;
    taxNumberDe?: string | undefined;
    vatId?: string | undefined;
    address?: string | undefined;
    eInvoiceAddressCalculated?: string | undefined;
    comment?: string | undefined;
    commentForTimeTracking?: string | undefined;
    amountModel?: RateRuleAmountModel | undefined;
    invoiceEmail?: string | undefined;
    invoiceEmailText?: string | undefined;
    invoiceEmailTextSettings?: string | undefined;
    invoiceEmailSubject?: string | undefined;
    invoiceEmailSubjectSettings?: string | undefined;
    invoiceTitle?: string | undefined;
    invoiceTitleSettings?: string | undefined;
    invoiceDescription?: string | undefined;
    invoiceDescriptionSettings?: string | undefined;
    invoicePaymentTerms?: string | undefined;
    invoicePaymentTermsSettings?: string | undefined;
    invoicePaymentTermsOverwritten?: boolean;
    invoiceEmailTextOverwritten?: boolean;
    invoiceEmailSubjectOverwritten?: boolean;
    invoiceTitleOverwritten?: boolean;
    invoiceDescriptionOverwritten?: boolean;
    hasNoProjects?: boolean;
    projectEditModel?: ProjectAsCustomerEditModel | undefined;
    isArchived?: boolean;
}

export class RateRuleAmountModel implements IRateRuleAmountModel {
    rateRuleId?: number;
    amount?: number;
    overrideAmount?: boolean;
    parentAmount?: number | undefined;
    sourceRule?: RateRuleEnum;

    constructor(data?: IRateRuleAmountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rateRuleId = _data["rateRuleId"];
            this.amount = _data["amount"];
            this.overrideAmount = _data["overrideAmount"];
            this.parentAmount = _data["parentAmount"];
            this.sourceRule = _data["sourceRule"];
        }
    }

    static fromJS(data: any): RateRuleAmountModel {
        data = typeof data === 'object' ? data : {};
        let result = new RateRuleAmountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rateRuleId"] = this.rateRuleId;
        data["amount"] = this.amount;
        data["overrideAmount"] = this.overrideAmount;
        data["parentAmount"] = this.parentAmount;
        data["sourceRule"] = this.sourceRule;
        return data;
    }
}

export interface IRateRuleAmountModel {
    rateRuleId?: number;
    amount?: number;
    overrideAmount?: boolean;
    parentAmount?: number | undefined;
    sourceRule?: RateRuleEnum;
}

export enum RateRuleEnum {
    Global = "Global",
    Customer = "Customer",
    Project = "Project",
    ProjectTask = "ProjectTask",
    GlobalProjectTask = "GlobalProjectTask",
    AppUser = "AppUser",
}

export class ProjectAsCustomerEditModel implements IProjectAsCustomerEditModel {
    id?: number;
    isBillable?: boolean;
    projectStaff?: ProjectStaffEditModel[] | undefined;
    budget?: number;
    budgetUnit?: BudgetUnitEnum;
    budgetTimeFrame?: BudgetTimeFrameEnum;
    notifyOnBudgetOverrun?: boolean;
    budgetOverrunThresholdPercent?: number;
    startDate?: string | undefined;
    endDate?: string | undefined;
    isFixedPrice?: boolean;
    fixedPrice?: number;
    fixedPriceCalcRate?: number;

    constructor(data?: IProjectAsCustomerEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isBillable = _data["isBillable"];
            if (Array.isArray(_data["projectStaff"])) {
                this.projectStaff = [] as any;
                for (let item of _data["projectStaff"])
                    this.projectStaff!.push(ProjectStaffEditModel.fromJS(item));
            }
            this.budget = _data["budget"];
            this.budgetUnit = _data["budgetUnit"];
            this.budgetTimeFrame = _data["budgetTimeFrame"];
            this.notifyOnBudgetOverrun = _data["notifyOnBudgetOverrun"];
            this.budgetOverrunThresholdPercent = _data["budgetOverrunThresholdPercent"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.isFixedPrice = _data["isFixedPrice"];
            this.fixedPrice = _data["fixedPrice"];
            this.fixedPriceCalcRate = _data["fixedPriceCalcRate"];
        }
    }

    static fromJS(data: any): ProjectAsCustomerEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectAsCustomerEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isBillable"] = this.isBillable;
        if (Array.isArray(this.projectStaff)) {
            data["projectStaff"] = [];
            for (let item of this.projectStaff)
                data["projectStaff"].push(item.toJSON());
        }
        data["budget"] = this.budget;
        data["budgetUnit"] = this.budgetUnit;
        data["budgetTimeFrame"] = this.budgetTimeFrame;
        data["notifyOnBudgetOverrun"] = this.notifyOnBudgetOverrun;
        data["budgetOverrunThresholdPercent"] = this.budgetOverrunThresholdPercent;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["isFixedPrice"] = this.isFixedPrice;
        data["fixedPrice"] = this.fixedPrice;
        data["fixedPriceCalcRate"] = this.fixedPriceCalcRate;
        return data;
    }
}

export interface IProjectAsCustomerEditModel {
    id?: number;
    isBillable?: boolean;
    projectStaff?: ProjectStaffEditModel[] | undefined;
    budget?: number;
    budgetUnit?: BudgetUnitEnum;
    budgetTimeFrame?: BudgetTimeFrameEnum;
    notifyOnBudgetOverrun?: boolean;
    budgetOverrunThresholdPercent?: number;
    startDate?: string | undefined;
    endDate?: string | undefined;
    isFixedPrice?: boolean;
    fixedPrice?: number;
    fixedPriceCalcRate?: number;
}

export class ProjectStaffEditModel implements IProjectStaffEditModel {
    projectId?: number;
    appUserId?: number;
    canViewAllProjectTimeEntries?: boolean;
    canEditAllProjectTimeEntries?: boolean;

    constructor(data?: IProjectStaffEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.appUserId = _data["appUserId"];
            this.canViewAllProjectTimeEntries = _data["canViewAllProjectTimeEntries"];
            this.canEditAllProjectTimeEntries = _data["canEditAllProjectTimeEntries"];
        }
    }

    static fromJS(data: any): ProjectStaffEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectStaffEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["appUserId"] = this.appUserId;
        data["canViewAllProjectTimeEntries"] = this.canViewAllProjectTimeEntries;
        data["canEditAllProjectTimeEntries"] = this.canEditAllProjectTimeEntries;
        return data;
    }
}

export interface IProjectStaffEditModel {
    projectId?: number;
    appUserId?: number;
    canViewAllProjectTimeEntries?: boolean;
    canEditAllProjectTimeEntries?: boolean;
}

export enum BudgetUnitEnum {
    Currency = "Currency",
    Hours = "Hours",
    HoursBillable = "HoursBillable",
}

export enum BudgetTimeFrameEnum {
    Fixed = "Fixed",
    Month = "Month",
    Year = "Year",
}

export class CustomerViewModel implements ICustomerViewModel {
    id?: number;
    guid?: string;
    name?: string | undefined;
    isArchived?: boolean;
    contactName?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    streetAddress?: string | undefined;
    country?: string | undefined;
    taxNumberDe?: string | undefined;
    vatId?: string | undefined;
    comment?: string | undefined;
    projects?: ProjectViewModel[] | undefined;
    noOfActiveProjects?: number;
    noOfArchivedProjects?: number;
    editMode?: boolean;
    editModel?: CustomerEditModel | undefined;
    newProjectEditMode?: boolean;
    newProjectEditModel?: ProjectEditModel | undefined;
    amountModel?: RateRuleAmountModel | undefined;
    hasNoProjects?: boolean;
    isBasicTimeTrackingDefaultCustomer?: boolean;

    constructor(data?: ICustomerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.guid = _data["guid"];
            this.name = _data["name"];
            this.isArchived = _data["isArchived"];
            this.contactName = _data["contactName"];
            this.city = _data["city"];
            this.zip = _data["zip"];
            this.streetAddress = _data["streetAddress"];
            this.country = _data["country"];
            this.taxNumberDe = _data["taxNumberDe"];
            this.vatId = _data["vatId"];
            this.comment = _data["comment"];
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectViewModel.fromJS(item));
            }
            this.noOfActiveProjects = _data["noOfActiveProjects"];
            this.noOfArchivedProjects = _data["noOfArchivedProjects"];
            this.editMode = _data["editMode"];
            this.editModel = _data["editModel"] ? CustomerEditModel.fromJS(_data["editModel"]) : <any>undefined;
            this.newProjectEditMode = _data["newProjectEditMode"];
            this.newProjectEditModel = _data["newProjectEditModel"] ? ProjectEditModel.fromJS(_data["newProjectEditModel"]) : <any>undefined;
            this.amountModel = _data["amountModel"] ? RateRuleAmountModel.fromJS(_data["amountModel"]) : <any>undefined;
            this.hasNoProjects = _data["hasNoProjects"];
            this.isBasicTimeTrackingDefaultCustomer = _data["isBasicTimeTrackingDefaultCustomer"];
        }
    }

    static fromJS(data: any): CustomerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["guid"] = this.guid;
        data["name"] = this.name;
        data["isArchived"] = this.isArchived;
        data["contactName"] = this.contactName;
        data["city"] = this.city;
        data["zip"] = this.zip;
        data["streetAddress"] = this.streetAddress;
        data["country"] = this.country;
        data["taxNumberDe"] = this.taxNumberDe;
        data["vatId"] = this.vatId;
        data["comment"] = this.comment;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        data["noOfActiveProjects"] = this.noOfActiveProjects;
        data["noOfArchivedProjects"] = this.noOfArchivedProjects;
        data["editMode"] = this.editMode;
        data["editModel"] = this.editModel ? this.editModel.toJSON() : <any>undefined;
        data["newProjectEditMode"] = this.newProjectEditMode;
        data["newProjectEditModel"] = this.newProjectEditModel ? this.newProjectEditModel.toJSON() : <any>undefined;
        data["amountModel"] = this.amountModel ? this.amountModel.toJSON() : <any>undefined;
        data["hasNoProjects"] = this.hasNoProjects;
        data["isBasicTimeTrackingDefaultCustomer"] = this.isBasicTimeTrackingDefaultCustomer;
        return data;
    }
}

export interface ICustomerViewModel {
    id?: number;
    guid?: string;
    name?: string | undefined;
    isArchived?: boolean;
    contactName?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    streetAddress?: string | undefined;
    country?: string | undefined;
    taxNumberDe?: string | undefined;
    vatId?: string | undefined;
    comment?: string | undefined;
    projects?: ProjectViewModel[] | undefined;
    noOfActiveProjects?: number;
    noOfArchivedProjects?: number;
    editMode?: boolean;
    editModel?: CustomerEditModel | undefined;
    newProjectEditMode?: boolean;
    newProjectEditModel?: ProjectEditModel | undefined;
    amountModel?: RateRuleAmountModel | undefined;
    hasNoProjects?: boolean;
    isBasicTimeTrackingDefaultCustomer?: boolean;
}

export class ProjectViewModel implements IProjectViewModel {
    id?: number;
    guid?: string;
    isBillable?: boolean;
    isFixedPrice?: boolean;
    fixedPrice?: number;
    fixedPriceCalcRate?: number;
    activeFixedPriceRate?: number;
    budget?: number;
    hasBudget?: boolean;
    budgetUnit?: BudgetUnitEnum;
    budgetTimeFrame?: BudgetTimeFrameEnum;
    customerId?: number;
    customerName?: string | undefined;
    customerProjectId?: string | undefined;
    customerGuid?: string;
    name?: string | undefined;
    comment?: string | undefined;
    isArchived?: boolean;
    hasProjectTasks?: boolean;
    projectTasks?: ProjectTaskViewModel[] | undefined;
    amountModel?: RateRuleAmountModel | undefined;
    notifyOnBudgetOverrun?: boolean;
    isCustomerProject?: boolean;
    startDate?: string | undefined;
    endDate?: string | undefined;
    isBasicTimeTrackingDefaultProject?: boolean;
    isReadonly?: boolean;
    finishedDate?: string | undefined;

    constructor(data?: IProjectViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.guid = _data["guid"];
            this.isBillable = _data["isBillable"];
            this.isFixedPrice = _data["isFixedPrice"];
            this.fixedPrice = _data["fixedPrice"];
            this.fixedPriceCalcRate = _data["fixedPriceCalcRate"];
            this.activeFixedPriceRate = _data["activeFixedPriceRate"];
            this.budget = _data["budget"];
            this.hasBudget = _data["hasBudget"];
            this.budgetUnit = _data["budgetUnit"];
            this.budgetTimeFrame = _data["budgetTimeFrame"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.customerProjectId = _data["customerProjectId"];
            this.customerGuid = _data["customerGuid"];
            this.name = _data["name"];
            this.comment = _data["comment"];
            this.isArchived = _data["isArchived"];
            this.hasProjectTasks = _data["hasProjectTasks"];
            if (Array.isArray(_data["projectTasks"])) {
                this.projectTasks = [] as any;
                for (let item of _data["projectTasks"])
                    this.projectTasks!.push(ProjectTaskViewModel.fromJS(item));
            }
            this.amountModel = _data["amountModel"] ? RateRuleAmountModel.fromJS(_data["amountModel"]) : <any>undefined;
            this.notifyOnBudgetOverrun = _data["notifyOnBudgetOverrun"];
            this.isCustomerProject = _data["isCustomerProject"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.isBasicTimeTrackingDefaultProject = _data["isBasicTimeTrackingDefaultProject"];
            this.isReadonly = _data["isReadonly"];
            this.finishedDate = _data["finishedDate"];
        }
    }

    static fromJS(data: any): ProjectViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["guid"] = this.guid;
        data["isBillable"] = this.isBillable;
        data["isFixedPrice"] = this.isFixedPrice;
        data["fixedPrice"] = this.fixedPrice;
        data["fixedPriceCalcRate"] = this.fixedPriceCalcRate;
        data["activeFixedPriceRate"] = this.activeFixedPriceRate;
        data["budget"] = this.budget;
        data["hasBudget"] = this.hasBudget;
        data["budgetUnit"] = this.budgetUnit;
        data["budgetTimeFrame"] = this.budgetTimeFrame;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["customerProjectId"] = this.customerProjectId;
        data["customerGuid"] = this.customerGuid;
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["isArchived"] = this.isArchived;
        data["hasProjectTasks"] = this.hasProjectTasks;
        if (Array.isArray(this.projectTasks)) {
            data["projectTasks"] = [];
            for (let item of this.projectTasks)
                data["projectTasks"].push(item.toJSON());
        }
        data["amountModel"] = this.amountModel ? this.amountModel.toJSON() : <any>undefined;
        data["notifyOnBudgetOverrun"] = this.notifyOnBudgetOverrun;
        data["isCustomerProject"] = this.isCustomerProject;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["isBasicTimeTrackingDefaultProject"] = this.isBasicTimeTrackingDefaultProject;
        data["isReadonly"] = this.isReadonly;
        data["finishedDate"] = this.finishedDate;
        return data;
    }
}

export interface IProjectViewModel {
    id?: number;
    guid?: string;
    isBillable?: boolean;
    isFixedPrice?: boolean;
    fixedPrice?: number;
    fixedPriceCalcRate?: number;
    activeFixedPriceRate?: number;
    budget?: number;
    hasBudget?: boolean;
    budgetUnit?: BudgetUnitEnum;
    budgetTimeFrame?: BudgetTimeFrameEnum;
    customerId?: number;
    customerName?: string | undefined;
    customerProjectId?: string | undefined;
    customerGuid?: string;
    name?: string | undefined;
    comment?: string | undefined;
    isArchived?: boolean;
    hasProjectTasks?: boolean;
    projectTasks?: ProjectTaskViewModel[] | undefined;
    amountModel?: RateRuleAmountModel | undefined;
    notifyOnBudgetOverrun?: boolean;
    isCustomerProject?: boolean;
    startDate?: string | undefined;
    endDate?: string | undefined;
    isBasicTimeTrackingDefaultProject?: boolean;
    isReadonly?: boolean;
    finishedDate?: string | undefined;
}

export class ProjectTaskViewModel implements IProjectTaskViewModel {
    id?: number;
    name?: string | undefined;
    isArchived?: boolean;
    editMode?: boolean;
    projectId?: number | undefined;
    editModel?: ProjectTaskEditModel | undefined;
    amountModel?: RateRuleAmountModel | undefined;
    guid?: string;

    constructor(data?: IProjectTaskViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isArchived = _data["isArchived"];
            this.editMode = _data["editMode"];
            this.projectId = _data["projectId"];
            this.editModel = _data["editModel"] ? ProjectTaskEditModel.fromJS(_data["editModel"]) : <any>undefined;
            this.amountModel = _data["amountModel"] ? RateRuleAmountModel.fromJS(_data["amountModel"]) : <any>undefined;
            this.guid = _data["guid"];
        }
    }

    static fromJS(data: any): ProjectTaskViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTaskViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isArchived"] = this.isArchived;
        data["editMode"] = this.editMode;
        data["projectId"] = this.projectId;
        data["editModel"] = this.editModel ? this.editModel.toJSON() : <any>undefined;
        data["amountModel"] = this.amountModel ? this.amountModel.toJSON() : <any>undefined;
        data["guid"] = this.guid;
        return data;
    }
}

export interface IProjectTaskViewModel {
    id?: number;
    name?: string | undefined;
    isArchived?: boolean;
    editMode?: boolean;
    projectId?: number | undefined;
    editModel?: ProjectTaskEditModel | undefined;
    amountModel?: RateRuleAmountModel | undefined;
    guid?: string;
}

export class ProjectTaskEditModel implements IProjectTaskEditModel {
    id?: number;
    name!: string;
    isArchived?: boolean;
    projectId?: number | undefined;
    amountModel?: RateRuleAmountModel | undefined;

    constructor(data?: IProjectTaskEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isArchived = _data["isArchived"];
            this.projectId = _data["projectId"];
            this.amountModel = _data["amountModel"] ? RateRuleAmountModel.fromJS(_data["amountModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectTaskEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTaskEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isArchived"] = this.isArchived;
        data["projectId"] = this.projectId;
        data["amountModel"] = this.amountModel ? this.amountModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProjectTaskEditModel {
    id?: number;
    name: string;
    isArchived?: boolean;
    projectId?: number | undefined;
    amountModel?: RateRuleAmountModel | undefined;
}

export class ProjectEditModel implements IProjectEditModel {
    id?: number;
    isBillable?: boolean;
    isFixedPrice?: boolean;
    fixedPrice?: number;
    fixedPriceCalcRate?: number;
    budget?: number;
    budgetUnit?: BudgetUnitEnum;
    budgetTimeFrame?: BudgetTimeFrameEnum;
    customerId!: number;
    name!: string;
    comment?: string | undefined;
    commentForTimeTracking?: string | undefined;
    customerName?: string | undefined;
    customerProjectId?: string | undefined;
    amountModel?: RateRuleAmountModel | undefined;
    projectTasks?: ProjectTaskEditModel[] | undefined;
    projectStaff?: ProjectStaffEditModel[] | undefined;
    allowDeleteDependentEntitiesForProjectTasks?: boolean;
    notifyOnBudgetOverrun?: boolean;
    budgetOverrunThresholdPercent?: number;
    startDate?: string | undefined;
    endDate?: string | undefined;
    isArchived?: boolean;
    hideGlobalProjectTasks?: boolean;

    constructor(data?: IProjectEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isBillable = _data["isBillable"];
            this.isFixedPrice = _data["isFixedPrice"];
            this.fixedPrice = _data["fixedPrice"];
            this.fixedPriceCalcRate = _data["fixedPriceCalcRate"];
            this.budget = _data["budget"];
            this.budgetUnit = _data["budgetUnit"];
            this.budgetTimeFrame = _data["budgetTimeFrame"];
            this.customerId = _data["customerId"];
            this.name = _data["name"];
            this.comment = _data["comment"];
            this.commentForTimeTracking = _data["commentForTimeTracking"];
            this.customerName = _data["customerName"];
            this.customerProjectId = _data["customerProjectId"];
            this.amountModel = _data["amountModel"] ? RateRuleAmountModel.fromJS(_data["amountModel"]) : <any>undefined;
            if (Array.isArray(_data["projectTasks"])) {
                this.projectTasks = [] as any;
                for (let item of _data["projectTasks"])
                    this.projectTasks!.push(ProjectTaskEditModel.fromJS(item));
            }
            if (Array.isArray(_data["projectStaff"])) {
                this.projectStaff = [] as any;
                for (let item of _data["projectStaff"])
                    this.projectStaff!.push(ProjectStaffEditModel.fromJS(item));
            }
            this.allowDeleteDependentEntitiesForProjectTasks = _data["allowDeleteDependentEntitiesForProjectTasks"];
            this.notifyOnBudgetOverrun = _data["notifyOnBudgetOverrun"];
            this.budgetOverrunThresholdPercent = _data["budgetOverrunThresholdPercent"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.isArchived = _data["isArchived"];
            this.hideGlobalProjectTasks = _data["hideGlobalProjectTasks"];
        }
    }

    static fromJS(data: any): ProjectEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isBillable"] = this.isBillable;
        data["isFixedPrice"] = this.isFixedPrice;
        data["fixedPrice"] = this.fixedPrice;
        data["fixedPriceCalcRate"] = this.fixedPriceCalcRate;
        data["budget"] = this.budget;
        data["budgetUnit"] = this.budgetUnit;
        data["budgetTimeFrame"] = this.budgetTimeFrame;
        data["customerId"] = this.customerId;
        data["name"] = this.name;
        data["comment"] = this.comment;
        data["commentForTimeTracking"] = this.commentForTimeTracking;
        data["customerName"] = this.customerName;
        data["customerProjectId"] = this.customerProjectId;
        data["amountModel"] = this.amountModel ? this.amountModel.toJSON() : <any>undefined;
        if (Array.isArray(this.projectTasks)) {
            data["projectTasks"] = [];
            for (let item of this.projectTasks)
                data["projectTasks"].push(item.toJSON());
        }
        if (Array.isArray(this.projectStaff)) {
            data["projectStaff"] = [];
            for (let item of this.projectStaff)
                data["projectStaff"].push(item.toJSON());
        }
        data["allowDeleteDependentEntitiesForProjectTasks"] = this.allowDeleteDependentEntitiesForProjectTasks;
        data["notifyOnBudgetOverrun"] = this.notifyOnBudgetOverrun;
        data["budgetOverrunThresholdPercent"] = this.budgetOverrunThresholdPercent;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["isArchived"] = this.isArchived;
        data["hideGlobalProjectTasks"] = this.hideGlobalProjectTasks;
        return data;
    }
}

export interface IProjectEditModel {
    id?: number;
    isBillable?: boolean;
    isFixedPrice?: boolean;
    fixedPrice?: number;
    fixedPriceCalcRate?: number;
    budget?: number;
    budgetUnit?: BudgetUnitEnum;
    budgetTimeFrame?: BudgetTimeFrameEnum;
    customerId: number;
    name: string;
    comment?: string | undefined;
    commentForTimeTracking?: string | undefined;
    customerName?: string | undefined;
    customerProjectId?: string | undefined;
    amountModel?: RateRuleAmountModel | undefined;
    projectTasks?: ProjectTaskEditModel[] | undefined;
    projectStaff?: ProjectStaffEditModel[] | undefined;
    allowDeleteDependentEntitiesForProjectTasks?: boolean;
    notifyOnBudgetOverrun?: boolean;
    budgetOverrunThresholdPercent?: number;
    startDate?: string | undefined;
    endDate?: string | undefined;
    isArchived?: boolean;
    hideGlobalProjectTasks?: boolean;
}

export class CustomerFilter implements ICustomerFilter {
    id?: number | undefined;
    ids?: number[] | undefined;
    isArchived?: boolean | undefined;
    showArchivedProjects?: boolean | undefined;
    includeViewOnlyCustomer?: boolean | undefined;

    constructor(data?: ICustomerFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.isArchived = _data["isArchived"];
            this.showArchivedProjects = _data["showArchivedProjects"];
            this.includeViewOnlyCustomer = _data["includeViewOnlyCustomer"];
        }
    }

    static fromJS(data: any): CustomerFilter {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["isArchived"] = this.isArchived;
        data["showArchivedProjects"] = this.showArchivedProjects;
        data["includeViewOnlyCustomer"] = this.includeViewOnlyCustomer;
        return data;
    }
}

export interface ICustomerFilter {
    id?: number | undefined;
    ids?: number[] | undefined;
    isArchived?: boolean | undefined;
    showArchivedProjects?: boolean | undefined;
    includeViewOnlyCustomer?: boolean | undefined;
}

export class CustomerArchiveToggleCommand implements ICustomerArchiveToggleCommand {
    customerId?: number;

    constructor(data?: ICustomerArchiveToggleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): CustomerArchiveToggleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerArchiveToggleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface ICustomerArchiveToggleCommand {
    customerId?: number;
}

export class InvoiceViewModel implements IInvoiceViewModel {
    id?: number;
    invoiceNumber?: string | undefined;
    createdDate?: string;
    basePriceCent?: number;
    basePriceCentBasic?: number;
    amountCentNetFullUsers?: number;
    amountCentNetBasicUsers?: number;
    amountCent?: number;
    vatAmountCent?: number;
    vatReverseCharge?: boolean;
    grossAmountCent?: number;
    userCount?: number;
    userCountBasic?: number;
    paymentType?: string | undefined;
    isPaid?: boolean;
    paymentRecipient?: string | undefined;
    paymentCompany?: string | undefined;
    paymentStreet?: string | undefined;
    paymentZip?: string | undefined;
    paymentCity?: string | undefined;
    paymentCountry?: string | undefined;
    paymentVatId?: string | undefined;
    paymentMethod?: string | undefined;
    paidTill?: string;
    invoicePdf?: string | undefined;
    invoicePdfFileName?: string | undefined;

    constructor(data?: IInvoiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.createdDate = _data["createdDate"];
            this.basePriceCent = _data["basePriceCent"];
            this.basePriceCentBasic = _data["basePriceCentBasic"];
            this.amountCentNetFullUsers = _data["amountCentNetFullUsers"];
            this.amountCentNetBasicUsers = _data["amountCentNetBasicUsers"];
            this.amountCent = _data["amountCent"];
            this.vatAmountCent = _data["vatAmountCent"];
            this.vatReverseCharge = _data["vatReverseCharge"];
            this.grossAmountCent = _data["grossAmountCent"];
            this.userCount = _data["userCount"];
            this.userCountBasic = _data["userCountBasic"];
            this.paymentType = _data["paymentType"];
            this.isPaid = _data["isPaid"];
            this.paymentRecipient = _data["paymentRecipient"];
            this.paymentCompany = _data["paymentCompany"];
            this.paymentStreet = _data["paymentStreet"];
            this.paymentZip = _data["paymentZip"];
            this.paymentCity = _data["paymentCity"];
            this.paymentCountry = _data["paymentCountry"];
            this.paymentVatId = _data["paymentVatId"];
            this.paymentMethod = _data["paymentMethod"];
            this.paidTill = _data["paidTill"];
            this.invoicePdf = _data["invoicePdf"];
            this.invoicePdfFileName = _data["invoicePdfFileName"];
        }
    }

    static fromJS(data: any): InvoiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new InvoiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNumber"] = this.invoiceNumber;
        data["createdDate"] = this.createdDate;
        data["basePriceCent"] = this.basePriceCent;
        data["basePriceCentBasic"] = this.basePriceCentBasic;
        data["amountCentNetFullUsers"] = this.amountCentNetFullUsers;
        data["amountCentNetBasicUsers"] = this.amountCentNetBasicUsers;
        data["amountCent"] = this.amountCent;
        data["vatAmountCent"] = this.vatAmountCent;
        data["vatReverseCharge"] = this.vatReverseCharge;
        data["grossAmountCent"] = this.grossAmountCent;
        data["userCount"] = this.userCount;
        data["userCountBasic"] = this.userCountBasic;
        data["paymentType"] = this.paymentType;
        data["isPaid"] = this.isPaid;
        data["paymentRecipient"] = this.paymentRecipient;
        data["paymentCompany"] = this.paymentCompany;
        data["paymentStreet"] = this.paymentStreet;
        data["paymentZip"] = this.paymentZip;
        data["paymentCity"] = this.paymentCity;
        data["paymentCountry"] = this.paymentCountry;
        data["paymentVatId"] = this.paymentVatId;
        data["paymentMethod"] = this.paymentMethod;
        data["paidTill"] = this.paidTill;
        data["invoicePdf"] = this.invoicePdf;
        data["invoicePdfFileName"] = this.invoicePdfFileName;
        return data;
    }
}

export interface IInvoiceViewModel {
    id?: number;
    invoiceNumber?: string | undefined;
    createdDate?: string;
    basePriceCent?: number;
    basePriceCentBasic?: number;
    amountCentNetFullUsers?: number;
    amountCentNetBasicUsers?: number;
    amountCent?: number;
    vatAmountCent?: number;
    vatReverseCharge?: boolean;
    grossAmountCent?: number;
    userCount?: number;
    userCountBasic?: number;
    paymentType?: string | undefined;
    isPaid?: boolean;
    paymentRecipient?: string | undefined;
    paymentCompany?: string | undefined;
    paymentStreet?: string | undefined;
    paymentZip?: string | undefined;
    paymentCity?: string | undefined;
    paymentCountry?: string | undefined;
    paymentVatId?: string | undefined;
    paymentMethod?: string | undefined;
    paidTill?: string;
    invoicePdf?: string | undefined;
    invoicePdfFileName?: string | undefined;
}

export class ListResult implements IListResult {
    rows?: ResultRow[] | undefined;
    numberOfGroups?: number;
    numberOfEntries?: number;
    extraFieldHeaderColumns?: ExtraFieldHeaderColumn[] | undefined;
    extraFieldSumHeaderColumns?: ExtraFieldHeaderColumn[] | undefined;
    listParameters?: ListParameters | undefined;
    filterItems?: ResultFilterItem[] | undefined;

    constructor(data?: IListResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ResultRow.fromJS(item));
            }
            this.numberOfGroups = _data["numberOfGroups"];
            this.numberOfEntries = _data["numberOfEntries"];
            if (Array.isArray(_data["extraFieldHeaderColumns"])) {
                this.extraFieldHeaderColumns = [] as any;
                for (let item of _data["extraFieldHeaderColumns"])
                    this.extraFieldHeaderColumns!.push(ExtraFieldHeaderColumn.fromJS(item));
            }
            if (Array.isArray(_data["extraFieldSumHeaderColumns"])) {
                this.extraFieldSumHeaderColumns = [] as any;
                for (let item of _data["extraFieldSumHeaderColumns"])
                    this.extraFieldSumHeaderColumns!.push(ExtraFieldHeaderColumn.fromJS(item));
            }
            this.listParameters = _data["listParameters"] ? ListParameters.fromJS(_data["listParameters"]) : <any>undefined;
            if (Array.isArray(_data["filterItems"])) {
                this.filterItems = [] as any;
                for (let item of _data["filterItems"])
                    this.filterItems!.push(ResultFilterItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListResult {
        data = typeof data === 'object' ? data : {};
        let result = new ListResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        data["numberOfGroups"] = this.numberOfGroups;
        data["numberOfEntries"] = this.numberOfEntries;
        if (Array.isArray(this.extraFieldHeaderColumns)) {
            data["extraFieldHeaderColumns"] = [];
            for (let item of this.extraFieldHeaderColumns)
                data["extraFieldHeaderColumns"].push(item.toJSON());
        }
        if (Array.isArray(this.extraFieldSumHeaderColumns)) {
            data["extraFieldSumHeaderColumns"] = [];
            for (let item of this.extraFieldSumHeaderColumns)
                data["extraFieldSumHeaderColumns"].push(item.toJSON());
        }
        data["listParameters"] = this.listParameters ? this.listParameters.toJSON() : <any>undefined;
        if (Array.isArray(this.filterItems)) {
            data["filterItems"] = [];
            for (let item of this.filterItems)
                data["filterItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListResult {
    rows?: ResultRow[] | undefined;
    numberOfGroups?: number;
    numberOfEntries?: number;
    extraFieldHeaderColumns?: ExtraFieldHeaderColumn[] | undefined;
    extraFieldSumHeaderColumns?: ExtraFieldHeaderColumn[] | undefined;
    listParameters?: ListParameters | undefined;
    filterItems?: ResultFilterItem[] | undefined;
}

export class ResultRow implements IResultRow {
    isSum?: boolean;
    group?: string | undefined;
    level?: number;
    durationMinutesSum?: number;
    durationMinutesSumNotBillable?: number;
    revenueSumBillable?: number;
    revenueSumNotBillable?: number;
    extraFieldSumColumns?: ExtraFieldSumColumn[] | undefined;
    timeEntry?: TimeEntryViewModel | undefined;

    constructor(data?: IResultRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSum = _data["isSum"];
            this.group = _data["group"];
            this.level = _data["level"];
            this.durationMinutesSum = _data["durationMinutesSum"];
            this.durationMinutesSumNotBillable = _data["durationMinutesSumNotBillable"];
            this.revenueSumBillable = _data["revenueSumBillable"];
            this.revenueSumNotBillable = _data["revenueSumNotBillable"];
            if (Array.isArray(_data["extraFieldSumColumns"])) {
                this.extraFieldSumColumns = [] as any;
                for (let item of _data["extraFieldSumColumns"])
                    this.extraFieldSumColumns!.push(ExtraFieldSumColumn.fromJS(item));
            }
            this.timeEntry = _data["timeEntry"] ? TimeEntryViewModel.fromJS(_data["timeEntry"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ResultRow {
        data = typeof data === 'object' ? data : {};
        let result = new ResultRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSum"] = this.isSum;
        data["group"] = this.group;
        data["level"] = this.level;
        data["durationMinutesSum"] = this.durationMinutesSum;
        data["durationMinutesSumNotBillable"] = this.durationMinutesSumNotBillable;
        data["revenueSumBillable"] = this.revenueSumBillable;
        data["revenueSumNotBillable"] = this.revenueSumNotBillable;
        if (Array.isArray(this.extraFieldSumColumns)) {
            data["extraFieldSumColumns"] = [];
            for (let item of this.extraFieldSumColumns)
                data["extraFieldSumColumns"].push(item.toJSON());
        }
        data["timeEntry"] = this.timeEntry ? this.timeEntry.toJSON() : <any>undefined;
        return data;
    }
}

export interface IResultRow {
    isSum?: boolean;
    group?: string | undefined;
    level?: number;
    durationMinutesSum?: number;
    durationMinutesSumNotBillable?: number;
    revenueSumBillable?: number;
    revenueSumNotBillable?: number;
    extraFieldSumColumns?: ExtraFieldSumColumn[] | undefined;
    timeEntry?: TimeEntryViewModel | undefined;
}

export class ExtraFieldSumColumn implements IExtraFieldSumColumn {
    id?: number;
    name?: string | undefined;
    dataType?: TimeEntryExtraFieldDataTypeEnum;
    sumValue?: number;

    constructor(data?: IExtraFieldSumColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.dataType = _data["dataType"];
            this.sumValue = _data["sumValue"];
        }
    }

    static fromJS(data: any): ExtraFieldSumColumn {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraFieldSumColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["dataType"] = this.dataType;
        data["sumValue"] = this.sumValue;
        return data;
    }
}

export interface IExtraFieldSumColumn {
    id?: number;
    name?: string | undefined;
    dataType?: TimeEntryExtraFieldDataTypeEnum;
    sumValue?: number;
}

export enum TimeEntryExtraFieldDataTypeEnum {
    Text = "Text",
    Integer = "Integer",
    Decimal = "Decimal",
    Rating = "Rating",
    YesNo = "YesNo",
    Selection = "Selection",
}

export class TimeEntryViewModel implements ITimeEntryViewModel {
    id?: number;
    entryDateDisplayGroup?: string | undefined;
    entryWeekDisplayGroup?: string | undefined;
    entryMonthDisplayGroup?: string | undefined;
    entryDate?: string;
    entryWeek?: number;
    entryMonth?: number;
    entryYear?: number;
    durationMinutes?: number;
    durationHours?: number;
    durationMinutesNotBillable?: number;
    durationMinutesPause?: number;
    durationHoursPause?: number;
    title?: string | undefined;
    description?: string | undefined;
    timeFrom?: string | undefined;
    timeTo?: string | undefined;
    isInputTimeFromTo?: boolean;
    isBillable?: boolean;
    isCleared?: boolean;
    revenue?: number;
    revenueBillable?: number;
    revenueNotBillable?: number;
    rateAmount?: number;
    rateAmountOverridden?: boolean;
    rateAmountComment?: string | undefined;
    timeEntryType?: TimeEntryTypeViewModel | undefined;
    projectId?: number;
    projectName?: string | undefined;
    projectIsArchived?: boolean;
    projectIsFinished?: boolean;
    projectCustomerProjectId?: string | undefined;
    isFixedPrice?: boolean;
    customerId?: number;
    customerName?: string | undefined;
    customerHasNoProjects?: boolean;
    projectTaskId?: number | undefined;
    projectTaskName?: string | undefined;
    projectTaskIsArchived?: boolean;
    projectTaskNameNullChecked?: string | undefined;
    tags?: TagViewModel[] | undefined;
    editType?: TimeEntryTypeEnum;
    timeEntryExtraFields?: TimeEntryExtraFieldViewModel[] | undefined;
    outgoingInvoiceId?: number | undefined;
    outgoingInvoiceNumber?: string | undefined;
    isDisabled?: boolean;
    disabledReason?: string | undefined;
    isDeleteDisabled?: boolean;
    appUserId?: number;
    appUserName?: string | undefined;
    warnings?: TimeEntryWarning[] | undefined;
    maxWarningSeverity?: TimeEntryWarningSeverity;
    isValid?: boolean;
    insertDateTime?: string;
    isInvoiced?: boolean;
    rowVersion?: number;
    isTwoDayEntry?: boolean;
    timeFromDt?: string | undefined;
    timeToDt?: string | undefined;
    featureFlagAppUserDepartmentInfoString?: string | undefined;

    constructor(data?: ITimeEntryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entryDateDisplayGroup = _data["entryDateDisplayGroup"];
            this.entryWeekDisplayGroup = _data["entryWeekDisplayGroup"];
            this.entryMonthDisplayGroup = _data["entryMonthDisplayGroup"];
            this.entryDate = _data["entryDate"];
            this.entryWeek = _data["entryWeek"];
            this.entryMonth = _data["entryMonth"];
            this.entryYear = _data["entryYear"];
            this.durationMinutes = _data["durationMinutes"];
            this.durationHours = _data["durationHours"];
            this.durationMinutesNotBillable = _data["durationMinutesNotBillable"];
            this.durationMinutesPause = _data["durationMinutesPause"];
            this.durationHoursPause = _data["durationHoursPause"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.timeFrom = _data["timeFrom"];
            this.timeTo = _data["timeTo"];
            this.isInputTimeFromTo = _data["isInputTimeFromTo"];
            this.isBillable = _data["isBillable"];
            this.isCleared = _data["isCleared"];
            this.revenue = _data["revenue"];
            this.revenueBillable = _data["revenueBillable"];
            this.revenueNotBillable = _data["revenueNotBillable"];
            this.rateAmount = _data["rateAmount"];
            this.rateAmountOverridden = _data["rateAmountOverridden"];
            this.rateAmountComment = _data["rateAmountComment"];
            this.timeEntryType = _data["timeEntryType"] ? TimeEntryTypeViewModel.fromJS(_data["timeEntryType"]) : <any>undefined;
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectIsArchived = _data["projectIsArchived"];
            this.projectIsFinished = _data["projectIsFinished"];
            this.projectCustomerProjectId = _data["projectCustomerProjectId"];
            this.isFixedPrice = _data["isFixedPrice"];
            this.customerId = _data["customerId"];
            this.customerName = _data["customerName"];
            this.customerHasNoProjects = _data["customerHasNoProjects"];
            this.projectTaskId = _data["projectTaskId"];
            this.projectTaskName = _data["projectTaskName"];
            this.projectTaskIsArchived = _data["projectTaskIsArchived"];
            this.projectTaskNameNullChecked = _data["projectTaskNameNullChecked"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagViewModel.fromJS(item));
            }
            this.editType = _data["editType"];
            if (Array.isArray(_data["timeEntryExtraFields"])) {
                this.timeEntryExtraFields = [] as any;
                for (let item of _data["timeEntryExtraFields"])
                    this.timeEntryExtraFields!.push(TimeEntryExtraFieldViewModel.fromJS(item));
            }
            this.outgoingInvoiceId = _data["outgoingInvoiceId"];
            this.outgoingInvoiceNumber = _data["outgoingInvoiceNumber"];
            this.isDisabled = _data["isDisabled"];
            this.disabledReason = _data["disabledReason"];
            this.isDeleteDisabled = _data["isDeleteDisabled"];
            this.appUserId = _data["appUserId"];
            this.appUserName = _data["appUserName"];
            if (Array.isArray(_data["warnings"])) {
                this.warnings = [] as any;
                for (let item of _data["warnings"])
                    this.warnings!.push(TimeEntryWarning.fromJS(item));
            }
            this.maxWarningSeverity = _data["maxWarningSeverity"];
            this.isValid = _data["isValid"];
            this.insertDateTime = _data["insertDateTime"];
            this.isInvoiced = _data["isInvoiced"];
            this.rowVersion = _data["rowVersion"];
            this.isTwoDayEntry = _data["isTwoDayEntry"];
            this.timeFromDt = _data["timeFromDt"];
            this.timeToDt = _data["timeToDt"];
            this.featureFlagAppUserDepartmentInfoString = _data["featureFlagAppUserDepartmentInfoString"];
        }
    }

    static fromJS(data: any): TimeEntryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entryDateDisplayGroup"] = this.entryDateDisplayGroup;
        data["entryWeekDisplayGroup"] = this.entryWeekDisplayGroup;
        data["entryMonthDisplayGroup"] = this.entryMonthDisplayGroup;
        data["entryDate"] = this.entryDate;
        data["entryWeek"] = this.entryWeek;
        data["entryMonth"] = this.entryMonth;
        data["entryYear"] = this.entryYear;
        data["durationMinutes"] = this.durationMinutes;
        data["durationHours"] = this.durationHours;
        data["durationMinutesNotBillable"] = this.durationMinutesNotBillable;
        data["durationMinutesPause"] = this.durationMinutesPause;
        data["durationHoursPause"] = this.durationHoursPause;
        data["title"] = this.title;
        data["description"] = this.description;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        data["isInputTimeFromTo"] = this.isInputTimeFromTo;
        data["isBillable"] = this.isBillable;
        data["isCleared"] = this.isCleared;
        data["revenue"] = this.revenue;
        data["revenueBillable"] = this.revenueBillable;
        data["revenueNotBillable"] = this.revenueNotBillable;
        data["rateAmount"] = this.rateAmount;
        data["rateAmountOverridden"] = this.rateAmountOverridden;
        data["rateAmountComment"] = this.rateAmountComment;
        data["timeEntryType"] = this.timeEntryType ? this.timeEntryType.toJSON() : <any>undefined;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectIsArchived"] = this.projectIsArchived;
        data["projectIsFinished"] = this.projectIsFinished;
        data["projectCustomerProjectId"] = this.projectCustomerProjectId;
        data["isFixedPrice"] = this.isFixedPrice;
        data["customerId"] = this.customerId;
        data["customerName"] = this.customerName;
        data["customerHasNoProjects"] = this.customerHasNoProjects;
        data["projectTaskId"] = this.projectTaskId;
        data["projectTaskName"] = this.projectTaskName;
        data["projectTaskIsArchived"] = this.projectTaskIsArchived;
        data["projectTaskNameNullChecked"] = this.projectTaskNameNullChecked;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["editType"] = this.editType;
        if (Array.isArray(this.timeEntryExtraFields)) {
            data["timeEntryExtraFields"] = [];
            for (let item of this.timeEntryExtraFields)
                data["timeEntryExtraFields"].push(item.toJSON());
        }
        data["outgoingInvoiceId"] = this.outgoingInvoiceId;
        data["outgoingInvoiceNumber"] = this.outgoingInvoiceNumber;
        data["isDisabled"] = this.isDisabled;
        data["disabledReason"] = this.disabledReason;
        data["isDeleteDisabled"] = this.isDeleteDisabled;
        data["appUserId"] = this.appUserId;
        data["appUserName"] = this.appUserName;
        if (Array.isArray(this.warnings)) {
            data["warnings"] = [];
            for (let item of this.warnings)
                data["warnings"].push(item.toJSON());
        }
        data["maxWarningSeverity"] = this.maxWarningSeverity;
        data["isValid"] = this.isValid;
        data["insertDateTime"] = this.insertDateTime;
        data["isInvoiced"] = this.isInvoiced;
        data["rowVersion"] = this.rowVersion;
        data["isTwoDayEntry"] = this.isTwoDayEntry;
        data["timeFromDt"] = this.timeFromDt;
        data["timeToDt"] = this.timeToDt;
        data["featureFlagAppUserDepartmentInfoString"] = this.featureFlagAppUserDepartmentInfoString;
        return data;
    }
}

export interface ITimeEntryViewModel {
    id?: number;
    entryDateDisplayGroup?: string | undefined;
    entryWeekDisplayGroup?: string | undefined;
    entryMonthDisplayGroup?: string | undefined;
    entryDate?: string;
    entryWeek?: number;
    entryMonth?: number;
    entryYear?: number;
    durationMinutes?: number;
    durationHours?: number;
    durationMinutesNotBillable?: number;
    durationMinutesPause?: number;
    durationHoursPause?: number;
    title?: string | undefined;
    description?: string | undefined;
    timeFrom?: string | undefined;
    timeTo?: string | undefined;
    isInputTimeFromTo?: boolean;
    isBillable?: boolean;
    isCleared?: boolean;
    revenue?: number;
    revenueBillable?: number;
    revenueNotBillable?: number;
    rateAmount?: number;
    rateAmountOverridden?: boolean;
    rateAmountComment?: string | undefined;
    timeEntryType?: TimeEntryTypeViewModel | undefined;
    projectId?: number;
    projectName?: string | undefined;
    projectIsArchived?: boolean;
    projectIsFinished?: boolean;
    projectCustomerProjectId?: string | undefined;
    isFixedPrice?: boolean;
    customerId?: number;
    customerName?: string | undefined;
    customerHasNoProjects?: boolean;
    projectTaskId?: number | undefined;
    projectTaskName?: string | undefined;
    projectTaskIsArchived?: boolean;
    projectTaskNameNullChecked?: string | undefined;
    tags?: TagViewModel[] | undefined;
    editType?: TimeEntryTypeEnum;
    timeEntryExtraFields?: TimeEntryExtraFieldViewModel[] | undefined;
    outgoingInvoiceId?: number | undefined;
    outgoingInvoiceNumber?: string | undefined;
    isDisabled?: boolean;
    disabledReason?: string | undefined;
    isDeleteDisabled?: boolean;
    appUserId?: number;
    appUserName?: string | undefined;
    warnings?: TimeEntryWarning[] | undefined;
    maxWarningSeverity?: TimeEntryWarningSeverity;
    isValid?: boolean;
    insertDateTime?: string;
    isInvoiced?: boolean;
    rowVersion?: number;
    isTwoDayEntry?: boolean;
    timeFromDt?: string | undefined;
    timeToDt?: string | undefined;
    featureFlagAppUserDepartmentInfoString?: string | undefined;
}

export class TimeEntryTypeViewModel implements ITimeEntryTypeViewModel {
    id?: number;
    nameTranslationKey?: string | undefined;
    type?: TimeEntryTypeEnum;
    isStopwatch?: boolean;

    constructor(data?: ITimeEntryTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.nameTranslationKey = _data["nameTranslationKey"];
            this.type = _data["type"];
            this.isStopwatch = _data["isStopwatch"];
        }
    }

    static fromJS(data: any): TimeEntryTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["nameTranslationKey"] = this.nameTranslationKey;
        data["type"] = this.type;
        data["isStopwatch"] = this.isStopwatch;
        return data;
    }
}

export interface ITimeEntryTypeViewModel {
    id?: number;
    nameTranslationKey?: string | undefined;
    type?: TimeEntryTypeEnum;
    isStopwatch?: boolean;
}

export enum TimeEntryTypeEnum {
    TimeEntry = "TimeEntry",
    Pause = "Pause",
    Stopwatch = "Stopwatch",
    AutoPause = "AutoPause",
}

export class TagViewModel implements ITagViewModel {
    id?: number;
    name?: string | undefined;
    colorClass?: string | undefined;
    isArchived?: boolean;

    constructor(data?: ITagViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.colorClass = _data["colorClass"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): TagViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TagViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["colorClass"] = this.colorClass;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface ITagViewModel {
    id?: number;
    name?: string | undefined;
    colorClass?: string | undefined;
    isArchived?: boolean;
}

export class TimeEntryExtraFieldViewModel implements ITimeEntryExtraFieldViewModel {
    value?: string | undefined;
    description?: string | undefined;
    dataType?: TimeEntryExtraFieldDataTypeEnum;
    hideInDayView?: boolean;

    constructor(data?: ITimeEntryExtraFieldViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.description = _data["description"];
            this.dataType = _data["dataType"];
            this.hideInDayView = _data["hideInDayView"];
        }
    }

    static fromJS(data: any): TimeEntryExtraFieldViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryExtraFieldViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["description"] = this.description;
        data["dataType"] = this.dataType;
        data["hideInDayView"] = this.hideInDayView;
        return data;
    }
}

export interface ITimeEntryExtraFieldViewModel {
    value?: string | undefined;
    description?: string | undefined;
    dataType?: TimeEntryExtraFieldDataTypeEnum;
    hideInDayView?: boolean;
}

export class TimeEntryWarning implements ITimeEntryWarning {
    severity?: TimeEntryWarningSeverity;
    warning?: string | undefined;

    constructor(data?: ITimeEntryWarning) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.severity = _data["severity"];
            this.warning = _data["warning"];
        }
    }

    static fromJS(data: any): TimeEntryWarning {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryWarning();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["severity"] = this.severity;
        data["warning"] = this.warning;
        return data;
    }
}

export interface ITimeEntryWarning {
    severity?: TimeEntryWarningSeverity;
    warning?: string | undefined;
}

export enum TimeEntryWarningSeverity {
    Nothing = "Nothing",
    Info = "Info",
    Warning = "Warning",
    Error = "Error",
}

export class ExtraFieldHeaderColumn implements IExtraFieldHeaderColumn {
    id?: number;
    name?: string | undefined;

    constructor(data?: IExtraFieldHeaderColumn) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ExtraFieldHeaderColumn {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraFieldHeaderColumn();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IExtraFieldHeaderColumn {
    id?: number;
    name?: string | undefined;
}

export class ListParameters implements IListParameters {
    grouping?: TimeEntryGroupingModel | undefined;
    filter?: TimeEntryFilter | undefined;
    listSettingsModel?: TimeEntryListSettingsModel | undefined;

    constructor(data?: IListParameters) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.grouping = _data["grouping"] ? TimeEntryGroupingModel.fromJS(_data["grouping"]) : <any>undefined;
            this.filter = _data["filter"] ? TimeEntryFilter.fromJS(_data["filter"]) : <any>undefined;
            this.listSettingsModel = _data["listSettingsModel"] ? TimeEntryListSettingsModel.fromJS(_data["listSettingsModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListParameters {
        data = typeof data === 'object' ? data : {};
        let result = new ListParameters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["grouping"] = this.grouping ? this.grouping.toJSON() : <any>undefined;
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        data["listSettingsModel"] = this.listSettingsModel ? this.listSettingsModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListParameters {
    grouping?: TimeEntryGroupingModel | undefined;
    filter?: TimeEntryFilter | undefined;
    listSettingsModel?: TimeEntryListSettingsModel | undefined;
}

export class TimeEntryGroupingModel implements ITimeEntryGroupingModel {
    day?: boolean;
    week?: boolean;
    month?: boolean;
    year?: boolean;
    customer?: boolean;
    project?: boolean;
    user?: boolean;
    projectTask?: boolean;
    details?: boolean;
    groups?: string[] | undefined;
    isGrouped?: boolean;

    constructor(data?: ITimeEntryGroupingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.day = _data["day"];
            this.week = _data["week"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.customer = _data["customer"];
            this.project = _data["project"];
            this.user = _data["user"];
            this.projectTask = _data["projectTask"];
            this.details = _data["details"];
            if (Array.isArray(_data["groups"])) {
                this.groups = [] as any;
                for (let item of _data["groups"])
                    this.groups!.push(item);
            }
            this.isGrouped = _data["isGrouped"];
        }
    }

    static fromJS(data: any): TimeEntryGroupingModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryGroupingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["day"] = this.day;
        data["week"] = this.week;
        data["month"] = this.month;
        data["year"] = this.year;
        data["customer"] = this.customer;
        data["project"] = this.project;
        data["user"] = this.user;
        data["projectTask"] = this.projectTask;
        data["details"] = this.details;
        if (Array.isArray(this.groups)) {
            data["groups"] = [];
            for (let item of this.groups)
                data["groups"].push(item);
        }
        data["isGrouped"] = this.isGrouped;
        return data;
    }
}

export interface ITimeEntryGroupingModel {
    day?: boolean;
    week?: boolean;
    month?: boolean;
    year?: boolean;
    customer?: boolean;
    project?: boolean;
    user?: boolean;
    projectTask?: boolean;
    details?: boolean;
    groups?: string[] | undefined;
    isGrouped?: boolean;
}

export class TimeEntryFilter implements ITimeEntryFilter {
    id?: number | undefined;
    timeframe?: TimeEntryFilterTimeFrame;
    entryDateFrom?: string | undefined;
    entryDateTo?: string | undefined;
    entryDate?: string | undefined;
    type?: TimeEntryTypeEnum | undefined;
    projectId?: number | undefined;
    projectTaskId?: number | undefined;
    customerIds?: number[] | undefined;
    projectIds?: number[] | undefined;
    projectTaskIds?: number[] | undefined;
    appUserIds?: number[] | undefined;
    tagIds?: number[] | undefined;
    ids?: number[] | undefined;
    outgoingInvoiceId?: number | undefined;
    isBillable?: boolean | undefined;
    isCleared?: boolean | undefined;
    description?: string | undefined;
    timeEntryExtraFieldMetadataId?: number | undefined;
    hasOutgoingInvoice?: boolean | undefined;
    extraFields?: TimeEntryFilterExtraField[] | undefined;
    customers?: string | undefined;
    projects?: string | undefined;
    projectTasks?: string | undefined;
    appUser?: string | undefined;
    tags?: string | undefined;
    previousTimeFrame?: ValueTupleOfNullableDateTimeAndNullableDateTime;

    constructor(data?: ITimeEntryFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.timeframe = _data["timeframe"];
            this.entryDateFrom = _data["entryDateFrom"];
            this.entryDateTo = _data["entryDateTo"];
            this.entryDate = _data["entryDate"];
            this.type = _data["type"];
            this.projectId = _data["projectId"];
            this.projectTaskId = _data["projectTaskId"];
            if (Array.isArray(_data["customerIds"])) {
                this.customerIds = [] as any;
                for (let item of _data["customerIds"])
                    this.customerIds!.push(item);
            }
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
            if (Array.isArray(_data["projectTaskIds"])) {
                this.projectTaskIds = [] as any;
                for (let item of _data["projectTaskIds"])
                    this.projectTaskIds!.push(item);
            }
            if (Array.isArray(_data["appUserIds"])) {
                this.appUserIds = [] as any;
                for (let item of _data["appUserIds"])
                    this.appUserIds!.push(item);
            }
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.outgoingInvoiceId = _data["outgoingInvoiceId"];
            this.isBillable = _data["isBillable"];
            this.isCleared = _data["isCleared"];
            this.description = _data["description"];
            this.timeEntryExtraFieldMetadataId = _data["timeEntryExtraFieldMetadataId"];
            this.hasOutgoingInvoice = _data["hasOutgoingInvoice"];
            if (Array.isArray(_data["extraFields"])) {
                this.extraFields = [] as any;
                for (let item of _data["extraFields"])
                    this.extraFields!.push(TimeEntryFilterExtraField.fromJS(item));
            }
            this.customers = _data["customers"];
            this.projects = _data["projects"];
            this.projectTasks = _data["projectTasks"];
            this.appUser = _data["appUser"];
            this.tags = _data["tags"];
            this.previousTimeFrame = _data["previousTimeFrame"] ? ValueTupleOfNullableDateTimeAndNullableDateTime.fromJS(_data["previousTimeFrame"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeEntryFilter {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timeframe"] = this.timeframe;
        data["entryDateFrom"] = this.entryDateFrom;
        data["entryDateTo"] = this.entryDateTo;
        data["entryDate"] = this.entryDate;
        data["type"] = this.type;
        data["projectId"] = this.projectId;
        data["projectTaskId"] = this.projectTaskId;
        if (Array.isArray(this.customerIds)) {
            data["customerIds"] = [];
            for (let item of this.customerIds)
                data["customerIds"].push(item);
        }
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        if (Array.isArray(this.projectTaskIds)) {
            data["projectTaskIds"] = [];
            for (let item of this.projectTaskIds)
                data["projectTaskIds"].push(item);
        }
        if (Array.isArray(this.appUserIds)) {
            data["appUserIds"] = [];
            for (let item of this.appUserIds)
                data["appUserIds"].push(item);
        }
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["outgoingInvoiceId"] = this.outgoingInvoiceId;
        data["isBillable"] = this.isBillable;
        data["isCleared"] = this.isCleared;
        data["description"] = this.description;
        data["timeEntryExtraFieldMetadataId"] = this.timeEntryExtraFieldMetadataId;
        data["hasOutgoingInvoice"] = this.hasOutgoingInvoice;
        if (Array.isArray(this.extraFields)) {
            data["extraFields"] = [];
            for (let item of this.extraFields)
                data["extraFields"].push(item.toJSON());
        }
        data["customers"] = this.customers;
        data["projects"] = this.projects;
        data["projectTasks"] = this.projectTasks;
        data["appUser"] = this.appUser;
        data["tags"] = this.tags;
        data["previousTimeFrame"] = this.previousTimeFrame ? this.previousTimeFrame.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITimeEntryFilter {
    id?: number | undefined;
    timeframe?: TimeEntryFilterTimeFrame;
    entryDateFrom?: string | undefined;
    entryDateTo?: string | undefined;
    entryDate?: string | undefined;
    type?: TimeEntryTypeEnum | undefined;
    projectId?: number | undefined;
    projectTaskId?: number | undefined;
    customerIds?: number[] | undefined;
    projectIds?: number[] | undefined;
    projectTaskIds?: number[] | undefined;
    appUserIds?: number[] | undefined;
    tagIds?: number[] | undefined;
    ids?: number[] | undefined;
    outgoingInvoiceId?: number | undefined;
    isBillable?: boolean | undefined;
    isCleared?: boolean | undefined;
    description?: string | undefined;
    timeEntryExtraFieldMetadataId?: number | undefined;
    hasOutgoingInvoice?: boolean | undefined;
    extraFields?: TimeEntryFilterExtraField[] | undefined;
    customers?: string | undefined;
    projects?: string | undefined;
    projectTasks?: string | undefined;
    appUser?: string | undefined;
    tags?: string | undefined;
    previousTimeFrame?: ValueTupleOfNullableDateTimeAndNullableDateTime;
}

export enum TimeEntryFilterTimeFrame {
    Custom = "Custom",
    Today = "Today",
    Yesterday = "Yesterday",
    Last7 = "Last7",
    ThisWeek = "ThisWeek",
    LastWeek = "LastWeek",
    ThisMonth = "ThisMonth",
    LastMonth = "LastMonth",
    ThisYear = "ThisYear",
    LastYear = "LastYear",
    Ytd = "Ytd",
    All = "All",
    Mtd = "Mtd",
    Last30 = "Last30",
    ThisQuarter = "ThisQuarter",
    LastQuarter = "LastQuarter",
}

export class TimeEntryFilterExtraField implements ITimeEntryFilterExtraField {
    timeEntryExtraFieldMetadataId?: number;
    searchText?: string | undefined;

    constructor(data?: ITimeEntryFilterExtraField) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeEntryExtraFieldMetadataId = _data["timeEntryExtraFieldMetadataId"];
            this.searchText = _data["searchText"];
        }
    }

    static fromJS(data: any): TimeEntryFilterExtraField {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryFilterExtraField();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeEntryExtraFieldMetadataId"] = this.timeEntryExtraFieldMetadataId;
        data["searchText"] = this.searchText;
        return data;
    }
}

export interface ITimeEntryFilterExtraField {
    timeEntryExtraFieldMetadataId?: number;
    searchText?: string | undefined;
}

export class ValueTupleOfNullableDateTimeAndNullableDateTime implements IValueTupleOfNullableDateTimeAndNullableDateTime {
    item1?: string | undefined;
    item2?: string | undefined;

    constructor(data?: IValueTupleOfNullableDateTimeAndNullableDateTime) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.item1 = _data["item1"];
            this.item2 = _data["item2"];
        }
    }

    static fromJS(data: any): ValueTupleOfNullableDateTimeAndNullableDateTime {
        data = typeof data === 'object' ? data : {};
        let result = new ValueTupleOfNullableDateTimeAndNullableDateTime();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["item1"] = this.item1;
        data["item2"] = this.item2;
        return data;
    }
}

export interface IValueTupleOfNullableDateTimeAndNullableDateTime {
    item1?: string | undefined;
    item2?: string | undefined;
}

export class TimeEntryListSettingsModel implements ITimeEntryListSettingsModel {
    hiddenColumns?: string[] | undefined;
    alignLandscape?: boolean;
    displayFilter?: boolean;
    columnLayout?: ListColumnLayout[] | undefined;
    extraFieldColumnLayout?: ExtraFieldColumnLayout[] | undefined;
    visibleExtraFieldIds?: number[] | undefined;
    sortDateAscending?: boolean;

    constructor(data?: ITimeEntryListSettingsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["hiddenColumns"])) {
                this.hiddenColumns = [] as any;
                for (let item of _data["hiddenColumns"])
                    this.hiddenColumns!.push(item);
            }
            this.alignLandscape = _data["alignLandscape"];
            this.displayFilter = _data["displayFilter"];
            if (Array.isArray(_data["columnLayout"])) {
                this.columnLayout = [] as any;
                for (let item of _data["columnLayout"])
                    this.columnLayout!.push(ListColumnLayout.fromJS(item));
            }
            if (Array.isArray(_data["extraFieldColumnLayout"])) {
                this.extraFieldColumnLayout = [] as any;
                for (let item of _data["extraFieldColumnLayout"])
                    this.extraFieldColumnLayout!.push(ExtraFieldColumnLayout.fromJS(item));
            }
            if (Array.isArray(_data["visibleExtraFieldIds"])) {
                this.visibleExtraFieldIds = [] as any;
                for (let item of _data["visibleExtraFieldIds"])
                    this.visibleExtraFieldIds!.push(item);
            }
            this.sortDateAscending = _data["sortDateAscending"];
        }
    }

    static fromJS(data: any): TimeEntryListSettingsModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryListSettingsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.hiddenColumns)) {
            data["hiddenColumns"] = [];
            for (let item of this.hiddenColumns)
                data["hiddenColumns"].push(item);
        }
        data["alignLandscape"] = this.alignLandscape;
        data["displayFilter"] = this.displayFilter;
        if (Array.isArray(this.columnLayout)) {
            data["columnLayout"] = [];
            for (let item of this.columnLayout)
                data["columnLayout"].push(item.toJSON());
        }
        if (Array.isArray(this.extraFieldColumnLayout)) {
            data["extraFieldColumnLayout"] = [];
            for (let item of this.extraFieldColumnLayout)
                data["extraFieldColumnLayout"].push(item.toJSON());
        }
        if (Array.isArray(this.visibleExtraFieldIds)) {
            data["visibleExtraFieldIds"] = [];
            for (let item of this.visibleExtraFieldIds)
                data["visibleExtraFieldIds"].push(item);
        }
        data["sortDateAscending"] = this.sortDateAscending;
        return data;
    }
}

export interface ITimeEntryListSettingsModel {
    hiddenColumns?: string[] | undefined;
    alignLandscape?: boolean;
    displayFilter?: boolean;
    columnLayout?: ListColumnLayout[] | undefined;
    extraFieldColumnLayout?: ExtraFieldColumnLayout[] | undefined;
    visibleExtraFieldIds?: number[] | undefined;
    sortDateAscending?: boolean;
}

export class ListColumnLayout implements IListColumnLayout {
    columnName?: string | undefined;
    width?: number;

    constructor(data?: IListColumnLayout) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.columnName = _data["columnName"];
            this.width = _data["width"];
        }
    }

    static fromJS(data: any): ListColumnLayout {
        data = typeof data === 'object' ? data : {};
        let result = new ListColumnLayout();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["columnName"] = this.columnName;
        data["width"] = this.width;
        return data;
    }
}

export interface IListColumnLayout {
    columnName?: string | undefined;
    width?: number;
}

export class ExtraFieldColumnLayout implements IExtraFieldColumnLayout {
    id?: number;
    width?: number;

    constructor(data?: IExtraFieldColumnLayout) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.width = _data["width"];
        }
    }

    static fromJS(data: any): ExtraFieldColumnLayout {
        data = typeof data === 'object' ? data : {};
        let result = new ExtraFieldColumnLayout();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["width"] = this.width;
        return data;
    }
}

export interface IExtraFieldColumnLayout {
    id?: number;
    width?: number;
}

export class ResultFilterItem implements IResultFilterItem {
    label?: string | undefined;
    filterSelection?: string | undefined;

    constructor(data?: IResultFilterItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.filterSelection = _data["filterSelection"];
        }
    }

    static fromJS(data: any): ResultFilterItem {
        data = typeof data === 'object' ? data : {};
        let result = new ResultFilterItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["filterSelection"] = this.filterSelection;
        return data;
    }
}

export interface IResultFilterItem {
    label?: string | undefined;
    filterSelection?: string | undefined;
}

export class ListPresetEditModel implements IListPresetEditModel {
    id?: number;
    name?: string | undefined;
    isDefault?: boolean;
    isExternalAccess?: boolean;
    listParameters?: ListParameters | undefined;

    constructor(data?: IListPresetEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isDefault = _data["isDefault"];
            this.isExternalAccess = _data["isExternalAccess"];
            this.listParameters = _data["listParameters"] ? ListParameters.fromJS(_data["listParameters"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListPresetEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListPresetEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        data["isExternalAccess"] = this.isExternalAccess;
        data["listParameters"] = this.listParameters ? this.listParameters.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListPresetEditModel {
    id?: number;
    name?: string | undefined;
    isDefault?: boolean;
    isExternalAccess?: boolean;
    listParameters?: ListParameters | undefined;
}

export class ListPresetListViewModel implements IListPresetListViewModel {
    id?: number;
    name?: string | undefined;
    isDefault?: boolean;
    isExternalAccess?: boolean;

    constructor(data?: IListPresetListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isDefault = _data["isDefault"];
            this.isExternalAccess = _data["isExternalAccess"];
        }
    }

    static fromJS(data: any): ListPresetListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListPresetListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isDefault"] = this.isDefault;
        data["isExternalAccess"] = this.isExternalAccess;
        return data;
    }
}

export interface IListPresetListViewModel {
    id?: number;
    name?: string | undefined;
    isDefault?: boolean;
    isExternalAccess?: boolean;
}

export class ListPresetViewModel extends ListPresetListViewModel implements IListPresetViewModel {
    listPresetExternalUrl?: string | undefined;
    listParameters?: ListParameters | undefined;

    constructor(data?: IListPresetViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.listPresetExternalUrl = _data["listPresetExternalUrl"];
            this.listParameters = _data["listParameters"] ? ListParameters.fromJS(_data["listParameters"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListPresetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ListPresetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["listPresetExternalUrl"] = this.listPresetExternalUrl;
        data["listParameters"] = this.listParameters ? this.listParameters.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IListPresetViewModel extends IListPresetListViewModel {
    listPresetExternalUrl?: string | undefined;
    listParameters?: ListParameters | undefined;
}

export class StStringSelectListItem implements IStStringSelectListItem {
    id?: string | undefined;
    description?: string | undefined;

    constructor(data?: IStStringSelectListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): StStringSelectListItem {
        data = typeof data === 'object' ? data : {};
        let result = new StStringSelectListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}

export interface IStStringSelectListItem {
    id?: string | undefined;
    description?: string | undefined;
}

export class NewsModel implements INewsModel {
    url?: string | undefined;
    userDisplayText?: string | undefined;
    isImportant?: boolean;

    constructor(data?: INewsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.url = _data["url"];
            this.userDisplayText = _data["userDisplayText"];
            this.isImportant = _data["isImportant"];
        }
    }

    static fromJS(data: any): NewsModel {
        data = typeof data === 'object' ? data : {};
        let result = new NewsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["url"] = this.url;
        data["userDisplayText"] = this.userDisplayText;
        data["isImportant"] = this.isImportant;
        return data;
    }
}

export interface INewsModel {
    url?: string | undefined;
    userDisplayText?: string | undefined;
    isImportant?: boolean;
}

export class OutgoingInvoiceSettingsViewModel implements IOutgoingInvoiceSettingsViewModel {
    id?: number;
    useEInvoice?: boolean;
    addressFrom?: string | undefined;
    companyName?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    contactPhone?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    streetAddress?: string | undefined;
    country?: string | undefined;
    taxNumberDe?: string | undefined;
    vatId?: string | undefined;
    footer?: string | undefined;
    paymentTerms?: string | undefined;
    prefix?: string | undefined;
    prefixDateFormat?: string | undefined;
    currentIncrementValue?: number;
    incrementNoOfZerosToPad?: number;
    defaultPositionText?: string | undefined;
    useAutomaticInvoiceNo?: boolean;
    useGlobalIncrementValue?: boolean;
    customLayoutComponentName?: string | undefined;
    emailText?: string | undefined;
    emailSubject?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    usePt?: boolean;

    constructor(data?: IOutgoingInvoiceSettingsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.useEInvoice = _data["useEInvoice"];
            this.addressFrom = _data["addressFrom"];
            this.companyName = _data["companyName"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.city = _data["city"];
            this.zip = _data["zip"];
            this.streetAddress = _data["streetAddress"];
            this.country = _data["country"];
            this.taxNumberDe = _data["taxNumberDe"];
            this.vatId = _data["vatId"];
            this.footer = _data["footer"];
            this.paymentTerms = _data["paymentTerms"];
            this.prefix = _data["prefix"];
            this.prefixDateFormat = _data["prefixDateFormat"];
            this.currentIncrementValue = _data["currentIncrementValue"];
            this.incrementNoOfZerosToPad = _data["incrementNoOfZerosToPad"];
            this.defaultPositionText = _data["defaultPositionText"];
            this.useAutomaticInvoiceNo = _data["useAutomaticInvoiceNo"];
            this.useGlobalIncrementValue = _data["useGlobalIncrementValue"];
            this.customLayoutComponentName = _data["customLayoutComponentName"];
            this.emailText = _data["emailText"];
            this.emailSubject = _data["emailSubject"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.usePt = _data["usePt"];
        }
    }

    static fromJS(data: any): OutgoingInvoiceSettingsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingInvoiceSettingsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["useEInvoice"] = this.useEInvoice;
        data["addressFrom"] = this.addressFrom;
        data["companyName"] = this.companyName;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["city"] = this.city;
        data["zip"] = this.zip;
        data["streetAddress"] = this.streetAddress;
        data["country"] = this.country;
        data["taxNumberDe"] = this.taxNumberDe;
        data["vatId"] = this.vatId;
        data["footer"] = this.footer;
        data["paymentTerms"] = this.paymentTerms;
        data["prefix"] = this.prefix;
        data["prefixDateFormat"] = this.prefixDateFormat;
        data["currentIncrementValue"] = this.currentIncrementValue;
        data["incrementNoOfZerosToPad"] = this.incrementNoOfZerosToPad;
        data["defaultPositionText"] = this.defaultPositionText;
        data["useAutomaticInvoiceNo"] = this.useAutomaticInvoiceNo;
        data["useGlobalIncrementValue"] = this.useGlobalIncrementValue;
        data["customLayoutComponentName"] = this.customLayoutComponentName;
        data["emailText"] = this.emailText;
        data["emailSubject"] = this.emailSubject;
        data["title"] = this.title;
        data["description"] = this.description;
        data["usePt"] = this.usePt;
        return data;
    }
}

export interface IOutgoingInvoiceSettingsViewModel {
    id?: number;
    useEInvoice?: boolean;
    addressFrom?: string | undefined;
    companyName?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    contactPhone?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    streetAddress?: string | undefined;
    country?: string | undefined;
    taxNumberDe?: string | undefined;
    vatId?: string | undefined;
    footer?: string | undefined;
    paymentTerms?: string | undefined;
    prefix?: string | undefined;
    prefixDateFormat?: string | undefined;
    currentIncrementValue?: number;
    incrementNoOfZerosToPad?: number;
    defaultPositionText?: string | undefined;
    useAutomaticInvoiceNo?: boolean;
    useGlobalIncrementValue?: boolean;
    customLayoutComponentName?: string | undefined;
    emailText?: string | undefined;
    emailSubject?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    usePt?: boolean;
}

export class OutgoingInvoiceSettingsEditModel implements IOutgoingInvoiceSettingsEditModel {
    id?: number;
    useEInvoice?: boolean;
    addressFrom?: string | undefined;
    companyName?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    contactPhone?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    streetAddress?: string | undefined;
    country?: string | undefined;
    taxNumberDe?: string | undefined;
    vatId?: string | undefined;
    footer?: string | undefined;
    paymentTerms?: string | undefined;
    prefix?: string | undefined;
    prefixDateFormat?: string | undefined;
    currentIncrementValue?: number;
    defaultPositionText?: string | undefined;
    incrementNoOfZerosToPad?: number;
    useAutomaticInvoiceNo?: boolean;
    useGlobalIncrementValue?: boolean;
    logoBytes?: string | undefined;
    logoMimeType?: string | undefined;
    logoFileName?: string | undefined;
    logoText?: string | undefined;
    emailText?: string | undefined;
    emailSubject?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    usePt?: boolean;

    constructor(data?: IOutgoingInvoiceSettingsEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.useEInvoice = _data["useEInvoice"];
            this.addressFrom = _data["addressFrom"];
            this.companyName = _data["companyName"];
            this.contactName = _data["contactName"];
            this.contactEmail = _data["contactEmail"];
            this.contactPhone = _data["contactPhone"];
            this.city = _data["city"];
            this.zip = _data["zip"];
            this.streetAddress = _data["streetAddress"];
            this.country = _data["country"];
            this.taxNumberDe = _data["taxNumberDe"];
            this.vatId = _data["vatId"];
            this.footer = _data["footer"];
            this.paymentTerms = _data["paymentTerms"];
            this.prefix = _data["prefix"];
            this.prefixDateFormat = _data["prefixDateFormat"];
            this.currentIncrementValue = _data["currentIncrementValue"];
            this.defaultPositionText = _data["defaultPositionText"];
            this.incrementNoOfZerosToPad = _data["incrementNoOfZerosToPad"];
            this.useAutomaticInvoiceNo = _data["useAutomaticInvoiceNo"];
            this.useGlobalIncrementValue = _data["useGlobalIncrementValue"];
            this.logoBytes = _data["logoBytes"];
            this.logoMimeType = _data["logoMimeType"];
            this.logoFileName = _data["logoFileName"];
            this.logoText = _data["logoText"];
            this.emailText = _data["emailText"];
            this.emailSubject = _data["emailSubject"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.usePt = _data["usePt"];
        }
    }

    static fromJS(data: any): OutgoingInvoiceSettingsEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingInvoiceSettingsEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["useEInvoice"] = this.useEInvoice;
        data["addressFrom"] = this.addressFrom;
        data["companyName"] = this.companyName;
        data["contactName"] = this.contactName;
        data["contactEmail"] = this.contactEmail;
        data["contactPhone"] = this.contactPhone;
        data["city"] = this.city;
        data["zip"] = this.zip;
        data["streetAddress"] = this.streetAddress;
        data["country"] = this.country;
        data["taxNumberDe"] = this.taxNumberDe;
        data["vatId"] = this.vatId;
        data["footer"] = this.footer;
        data["paymentTerms"] = this.paymentTerms;
        data["prefix"] = this.prefix;
        data["prefixDateFormat"] = this.prefixDateFormat;
        data["currentIncrementValue"] = this.currentIncrementValue;
        data["defaultPositionText"] = this.defaultPositionText;
        data["incrementNoOfZerosToPad"] = this.incrementNoOfZerosToPad;
        data["useAutomaticInvoiceNo"] = this.useAutomaticInvoiceNo;
        data["useGlobalIncrementValue"] = this.useGlobalIncrementValue;
        data["logoBytes"] = this.logoBytes;
        data["logoMimeType"] = this.logoMimeType;
        data["logoFileName"] = this.logoFileName;
        data["logoText"] = this.logoText;
        data["emailText"] = this.emailText;
        data["emailSubject"] = this.emailSubject;
        data["title"] = this.title;
        data["description"] = this.description;
        data["usePt"] = this.usePt;
        return data;
    }
}

export interface IOutgoingInvoiceSettingsEditModel {
    id?: number;
    useEInvoice?: boolean;
    addressFrom?: string | undefined;
    companyName?: string | undefined;
    contactName?: string | undefined;
    contactEmail?: string | undefined;
    contactPhone?: string | undefined;
    city?: string | undefined;
    zip?: string | undefined;
    streetAddress?: string | undefined;
    country?: string | undefined;
    taxNumberDe?: string | undefined;
    vatId?: string | undefined;
    footer?: string | undefined;
    paymentTerms?: string | undefined;
    prefix?: string | undefined;
    prefixDateFormat?: string | undefined;
    currentIncrementValue?: number;
    defaultPositionText?: string | undefined;
    incrementNoOfZerosToPad?: number;
    useAutomaticInvoiceNo?: boolean;
    useGlobalIncrementValue?: boolean;
    logoBytes?: string | undefined;
    logoMimeType?: string | undefined;
    logoFileName?: string | undefined;
    logoText?: string | undefined;
    emailText?: string | undefined;
    emailSubject?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    usePt?: boolean;
}

export class OutgoingInvoicePositionEditModel implements IOutgoingInvoicePositionEditModel {
    id?: number;
    position?: string | undefined;
    quantity?: number;
    durationMinutesBillable?: number | undefined;
    rateAmount?: number;
    revenue?: number;
    unit?: string | undefined;
    outgoingInvoiceId?: number;
    isCalculated?: boolean;

    constructor(data?: IOutgoingInvoicePositionEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.position = _data["position"];
            this.quantity = _data["quantity"];
            this.durationMinutesBillable = _data["durationMinutesBillable"];
            this.rateAmount = _data["rateAmount"];
            this.revenue = _data["revenue"];
            this.unit = _data["unit"];
            this.outgoingInvoiceId = _data["outgoingInvoiceId"];
            this.isCalculated = _data["isCalculated"];
        }
    }

    static fromJS(data: any): OutgoingInvoicePositionEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingInvoicePositionEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["position"] = this.position;
        data["quantity"] = this.quantity;
        data["durationMinutesBillable"] = this.durationMinutesBillable;
        data["rateAmount"] = this.rateAmount;
        data["revenue"] = this.revenue;
        data["unit"] = this.unit;
        data["outgoingInvoiceId"] = this.outgoingInvoiceId;
        data["isCalculated"] = this.isCalculated;
        return data;
    }
}

export interface IOutgoingInvoicePositionEditModel {
    id?: number;
    position?: string | undefined;
    quantity?: number;
    durationMinutesBillable?: number | undefined;
    rateAmount?: number;
    revenue?: number;
    unit?: string | undefined;
    outgoingInvoiceId?: number;
    isCalculated?: boolean;
}

export class OutgoingInvoiceEditModel implements IOutgoingInvoiceEditModel {
    id?: number;
    invoiceNo?: string | undefined;
    invoiceIncrementValue?: number;
    invoiceDate?: string;
    addressFrom?: string | undefined;
    addressTo?: string | undefined;
    addressFromCalculated?: string | undefined;
    addressToCalculated?: string | undefined;
    isEInvoice?: boolean;
    fromCompanyName?: string | undefined;
    fromContactName?: string | undefined;
    fromContactEmail?: string | undefined;
    fromContactPhone?: string | undefined;
    fromCity?: string | undefined;
    fromZip?: string | undefined;
    fromStreetAddress?: string | undefined;
    fromCountry?: string | undefined;
    fromTaxNumberDe?: string | undefined;
    fromVatId?: string | undefined;
    toCompanyName?: string | undefined;
    toContactName?: string | undefined;
    toContactEmail?: string | undefined;
    toCity?: string | undefined;
    toZip?: string | undefined;
    toStreetAddress?: string | undefined;
    toCountry?: string | undefined;
    toVatId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    paymentTerms?: string | undefined;
    footer?: string | undefined;
    vatRate?: number;
    currency?: string | undefined;
    filterJson?: string | undefined;
    filterTimeFrame?: TimeEntryFilterTimeFrame;
    cleared?: boolean;
    externalInvoiceId?: number;
    timeEntryGrouping?: OutgoingInvoiceTimeEntryGroupEnum;
    displayDatesOnGroup?: boolean;
    usePt?: boolean;
    timeEntryIds?: number[] | undefined;
    positions?: OutgoingInvoicePositionEditModel[] | undefined;
    customerId?: number;
    layoutName?: string | undefined;
    dateFromPlaceholder?: string | undefined;
    dateToPlaceholder?: string | undefined;
    emailTo?: string | undefined;
    emailCc?: string | undefined;
    emailBcc?: string | undefined;
    emailReplyTo?: string | undefined;
    emailText?: string | undefined;
    emailSubject?: string | undefined;
    attachTimeSheet?: boolean;
    currentStatus?: OutgoingInvoiceStatusViewModel | undefined;
    contactNamePlaceholder?: string | undefined;

    constructor(data?: IOutgoingInvoiceEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceNo = _data["invoiceNo"];
            this.invoiceIncrementValue = _data["invoiceIncrementValue"];
            this.invoiceDate = _data["invoiceDate"];
            this.addressFrom = _data["addressFrom"];
            this.addressTo = _data["addressTo"];
            this.addressFromCalculated = _data["addressFromCalculated"];
            this.addressToCalculated = _data["addressToCalculated"];
            this.isEInvoice = _data["isEInvoice"];
            this.fromCompanyName = _data["fromCompanyName"];
            this.fromContactName = _data["fromContactName"];
            this.fromContactEmail = _data["fromContactEmail"];
            this.fromContactPhone = _data["fromContactPhone"];
            this.fromCity = _data["fromCity"];
            this.fromZip = _data["fromZip"];
            this.fromStreetAddress = _data["fromStreetAddress"];
            this.fromCountry = _data["fromCountry"];
            this.fromTaxNumberDe = _data["fromTaxNumberDe"];
            this.fromVatId = _data["fromVatId"];
            this.toCompanyName = _data["toCompanyName"];
            this.toContactName = _data["toContactName"];
            this.toContactEmail = _data["toContactEmail"];
            this.toCity = _data["toCity"];
            this.toZip = _data["toZip"];
            this.toStreetAddress = _data["toStreetAddress"];
            this.toCountry = _data["toCountry"];
            this.toVatId = _data["toVatId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.paymentTerms = _data["paymentTerms"];
            this.footer = _data["footer"];
            this.vatRate = _data["vatRate"];
            this.currency = _data["currency"];
            this.filterJson = _data["filterJson"];
            this.filterTimeFrame = _data["filterTimeFrame"];
            this.cleared = _data["cleared"];
            this.externalInvoiceId = _data["externalInvoiceId"];
            this.timeEntryGrouping = _data["timeEntryGrouping"];
            this.displayDatesOnGroup = _data["displayDatesOnGroup"];
            this.usePt = _data["usePt"];
            if (Array.isArray(_data["timeEntryIds"])) {
                this.timeEntryIds = [] as any;
                for (let item of _data["timeEntryIds"])
                    this.timeEntryIds!.push(item);
            }
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(OutgoingInvoicePositionEditModel.fromJS(item));
            }
            this.customerId = _data["customerId"];
            this.layoutName = _data["layoutName"];
            this.dateFromPlaceholder = _data["dateFromPlaceholder"];
            this.dateToPlaceholder = _data["dateToPlaceholder"];
            this.emailTo = _data["emailTo"];
            this.emailCc = _data["emailCc"];
            this.emailBcc = _data["emailBcc"];
            this.emailReplyTo = _data["emailReplyTo"];
            this.emailText = _data["emailText"];
            this.emailSubject = _data["emailSubject"];
            this.attachTimeSheet = _data["attachTimeSheet"];
            this.currentStatus = _data["currentStatus"] ? OutgoingInvoiceStatusViewModel.fromJS(_data["currentStatus"]) : <any>undefined;
            this.contactNamePlaceholder = _data["contactNamePlaceholder"];
        }
    }

    static fromJS(data: any): OutgoingInvoiceEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingInvoiceEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceIncrementValue"] = this.invoiceIncrementValue;
        data["invoiceDate"] = this.invoiceDate;
        data["addressFrom"] = this.addressFrom;
        data["addressTo"] = this.addressTo;
        data["addressFromCalculated"] = this.addressFromCalculated;
        data["addressToCalculated"] = this.addressToCalculated;
        data["isEInvoice"] = this.isEInvoice;
        data["fromCompanyName"] = this.fromCompanyName;
        data["fromContactName"] = this.fromContactName;
        data["fromContactEmail"] = this.fromContactEmail;
        data["fromContactPhone"] = this.fromContactPhone;
        data["fromCity"] = this.fromCity;
        data["fromZip"] = this.fromZip;
        data["fromStreetAddress"] = this.fromStreetAddress;
        data["fromCountry"] = this.fromCountry;
        data["fromTaxNumberDe"] = this.fromTaxNumberDe;
        data["fromVatId"] = this.fromVatId;
        data["toCompanyName"] = this.toCompanyName;
        data["toContactName"] = this.toContactName;
        data["toContactEmail"] = this.toContactEmail;
        data["toCity"] = this.toCity;
        data["toZip"] = this.toZip;
        data["toStreetAddress"] = this.toStreetAddress;
        data["toCountry"] = this.toCountry;
        data["toVatId"] = this.toVatId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["paymentTerms"] = this.paymentTerms;
        data["footer"] = this.footer;
        data["vatRate"] = this.vatRate;
        data["currency"] = this.currency;
        data["filterJson"] = this.filterJson;
        data["filterTimeFrame"] = this.filterTimeFrame;
        data["cleared"] = this.cleared;
        data["externalInvoiceId"] = this.externalInvoiceId;
        data["timeEntryGrouping"] = this.timeEntryGrouping;
        data["displayDatesOnGroup"] = this.displayDatesOnGroup;
        data["usePt"] = this.usePt;
        if (Array.isArray(this.timeEntryIds)) {
            data["timeEntryIds"] = [];
            for (let item of this.timeEntryIds)
                data["timeEntryIds"].push(item);
        }
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item.toJSON());
        }
        data["customerId"] = this.customerId;
        data["layoutName"] = this.layoutName;
        data["dateFromPlaceholder"] = this.dateFromPlaceholder;
        data["dateToPlaceholder"] = this.dateToPlaceholder;
        data["emailTo"] = this.emailTo;
        data["emailCc"] = this.emailCc;
        data["emailBcc"] = this.emailBcc;
        data["emailReplyTo"] = this.emailReplyTo;
        data["emailText"] = this.emailText;
        data["emailSubject"] = this.emailSubject;
        data["attachTimeSheet"] = this.attachTimeSheet;
        data["currentStatus"] = this.currentStatus ? this.currentStatus.toJSON() : <any>undefined;
        data["contactNamePlaceholder"] = this.contactNamePlaceholder;
        return data;
    }
}

export interface IOutgoingInvoiceEditModel {
    id?: number;
    invoiceNo?: string | undefined;
    invoiceIncrementValue?: number;
    invoiceDate?: string;
    addressFrom?: string | undefined;
    addressTo?: string | undefined;
    addressFromCalculated?: string | undefined;
    addressToCalculated?: string | undefined;
    isEInvoice?: boolean;
    fromCompanyName?: string | undefined;
    fromContactName?: string | undefined;
    fromContactEmail?: string | undefined;
    fromContactPhone?: string | undefined;
    fromCity?: string | undefined;
    fromZip?: string | undefined;
    fromStreetAddress?: string | undefined;
    fromCountry?: string | undefined;
    fromTaxNumberDe?: string | undefined;
    fromVatId?: string | undefined;
    toCompanyName?: string | undefined;
    toContactName?: string | undefined;
    toContactEmail?: string | undefined;
    toCity?: string | undefined;
    toZip?: string | undefined;
    toStreetAddress?: string | undefined;
    toCountry?: string | undefined;
    toVatId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    paymentTerms?: string | undefined;
    footer?: string | undefined;
    vatRate?: number;
    currency?: string | undefined;
    filterJson?: string | undefined;
    filterTimeFrame?: TimeEntryFilterTimeFrame;
    cleared?: boolean;
    externalInvoiceId?: number;
    timeEntryGrouping?: OutgoingInvoiceTimeEntryGroupEnum;
    displayDatesOnGroup?: boolean;
    usePt?: boolean;
    timeEntryIds?: number[] | undefined;
    positions?: OutgoingInvoicePositionEditModel[] | undefined;
    customerId?: number;
    layoutName?: string | undefined;
    dateFromPlaceholder?: string | undefined;
    dateToPlaceholder?: string | undefined;
    emailTo?: string | undefined;
    emailCc?: string | undefined;
    emailBcc?: string | undefined;
    emailReplyTo?: string | undefined;
    emailText?: string | undefined;
    emailSubject?: string | undefined;
    attachTimeSheet?: boolean;
    currentStatus?: OutgoingInvoiceStatusViewModel | undefined;
    contactNamePlaceholder?: string | undefined;
}

export enum OutgoingInvoiceTimeEntryGroupEnum {
    ProjectTask = "ProjectTask",
    Rate = "Rate",
    Project = "Project",
    TimeEntry = "TimeEntry",
}

export class OutgoingInvoiceStatusViewModel implements IOutgoingInvoiceStatusViewModel {
    id?: number;
    status?: OutgoingInvoiceStatusEnum;
    statusDate?: string;
    comment?: string | undefined;
    statusTranslationString?: string | undefined;

    constructor(data?: IOutgoingInvoiceStatusViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.statusDate = _data["statusDate"];
            this.comment = _data["comment"];
            this.statusTranslationString = _data["statusTranslationString"];
        }
    }

    static fromJS(data: any): OutgoingInvoiceStatusViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingInvoiceStatusViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["statusDate"] = this.statusDate;
        data["comment"] = this.comment;
        data["statusTranslationString"] = this.statusTranslationString;
        return data;
    }
}

export interface IOutgoingInvoiceStatusViewModel {
    id?: number;
    status?: OutgoingInvoiceStatusEnum;
    statusDate?: string;
    comment?: string | undefined;
    statusTranslationString?: string | undefined;
}

export enum OutgoingInvoiceStatusEnum {
    Sent = "Sent",
    Paid = "Paid",
    Overdue = "Overdue",
    ReminderSent = "ReminderSent",
}

export class OutgoingInvoiceTimeEntryGroupFilter implements IOutgoingInvoiceTimeEntryGroupFilter {
    timeEntryIds?: number[] | undefined;
    group?: OutgoingInvoiceTimeEntryGroupEnum;
    displayDatesOnGroup?: boolean;
    usePt?: boolean;

    constructor(data?: IOutgoingInvoiceTimeEntryGroupFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["timeEntryIds"])) {
                this.timeEntryIds = [] as any;
                for (let item of _data["timeEntryIds"])
                    this.timeEntryIds!.push(item);
            }
            this.group = _data["group"];
            this.displayDatesOnGroup = _data["displayDatesOnGroup"];
            this.usePt = _data["usePt"];
        }
    }

    static fromJS(data: any): OutgoingInvoiceTimeEntryGroupFilter {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingInvoiceTimeEntryGroupFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.timeEntryIds)) {
            data["timeEntryIds"] = [];
            for (let item of this.timeEntryIds)
                data["timeEntryIds"].push(item);
        }
        data["group"] = this.group;
        data["displayDatesOnGroup"] = this.displayDatesOnGroup;
        data["usePt"] = this.usePt;
        return data;
    }
}

export interface IOutgoingInvoiceTimeEntryGroupFilter {
    timeEntryIds?: number[] | undefined;
    group?: OutgoingInvoiceTimeEntryGroupEnum;
    displayDatesOnGroup?: boolean;
    usePt?: boolean;
}

export class OutgoingInvoiceTimeEntryModel implements IOutgoingInvoiceTimeEntryModel {
    id?: number;
    entryDate?: string;
    title?: string | undefined;
    description?: string | undefined;
    durationHours?: number;
    durationMinutes?: number;
    durationMinutesPause?: number;
    isBillable?: boolean;
    isCleared?: boolean;
    revenue?: number;
    revenueBillable?: number;
    rateAmount?: number;
    appUserName?: string | undefined;
    projectName?: string | undefined;
    isFixedPrice?: boolean;
    customerName?: string | undefined;
    projectTaskName?: string | undefined;
    tags?: TagViewModel[] | undefined;
    disabledReason?: string | undefined;
    isDisabled?: boolean;

    constructor(data?: IOutgoingInvoiceTimeEntryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entryDate = _data["entryDate"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.durationHours = _data["durationHours"];
            this.durationMinutes = _data["durationMinutes"];
            this.durationMinutesPause = _data["durationMinutesPause"];
            this.isBillable = _data["isBillable"];
            this.isCleared = _data["isCleared"];
            this.revenue = _data["revenue"];
            this.revenueBillable = _data["revenueBillable"];
            this.rateAmount = _data["rateAmount"];
            this.appUserName = _data["appUserName"];
            this.projectName = _data["projectName"];
            this.isFixedPrice = _data["isFixedPrice"];
            this.customerName = _data["customerName"];
            this.projectTaskName = _data["projectTaskName"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagViewModel.fromJS(item));
            }
            this.disabledReason = _data["disabledReason"];
            this.isDisabled = _data["isDisabled"];
        }
    }

    static fromJS(data: any): OutgoingInvoiceTimeEntryModel {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingInvoiceTimeEntryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entryDate"] = this.entryDate;
        data["title"] = this.title;
        data["description"] = this.description;
        data["durationHours"] = this.durationHours;
        data["durationMinutes"] = this.durationMinutes;
        data["durationMinutesPause"] = this.durationMinutesPause;
        data["isBillable"] = this.isBillable;
        data["isCleared"] = this.isCleared;
        data["revenue"] = this.revenue;
        data["revenueBillable"] = this.revenueBillable;
        data["rateAmount"] = this.rateAmount;
        data["appUserName"] = this.appUserName;
        data["projectName"] = this.projectName;
        data["isFixedPrice"] = this.isFixedPrice;
        data["customerName"] = this.customerName;
        data["projectTaskName"] = this.projectTaskName;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["disabledReason"] = this.disabledReason;
        data["isDisabled"] = this.isDisabled;
        return data;
    }
}

export interface IOutgoingInvoiceTimeEntryModel {
    id?: number;
    entryDate?: string;
    title?: string | undefined;
    description?: string | undefined;
    durationHours?: number;
    durationMinutes?: number;
    durationMinutesPause?: number;
    isBillable?: boolean;
    isCleared?: boolean;
    revenue?: number;
    revenueBillable?: number;
    rateAmount?: number;
    appUserName?: string | undefined;
    projectName?: string | undefined;
    isFixedPrice?: boolean;
    customerName?: string | undefined;
    projectTaskName?: string | undefined;
    tags?: TagViewModel[] | undefined;
    disabledReason?: string | undefined;
    isDisabled?: boolean;
}

export class OutgoingInvoiceViewModel implements IOutgoingInvoiceViewModel {
    id?: number;
    invoiceNo?: string | undefined;
    invoiceDate?: string;
    addressFromCalculated?: string | undefined;
    addressToCalculated?: string | undefined;
    addressFrom?: string | undefined;
    addressTo?: string | undefined;
    isEInvoice?: boolean;
    fromCompanyName?: string | undefined;
    fromContactName?: string | undefined;
    fromContactEmail?: string | undefined;
    fromContactPhone?: string | undefined;
    fromCity?: string | undefined;
    fromZip?: string | undefined;
    fromStreetAddress?: string | undefined;
    fromCountry?: string | undefined;
    fromTaxNumberDe?: string | undefined;
    fromVatId?: string | undefined;
    toCompanyName?: string | undefined;
    toContactName?: string | undefined;
    toContactEmail?: string | undefined;
    toCity?: string | undefined;
    toZip?: string | undefined;
    toStreetAddress?: string | undefined;
    toCountry?: string | undefined;
    toVatId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    paymentTerms?: string | undefined;
    footer?: string | undefined;
    customerName?: string | undefined;
    vatRate?: number;
    currency?: string | undefined;
    filterJson?: string | undefined;
    cleared?: boolean;
    externalInvoiceId?: number;
    timeEntryGrouping?: OutgoingInvoiceTimeEntryGroupEnum;
    displayDatesOnGroup?: boolean;
    usePt?: boolean;
    timeEntryIds?: number[] | undefined;
    positions?: OutgoingInvoicePositionViewModel[] | undefined;
    netAmount?: number;
    vatAmount?: number;
    grossAmount?: number;
    logoBytes?: string | undefined;
    logoMimeType?: string | undefined;
    layoutName?: string | undefined;
    logoText?: string | undefined;
    currentStatus?: OutgoingInvoiceStatusViewModel | undefined;
    dateFromPlaceholder?: string | undefined;
    dateToPlaceholder?: string | undefined;
    contactNamePlaceholder?: string | undefined;
    attachTimeSheet?: boolean;
    emailTo?: string | undefined;
    emailCc?: string | undefined;
    emailBcc?: string | undefined;
    emailReplyTo?: string | undefined;
    emailText?: string | undefined;
    emailSubject?: string | undefined;

    constructor(data?: IOutgoingInvoiceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoiceNo = _data["invoiceNo"];
            this.invoiceDate = _data["invoiceDate"];
            this.addressFromCalculated = _data["addressFromCalculated"];
            this.addressToCalculated = _data["addressToCalculated"];
            this.addressFrom = _data["addressFrom"];
            this.addressTo = _data["addressTo"];
            this.isEInvoice = _data["isEInvoice"];
            this.fromCompanyName = _data["fromCompanyName"];
            this.fromContactName = _data["fromContactName"];
            this.fromContactEmail = _data["fromContactEmail"];
            this.fromContactPhone = _data["fromContactPhone"];
            this.fromCity = _data["fromCity"];
            this.fromZip = _data["fromZip"];
            this.fromStreetAddress = _data["fromStreetAddress"];
            this.fromCountry = _data["fromCountry"];
            this.fromTaxNumberDe = _data["fromTaxNumberDe"];
            this.fromVatId = _data["fromVatId"];
            this.toCompanyName = _data["toCompanyName"];
            this.toContactName = _data["toContactName"];
            this.toContactEmail = _data["toContactEmail"];
            this.toCity = _data["toCity"];
            this.toZip = _data["toZip"];
            this.toStreetAddress = _data["toStreetAddress"];
            this.toCountry = _data["toCountry"];
            this.toVatId = _data["toVatId"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.paymentTerms = _data["paymentTerms"];
            this.footer = _data["footer"];
            this.customerName = _data["customerName"];
            this.vatRate = _data["vatRate"];
            this.currency = _data["currency"];
            this.filterJson = _data["filterJson"];
            this.cleared = _data["cleared"];
            this.externalInvoiceId = _data["externalInvoiceId"];
            this.timeEntryGrouping = _data["timeEntryGrouping"];
            this.displayDatesOnGroup = _data["displayDatesOnGroup"];
            this.usePt = _data["usePt"];
            if (Array.isArray(_data["timeEntryIds"])) {
                this.timeEntryIds = [] as any;
                for (let item of _data["timeEntryIds"])
                    this.timeEntryIds!.push(item);
            }
            if (Array.isArray(_data["positions"])) {
                this.positions = [] as any;
                for (let item of _data["positions"])
                    this.positions!.push(OutgoingInvoicePositionViewModel.fromJS(item));
            }
            this.netAmount = _data["netAmount"];
            this.vatAmount = _data["vatAmount"];
            this.grossAmount = _data["grossAmount"];
            this.logoBytes = _data["logoBytes"];
            this.logoMimeType = _data["logoMimeType"];
            this.layoutName = _data["layoutName"];
            this.logoText = _data["logoText"];
            this.currentStatus = _data["currentStatus"] ? OutgoingInvoiceStatusViewModel.fromJS(_data["currentStatus"]) : <any>undefined;
            this.dateFromPlaceholder = _data["dateFromPlaceholder"];
            this.dateToPlaceholder = _data["dateToPlaceholder"];
            this.contactNamePlaceholder = _data["contactNamePlaceholder"];
            this.attachTimeSheet = _data["attachTimeSheet"];
            this.emailTo = _data["emailTo"];
            this.emailCc = _data["emailCc"];
            this.emailBcc = _data["emailBcc"];
            this.emailReplyTo = _data["emailReplyTo"];
            this.emailText = _data["emailText"];
            this.emailSubject = _data["emailSubject"];
        }
    }

    static fromJS(data: any): OutgoingInvoiceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingInvoiceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoiceNo"] = this.invoiceNo;
        data["invoiceDate"] = this.invoiceDate;
        data["addressFromCalculated"] = this.addressFromCalculated;
        data["addressToCalculated"] = this.addressToCalculated;
        data["addressFrom"] = this.addressFrom;
        data["addressTo"] = this.addressTo;
        data["isEInvoice"] = this.isEInvoice;
        data["fromCompanyName"] = this.fromCompanyName;
        data["fromContactName"] = this.fromContactName;
        data["fromContactEmail"] = this.fromContactEmail;
        data["fromContactPhone"] = this.fromContactPhone;
        data["fromCity"] = this.fromCity;
        data["fromZip"] = this.fromZip;
        data["fromStreetAddress"] = this.fromStreetAddress;
        data["fromCountry"] = this.fromCountry;
        data["fromTaxNumberDe"] = this.fromTaxNumberDe;
        data["fromVatId"] = this.fromVatId;
        data["toCompanyName"] = this.toCompanyName;
        data["toContactName"] = this.toContactName;
        data["toContactEmail"] = this.toContactEmail;
        data["toCity"] = this.toCity;
        data["toZip"] = this.toZip;
        data["toStreetAddress"] = this.toStreetAddress;
        data["toCountry"] = this.toCountry;
        data["toVatId"] = this.toVatId;
        data["title"] = this.title;
        data["description"] = this.description;
        data["paymentTerms"] = this.paymentTerms;
        data["footer"] = this.footer;
        data["customerName"] = this.customerName;
        data["vatRate"] = this.vatRate;
        data["currency"] = this.currency;
        data["filterJson"] = this.filterJson;
        data["cleared"] = this.cleared;
        data["externalInvoiceId"] = this.externalInvoiceId;
        data["timeEntryGrouping"] = this.timeEntryGrouping;
        data["displayDatesOnGroup"] = this.displayDatesOnGroup;
        data["usePt"] = this.usePt;
        if (Array.isArray(this.timeEntryIds)) {
            data["timeEntryIds"] = [];
            for (let item of this.timeEntryIds)
                data["timeEntryIds"].push(item);
        }
        if (Array.isArray(this.positions)) {
            data["positions"] = [];
            for (let item of this.positions)
                data["positions"].push(item.toJSON());
        }
        data["netAmount"] = this.netAmount;
        data["vatAmount"] = this.vatAmount;
        data["grossAmount"] = this.grossAmount;
        data["logoBytes"] = this.logoBytes;
        data["logoMimeType"] = this.logoMimeType;
        data["layoutName"] = this.layoutName;
        data["logoText"] = this.logoText;
        data["currentStatus"] = this.currentStatus ? this.currentStatus.toJSON() : <any>undefined;
        data["dateFromPlaceholder"] = this.dateFromPlaceholder;
        data["dateToPlaceholder"] = this.dateToPlaceholder;
        data["contactNamePlaceholder"] = this.contactNamePlaceholder;
        data["attachTimeSheet"] = this.attachTimeSheet;
        data["emailTo"] = this.emailTo;
        data["emailCc"] = this.emailCc;
        data["emailBcc"] = this.emailBcc;
        data["emailReplyTo"] = this.emailReplyTo;
        data["emailText"] = this.emailText;
        data["emailSubject"] = this.emailSubject;
        return data;
    }
}

export interface IOutgoingInvoiceViewModel {
    id?: number;
    invoiceNo?: string | undefined;
    invoiceDate?: string;
    addressFromCalculated?: string | undefined;
    addressToCalculated?: string | undefined;
    addressFrom?: string | undefined;
    addressTo?: string | undefined;
    isEInvoice?: boolean;
    fromCompanyName?: string | undefined;
    fromContactName?: string | undefined;
    fromContactEmail?: string | undefined;
    fromContactPhone?: string | undefined;
    fromCity?: string | undefined;
    fromZip?: string | undefined;
    fromStreetAddress?: string | undefined;
    fromCountry?: string | undefined;
    fromTaxNumberDe?: string | undefined;
    fromVatId?: string | undefined;
    toCompanyName?: string | undefined;
    toContactName?: string | undefined;
    toContactEmail?: string | undefined;
    toCity?: string | undefined;
    toZip?: string | undefined;
    toStreetAddress?: string | undefined;
    toCountry?: string | undefined;
    toVatId?: string | undefined;
    title?: string | undefined;
    description?: string | undefined;
    paymentTerms?: string | undefined;
    footer?: string | undefined;
    customerName?: string | undefined;
    vatRate?: number;
    currency?: string | undefined;
    filterJson?: string | undefined;
    cleared?: boolean;
    externalInvoiceId?: number;
    timeEntryGrouping?: OutgoingInvoiceTimeEntryGroupEnum;
    displayDatesOnGroup?: boolean;
    usePt?: boolean;
    timeEntryIds?: number[] | undefined;
    positions?: OutgoingInvoicePositionViewModel[] | undefined;
    netAmount?: number;
    vatAmount?: number;
    grossAmount?: number;
    logoBytes?: string | undefined;
    logoMimeType?: string | undefined;
    layoutName?: string | undefined;
    logoText?: string | undefined;
    currentStatus?: OutgoingInvoiceStatusViewModel | undefined;
    dateFromPlaceholder?: string | undefined;
    dateToPlaceholder?: string | undefined;
    contactNamePlaceholder?: string | undefined;
    attachTimeSheet?: boolean;
    emailTo?: string | undefined;
    emailCc?: string | undefined;
    emailBcc?: string | undefined;
    emailReplyTo?: string | undefined;
    emailText?: string | undefined;
    emailSubject?: string | undefined;
}

export class OutgoingInvoicePositionViewModel implements IOutgoingInvoicePositionViewModel {
    id?: number;
    position?: string | undefined;
    quantity?: number;
    rateAmount?: number;
    revenue?: number;
    unit?: string | undefined;
    isCalculated?: boolean;

    constructor(data?: IOutgoingInvoicePositionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.position = _data["position"];
            this.quantity = _data["quantity"];
            this.rateAmount = _data["rateAmount"];
            this.revenue = _data["revenue"];
            this.unit = _data["unit"];
            this.isCalculated = _data["isCalculated"];
        }
    }

    static fromJS(data: any): OutgoingInvoicePositionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingInvoicePositionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["position"] = this.position;
        data["quantity"] = this.quantity;
        data["rateAmount"] = this.rateAmount;
        data["revenue"] = this.revenue;
        data["unit"] = this.unit;
        data["isCalculated"] = this.isCalculated;
        return data;
    }
}

export interface IOutgoingInvoicePositionViewModel {
    id?: number;
    position?: string | undefined;
    quantity?: number;
    rateAmount?: number;
    revenue?: number;
    unit?: string | undefined;
    isCalculated?: boolean;
}

export class OutgoingInvoiceFilter implements IOutgoingInvoiceFilter {
    id?: number | undefined;
    year?: number | undefined;
    month?: number | undefined;
    customerId?: number | undefined;

    constructor(data?: IOutgoingInvoiceFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            this.month = _data["month"];
            this.customerId = _data["customerId"];
        }
    }

    static fromJS(data: any): OutgoingInvoiceFilter {
        data = typeof data === 'object' ? data : {};
        let result = new OutgoingInvoiceFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        data["month"] = this.month;
        data["customerId"] = this.customerId;
        return data;
    }
}

export interface IOutgoingInvoiceFilter {
    id?: number | undefined;
    year?: number | undefined;
    month?: number | undefined;
    customerId?: number | undefined;
}

export class SetupIntentConfirmationModel implements ISetupIntentConfirmationModel {
    isSuccess?: boolean;

    constructor(data?: ISetupIntentConfirmationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccess = _data["isSuccess"];
        }
    }

    static fromJS(data: any): SetupIntentConfirmationModel {
        data = typeof data === 'object' ? data : {};
        let result = new SetupIntentConfirmationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccess"] = this.isSuccess;
        return data;
    }
}

export interface ISetupIntentConfirmationModel {
    isSuccess?: boolean;
}

export class AuthorizedProjectList implements IAuthorizedProjectList {
    projects?: ProjectViewModel[] | undefined;
    canAccessAllProjects?: boolean;

    constructor(data?: IAuthorizedProjectList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectViewModel.fromJS(item));
            }
            this.canAccessAllProjects = _data["canAccessAllProjects"];
        }
    }

    static fromJS(data: any): AuthorizedProjectList {
        data = typeof data === 'object' ? data : {};
        let result = new AuthorizedProjectList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        data["canAccessAllProjects"] = this.canAccessAllProjects;
        return data;
    }
}

export interface IAuthorizedProjectList {
    projects?: ProjectViewModel[] | undefined;
    canAccessAllProjects?: boolean;
}

export class ProjectTimeEntryViewModel implements IProjectTimeEntryViewModel {
    id?: number;
    isBillable?: boolean;
    isFixedPrice?: boolean;
    fixedPrice?: number;
    fixedPriceCalcRate?: number;
    activeFixedPriceRate?: number;
    name?: string | undefined;
    hasProjectTasks?: boolean;
    preselectedProjectTaskId?: number | undefined;
    projectTimeEntryComment?: string | undefined;
    customerTimeEntryComment?: string | undefined;

    constructor(data?: IProjectTimeEntryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isBillable = _data["isBillable"];
            this.isFixedPrice = _data["isFixedPrice"];
            this.fixedPrice = _data["fixedPrice"];
            this.fixedPriceCalcRate = _data["fixedPriceCalcRate"];
            this.activeFixedPriceRate = _data["activeFixedPriceRate"];
            this.name = _data["name"];
            this.hasProjectTasks = _data["hasProjectTasks"];
            this.preselectedProjectTaskId = _data["preselectedProjectTaskId"];
            this.projectTimeEntryComment = _data["projectTimeEntryComment"];
            this.customerTimeEntryComment = _data["customerTimeEntryComment"];
        }
    }

    static fromJS(data: any): ProjectTimeEntryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTimeEntryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isBillable"] = this.isBillable;
        data["isFixedPrice"] = this.isFixedPrice;
        data["fixedPrice"] = this.fixedPrice;
        data["fixedPriceCalcRate"] = this.fixedPriceCalcRate;
        data["activeFixedPriceRate"] = this.activeFixedPriceRate;
        data["name"] = this.name;
        data["hasProjectTasks"] = this.hasProjectTasks;
        data["preselectedProjectTaskId"] = this.preselectedProjectTaskId;
        data["projectTimeEntryComment"] = this.projectTimeEntryComment;
        data["customerTimeEntryComment"] = this.customerTimeEntryComment;
        return data;
    }
}

export interface IProjectTimeEntryViewModel {
    id?: number;
    isBillable?: boolean;
    isFixedPrice?: boolean;
    fixedPrice?: number;
    fixedPriceCalcRate?: number;
    activeFixedPriceRate?: number;
    name?: string | undefined;
    hasProjectTasks?: boolean;
    preselectedProjectTaskId?: number | undefined;
    projectTimeEntryComment?: string | undefined;
    customerTimeEntryComment?: string | undefined;
}

export class ProjectCheckFixedPriceChangeResult implements IProjectCheckFixedPriceChangeResult {
    canBeChanged?: boolean;
    warningText?: string | undefined;

    constructor(data?: IProjectCheckFixedPriceChangeResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.canBeChanged = _data["canBeChanged"];
            this.warningText = _data["warningText"];
        }
    }

    static fromJS(data: any): ProjectCheckFixedPriceChangeResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCheckFixedPriceChangeResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canBeChanged"] = this.canBeChanged;
        data["warningText"] = this.warningText;
        return data;
    }
}

export interface IProjectCheckFixedPriceChangeResult {
    canBeChanged?: boolean;
    warningText?: string | undefined;
}

export class ProjectCheckFixedPriceChangeCommand implements IProjectCheckFixedPriceChangeCommand {
    id?: number;
    changeFixedPriceValueTo?: boolean;

    constructor(data?: IProjectCheckFixedPriceChangeCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.changeFixedPriceValueTo = _data["changeFixedPriceValueTo"];
        }
    }

    static fromJS(data: any): ProjectCheckFixedPriceChangeCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCheckFixedPriceChangeCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["changeFixedPriceValueTo"] = this.changeFixedPriceValueTo;
        return data;
    }
}

export interface IProjectCheckFixedPriceChangeCommand {
    id?: number;
    changeFixedPriceValueTo?: boolean;
}

export class ProjectFilter implements IProjectFilter {
    id?: number | undefined;
    ids?: number[] | undefined;
    customerId?: number | undefined;
    customerIds?: number[] | undefined;
    isArchived?: boolean | undefined;
    includeViewOnlyProjects?: boolean | undefined;
    appUserId?: number | undefined;
    isFinished?: boolean | undefined;
    onlyShowInTimeTracking?: boolean | undefined;

    constructor(data?: IProjectFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["customerIds"])) {
                this.customerIds = [] as any;
                for (let item of _data["customerIds"])
                    this.customerIds!.push(item);
            }
            this.isArchived = _data["isArchived"];
            this.includeViewOnlyProjects = _data["includeViewOnlyProjects"];
            this.appUserId = _data["appUserId"];
            this.isFinished = _data["isFinished"];
            this.onlyShowInTimeTracking = _data["onlyShowInTimeTracking"];
        }
    }

    static fromJS(data: any): ProjectFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["customerId"] = this.customerId;
        if (Array.isArray(this.customerIds)) {
            data["customerIds"] = [];
            for (let item of this.customerIds)
                data["customerIds"].push(item);
        }
        data["isArchived"] = this.isArchived;
        data["includeViewOnlyProjects"] = this.includeViewOnlyProjects;
        data["appUserId"] = this.appUserId;
        data["isFinished"] = this.isFinished;
        data["onlyShowInTimeTracking"] = this.onlyShowInTimeTracking;
        return data;
    }
}

export interface IProjectFilter {
    id?: number | undefined;
    ids?: number[] | undefined;
    customerId?: number | undefined;
    customerIds?: number[] | undefined;
    isArchived?: boolean | undefined;
    includeViewOnlyProjects?: boolean | undefined;
    appUserId?: number | undefined;
    isFinished?: boolean | undefined;
    onlyShowInTimeTracking?: boolean | undefined;
}

export class ProjectBudgetViewModel implements IProjectBudgetViewModel {
    projectId?: number;
    budget?: number;
    budgetUnit?: BudgetUnitEnum;
    budgetTimeFrame?: BudgetTimeFrameEnum;
    actualValue?: number;
    percentage?: number;
    percentageOnly?: boolean;
    projectName?: string | undefined;
    budgetOverrunThresholdPercent?: number;
    budgetOverrunNotificationSent?: boolean;
    budgetIsOverrun?: boolean;

    constructor(data?: IProjectBudgetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.budget = _data["budget"];
            this.budgetUnit = _data["budgetUnit"];
            this.budgetTimeFrame = _data["budgetTimeFrame"];
            this.actualValue = _data["actualValue"];
            this.percentage = _data["percentage"];
            this.percentageOnly = _data["percentageOnly"];
            this.projectName = _data["projectName"];
            this.budgetOverrunThresholdPercent = _data["budgetOverrunThresholdPercent"];
            this.budgetOverrunNotificationSent = _data["budgetOverrunNotificationSent"];
            this.budgetIsOverrun = _data["budgetIsOverrun"];
        }
    }

    static fromJS(data: any): ProjectBudgetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectBudgetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["budget"] = this.budget;
        data["budgetUnit"] = this.budgetUnit;
        data["budgetTimeFrame"] = this.budgetTimeFrame;
        data["actualValue"] = this.actualValue;
        data["percentage"] = this.percentage;
        data["percentageOnly"] = this.percentageOnly;
        data["projectName"] = this.projectName;
        data["budgetOverrunThresholdPercent"] = this.budgetOverrunThresholdPercent;
        data["budgetOverrunNotificationSent"] = this.budgetOverrunNotificationSent;
        data["budgetIsOverrun"] = this.budgetIsOverrun;
        return data;
    }
}

export interface IProjectBudgetViewModel {
    projectId?: number;
    budget?: number;
    budgetUnit?: BudgetUnitEnum;
    budgetTimeFrame?: BudgetTimeFrameEnum;
    actualValue?: number;
    percentage?: number;
    percentageOnly?: boolean;
    projectName?: string | undefined;
    budgetOverrunThresholdPercent?: number;
    budgetOverrunNotificationSent?: boolean;
    budgetIsOverrun?: boolean;
}

export class ProjectFinishToggleCommand implements IProjectFinishToggleCommand {
    projectId?: number;

    constructor(data?: IProjectFinishToggleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): ProjectFinishToggleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFinishToggleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IProjectFinishToggleCommand {
    projectId?: number;
}

export class ProjectArchiveToggleCommand implements IProjectArchiveToggleCommand {
    projectId?: number;

    constructor(data?: IProjectArchiveToggleCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): ProjectArchiveToggleCommand {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectArchiveToggleCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IProjectArchiveToggleCommand {
    projectId?: number;
}

export class ProjectReportViewModel implements IProjectReportViewModel {
    id?: number;
    name?: string | undefined;
    customerName?: string | undefined;
    isBillable?: boolean;
    isFixedPrice?: boolean;
    fixedPrice?: number;
    budget?: number;
    plannedStartDate?: string | undefined;
    plannedEndDate?: string | undefined;
    budgetPercentage?: number;
    budgetActualValue?: number;
    budgetUnit?: BudgetUnitEnum;
    budgetTimeFrame?: BudgetTimeFrameEnum;
    startDate?: string | undefined;
    endDate?: string | undefined;
    hours?: number;
    hoursBillable?: number;
    hoursNotBillable?: number;
    revenueBillable?: number;
    revenueNotBillable?: number;
    cost?: number;
    db1?: number;
    allEntriesHaveCost?: boolean;
    anyEntryHasCost?: boolean;
    isArchived?: boolean;
    timeEntries?: TimeEntryReportViewModel[] | undefined;
    timeFrameModel?: ReportTimeFrameModel[] | undefined;
    userModel?: ProjectReportUserModel[] | undefined;
    displayTimeChartDaily?: boolean;

    constructor(data?: IProjectReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.customerName = _data["customerName"];
            this.isBillable = _data["isBillable"];
            this.isFixedPrice = _data["isFixedPrice"];
            this.fixedPrice = _data["fixedPrice"];
            this.budget = _data["budget"];
            this.plannedStartDate = _data["plannedStartDate"];
            this.plannedEndDate = _data["plannedEndDate"];
            this.budgetPercentage = _data["budgetPercentage"];
            this.budgetActualValue = _data["budgetActualValue"];
            this.budgetUnit = _data["budgetUnit"];
            this.budgetTimeFrame = _data["budgetTimeFrame"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.hours = _data["hours"];
            this.hoursBillable = _data["hoursBillable"];
            this.hoursNotBillable = _data["hoursNotBillable"];
            this.revenueBillable = _data["revenueBillable"];
            this.revenueNotBillable = _data["revenueNotBillable"];
            this.cost = _data["cost"];
            this.db1 = _data["db1"];
            this.allEntriesHaveCost = _data["allEntriesHaveCost"];
            this.anyEntryHasCost = _data["anyEntryHasCost"];
            this.isArchived = _data["isArchived"];
            if (Array.isArray(_data["timeEntries"])) {
                this.timeEntries = [] as any;
                for (let item of _data["timeEntries"])
                    this.timeEntries!.push(TimeEntryReportViewModel.fromJS(item));
            }
            if (Array.isArray(_data["timeFrameModel"])) {
                this.timeFrameModel = [] as any;
                for (let item of _data["timeFrameModel"])
                    this.timeFrameModel!.push(ReportTimeFrameModel.fromJS(item));
            }
            if (Array.isArray(_data["userModel"])) {
                this.userModel = [] as any;
                for (let item of _data["userModel"])
                    this.userModel!.push(ProjectReportUserModel.fromJS(item));
            }
            this.displayTimeChartDaily = _data["displayTimeChartDaily"];
        }
    }

    static fromJS(data: any): ProjectReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["customerName"] = this.customerName;
        data["isBillable"] = this.isBillable;
        data["isFixedPrice"] = this.isFixedPrice;
        data["fixedPrice"] = this.fixedPrice;
        data["budget"] = this.budget;
        data["plannedStartDate"] = this.plannedStartDate;
        data["plannedEndDate"] = this.plannedEndDate;
        data["budgetPercentage"] = this.budgetPercentage;
        data["budgetActualValue"] = this.budgetActualValue;
        data["budgetUnit"] = this.budgetUnit;
        data["budgetTimeFrame"] = this.budgetTimeFrame;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["hours"] = this.hours;
        data["hoursBillable"] = this.hoursBillable;
        data["hoursNotBillable"] = this.hoursNotBillable;
        data["revenueBillable"] = this.revenueBillable;
        data["revenueNotBillable"] = this.revenueNotBillable;
        data["cost"] = this.cost;
        data["db1"] = this.db1;
        data["allEntriesHaveCost"] = this.allEntriesHaveCost;
        data["anyEntryHasCost"] = this.anyEntryHasCost;
        data["isArchived"] = this.isArchived;
        if (Array.isArray(this.timeEntries)) {
            data["timeEntries"] = [];
            for (let item of this.timeEntries)
                data["timeEntries"].push(item.toJSON());
        }
        if (Array.isArray(this.timeFrameModel)) {
            data["timeFrameModel"] = [];
            for (let item of this.timeFrameModel)
                data["timeFrameModel"].push(item.toJSON());
        }
        if (Array.isArray(this.userModel)) {
            data["userModel"] = [];
            for (let item of this.userModel)
                data["userModel"].push(item.toJSON());
        }
        data["displayTimeChartDaily"] = this.displayTimeChartDaily;
        return data;
    }
}

export interface IProjectReportViewModel {
    id?: number;
    name?: string | undefined;
    customerName?: string | undefined;
    isBillable?: boolean;
    isFixedPrice?: boolean;
    fixedPrice?: number;
    budget?: number;
    plannedStartDate?: string | undefined;
    plannedEndDate?: string | undefined;
    budgetPercentage?: number;
    budgetActualValue?: number;
    budgetUnit?: BudgetUnitEnum;
    budgetTimeFrame?: BudgetTimeFrameEnum;
    startDate?: string | undefined;
    endDate?: string | undefined;
    hours?: number;
    hoursBillable?: number;
    hoursNotBillable?: number;
    revenueBillable?: number;
    revenueNotBillable?: number;
    cost?: number;
    db1?: number;
    allEntriesHaveCost?: boolean;
    anyEntryHasCost?: boolean;
    isArchived?: boolean;
    timeEntries?: TimeEntryReportViewModel[] | undefined;
    timeFrameModel?: ReportTimeFrameModel[] | undefined;
    userModel?: ProjectReportUserModel[] | undefined;
    displayTimeChartDaily?: boolean;
}

export class TimeEntryReportViewModel implements ITimeEntryReportViewModel {
    id?: number;
    entryDate?: string;
    projectId?: string | undefined;
    projectName?: string | undefined;
    projectCustomerId?: string | undefined;
    projectCustomerName?: string | undefined;
    appUserId?: string | undefined;
    appUserName?: string | undefined;
    durationMinutes?: number;
    durationHours?: number;
    durationHoursBillable?: number;
    title?: string | undefined;
    description?: string | undefined;
    timeFrom?: string | undefined;
    timeTo?: string | undefined;
    isInputTimeFromTo?: boolean;
    isBillable?: boolean;
    isCleared?: boolean;
    revenue?: number;
    revenueBillable?: number;
    rateAmount?: number;
    rateAmountOverridden?: boolean;
    costPerHour?: number;
    cost?: number;
    projectTaskName?: string | undefined;
    tags?: TagViewModel[] | undefined;

    constructor(data?: ITimeEntryReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entryDate = _data["entryDate"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.projectCustomerId = _data["projectCustomerId"];
            this.projectCustomerName = _data["projectCustomerName"];
            this.appUserId = _data["appUserId"];
            this.appUserName = _data["appUserName"];
            this.durationMinutes = _data["durationMinutes"];
            this.durationHours = _data["durationHours"];
            this.durationHoursBillable = _data["durationHoursBillable"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.timeFrom = _data["timeFrom"];
            this.timeTo = _data["timeTo"];
            this.isInputTimeFromTo = _data["isInputTimeFromTo"];
            this.isBillable = _data["isBillable"];
            this.isCleared = _data["isCleared"];
            this.revenue = _data["revenue"];
            this.revenueBillable = _data["revenueBillable"];
            this.rateAmount = _data["rateAmount"];
            this.rateAmountOverridden = _data["rateAmountOverridden"];
            this.costPerHour = _data["costPerHour"];
            this.cost = _data["cost"];
            this.projectTaskName = _data["projectTaskName"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimeEntryReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entryDate"] = this.entryDate;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["projectCustomerId"] = this.projectCustomerId;
        data["projectCustomerName"] = this.projectCustomerName;
        data["appUserId"] = this.appUserId;
        data["appUserName"] = this.appUserName;
        data["durationMinutes"] = this.durationMinutes;
        data["durationHours"] = this.durationHours;
        data["durationHoursBillable"] = this.durationHoursBillable;
        data["title"] = this.title;
        data["description"] = this.description;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        data["isInputTimeFromTo"] = this.isInputTimeFromTo;
        data["isBillable"] = this.isBillable;
        data["isCleared"] = this.isCleared;
        data["revenue"] = this.revenue;
        data["revenueBillable"] = this.revenueBillable;
        data["rateAmount"] = this.rateAmount;
        data["rateAmountOverridden"] = this.rateAmountOverridden;
        data["costPerHour"] = this.costPerHour;
        data["cost"] = this.cost;
        data["projectTaskName"] = this.projectTaskName;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITimeEntryReportViewModel {
    id?: number;
    entryDate?: string;
    projectId?: string | undefined;
    projectName?: string | undefined;
    projectCustomerId?: string | undefined;
    projectCustomerName?: string | undefined;
    appUserId?: string | undefined;
    appUserName?: string | undefined;
    durationMinutes?: number;
    durationHours?: number;
    durationHoursBillable?: number;
    title?: string | undefined;
    description?: string | undefined;
    timeFrom?: string | undefined;
    timeTo?: string | undefined;
    isInputTimeFromTo?: boolean;
    isBillable?: boolean;
    isCleared?: boolean;
    revenue?: number;
    revenueBillable?: number;
    rateAmount?: number;
    rateAmountOverridden?: boolean;
    costPerHour?: number;
    cost?: number;
    projectTaskName?: string | undefined;
    tags?: TagViewModel[] | undefined;
}

export class ReportTimeFrameModel implements IReportTimeFrameModel {
    date?: string;
    hours?: number;
    revenue?: number;
    cost?: number;

    constructor(data?: IReportTimeFrameModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.hours = _data["hours"];
            this.revenue = _data["revenue"];
            this.cost = _data["cost"];
        }
    }

    static fromJS(data: any): ReportTimeFrameModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportTimeFrameModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["hours"] = this.hours;
        data["revenue"] = this.revenue;
        data["cost"] = this.cost;
        return data;
    }
}

export interface IReportTimeFrameModel {
    date?: string;
    hours?: number;
    revenue?: number;
    cost?: number;
}

export class ProjectReportUserModel implements IProjectReportUserModel {
    userFullName?: string | undefined;
    hours?: number;
    revenue?: number;
    revenueBillable?: number;
    cost?: number;

    constructor(data?: IProjectReportUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userFullName = _data["userFullName"];
            this.hours = _data["hours"];
            this.revenue = _data["revenue"];
            this.revenueBillable = _data["revenueBillable"];
            this.cost = _data["cost"];
        }
    }

    static fromJS(data: any): ProjectReportUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectReportUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userFullName"] = this.userFullName;
        data["hours"] = this.hours;
        data["revenue"] = this.revenue;
        data["revenueBillable"] = this.revenueBillable;
        data["cost"] = this.cost;
        return data;
    }
}

export interface IProjectReportUserModel {
    userFullName?: string | undefined;
    hours?: number;
    revenue?: number;
    revenueBillable?: number;
    cost?: number;
}

export class ProjectFixedPriceUserOverviewModel implements IProjectFixedPriceUserOverviewModel {
    appUserName?: string | undefined;
    projectRevenue?: number;
    projectRevenueFte?: number;
    projectRevenueFteInclNotFinished?: number;

    constructor(data?: IProjectFixedPriceUserOverviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appUserName = _data["appUserName"];
            this.projectRevenue = _data["projectRevenue"];
            this.projectRevenueFte = _data["projectRevenueFte"];
            this.projectRevenueFteInclNotFinished = _data["projectRevenueFteInclNotFinished"];
        }
    }

    static fromJS(data: any): ProjectFixedPriceUserOverviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFixedPriceUserOverviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appUserName"] = this.appUserName;
        data["projectRevenue"] = this.projectRevenue;
        data["projectRevenueFte"] = this.projectRevenueFte;
        data["projectRevenueFteInclNotFinished"] = this.projectRevenueFteInclNotFinished;
        return data;
    }
}

export interface IProjectFixedPriceUserOverviewModel {
    appUserName?: string | undefined;
    projectRevenue?: number;
    projectRevenueFte?: number;
    projectRevenueFteInclNotFinished?: number;
}

export class ProjectFixedPriceUserOverviewQuery implements IProjectFixedPriceUserOverviewQuery {
    entryDateFrom?: string;
    entryDateTo?: string;

    constructor(data?: IProjectFixedPriceUserOverviewQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entryDateFrom = _data["entryDateFrom"];
            this.entryDateTo = _data["entryDateTo"];
        }
    }

    static fromJS(data: any): ProjectFixedPriceUserOverviewQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFixedPriceUserOverviewQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entryDateFrom"] = this.entryDateFrom;
        data["entryDateTo"] = this.entryDateTo;
        return data;
    }
}

export interface IProjectFixedPriceUserOverviewQuery {
    entryDateFrom?: string;
    entryDateTo?: string;
}

export class ProjectFixedPriceRevenueFteModel implements IProjectFixedPriceRevenueFteModel {
    date?: string;
    avgRevenueFte?: number;
    avgRevenueFteInclNotFinished?: number;

    constructor(data?: IProjectFixedPriceRevenueFteModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.avgRevenueFte = _data["avgRevenueFte"];
            this.avgRevenueFteInclNotFinished = _data["avgRevenueFteInclNotFinished"];
        }
    }

    static fromJS(data: any): ProjectFixedPriceRevenueFteModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFixedPriceRevenueFteModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["avgRevenueFte"] = this.avgRevenueFte;
        data["avgRevenueFteInclNotFinished"] = this.avgRevenueFteInclNotFinished;
        return data;
    }
}

export interface IProjectFixedPriceRevenueFteModel {
    date?: string;
    avgRevenueFte?: number;
    avgRevenueFteInclNotFinished?: number;
}

export class ProjectFixedPriceRevenueFteQuery implements IProjectFixedPriceRevenueFteQuery {
    filter?: TimeEntryFilter | undefined;

    constructor(data?: IProjectFixedPriceRevenueFteQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"] ? TimeEntryFilter.fromJS(_data["filter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectFixedPriceRevenueFteQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFixedPriceRevenueFteQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProjectFixedPriceRevenueFteQuery {
    filter?: TimeEntryFilter | undefined;
}

export class ProjectFixedPriceDailyRateReportModel implements IProjectFixedPriceDailyRateReportModel {
    month?: string;
    avgDailyRate?: number;

    constructor(data?: IProjectFixedPriceDailyRateReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.avgDailyRate = _data["avgDailyRate"];
        }
    }

    static fromJS(data: any): ProjectFixedPriceDailyRateReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFixedPriceDailyRateReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["avgDailyRate"] = this.avgDailyRate;
        return data;
    }
}

export interface IProjectFixedPriceDailyRateReportModel {
    month?: string;
    avgDailyRate?: number;
}

export class ProjectFixedPriceDailyRateReportQuery implements IProjectFixedPriceDailyRateReportQuery {
    filter?: TimeEntryFilter | undefined;

    constructor(data?: IProjectFixedPriceDailyRateReportQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.filter = _data["filter"] ? TimeEntryFilter.fromJS(_data["filter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ProjectFixedPriceDailyRateReportQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFixedPriceDailyRateReportQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["filter"] = this.filter ? this.filter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProjectFixedPriceDailyRateReportQuery {
    filter?: TimeEntryFilter | undefined;
}

export class ProjectStaffFilter implements IProjectStaffFilter {
    projectId?: number | undefined;
    appUserId?: number | undefined;

    constructor(data?: IProjectStaffFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.appUserId = _data["appUserId"];
        }
    }

    static fromJS(data: any): ProjectStaffFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectStaffFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["appUserId"] = this.appUserId;
        return data;
    }
}

export interface IProjectStaffFilter {
    projectId?: number | undefined;
    appUserId?: number | undefined;
}

export class ProjectStaffAppUserViewModel implements IProjectStaffAppUserViewModel {
    appUserId?: number;
    appUserName?: string | undefined;
    canViewTimeEntriesForEmployees?: boolean;
    canEditTimeEntriesForEmployees?: boolean;
    canEditTimeEntriesForAllProjects?: boolean;

    constructor(data?: IProjectStaffAppUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appUserId = _data["appUserId"];
            this.appUserName = _data["appUserName"];
            this.canViewTimeEntriesForEmployees = _data["canViewTimeEntriesForEmployees"];
            this.canEditTimeEntriesForEmployees = _data["canEditTimeEntriesForEmployees"];
            this.canEditTimeEntriesForAllProjects = _data["canEditTimeEntriesForAllProjects"];
        }
    }

    static fromJS(data: any): ProjectStaffAppUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectStaffAppUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appUserId"] = this.appUserId;
        data["appUserName"] = this.appUserName;
        data["canViewTimeEntriesForEmployees"] = this.canViewTimeEntriesForEmployees;
        data["canEditTimeEntriesForEmployees"] = this.canEditTimeEntriesForEmployees;
        data["canEditTimeEntriesForAllProjects"] = this.canEditTimeEntriesForAllProjects;
        return data;
    }
}

export interface IProjectStaffAppUserViewModel {
    appUserId?: number;
    appUserName?: string | undefined;
    canViewTimeEntriesForEmployees?: boolean;
    canEditTimeEntriesForEmployees?: boolean;
    canEditTimeEntriesForAllProjects?: boolean;
}

export class ProjectTaskFilter implements IProjectTaskFilter {
    id?: number | undefined;
    ids?: number[] | undefined;
    isArchived?: boolean | undefined;
    onlyGlobal?: boolean | undefined;
    onlyProject?: boolean | undefined;
    projectId?: number | undefined;
    projectIds?: number[] | undefined;

    constructor(data?: IProjectTaskFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.isArchived = _data["isArchived"];
            this.onlyGlobal = _data["onlyGlobal"];
            this.onlyProject = _data["onlyProject"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["projectIds"])) {
                this.projectIds = [] as any;
                for (let item of _data["projectIds"])
                    this.projectIds!.push(item);
            }
        }
    }

    static fromJS(data: any): ProjectTaskFilter {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTaskFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["isArchived"] = this.isArchived;
        data["onlyGlobal"] = this.onlyGlobal;
        data["onlyProject"] = this.onlyProject;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.projectIds)) {
            data["projectIds"] = [];
            for (let item of this.projectIds)
                data["projectIds"].push(item);
        }
        return data;
    }
}

export interface IProjectTaskFilter {
    id?: number | undefined;
    ids?: number[] | undefined;
    isArchived?: boolean | undefined;
    onlyGlobal?: boolean | undefined;
    onlyProject?: boolean | undefined;
    projectId?: number | undefined;
    projectIds?: number[] | undefined;
}

export class ProjectTaskSelectListForProjectQuery implements IProjectTaskSelectListForProjectQuery {
    projectId?: number;

    constructor(data?: IProjectTaskSelectListForProjectQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): ProjectTaskSelectListForProjectQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTaskSelectListForProjectQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IProjectTaskSelectListForProjectQuery {
    projectId?: number;
}

export class PublicHolidayEditModel implements IPublicHolidayEditModel {
    id?: number;
    publicHolidayGroupId?: number;
    publicHolidayDate?: string;
    description?: string | undefined;
    isHalfDay?: boolean;
    repeatsEveryYearSameDay?: boolean;
    isGlobalOverwrite?: boolean;

    constructor(data?: IPublicHolidayEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.publicHolidayGroupId = _data["publicHolidayGroupId"];
            this.publicHolidayDate = _data["publicHolidayDate"];
            this.description = _data["description"];
            this.isHalfDay = _data["isHalfDay"];
            this.repeatsEveryYearSameDay = _data["repeatsEveryYearSameDay"];
            this.isGlobalOverwrite = _data["isGlobalOverwrite"];
        }
    }

    static fromJS(data: any): PublicHolidayEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicHolidayEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["publicHolidayGroupId"] = this.publicHolidayGroupId;
        data["publicHolidayDate"] = this.publicHolidayDate;
        data["description"] = this.description;
        data["isHalfDay"] = this.isHalfDay;
        data["repeatsEveryYearSameDay"] = this.repeatsEveryYearSameDay;
        data["isGlobalOverwrite"] = this.isGlobalOverwrite;
        return data;
    }
}

export interface IPublicHolidayEditModel {
    id?: number;
    publicHolidayGroupId?: number;
    publicHolidayDate?: string;
    description?: string | undefined;
    isHalfDay?: boolean;
    repeatsEveryYearSameDay?: boolean;
    isGlobalOverwrite?: boolean;
}

export class PublicHolidayFilter implements IPublicHolidayFilter {
    publicHolidayGroupId?: number;
    year?: number | undefined;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
    onlyUserHolidays?: boolean | undefined;
    appUserId?: number | undefined;

    constructor(data?: IPublicHolidayFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.publicHolidayGroupId = _data["publicHolidayGroupId"];
            this.year = _data["year"];
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
            this.onlyUserHolidays = _data["onlyUserHolidays"];
            this.appUserId = _data["appUserId"];
        }
    }

    static fromJS(data: any): PublicHolidayFilter {
        data = typeof data === 'object' ? data : {};
        let result = new PublicHolidayFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["publicHolidayGroupId"] = this.publicHolidayGroupId;
        data["year"] = this.year;
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        data["onlyUserHolidays"] = this.onlyUserHolidays;
        data["appUserId"] = this.appUserId;
        return data;
    }
}

export interface IPublicHolidayFilter {
    publicHolidayGroupId?: number;
    year?: number | undefined;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
    onlyUserHolidays?: boolean | undefined;
    appUserId?: number | undefined;
}

export class PublicHolidayGroupEditModel implements IPublicHolidayGroupEditModel {
    id?: number;
    name?: string | undefined;
    isGlobal?: boolean;
    publicHolidayGroupId?: number | undefined;

    constructor(data?: IPublicHolidayGroupEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isGlobal = _data["isGlobal"];
            this.publicHolidayGroupId = _data["publicHolidayGroupId"];
        }
    }

    static fromJS(data: any): PublicHolidayGroupEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicHolidayGroupEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isGlobal"] = this.isGlobal;
        data["publicHolidayGroupId"] = this.publicHolidayGroupId;
        return data;
    }
}

export interface IPublicHolidayGroupEditModel {
    id?: number;
    name?: string | undefined;
    isGlobal?: boolean;
    publicHolidayGroupId?: number | undefined;
}

export class PublicHolidayGroupViewModel implements IPublicHolidayGroupViewModel {
    id?: number;
    name?: string | undefined;
    editMode?: boolean;
    isGlobal?: boolean;
    editModel?: PublicHolidayGroupEditModel | undefined;

    constructor(data?: IPublicHolidayGroupViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.editMode = _data["editMode"];
            this.isGlobal = _data["isGlobal"];
            this.editModel = _data["editModel"] ? PublicHolidayGroupEditModel.fromJS(_data["editModel"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PublicHolidayGroupViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicHolidayGroupViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["editMode"] = this.editMode;
        data["isGlobal"] = this.isGlobal;
        data["editModel"] = this.editModel ? this.editModel.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPublicHolidayGroupViewModel {
    id?: number;
    name?: string | undefined;
    editMode?: boolean;
    isGlobal?: boolean;
    editModel?: PublicHolidayGroupEditModel | undefined;
}

export class PublicHolidayGroupFilter implements IPublicHolidayGroupFilter {
    isGlobal?: boolean | undefined;
    id?: number | undefined;

    constructor(data?: IPublicHolidayGroupFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isGlobal = _data["isGlobal"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): PublicHolidayGroupFilter {
        data = typeof data === 'object' ? data : {};
        let result = new PublicHolidayGroupFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isGlobal"] = this.isGlobal;
        data["id"] = this.id;
        return data;
    }
}

export interface IPublicHolidayGroupFilter {
    isGlobal?: boolean | undefined;
    id?: number | undefined;
}

export class RateRuleEditModel implements IRateRuleEditModel {
    id?: number;
    parentRateRuleId?: number | undefined;
    isGlobal?: boolean;
    customerIds?: NestedEditModel[] | undefined;
    projectTaskIds?: number[] | undefined;
    appUserIds?: number[] | undefined;
    hasRules?: boolean;
    sortOrder?: number;
    amount?: number;

    constructor(data?: IRateRuleEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.parentRateRuleId = _data["parentRateRuleId"];
            this.isGlobal = _data["isGlobal"];
            if (Array.isArray(_data["customerIds"])) {
                this.customerIds = [] as any;
                for (let item of _data["customerIds"])
                    this.customerIds!.push(NestedEditModel.fromJS(item));
            }
            if (Array.isArray(_data["projectTaskIds"])) {
                this.projectTaskIds = [] as any;
                for (let item of _data["projectTaskIds"])
                    this.projectTaskIds!.push(item);
            }
            if (Array.isArray(_data["appUserIds"])) {
                this.appUserIds = [] as any;
                for (let item of _data["appUserIds"])
                    this.appUserIds!.push(item);
            }
            this.hasRules = _data["hasRules"];
            this.sortOrder = _data["sortOrder"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): RateRuleEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new RateRuleEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["parentRateRuleId"] = this.parentRateRuleId;
        data["isGlobal"] = this.isGlobal;
        if (Array.isArray(this.customerIds)) {
            data["customerIds"] = [];
            for (let item of this.customerIds)
                data["customerIds"].push(item.toJSON());
        }
        if (Array.isArray(this.projectTaskIds)) {
            data["projectTaskIds"] = [];
            for (let item of this.projectTaskIds)
                data["projectTaskIds"].push(item);
        }
        if (Array.isArray(this.appUserIds)) {
            data["appUserIds"] = [];
            for (let item of this.appUserIds)
                data["appUserIds"].push(item);
        }
        data["hasRules"] = this.hasRules;
        data["sortOrder"] = this.sortOrder;
        data["amount"] = this.amount;
        return data;
    }
}

export interface IRateRuleEditModel {
    id?: number;
    parentRateRuleId?: number | undefined;
    isGlobal?: boolean;
    customerIds?: NestedEditModel[] | undefined;
    projectTaskIds?: number[] | undefined;
    appUserIds?: number[] | undefined;
    hasRules?: boolean;
    sortOrder?: number;
    amount?: number;
}

export class NestedEditModel implements INestedEditModel {
    id?: number;
    nestedIds?: NestedEditModel[] | undefined;
    allSelected?: boolean;

    constructor(data?: INestedEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["nestedIds"])) {
                this.nestedIds = [] as any;
                for (let item of _data["nestedIds"])
                    this.nestedIds!.push(NestedEditModel.fromJS(item));
            }
            this.allSelected = _data["allSelected"];
        }
    }

    static fromJS(data: any): NestedEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new NestedEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.nestedIds)) {
            data["nestedIds"] = [];
            for (let item of this.nestedIds)
                data["nestedIds"].push(item.toJSON());
        }
        data["allSelected"] = this.allSelected;
        return data;
    }
}

export interface INestedEditModel {
    id?: number;
    nestedIds?: NestedEditModel[] | undefined;
    allSelected?: boolean;
}

export class RateRuleLookupModel implements IRateRuleLookupModel {
    customerProjects?: RateRuleSelectListItem[] | undefined;
    projectTasks?: RateRuleSelectListItem[] | undefined;
    appUsers?: RateRuleSelectListItem[] | undefined;

    constructor(data?: IRateRuleLookupModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customerProjects"])) {
                this.customerProjects = [] as any;
                for (let item of _data["customerProjects"])
                    this.customerProjects!.push(RateRuleSelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["projectTasks"])) {
                this.projectTasks = [] as any;
                for (let item of _data["projectTasks"])
                    this.projectTasks!.push(RateRuleSelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["appUsers"])) {
                this.appUsers = [] as any;
                for (let item of _data["appUsers"])
                    this.appUsers!.push(RateRuleSelectListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RateRuleLookupModel {
        data = typeof data === 'object' ? data : {};
        let result = new RateRuleLookupModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customerProjects)) {
            data["customerProjects"] = [];
            for (let item of this.customerProjects)
                data["customerProjects"].push(item.toJSON());
        }
        if (Array.isArray(this.projectTasks)) {
            data["projectTasks"] = [];
            for (let item of this.projectTasks)
                data["projectTasks"].push(item.toJSON());
        }
        if (Array.isArray(this.appUsers)) {
            data["appUsers"] = [];
            for (let item of this.appUsers)
                data["appUsers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRateRuleLookupModel {
    customerProjects?: RateRuleSelectListItem[] | undefined;
    projectTasks?: RateRuleSelectListItem[] | undefined;
    appUsers?: RateRuleSelectListItem[] | undefined;
}

export class RateRuleSelectListItem implements IRateRuleSelectListItem {
    id?: number;
    description?: string | undefined;
    isArchived?: boolean;
    disabledChildSelected?: boolean;
    disabledParentNotSelected?: boolean;
    isDisabled?: boolean;
    childItems?: RateRuleSelectListItem[] | undefined;

    constructor(data?: IRateRuleSelectListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.isArchived = _data["isArchived"];
            this.disabledChildSelected = _data["disabledChildSelected"];
            this.disabledParentNotSelected = _data["disabledParentNotSelected"];
            this.isDisabled = _data["isDisabled"];
            if (Array.isArray(_data["childItems"])) {
                this.childItems = [] as any;
                for (let item of _data["childItems"])
                    this.childItems!.push(RateRuleSelectListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RateRuleSelectListItem {
        data = typeof data === 'object' ? data : {};
        let result = new RateRuleSelectListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["isArchived"] = this.isArchived;
        data["disabledChildSelected"] = this.disabledChildSelected;
        data["disabledParentNotSelected"] = this.disabledParentNotSelected;
        data["isDisabled"] = this.isDisabled;
        if (Array.isArray(this.childItems)) {
            data["childItems"] = [];
            for (let item of this.childItems)
                data["childItems"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRateRuleSelectListItem {
    id?: number;
    description?: string | undefined;
    isArchived?: boolean;
    disabledChildSelected?: boolean;
    disabledParentNotSelected?: boolean;
    isDisabled?: boolean;
    childItems?: RateRuleSelectListItem[] | undefined;
}

export class RateRuleViewModel implements IRateRuleViewModel {
    id?: number;
    isGlobal?: boolean;
    customerNames?: RateRuleNestedViewModel[] | undefined;
    projectTaskNames?: string[] | undefined;
    appUserNames?: string[] | undefined;
    amount?: number;
    childRateRules?: RateRuleViewModel[] | undefined;
    isDisabled?: boolean;
    disabledReason?: string | undefined;
    editMode?: boolean;
    editModel?: RateRuleEditModel | undefined;
    newRateRuleEditMode?: boolean;
    newRateRuleEditModel?: RateRuleEditModel | undefined;
    sortOrder?: number;

    constructor(data?: IRateRuleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isGlobal = _data["isGlobal"];
            if (Array.isArray(_data["customerNames"])) {
                this.customerNames = [] as any;
                for (let item of _data["customerNames"])
                    this.customerNames!.push(RateRuleNestedViewModel.fromJS(item));
            }
            if (Array.isArray(_data["projectTaskNames"])) {
                this.projectTaskNames = [] as any;
                for (let item of _data["projectTaskNames"])
                    this.projectTaskNames!.push(item);
            }
            if (Array.isArray(_data["appUserNames"])) {
                this.appUserNames = [] as any;
                for (let item of _data["appUserNames"])
                    this.appUserNames!.push(item);
            }
            this.amount = _data["amount"];
            if (Array.isArray(_data["childRateRules"])) {
                this.childRateRules = [] as any;
                for (let item of _data["childRateRules"])
                    this.childRateRules!.push(RateRuleViewModel.fromJS(item));
            }
            this.isDisabled = _data["isDisabled"];
            this.disabledReason = _data["disabledReason"];
            this.editMode = _data["editMode"];
            this.editModel = _data["editModel"] ? RateRuleEditModel.fromJS(_data["editModel"]) : <any>undefined;
            this.newRateRuleEditMode = _data["newRateRuleEditMode"];
            this.newRateRuleEditModel = _data["newRateRuleEditModel"] ? RateRuleEditModel.fromJS(_data["newRateRuleEditModel"]) : <any>undefined;
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): RateRuleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RateRuleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isGlobal"] = this.isGlobal;
        if (Array.isArray(this.customerNames)) {
            data["customerNames"] = [];
            for (let item of this.customerNames)
                data["customerNames"].push(item.toJSON());
        }
        if (Array.isArray(this.projectTaskNames)) {
            data["projectTaskNames"] = [];
            for (let item of this.projectTaskNames)
                data["projectTaskNames"].push(item);
        }
        if (Array.isArray(this.appUserNames)) {
            data["appUserNames"] = [];
            for (let item of this.appUserNames)
                data["appUserNames"].push(item);
        }
        data["amount"] = this.amount;
        if (Array.isArray(this.childRateRules)) {
            data["childRateRules"] = [];
            for (let item of this.childRateRules)
                data["childRateRules"].push(item.toJSON());
        }
        data["isDisabled"] = this.isDisabled;
        data["disabledReason"] = this.disabledReason;
        data["editMode"] = this.editMode;
        data["editModel"] = this.editModel ? this.editModel.toJSON() : <any>undefined;
        data["newRateRuleEditMode"] = this.newRateRuleEditMode;
        data["newRateRuleEditModel"] = this.newRateRuleEditModel ? this.newRateRuleEditModel.toJSON() : <any>undefined;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IRateRuleViewModel {
    id?: number;
    isGlobal?: boolean;
    customerNames?: RateRuleNestedViewModel[] | undefined;
    projectTaskNames?: string[] | undefined;
    appUserNames?: string[] | undefined;
    amount?: number;
    childRateRules?: RateRuleViewModel[] | undefined;
    isDisabled?: boolean;
    disabledReason?: string | undefined;
    editMode?: boolean;
    editModel?: RateRuleEditModel | undefined;
    newRateRuleEditMode?: boolean;
    newRateRuleEditModel?: RateRuleEditModel | undefined;
    sortOrder?: number;
}

export class RateRuleNestedViewModel implements IRateRuleNestedViewModel {
    name?: string | undefined;
    nestedNames?: RateRuleNestedViewModel[] | undefined;
    allSelected?: boolean;

    constructor(data?: IRateRuleNestedViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["nestedNames"])) {
                this.nestedNames = [] as any;
                for (let item of _data["nestedNames"])
                    this.nestedNames!.push(RateRuleNestedViewModel.fromJS(item));
            }
            this.allSelected = _data["allSelected"];
        }
    }

    static fromJS(data: any): RateRuleNestedViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RateRuleNestedViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.nestedNames)) {
            data["nestedNames"] = [];
            for (let item of this.nestedNames)
                data["nestedNames"].push(item.toJSON());
        }
        data["allSelected"] = this.allSelected;
        return data;
    }
}

export interface IRateRuleNestedViewModel {
    name?: string | undefined;
    nestedNames?: RateRuleNestedViewModel[] | undefined;
    allSelected?: boolean;
}

export class RateRuleAmountListModel implements IRateRuleAmountListModel {
    customerId?: number | undefined;
    projectId?: number | undefined;
    projectTaskId?: number | undefined;
    globalProjectTaskId?: number | undefined;
    isGlobalRule?: boolean;
    amount?: number;
    overrideAmount?: boolean;
    parentAmount?: number | undefined;
    sourceRule?: RateRuleEnum;

    constructor(data?: IRateRuleAmountListModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.projectId = _data["projectId"];
            this.projectTaskId = _data["projectTaskId"];
            this.globalProjectTaskId = _data["globalProjectTaskId"];
            this.isGlobalRule = _data["isGlobalRule"];
            this.amount = _data["amount"];
            this.overrideAmount = _data["overrideAmount"];
            this.parentAmount = _data["parentAmount"];
            this.sourceRule = _data["sourceRule"];
        }
    }

    static fromJS(data: any): RateRuleAmountListModel {
        data = typeof data === 'object' ? data : {};
        let result = new RateRuleAmountListModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["projectId"] = this.projectId;
        data["projectTaskId"] = this.projectTaskId;
        data["globalProjectTaskId"] = this.globalProjectTaskId;
        data["isGlobalRule"] = this.isGlobalRule;
        data["amount"] = this.amount;
        data["overrideAmount"] = this.overrideAmount;
        data["parentAmount"] = this.parentAmount;
        data["sourceRule"] = this.sourceRule;
        return data;
    }
}

export interface IRateRuleAmountListModel {
    customerId?: number | undefined;
    projectId?: number | undefined;
    projectTaskId?: number | undefined;
    globalProjectTaskId?: number | undefined;
    isGlobalRule?: boolean;
    amount?: number;
    overrideAmount?: boolean;
    parentAmount?: number | undefined;
    sourceRule?: RateRuleEnum;
}

export class RateRuleAmountFilter implements IRateRuleAmountFilter {
    customerId?: number | undefined;
    projectId?: number | undefined;
    projectTaskId?: number | undefined;
    appUserId?: number | undefined;
    isGlobalRule?: boolean;

    constructor(data?: IRateRuleAmountFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerId = _data["customerId"];
            this.projectId = _data["projectId"];
            this.projectTaskId = _data["projectTaskId"];
            this.appUserId = _data["appUserId"];
            this.isGlobalRule = _data["isGlobalRule"];
        }
    }

    static fromJS(data: any): RateRuleAmountFilter {
        data = typeof data === 'object' ? data : {};
        let result = new RateRuleAmountFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerId"] = this.customerId;
        data["projectId"] = this.projectId;
        data["projectTaskId"] = this.projectTaskId;
        data["appUserId"] = this.appUserId;
        data["isGlobalRule"] = this.isGlobalRule;
        return data;
    }
}

export interface IRateRuleAmountFilter {
    customerId?: number | undefined;
    projectId?: number | undefined;
    projectTaskId?: number | undefined;
    appUserId?: number | undefined;
    isGlobalRule?: boolean;
}

export class RateRuleSortOrderEditModel implements IRateRuleSortOrderEditModel {
    id?: number;
    sortOrder?: number;

    constructor(data?: IRateRuleSortOrderEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.sortOrder = _data["sortOrder"];
        }
    }

    static fromJS(data: any): RateRuleSortOrderEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new RateRuleSortOrderEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["sortOrder"] = this.sortOrder;
        return data;
    }
}

export interface IRateRuleSortOrderEditModel {
    id?: number;
    sortOrder?: number;
}

export class ReportViewModel implements IReportViewModel {
    duration?: ReportComparisonViewModel | undefined;
    revenue?: ReportComparisonViewModel | undefined;
    billable?: ReportComparisonViewModel | undefined;
    timeFrameModel?: ReportTimeFrameModel[] | undefined;
    customerPieData?: PieChartPoint[] | undefined;
    displayTimeChartDaily?: boolean;
    projectPieData?: PieChartPoint[] | undefined;
    tagsPieData?: PieChartPoint[] | undefined;

    constructor(data?: IReportViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.duration = _data["duration"] ? ReportComparisonViewModel.fromJS(_data["duration"]) : <any>undefined;
            this.revenue = _data["revenue"] ? ReportComparisonViewModel.fromJS(_data["revenue"]) : <any>undefined;
            this.billable = _data["billable"] ? ReportComparisonViewModel.fromJS(_data["billable"]) : <any>undefined;
            if (Array.isArray(_data["timeFrameModel"])) {
                this.timeFrameModel = [] as any;
                for (let item of _data["timeFrameModel"])
                    this.timeFrameModel!.push(ReportTimeFrameModel.fromJS(item));
            }
            if (Array.isArray(_data["customerPieData"])) {
                this.customerPieData = [] as any;
                for (let item of _data["customerPieData"])
                    this.customerPieData!.push(PieChartPoint.fromJS(item));
            }
            this.displayTimeChartDaily = _data["displayTimeChartDaily"];
            if (Array.isArray(_data["projectPieData"])) {
                this.projectPieData = [] as any;
                for (let item of _data["projectPieData"])
                    this.projectPieData!.push(PieChartPoint.fromJS(item));
            }
            if (Array.isArray(_data["tagsPieData"])) {
                this.tagsPieData = [] as any;
                for (let item of _data["tagsPieData"])
                    this.tagsPieData!.push(PieChartPoint.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ReportViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["duration"] = this.duration ? this.duration.toJSON() : <any>undefined;
        data["revenue"] = this.revenue ? this.revenue.toJSON() : <any>undefined;
        data["billable"] = this.billable ? this.billable.toJSON() : <any>undefined;
        if (Array.isArray(this.timeFrameModel)) {
            data["timeFrameModel"] = [];
            for (let item of this.timeFrameModel)
                data["timeFrameModel"].push(item.toJSON());
        }
        if (Array.isArray(this.customerPieData)) {
            data["customerPieData"] = [];
            for (let item of this.customerPieData)
                data["customerPieData"].push(item.toJSON());
        }
        data["displayTimeChartDaily"] = this.displayTimeChartDaily;
        if (Array.isArray(this.projectPieData)) {
            data["projectPieData"] = [];
            for (let item of this.projectPieData)
                data["projectPieData"].push(item.toJSON());
        }
        if (Array.isArray(this.tagsPieData)) {
            data["tagsPieData"] = [];
            for (let item of this.tagsPieData)
                data["tagsPieData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IReportViewModel {
    duration?: ReportComparisonViewModel | undefined;
    revenue?: ReportComparisonViewModel | undefined;
    billable?: ReportComparisonViewModel | undefined;
    timeFrameModel?: ReportTimeFrameModel[] | undefined;
    customerPieData?: PieChartPoint[] | undefined;
    displayTimeChartDaily?: boolean;
    projectPieData?: PieChartPoint[] | undefined;
    tagsPieData?: PieChartPoint[] | undefined;
}

export class ReportComparisonViewModel implements IReportComparisonViewModel {
    value?: number;
    previousValue?: number;
    isPercentage?: boolean;
    isPositive?: boolean;
    comparisonValue?: number;
    comparisonPercentage?: number;
    previousPeriodFrom?: string | undefined;
    previousPeriodTo?: string | undefined;

    constructor(data?: IReportComparisonViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.previousValue = _data["previousValue"];
            this.isPercentage = _data["isPercentage"];
            this.isPositive = _data["isPositive"];
            this.comparisonValue = _data["comparisonValue"];
            this.comparisonPercentage = _data["comparisonPercentage"];
            this.previousPeriodFrom = _data["previousPeriodFrom"];
            this.previousPeriodTo = _data["previousPeriodTo"];
        }
    }

    static fromJS(data: any): ReportComparisonViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReportComparisonViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["previousValue"] = this.previousValue;
        data["isPercentage"] = this.isPercentage;
        data["isPositive"] = this.isPositive;
        data["comparisonValue"] = this.comparisonValue;
        data["comparisonPercentage"] = this.comparisonPercentage;
        data["previousPeriodFrom"] = this.previousPeriodFrom;
        data["previousPeriodTo"] = this.previousPeriodTo;
        return data;
    }
}

export interface IReportComparisonViewModel {
    value?: number;
    previousValue?: number;
    isPercentage?: boolean;
    isPositive?: boolean;
    comparisonValue?: number;
    comparisonPercentage?: number;
    previousPeriodFrom?: string | undefined;
    previousPeriodTo?: string | undefined;
}

export class PieChartPoint implements IPieChartPoint {
    label?: string | undefined;
    value?: number;

    constructor(data?: IPieChartPoint) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.label = _data["label"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): PieChartPoint {
        data = typeof data === 'object' ? data : {};
        let result = new PieChartPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["label"] = this.label;
        data["value"] = this.value;
        return data;
    }
}

export interface IPieChartPoint {
    label?: string | undefined;
    value?: number;
}

export class BillableTargetReportModel implements IBillableTargetReportModel {
    year?: number;
    months?: string[] | undefined;
    appUserModels?: BillableTargetAppUserModel[] | undefined;

    constructor(data?: IBillableTargetReportModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            if (Array.isArray(_data["months"])) {
                this.months = [] as any;
                for (let item of _data["months"])
                    this.months!.push(item);
            }
            if (Array.isArray(_data["appUserModels"])) {
                this.appUserModels = [] as any;
                for (let item of _data["appUserModels"])
                    this.appUserModels!.push(BillableTargetAppUserModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BillableTargetReportModel {
        data = typeof data === 'object' ? data : {};
        let result = new BillableTargetReportModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        if (Array.isArray(this.months)) {
            data["months"] = [];
            for (let item of this.months)
                data["months"].push(item);
        }
        if (Array.isArray(this.appUserModels)) {
            data["appUserModels"] = [];
            for (let item of this.appUserModels)
                data["appUserModels"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBillableTargetReportModel {
    year?: number;
    months?: string[] | undefined;
    appUserModels?: BillableTargetAppUserModel[] | undefined;
}

export class BillableTargetAppUserModel implements IBillableTargetAppUserModel {
    appUser?: AppUserViewModel | undefined;
    monthData?: BillableTargetAppUserMonthModel[] | undefined;

    constructor(data?: IBillableTargetAppUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appUser = _data["appUser"] ? AppUserViewModel.fromJS(_data["appUser"]) : <any>undefined;
            if (Array.isArray(_data["monthData"])) {
                this.monthData = [] as any;
                for (let item of _data["monthData"])
                    this.monthData!.push(BillableTargetAppUserMonthModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BillableTargetAppUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new BillableTargetAppUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appUser"] = this.appUser ? this.appUser.toJSON() : <any>undefined;
        if (Array.isArray(this.monthData)) {
            data["monthData"] = [];
            for (let item of this.monthData)
                data["monthData"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBillableTargetAppUserModel {
    appUser?: AppUserViewModel | undefined;
    monthData?: BillableTargetAppUserMonthModel[] | undefined;
}

export class BillableTargetAppUserMonthModel implements IBillableTargetAppUserMonthModel {
    month?: string;
    targetMinutes?: number;
    durationMinutes?: number;
    durationMinutesBillable?: number;
    billableTargetPercentage?: number;
    billableTargetMinutes?: number;
    targetAchievment?: number;
    hasBillableTargetPercentage?: boolean;
    isAverage?: boolean;

    constructor(data?: IBillableTargetAppUserMonthModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            this.targetMinutes = _data["targetMinutes"];
            this.durationMinutes = _data["durationMinutes"];
            this.durationMinutesBillable = _data["durationMinutesBillable"];
            this.billableTargetPercentage = _data["billableTargetPercentage"];
            this.billableTargetMinutes = _data["billableTargetMinutes"];
            this.targetAchievment = _data["targetAchievment"];
            this.hasBillableTargetPercentage = _data["hasBillableTargetPercentage"];
            this.isAverage = _data["isAverage"];
        }
    }

    static fromJS(data: any): BillableTargetAppUserMonthModel {
        data = typeof data === 'object' ? data : {};
        let result = new BillableTargetAppUserMonthModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        data["targetMinutes"] = this.targetMinutes;
        data["durationMinutes"] = this.durationMinutes;
        data["durationMinutesBillable"] = this.durationMinutesBillable;
        data["billableTargetPercentage"] = this.billableTargetPercentage;
        data["billableTargetMinutes"] = this.billableTargetMinutes;
        data["targetAchievment"] = this.targetAchievment;
        data["hasBillableTargetPercentage"] = this.hasBillableTargetPercentage;
        data["isAverage"] = this.isAverage;
        return data;
    }
}

export interface IBillableTargetAppUserMonthModel {
    month?: string;
    targetMinutes?: number;
    durationMinutes?: number;
    durationMinutesBillable?: number;
    billableTargetPercentage?: number;
    billableTargetMinutes?: number;
    targetAchievment?: number;
    hasBillableTargetPercentage?: boolean;
    isAverage?: boolean;
}

export class RoleViewModel implements IRoleViewModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    hasAppUserRights?: boolean;

    constructor(data?: IRoleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.hasAppUserRights = _data["hasAppUserRights"];
        }
    }

    static fromJS(data: any): RoleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["hasAppUserRights"] = this.hasAppUserRights;
        return data;
    }
}

export interface IRoleViewModel {
    id?: number;
    name?: string | undefined;
    description?: string | undefined;
    hasAppUserRights?: boolean;
}

export class StopwatchViewModel implements IStopwatchViewModel {
    id?: number;
    description?: string | undefined;
    stopwatchStartDateTimeUtc?: string;
    isBillable?: boolean;
    projectName?: string | undefined;
    customerName?: string | undefined;
    projectTaskName?: string | undefined;
    rateAmount?: number;
    timeEntryType?: TimeEntryTypeViewModel | undefined;
    pausedTimeEntryId?: number;
    tags?: TagViewModel[] | undefined;
    invalidReason?: string | undefined;
    timeEntryExtraFields?: TimeEntryExtraFieldViewModel[] | undefined;

    constructor(data?: IStopwatchViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.stopwatchStartDateTimeUtc = _data["stopwatchStartDateTimeUtc"];
            this.isBillable = _data["isBillable"];
            this.projectName = _data["projectName"];
            this.customerName = _data["customerName"];
            this.projectTaskName = _data["projectTaskName"];
            this.rateAmount = _data["rateAmount"];
            this.timeEntryType = _data["timeEntryType"] ? TimeEntryTypeViewModel.fromJS(_data["timeEntryType"]) : <any>undefined;
            this.pausedTimeEntryId = _data["pausedTimeEntryId"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagViewModel.fromJS(item));
            }
            this.invalidReason = _data["invalidReason"];
            if (Array.isArray(_data["timeEntryExtraFields"])) {
                this.timeEntryExtraFields = [] as any;
                for (let item of _data["timeEntryExtraFields"])
                    this.timeEntryExtraFields!.push(TimeEntryExtraFieldViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): StopwatchViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StopwatchViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["stopwatchStartDateTimeUtc"] = this.stopwatchStartDateTimeUtc;
        data["isBillable"] = this.isBillable;
        data["projectName"] = this.projectName;
        data["customerName"] = this.customerName;
        data["projectTaskName"] = this.projectTaskName;
        data["rateAmount"] = this.rateAmount;
        data["timeEntryType"] = this.timeEntryType ? this.timeEntryType.toJSON() : <any>undefined;
        data["pausedTimeEntryId"] = this.pausedTimeEntryId;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["invalidReason"] = this.invalidReason;
        if (Array.isArray(this.timeEntryExtraFields)) {
            data["timeEntryExtraFields"] = [];
            for (let item of this.timeEntryExtraFields)
                data["timeEntryExtraFields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IStopwatchViewModel {
    id?: number;
    description?: string | undefined;
    stopwatchStartDateTimeUtc?: string;
    isBillable?: boolean;
    projectName?: string | undefined;
    customerName?: string | undefined;
    projectTaskName?: string | undefined;
    rateAmount?: number;
    timeEntryType?: TimeEntryTypeViewModel | undefined;
    pausedTimeEntryId?: number;
    tags?: TagViewModel[] | undefined;
    invalidReason?: string | undefined;
    timeEntryExtraFields?: TimeEntryExtraFieldViewModel[] | undefined;
}

export class StopwatchEditModel implements IStopwatchEditModel {
    id?: number;
    description?: string | undefined;
    isBillable?: boolean;
    projectId?: number;
    projectTaskId?: number | undefined;
    isInputTimeFromTo?: boolean;
    appUserId?: number | undefined;
    pausedTimeEntryId?: number;
    tagIds?: number[] | undefined;
    rateAmount?: number | undefined;
    useCurrentRateAmount?: boolean;
    timeEntryExtraFields?: TimeEntryExtraFieldEditModel[] | undefined;
    isBasicTimeEntry?: boolean;

    constructor(data?: IStopwatchEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            this.isBillable = _data["isBillable"];
            this.projectId = _data["projectId"];
            this.projectTaskId = _data["projectTaskId"];
            this.isInputTimeFromTo = _data["isInputTimeFromTo"];
            this.appUserId = _data["appUserId"];
            this.pausedTimeEntryId = _data["pausedTimeEntryId"];
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            this.rateAmount = _data["rateAmount"];
            this.useCurrentRateAmount = _data["useCurrentRateAmount"];
            if (Array.isArray(_data["timeEntryExtraFields"])) {
                this.timeEntryExtraFields = [] as any;
                for (let item of _data["timeEntryExtraFields"])
                    this.timeEntryExtraFields!.push(TimeEntryExtraFieldEditModel.fromJS(item));
            }
            this.isBasicTimeEntry = _data["isBasicTimeEntry"];
        }
    }

    static fromJS(data: any): StopwatchEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new StopwatchEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        data["isBillable"] = this.isBillable;
        data["projectId"] = this.projectId;
        data["projectTaskId"] = this.projectTaskId;
        data["isInputTimeFromTo"] = this.isInputTimeFromTo;
        data["appUserId"] = this.appUserId;
        data["pausedTimeEntryId"] = this.pausedTimeEntryId;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        data["rateAmount"] = this.rateAmount;
        data["useCurrentRateAmount"] = this.useCurrentRateAmount;
        if (Array.isArray(this.timeEntryExtraFields)) {
            data["timeEntryExtraFields"] = [];
            for (let item of this.timeEntryExtraFields)
                data["timeEntryExtraFields"].push(item.toJSON());
        }
        data["isBasicTimeEntry"] = this.isBasicTimeEntry;
        return data;
    }
}

export interface IStopwatchEditModel {
    id?: number;
    description?: string | undefined;
    isBillable?: boolean;
    projectId?: number;
    projectTaskId?: number | undefined;
    isInputTimeFromTo?: boolean;
    appUserId?: number | undefined;
    pausedTimeEntryId?: number;
    tagIds?: number[] | undefined;
    rateAmount?: number | undefined;
    useCurrentRateAmount?: boolean;
    timeEntryExtraFields?: TimeEntryExtraFieldEditModel[] | undefined;
    isBasicTimeEntry?: boolean;
}

export class TimeEntryExtraFieldEditModel implements ITimeEntryExtraFieldEditModel {
    id?: number;
    timeEntryId?: number;
    timeEntryExtraFieldMetadataId?: number;
    value?: string | undefined;
    description?: string | undefined;
    dataTypeDescription?: string | undefined;
    isRequired?: boolean;
    selectionValues?: string[] | undefined;
    dataType?: TimeEntryExtraFieldDataTypeEnum;
    toolTip?: string | undefined;

    constructor(data?: ITimeEntryExtraFieldEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.timeEntryId = _data["timeEntryId"];
            this.timeEntryExtraFieldMetadataId = _data["timeEntryExtraFieldMetadataId"];
            this.value = _data["value"];
            this.description = _data["description"];
            this.dataTypeDescription = _data["dataTypeDescription"];
            this.isRequired = _data["isRequired"];
            if (Array.isArray(_data["selectionValues"])) {
                this.selectionValues = [] as any;
                for (let item of _data["selectionValues"])
                    this.selectionValues!.push(item);
            }
            this.dataType = _data["dataType"];
            this.toolTip = _data["toolTip"];
        }
    }

    static fromJS(data: any): TimeEntryExtraFieldEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryExtraFieldEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["timeEntryId"] = this.timeEntryId;
        data["timeEntryExtraFieldMetadataId"] = this.timeEntryExtraFieldMetadataId;
        data["value"] = this.value;
        data["description"] = this.description;
        data["dataTypeDescription"] = this.dataTypeDescription;
        data["isRequired"] = this.isRequired;
        if (Array.isArray(this.selectionValues)) {
            data["selectionValues"] = [];
            for (let item of this.selectionValues)
                data["selectionValues"].push(item);
        }
        data["dataType"] = this.dataType;
        data["toolTip"] = this.toolTip;
        return data;
    }
}

export interface ITimeEntryExtraFieldEditModel {
    id?: number;
    timeEntryId?: number;
    timeEntryExtraFieldMetadataId?: number;
    value?: string | undefined;
    description?: string | undefined;
    dataTypeDescription?: string | undefined;
    isRequired?: boolean;
    selectionValues?: string[] | undefined;
    dataType?: TimeEntryExtraFieldDataTypeEnum;
    toolTip?: string | undefined;
}

export class TimeEntryEditModel implements ITimeEntryEditModel {
    id?: number;
    entryDate?: string;
    durationMinutes?: number;
    durationMinutesPause?: number;
    title?: string | undefined;
    description?: string | undefined;
    timeFrom?: string | undefined;
    timeTo?: string | undefined;
    isInputTimeFromTo?: boolean;
    timeEntryTypeId?: number;
    isBillable?: boolean;
    isCleared?: boolean;
    projectId?: number | undefined;
    projectTaskId?: number | undefined;
    rateAmount?: number | undefined;
    useCurrentRateAmount?: boolean;
    appUserId?: number | undefined;
    tagIds?: number[] | undefined;
    isMigratedTimeEntryWithPause?: boolean;
    timeEntryExtraFields?: TimeEntryExtraFieldEditModel[] | undefined;
    insertDateTime?: string | undefined;
    lastUpdateDateTime?: string | undefined;
    isTwoDayEntry?: boolean;
    additionalInsertAppUserIds?: number[] | undefined;
    isBasicTimeEntry?: boolean;

    constructor(data?: ITimeEntryEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entryDate = _data["entryDate"];
            this.durationMinutes = _data["durationMinutes"];
            this.durationMinutesPause = _data["durationMinutesPause"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.timeFrom = _data["timeFrom"];
            this.timeTo = _data["timeTo"];
            this.isInputTimeFromTo = _data["isInputTimeFromTo"];
            this.timeEntryTypeId = _data["timeEntryTypeId"];
            this.isBillable = _data["isBillable"];
            this.isCleared = _data["isCleared"];
            this.projectId = _data["projectId"];
            this.projectTaskId = _data["projectTaskId"];
            this.rateAmount = _data["rateAmount"];
            this.useCurrentRateAmount = _data["useCurrentRateAmount"];
            this.appUserId = _data["appUserId"];
            if (Array.isArray(_data["tagIds"])) {
                this.tagIds = [] as any;
                for (let item of _data["tagIds"])
                    this.tagIds!.push(item);
            }
            this.isMigratedTimeEntryWithPause = _data["isMigratedTimeEntryWithPause"];
            if (Array.isArray(_data["timeEntryExtraFields"])) {
                this.timeEntryExtraFields = [] as any;
                for (let item of _data["timeEntryExtraFields"])
                    this.timeEntryExtraFields!.push(TimeEntryExtraFieldEditModel.fromJS(item));
            }
            this.insertDateTime = _data["insertDateTime"];
            this.lastUpdateDateTime = _data["lastUpdateDateTime"];
            this.isTwoDayEntry = _data["isTwoDayEntry"];
            if (Array.isArray(_data["additionalInsertAppUserIds"])) {
                this.additionalInsertAppUserIds = [] as any;
                for (let item of _data["additionalInsertAppUserIds"])
                    this.additionalInsertAppUserIds!.push(item);
            }
            this.isBasicTimeEntry = _data["isBasicTimeEntry"];
        }
    }

    static fromJS(data: any): TimeEntryEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entryDate"] = this.entryDate;
        data["durationMinutes"] = this.durationMinutes;
        data["durationMinutesPause"] = this.durationMinutesPause;
        data["title"] = this.title;
        data["description"] = this.description;
        data["timeFrom"] = this.timeFrom;
        data["timeTo"] = this.timeTo;
        data["isInputTimeFromTo"] = this.isInputTimeFromTo;
        data["timeEntryTypeId"] = this.timeEntryTypeId;
        data["isBillable"] = this.isBillable;
        data["isCleared"] = this.isCleared;
        data["projectId"] = this.projectId;
        data["projectTaskId"] = this.projectTaskId;
        data["rateAmount"] = this.rateAmount;
        data["useCurrentRateAmount"] = this.useCurrentRateAmount;
        data["appUserId"] = this.appUserId;
        if (Array.isArray(this.tagIds)) {
            data["tagIds"] = [];
            for (let item of this.tagIds)
                data["tagIds"].push(item);
        }
        data["isMigratedTimeEntryWithPause"] = this.isMigratedTimeEntryWithPause;
        if (Array.isArray(this.timeEntryExtraFields)) {
            data["timeEntryExtraFields"] = [];
            for (let item of this.timeEntryExtraFields)
                data["timeEntryExtraFields"].push(item.toJSON());
        }
        data["insertDateTime"] = this.insertDateTime;
        data["lastUpdateDateTime"] = this.lastUpdateDateTime;
        data["isTwoDayEntry"] = this.isTwoDayEntry;
        if (Array.isArray(this.additionalInsertAppUserIds)) {
            data["additionalInsertAppUserIds"] = [];
            for (let item of this.additionalInsertAppUserIds)
                data["additionalInsertAppUserIds"].push(item);
        }
        data["isBasicTimeEntry"] = this.isBasicTimeEntry;
        return data;
    }
}

export interface ITimeEntryEditModel {
    id?: number;
    entryDate?: string;
    durationMinutes?: number;
    durationMinutesPause?: number;
    title?: string | undefined;
    description?: string | undefined;
    timeFrom?: string | undefined;
    timeTo?: string | undefined;
    isInputTimeFromTo?: boolean;
    timeEntryTypeId?: number;
    isBillable?: boolean;
    isCleared?: boolean;
    projectId?: number | undefined;
    projectTaskId?: number | undefined;
    rateAmount?: number | undefined;
    useCurrentRateAmount?: boolean;
    appUserId?: number | undefined;
    tagIds?: number[] | undefined;
    isMigratedTimeEntryWithPause?: boolean;
    timeEntryExtraFields?: TimeEntryExtraFieldEditModel[] | undefined;
    insertDateTime?: string | undefined;
    lastUpdateDateTime?: string | undefined;
    isTwoDayEntry?: boolean;
    additionalInsertAppUserIds?: number[] | undefined;
    isBasicTimeEntry?: boolean;
}

export class SupportRequestModel implements ISupportRequestModel {
    email?: string | undefined;
    subject?: string | undefined;
    text?: string | undefined;

    constructor(data?: ISupportRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"];
            this.subject = _data["subject"];
            this.text = _data["text"];
        }
    }

    static fromJS(data: any): SupportRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new SupportRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email;
        data["subject"] = this.subject;
        data["text"] = this.text;
        return data;
    }
}

export interface ISupportRequestModel {
    email?: string | undefined;
    subject?: string | undefined;
    text?: string | undefined;
}

export class TagEditModel implements ITagEditModel {
    id?: number;
    name?: string | undefined;
    colorClass?: string | undefined;
    isArchived?: boolean;

    constructor(data?: ITagEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.colorClass = _data["colorClass"];
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): TagEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new TagEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["colorClass"] = this.colorClass;
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface ITagEditModel {
    id?: number;
    name?: string | undefined;
    colorClass?: string | undefined;
    isArchived?: boolean;
}

export class TagFilter implements ITagFilter {
    id?: number | undefined;
    ids?: number[] | undefined;
    isArchived?: boolean | undefined;

    constructor(data?: ITagFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            this.isArchived = _data["isArchived"];
        }
    }

    static fromJS(data: any): TagFilter {
        data = typeof data === 'object' ? data : {};
        let result = new TagFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        data["isArchived"] = this.isArchived;
        return data;
    }
}

export interface ITagFilter {
    id?: number | undefined;
    ids?: number[] | undefined;
    isArchived?: boolean | undefined;
}

export class TeamOverviewTimeValidationModel implements ITeamOverviewTimeValidationModel {
    months?: TeamOverviewTimeValidationMonthModel[] | undefined;
    timeEntrySummaryLastSent?: string | undefined;

    constructor(data?: ITeamOverviewTimeValidationModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["months"])) {
                this.months = [] as any;
                for (let item of _data["months"])
                    this.months!.push(TeamOverviewTimeValidationMonthModel.fromJS(item));
            }
            this.timeEntrySummaryLastSent = _data["timeEntrySummaryLastSent"];
        }
    }

    static fromJS(data: any): TeamOverviewTimeValidationModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeamOverviewTimeValidationModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.months)) {
            data["months"] = [];
            for (let item of this.months)
                data["months"].push(item.toJSON());
        }
        data["timeEntrySummaryLastSent"] = this.timeEntrySummaryLastSent;
        return data;
    }
}

export interface ITeamOverviewTimeValidationModel {
    months?: TeamOverviewTimeValidationMonthModel[] | undefined;
    timeEntrySummaryLastSent?: string | undefined;
}

export class TeamOverviewTimeValidationMonthModel implements ITeamOverviewTimeValidationMonthModel {
    year?: number;
    month?: number;
    appUserIntervalModels?: TeamOverviewTimeValidationAppUserIntervalModel[] | undefined;

    constructor(data?: ITeamOverviewTimeValidationMonthModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.month = _data["month"];
            if (Array.isArray(_data["appUserIntervalModels"])) {
                this.appUserIntervalModels = [] as any;
                for (let item of _data["appUserIntervalModels"])
                    this.appUserIntervalModels!.push(TeamOverviewTimeValidationAppUserIntervalModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeamOverviewTimeValidationMonthModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeamOverviewTimeValidationMonthModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["month"] = this.month;
        if (Array.isArray(this.appUserIntervalModels)) {
            data["appUserIntervalModels"] = [];
            for (let item of this.appUserIntervalModels)
                data["appUserIntervalModels"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITeamOverviewTimeValidationMonthModel {
    year?: number;
    month?: number;
    appUserIntervalModels?: TeamOverviewTimeValidationAppUserIntervalModel[] | undefined;
}

export class TeamOverviewTimeValidationAppUserIntervalModel implements ITeamOverviewTimeValidationAppUserIntervalModel {
    appUser?: AppUserViewModel | undefined;
    dateIntervalFrom?: string;
    dateIntervalTo?: string;
    useTargetMinutes?: boolean;
    overallDurationMinutesBalance?: number;
    appUserDayModels?: TeamOverviewTimeValidationAppUserDayModel[] | undefined;

    constructor(data?: ITeamOverviewTimeValidationAppUserIntervalModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appUser = _data["appUser"] ? AppUserViewModel.fromJS(_data["appUser"]) : <any>undefined;
            this.dateIntervalFrom = _data["dateIntervalFrom"];
            this.dateIntervalTo = _data["dateIntervalTo"];
            this.useTargetMinutes = _data["useTargetMinutes"];
            this.overallDurationMinutesBalance = _data["overallDurationMinutesBalance"];
            if (Array.isArray(_data["appUserDayModels"])) {
                this.appUserDayModels = [] as any;
                for (let item of _data["appUserDayModels"])
                    this.appUserDayModels!.push(TeamOverviewTimeValidationAppUserDayModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeamOverviewTimeValidationAppUserIntervalModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeamOverviewTimeValidationAppUserIntervalModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appUser"] = this.appUser ? this.appUser.toJSON() : <any>undefined;
        data["dateIntervalFrom"] = this.dateIntervalFrom;
        data["dateIntervalTo"] = this.dateIntervalTo;
        data["useTargetMinutes"] = this.useTargetMinutes;
        data["overallDurationMinutesBalance"] = this.overallDurationMinutesBalance;
        if (Array.isArray(this.appUserDayModels)) {
            data["appUserDayModels"] = [];
            for (let item of this.appUserDayModels)
                data["appUserDayModels"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITeamOverviewTimeValidationAppUserIntervalModel {
    appUser?: AppUserViewModel | undefined;
    dateIntervalFrom?: string;
    dateIntervalTo?: string;
    useTargetMinutes?: boolean;
    overallDurationMinutesBalance?: number;
    appUserDayModels?: TeamOverviewTimeValidationAppUserDayModel[] | undefined;
}

export class TeamOverviewTimeValidationAppUserDayModel implements ITeamOverviewTimeValidationAppUserDayModel {
    date?: string;
    appUserDay?: AppUserDayViewModel | undefined;

    constructor(data?: ITeamOverviewTimeValidationAppUserDayModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.appUserDay = _data["appUserDay"] ? AppUserDayViewModel.fromJS(_data["appUserDay"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TeamOverviewTimeValidationAppUserDayModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeamOverviewTimeValidationAppUserDayModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["appUserDay"] = this.appUserDay ? this.appUserDay.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITeamOverviewTimeValidationAppUserDayModel {
    date?: string;
    appUserDay?: AppUserDayViewModel | undefined;
}

export class AppUserDayViewModel implements IAppUserDayViewModel {
    appUserCountryIsoCode?: string | undefined;
    date?: string;
    absence?: AbsenceViewModel | undefined;
    publicHoliday?: PublicHolidayViewModel | undefined;
    useTargetMinutes?: boolean;
    targetMinutes?: number;
    targetMinutesEffective?: number;
    durationMinutes?: number;
    vacationDays?: number;
    isPublicHoliday?: boolean;
    isAbsence?: boolean;
    isApprovedAbsence?: boolean;
    isVacation?: boolean;
    isSick?: boolean;
    effectiveTargetMinutesEnteredPercentage?: number;
    isWeekend?: boolean;
    dayDescription?: DayModifier | undefined;
    timeEntryDayApproval?: TimeEntryDayApprovalViewModel | undefined;
    dayLockedApproval?: boolean;
    dayLockedApprovalComment?: string | undefined;
    dayCanBeSubmitted?: boolean;
    violatedValidationRules?: AppUserDayValidationRule[] | undefined;
    hasViolatedValidationRules?: boolean;

    constructor(data?: IAppUserDayViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appUserCountryIsoCode = _data["appUserCountryIsoCode"];
            this.date = _data["date"];
            this.absence = _data["absence"] ? AbsenceViewModel.fromJS(_data["absence"]) : <any>undefined;
            this.publicHoliday = _data["publicHoliday"] ? PublicHolidayViewModel.fromJS(_data["publicHoliday"]) : <any>undefined;
            this.useTargetMinutes = _data["useTargetMinutes"];
            this.targetMinutes = _data["targetMinutes"];
            this.targetMinutesEffective = _data["targetMinutesEffective"];
            this.durationMinutes = _data["durationMinutes"];
            this.vacationDays = _data["vacationDays"];
            this.isPublicHoliday = _data["isPublicHoliday"];
            this.isAbsence = _data["isAbsence"];
            this.isApprovedAbsence = _data["isApprovedAbsence"];
            this.isVacation = _data["isVacation"];
            this.isSick = _data["isSick"];
            this.effectiveTargetMinutesEnteredPercentage = _data["effectiveTargetMinutesEnteredPercentage"];
            this.isWeekend = _data["isWeekend"];
            this.dayDescription = _data["dayDescription"] ? DayModifier.fromJS(_data["dayDescription"]) : <any>undefined;
            this.timeEntryDayApproval = _data["timeEntryDayApproval"] ? TimeEntryDayApprovalViewModel.fromJS(_data["timeEntryDayApproval"]) : <any>undefined;
            this.dayLockedApproval = _data["dayLockedApproval"];
            this.dayLockedApprovalComment = _data["dayLockedApprovalComment"];
            this.dayCanBeSubmitted = _data["dayCanBeSubmitted"];
            if (Array.isArray(_data["violatedValidationRules"])) {
                this.violatedValidationRules = [] as any;
                for (let item of _data["violatedValidationRules"])
                    this.violatedValidationRules!.push(AppUserDayValidationRule.fromJS(item));
            }
            this.hasViolatedValidationRules = _data["hasViolatedValidationRules"];
        }
    }

    static fromJS(data: any): AppUserDayViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserDayViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appUserCountryIsoCode"] = this.appUserCountryIsoCode;
        data["date"] = this.date;
        data["absence"] = this.absence ? this.absence.toJSON() : <any>undefined;
        data["publicHoliday"] = this.publicHoliday ? this.publicHoliday.toJSON() : <any>undefined;
        data["useTargetMinutes"] = this.useTargetMinutes;
        data["targetMinutes"] = this.targetMinutes;
        data["targetMinutesEffective"] = this.targetMinutesEffective;
        data["durationMinutes"] = this.durationMinutes;
        data["vacationDays"] = this.vacationDays;
        data["isPublicHoliday"] = this.isPublicHoliday;
        data["isAbsence"] = this.isAbsence;
        data["isApprovedAbsence"] = this.isApprovedAbsence;
        data["isVacation"] = this.isVacation;
        data["isSick"] = this.isSick;
        data["effectiveTargetMinutesEnteredPercentage"] = this.effectiveTargetMinutesEnteredPercentage;
        data["isWeekend"] = this.isWeekend;
        data["dayDescription"] = this.dayDescription ? this.dayDescription.toJSON() : <any>undefined;
        data["timeEntryDayApproval"] = this.timeEntryDayApproval ? this.timeEntryDayApproval.toJSON() : <any>undefined;
        data["dayLockedApproval"] = this.dayLockedApproval;
        data["dayLockedApprovalComment"] = this.dayLockedApprovalComment;
        data["dayCanBeSubmitted"] = this.dayCanBeSubmitted;
        if (Array.isArray(this.violatedValidationRules)) {
            data["violatedValidationRules"] = [];
            for (let item of this.violatedValidationRules)
                data["violatedValidationRules"].push(item.toJSON());
        }
        data["hasViolatedValidationRules"] = this.hasViolatedValidationRules;
        return data;
    }
}

export interface IAppUserDayViewModel {
    appUserCountryIsoCode?: string | undefined;
    date?: string;
    absence?: AbsenceViewModel | undefined;
    publicHoliday?: PublicHolidayViewModel | undefined;
    useTargetMinutes?: boolean;
    targetMinutes?: number;
    targetMinutesEffective?: number;
    durationMinutes?: number;
    vacationDays?: number;
    isPublicHoliday?: boolean;
    isAbsence?: boolean;
    isApprovedAbsence?: boolean;
    isVacation?: boolean;
    isSick?: boolean;
    effectiveTargetMinutesEnteredPercentage?: number;
    isWeekend?: boolean;
    dayDescription?: DayModifier | undefined;
    timeEntryDayApproval?: TimeEntryDayApprovalViewModel | undefined;
    dayLockedApproval?: boolean;
    dayLockedApprovalComment?: string | undefined;
    dayCanBeSubmitted?: boolean;
    violatedValidationRules?: AppUserDayValidationRule[] | undefined;
    hasViolatedValidationRules?: boolean;
}

export class DayModifier implements IDayModifier {
    description?: string | undefined;
    badgeText?: string | undefined;
    isWorkDay?: boolean;

    constructor(data?: IDayModifier) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.badgeText = _data["badgeText"];
            this.isWorkDay = _data["isWorkDay"];
        }
    }

    static fromJS(data: any): DayModifier {
        data = typeof data === 'object' ? data : {};
        let result = new DayModifier();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["badgeText"] = this.badgeText;
        data["isWorkDay"] = this.isWorkDay;
        return data;
    }
}

export interface IDayModifier {
    description?: string | undefined;
    badgeText?: string | undefined;
    isWorkDay?: boolean;
}

export class TimeEntryDayApprovalViewModel implements ITimeEntryDayApprovalViewModel {
    date?: string;
    appUser?: AppUserViewModel | undefined;
    approvalAppUser?: AppUserViewModel | undefined;
    approvalEnum?: TimeEntryDayApprovalEnum;
    comment?: string | undefined;

    constructor(data?: ITimeEntryDayApprovalViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.appUser = _data["appUser"] ? AppUserViewModel.fromJS(_data["appUser"]) : <any>undefined;
            this.approvalAppUser = _data["approvalAppUser"] ? AppUserViewModel.fromJS(_data["approvalAppUser"]) : <any>undefined;
            this.approvalEnum = _data["approvalEnum"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): TimeEntryDayApprovalViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryDayApprovalViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["appUser"] = this.appUser ? this.appUser.toJSON() : <any>undefined;
        data["approvalAppUser"] = this.approvalAppUser ? this.approvalAppUser.toJSON() : <any>undefined;
        data["approvalEnum"] = this.approvalEnum;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ITimeEntryDayApprovalViewModel {
    date?: string;
    appUser?: AppUserViewModel | undefined;
    approvalAppUser?: AppUserViewModel | undefined;
    approvalEnum?: TimeEntryDayApprovalEnum;
    comment?: string | undefined;
}

export enum TimeEntryDayApprovalEnum {
    None = "None",
    IsSubmitted = "IsSubmitted",
    IsSubmittedImplicitly = "IsSubmittedImplicitly",
    IsApproved = "IsApproved",
    IsDeclined = "IsDeclined",
}

export class AppUserDayValidationRule implements IAppUserDayValidationRule {
    date?: string;
    ruleEnum?: AppUserDayValidationRuleEnum;
    severity?: TimeEntryWarningSeverity;
    ruleDescription?: string | undefined;

    constructor(data?: IAppUserDayValidationRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.ruleEnum = _data["ruleEnum"];
            this.severity = _data["severity"];
            this.ruleDescription = _data["ruleDescription"];
        }
    }

    static fromJS(data: any): AppUserDayValidationRule {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserDayValidationRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["ruleEnum"] = this.ruleEnum;
        data["severity"] = this.severity;
        data["ruleDescription"] = this.ruleDescription;
        return data;
    }
}

export interface IAppUserDayValidationRule {
    date?: string;
    ruleEnum?: AppUserDayValidationRuleEnum;
    severity?: TimeEntryWarningSeverity;
    ruleDescription?: string | undefined;
}

export enum AppUserDayValidationRuleEnum {
    TimeEntriesOnFreeDay = "TimeEntriesOnFreeDay",
    TimeEntriesOnSundayOrPublicHoliday = "TimeEntriesOnSundayOrPublicHoliday",
    TimeEntriesOnAbsenceDay = "TimeEntriesOnAbsenceDay",
    MaxDailyHoursExceeded = "MaxDailyHoursExceeded",
    RestTimeUndershot = "RestTimeUndershot",
    RestTimeValidationNotPossible = "RestTimeValidationNotPossible",
    NoTimeEntries = "NoTimeEntries",
    ConflictingTimeEntries = "ConflictingTimeEntries",
    PauseRuleViolated = "PauseRuleViolated",
    PauseValidationNotPossible = "PauseValidationNotPossible",
}

export class TeamOverviewApprovalModel implements ITeamOverviewApprovalModel {
    appUserModels?: TeamOverviewApprovalAppUserModel[] | undefined;
    dateFrom?: string;
    dateTo?: string;

    constructor(data?: ITeamOverviewApprovalModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["appUserModels"])) {
                this.appUserModels = [] as any;
                for (let item of _data["appUserModels"])
                    this.appUserModels!.push(TeamOverviewApprovalAppUserModel.fromJS(item));
            }
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
        }
    }

    static fromJS(data: any): TeamOverviewApprovalModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeamOverviewApprovalModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.appUserModels)) {
            data["appUserModels"] = [];
            for (let item of this.appUserModels)
                data["appUserModels"].push(item.toJSON());
        }
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        return data;
    }
}

export interface ITeamOverviewApprovalModel {
    appUserModels?: TeamOverviewApprovalAppUserModel[] | undefined;
    dateFrom?: string;
    dateTo?: string;
}

export class TeamOverviewApprovalAppUserModel implements ITeamOverviewApprovalAppUserModel {
    appUser?: AppUserViewModel | undefined;
    timeFrameModels?: TeamOverviewApprovalAppUserTimeFrameModel[] | undefined;

    constructor(data?: ITeamOverviewApprovalAppUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appUser = _data["appUser"] ? AppUserViewModel.fromJS(_data["appUser"]) : <any>undefined;
            if (Array.isArray(_data["timeFrameModels"])) {
                this.timeFrameModels = [] as any;
                for (let item of _data["timeFrameModels"])
                    this.timeFrameModels!.push(TeamOverviewApprovalAppUserTimeFrameModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeamOverviewApprovalAppUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeamOverviewApprovalAppUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appUser"] = this.appUser ? this.appUser.toJSON() : <any>undefined;
        if (Array.isArray(this.timeFrameModels)) {
            data["timeFrameModels"] = [];
            for (let item of this.timeFrameModels)
                data["timeFrameModels"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITeamOverviewApprovalAppUserModel {
    appUser?: AppUserViewModel | undefined;
    timeFrameModels?: TeamOverviewApprovalAppUserTimeFrameModel[] | undefined;
}

export class TeamOverviewApprovalAppUserTimeFrameModel implements ITeamOverviewApprovalAppUserTimeFrameModel {
    timeFrameName?: string | undefined;
    dateFrom?: string;
    dateTo?: string;
    appUserDays?: AppUserDayViewModel[] | undefined;

    constructor(data?: ITeamOverviewApprovalAppUserTimeFrameModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timeFrameName = _data["timeFrameName"];
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
            if (Array.isArray(_data["appUserDays"])) {
                this.appUserDays = [] as any;
                for (let item of _data["appUserDays"])
                    this.appUserDays!.push(AppUserDayViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TeamOverviewApprovalAppUserTimeFrameModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeamOverviewApprovalAppUserTimeFrameModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timeFrameName"] = this.timeFrameName;
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        if (Array.isArray(this.appUserDays)) {
            data["appUserDays"] = [];
            for (let item of this.appUserDays)
                data["appUserDays"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITeamOverviewApprovalAppUserTimeFrameModel {
    timeFrameName?: string | undefined;
    dateFrom?: string;
    dateTo?: string;
    appUserDays?: AppUserDayViewModel[] | undefined;
}

export class TimeAccountYearViewModel implements ITimeAccountYearViewModel {
    hasTargetHoursGlobal?: boolean;
    year?: number;
    appUserMinYear?: number;
    timeAccountMonthly?: TimeAccountMonthly[] | undefined;
    targetMinutes?: number;
    workingMinutes?: number;
    adjustmentMinutes?: number;
    balanceMinutes?: number;
    hasTargetHours?: boolean;

    constructor(data?: ITimeAccountYearViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasTargetHoursGlobal = _data["hasTargetHoursGlobal"];
            this.year = _data["year"];
            this.appUserMinYear = _data["appUserMinYear"];
            if (Array.isArray(_data["timeAccountMonthly"])) {
                this.timeAccountMonthly = [] as any;
                for (let item of _data["timeAccountMonthly"])
                    this.timeAccountMonthly!.push(TimeAccountMonthly.fromJS(item));
            }
            this.targetMinutes = _data["targetMinutes"];
            this.workingMinutes = _data["workingMinutes"];
            this.adjustmentMinutes = _data["adjustmentMinutes"];
            this.balanceMinutes = _data["balanceMinutes"];
            this.hasTargetHours = _data["hasTargetHours"];
        }
    }

    static fromJS(data: any): TimeAccountYearViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAccountYearViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasTargetHoursGlobal"] = this.hasTargetHoursGlobal;
        data["year"] = this.year;
        data["appUserMinYear"] = this.appUserMinYear;
        if (Array.isArray(this.timeAccountMonthly)) {
            data["timeAccountMonthly"] = [];
            for (let item of this.timeAccountMonthly)
                data["timeAccountMonthly"].push(item.toJSON());
        }
        data["targetMinutes"] = this.targetMinutes;
        data["workingMinutes"] = this.workingMinutes;
        data["adjustmentMinutes"] = this.adjustmentMinutes;
        data["balanceMinutes"] = this.balanceMinutes;
        data["hasTargetHours"] = this.hasTargetHours;
        return data;
    }
}

export interface ITimeAccountYearViewModel {
    hasTargetHoursGlobal?: boolean;
    year?: number;
    appUserMinYear?: number;
    timeAccountMonthly?: TimeAccountMonthly[] | undefined;
    targetMinutes?: number;
    workingMinutes?: number;
    adjustmentMinutes?: number;
    balanceMinutes?: number;
    hasTargetHours?: boolean;
}

export class TimeAccountMonthly implements ITimeAccountMonthly {
    month?: number;
    timeAccountWeekly?: TimeAccountWeekly[] | undefined;
    targetMinutes?: number;
    workingMinutes?: number;
    adjustmentMinutes?: number;
    balanceMinutes?: number;
    hasTargetHours?: boolean;

    constructor(data?: ITimeAccountMonthly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.month = _data["month"];
            if (Array.isArray(_data["timeAccountWeekly"])) {
                this.timeAccountWeekly = [] as any;
                for (let item of _data["timeAccountWeekly"])
                    this.timeAccountWeekly!.push(TimeAccountWeekly.fromJS(item));
            }
            this.targetMinutes = _data["targetMinutes"];
            this.workingMinutes = _data["workingMinutes"];
            this.adjustmentMinutes = _data["adjustmentMinutes"];
            this.balanceMinutes = _data["balanceMinutes"];
            this.hasTargetHours = _data["hasTargetHours"];
        }
    }

    static fromJS(data: any): TimeAccountMonthly {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAccountMonthly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["month"] = this.month;
        if (Array.isArray(this.timeAccountWeekly)) {
            data["timeAccountWeekly"] = [];
            for (let item of this.timeAccountWeekly)
                data["timeAccountWeekly"].push(item.toJSON());
        }
        data["targetMinutes"] = this.targetMinutes;
        data["workingMinutes"] = this.workingMinutes;
        data["adjustmentMinutes"] = this.adjustmentMinutes;
        data["balanceMinutes"] = this.balanceMinutes;
        data["hasTargetHours"] = this.hasTargetHours;
        return data;
    }
}

export interface ITimeAccountMonthly {
    month?: number;
    timeAccountWeekly?: TimeAccountWeekly[] | undefined;
    targetMinutes?: number;
    workingMinutes?: number;
    adjustmentMinutes?: number;
    balanceMinutes?: number;
    hasTargetHours?: boolean;
}

export class TimeAccountWeekly implements ITimeAccountWeekly {
    weekNumber?: number;
    timeAccountDaily?: TimeAccountDaily[] | undefined;
    targetMinutes?: number;
    workingMinutes?: number;
    adjustmentMinutes?: number;
    balanceMinutes?: number;
    hasTargetHours?: boolean;
    isVirtual?: boolean;

    constructor(data?: ITimeAccountWeekly) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekNumber = _data["weekNumber"];
            if (Array.isArray(_data["timeAccountDaily"])) {
                this.timeAccountDaily = [] as any;
                for (let item of _data["timeAccountDaily"])
                    this.timeAccountDaily!.push(TimeAccountDaily.fromJS(item));
            }
            this.targetMinutes = _data["targetMinutes"];
            this.workingMinutes = _data["workingMinutes"];
            this.adjustmentMinutes = _data["adjustmentMinutes"];
            this.balanceMinutes = _data["balanceMinutes"];
            this.hasTargetHours = _data["hasTargetHours"];
            this.isVirtual = _data["isVirtual"];
        }
    }

    static fromJS(data: any): TimeAccountWeekly {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAccountWeekly();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekNumber"] = this.weekNumber;
        if (Array.isArray(this.timeAccountDaily)) {
            data["timeAccountDaily"] = [];
            for (let item of this.timeAccountDaily)
                data["timeAccountDaily"].push(item.toJSON());
        }
        data["targetMinutes"] = this.targetMinutes;
        data["workingMinutes"] = this.workingMinutes;
        data["adjustmentMinutes"] = this.adjustmentMinutes;
        data["balanceMinutes"] = this.balanceMinutes;
        data["hasTargetHours"] = this.hasTargetHours;
        data["isVirtual"] = this.isVirtual;
        return data;
    }
}

export interface ITimeAccountWeekly {
    weekNumber?: number;
    timeAccountDaily?: TimeAccountDaily[] | undefined;
    targetMinutes?: number;
    workingMinutes?: number;
    adjustmentMinutes?: number;
    balanceMinutes?: number;
    hasTargetHours?: boolean;
    isVirtual?: boolean;
}

export class TimeAccountDaily implements ITimeAccountDaily {
    date?: string;
    dayInMonth?: number;
    month?: number;
    dayOfWeek?: number;
    timeAdjustments?: TimeAdjustmentViewModel[] | undefined;
    isVirtual?: boolean;
    dayDescription?: DayModifier | undefined;
    targetMinutes?: number;
    workingMinutes?: number;
    adjustmentMinutes?: number;
    balanceMinutes?: number;
    hasTargetHours?: boolean;

    constructor(data?: ITimeAccountDaily) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.dayInMonth = _data["dayInMonth"];
            this.month = _data["month"];
            this.dayOfWeek = _data["dayOfWeek"];
            if (Array.isArray(_data["timeAdjustments"])) {
                this.timeAdjustments = [] as any;
                for (let item of _data["timeAdjustments"])
                    this.timeAdjustments!.push(TimeAdjustmentViewModel.fromJS(item));
            }
            this.isVirtual = _data["isVirtual"];
            this.dayDescription = _data["dayDescription"] ? DayModifier.fromJS(_data["dayDescription"]) : <any>undefined;
            this.targetMinutes = _data["targetMinutes"];
            this.workingMinutes = _data["workingMinutes"];
            this.adjustmentMinutes = _data["adjustmentMinutes"];
            this.balanceMinutes = _data["balanceMinutes"];
            this.hasTargetHours = _data["hasTargetHours"];
        }
    }

    static fromJS(data: any): TimeAccountDaily {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAccountDaily();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["dayInMonth"] = this.dayInMonth;
        data["month"] = this.month;
        data["dayOfWeek"] = this.dayOfWeek;
        if (Array.isArray(this.timeAdjustments)) {
            data["timeAdjustments"] = [];
            for (let item of this.timeAdjustments)
                data["timeAdjustments"].push(item.toJSON());
        }
        data["isVirtual"] = this.isVirtual;
        data["dayDescription"] = this.dayDescription ? this.dayDescription.toJSON() : <any>undefined;
        data["targetMinutes"] = this.targetMinutes;
        data["workingMinutes"] = this.workingMinutes;
        data["adjustmentMinutes"] = this.adjustmentMinutes;
        data["balanceMinutes"] = this.balanceMinutes;
        data["hasTargetHours"] = this.hasTargetHours;
        return data;
    }
}

export interface ITimeAccountDaily {
    date?: string;
    dayInMonth?: number;
    month?: number;
    dayOfWeek?: number;
    timeAdjustments?: TimeAdjustmentViewModel[] | undefined;
    isVirtual?: boolean;
    dayDescription?: DayModifier | undefined;
    targetMinutes?: number;
    workingMinutes?: number;
    adjustmentMinutes?: number;
    balanceMinutes?: number;
    hasTargetHours?: boolean;
}

export class TimeAdjustmentViewModel implements ITimeAdjustmentViewModel {
    id?: number;
    entryDate?: string;
    durationMinutes?: number;
    comment?: string | undefined;

    constructor(data?: ITimeAdjustmentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entryDate = _data["entryDate"];
            this.durationMinutes = _data["durationMinutes"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): TimeAdjustmentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAdjustmentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entryDate"] = this.entryDate;
        data["durationMinutes"] = this.durationMinutes;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ITimeAdjustmentViewModel {
    id?: number;
    entryDate?: string;
    durationMinutes?: number;
    comment?: string | undefined;
}

export class TimeAccountSummaryModel implements ITimeAccountSummaryModel {
    hasTargetHoursGlobal?: boolean;
    balanceOverall?: TimeAccountBalance | undefined;

    constructor(data?: ITimeAccountSummaryModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasTargetHoursGlobal = _data["hasTargetHoursGlobal"];
            this.balanceOverall = _data["balanceOverall"] ? TimeAccountBalance.fromJS(_data["balanceOverall"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeAccountSummaryModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAccountSummaryModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasTargetHoursGlobal"] = this.hasTargetHoursGlobal;
        data["balanceOverall"] = this.balanceOverall ? this.balanceOverall.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITimeAccountSummaryModel {
    hasTargetHoursGlobal?: boolean;
    balanceOverall?: TimeAccountBalance | undefined;
}

export class TimeAccountBalance implements ITimeAccountBalance {
    durationMinutesTarget?: number;
    durationMinutesWork?: number;
    durationMinutesAdjustment?: number;
    durationMinutesBalance?: number;

    constructor(data?: ITimeAccountBalance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.durationMinutesTarget = _data["durationMinutesTarget"];
            this.durationMinutesWork = _data["durationMinutesWork"];
            this.durationMinutesAdjustment = _data["durationMinutesAdjustment"];
            this.durationMinutesBalance = _data["durationMinutesBalance"];
        }
    }

    static fromJS(data: any): TimeAccountBalance {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAccountBalance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["durationMinutesTarget"] = this.durationMinutesTarget;
        data["durationMinutesWork"] = this.durationMinutesWork;
        data["durationMinutesAdjustment"] = this.durationMinutesAdjustment;
        data["durationMinutesBalance"] = this.durationMinutesBalance;
        return data;
    }
}

export interface ITimeAccountBalance {
    durationMinutesTarget?: number;
    durationMinutesWork?: number;
    durationMinutesAdjustment?: number;
    durationMinutesBalance?: number;
}

export class TimeAccountUserViewModel implements ITimeAccountUserViewModel {
    name?: string | undefined;
    useTargetHours?: boolean;
    currentHistoryEntry?: AppUserHistoryViewModel | undefined;

    constructor(data?: ITimeAccountUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.useTargetHours = _data["useTargetHours"];
            this.currentHistoryEntry = _data["currentHistoryEntry"] ? AppUserHistoryViewModel.fromJS(_data["currentHistoryEntry"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeAccountUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAccountUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["useTargetHours"] = this.useTargetHours;
        data["currentHistoryEntry"] = this.currentHistoryEntry ? this.currentHistoryEntry.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITimeAccountUserViewModel {
    name?: string | undefined;
    useTargetHours?: boolean;
    currentHistoryEntry?: AppUserHistoryViewModel | undefined;
}

export class AppUserHistoryViewModel implements IAppUserHistoryViewModel {
    id?: string;
    weeklyWorkHours?: number;
    dailyWorkHours?: WorkHoursDay[] | undefined;
    validFrom?: string;

    constructor(data?: IAppUserHistoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.weeklyWorkHours = _data["weeklyWorkHours"];
            if (Array.isArray(_data["dailyWorkHours"])) {
                this.dailyWorkHours = [] as any;
                for (let item of _data["dailyWorkHours"])
                    this.dailyWorkHours!.push(WorkHoursDay.fromJS(item));
            }
            this.validFrom = _data["validFrom"];
        }
    }

    static fromJS(data: any): AppUserHistoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserHistoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["weeklyWorkHours"] = this.weeklyWorkHours;
        if (Array.isArray(this.dailyWorkHours)) {
            data["dailyWorkHours"] = [];
            for (let item of this.dailyWorkHours)
                data["dailyWorkHours"].push(item.toJSON());
        }
        data["validFrom"] = this.validFrom;
        return data;
    }
}

export interface IAppUserHistoryViewModel {
    id?: string;
    weeklyWorkHours?: number;
    dailyWorkHours?: WorkHoursDay[] | undefined;
    validFrom?: string;
}

export class TimeAccountSummaryTimeEntryPageModel implements ITimeAccountSummaryTimeEntryPageModel {
    dateTo?: string;
    balanceWeek?: TimeAccountBalance | undefined;
    balanceOverall?: TimeAccountBalance | undefined;
    hasTargetHoursGlobal?: boolean;
    displayOvertimeIsNotApprovedWarning?: boolean;
    overtimeIsApproved?: boolean;
    overtimeIsApprovedComment?: string | undefined;
    currentWeekAppUserDays?: WeekAppUserDay[] | undefined;

    constructor(data?: ITimeAccountSummaryTimeEntryPageModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.dateTo = _data["dateTo"];
            this.balanceWeek = _data["balanceWeek"] ? TimeAccountBalance.fromJS(_data["balanceWeek"]) : <any>undefined;
            this.balanceOverall = _data["balanceOverall"] ? TimeAccountBalance.fromJS(_data["balanceOverall"]) : <any>undefined;
            this.hasTargetHoursGlobal = _data["hasTargetHoursGlobal"];
            this.displayOvertimeIsNotApprovedWarning = _data["displayOvertimeIsNotApprovedWarning"];
            this.overtimeIsApproved = _data["overtimeIsApproved"];
            this.overtimeIsApprovedComment = _data["overtimeIsApprovedComment"];
            if (Array.isArray(_data["currentWeekAppUserDays"])) {
                this.currentWeekAppUserDays = [] as any;
                for (let item of _data["currentWeekAppUserDays"])
                    this.currentWeekAppUserDays!.push(WeekAppUserDay.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimeAccountSummaryTimeEntryPageModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAccountSummaryTimeEntryPageModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["dateTo"] = this.dateTo;
        data["balanceWeek"] = this.balanceWeek ? this.balanceWeek.toJSON() : <any>undefined;
        data["balanceOverall"] = this.balanceOverall ? this.balanceOverall.toJSON() : <any>undefined;
        data["hasTargetHoursGlobal"] = this.hasTargetHoursGlobal;
        data["displayOvertimeIsNotApprovedWarning"] = this.displayOvertimeIsNotApprovedWarning;
        data["overtimeIsApproved"] = this.overtimeIsApproved;
        data["overtimeIsApprovedComment"] = this.overtimeIsApprovedComment;
        if (Array.isArray(this.currentWeekAppUserDays)) {
            data["currentWeekAppUserDays"] = [];
            for (let item of this.currentWeekAppUserDays)
                data["currentWeekAppUserDays"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITimeAccountSummaryTimeEntryPageModel {
    dateTo?: string;
    balanceWeek?: TimeAccountBalance | undefined;
    balanceOverall?: TimeAccountBalance | undefined;
    hasTargetHoursGlobal?: boolean;
    displayOvertimeIsNotApprovedWarning?: boolean;
    overtimeIsApproved?: boolean;
    overtimeIsApprovedComment?: string | undefined;
    currentWeekAppUserDays?: WeekAppUserDay[] | undefined;
}

export class WeekAppUserDay implements IWeekAppUserDay {
    date?: string;
    balanceMinutes?: number;
    targetMinutes?: number;
    durationMinutes?: number;

    constructor(data?: IWeekAppUserDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.balanceMinutes = _data["balanceMinutes"];
            this.targetMinutes = _data["targetMinutes"];
            this.durationMinutes = _data["durationMinutes"];
        }
    }

    static fromJS(data: any): WeekAppUserDay {
        data = typeof data === 'object' ? data : {};
        let result = new WeekAppUserDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["balanceMinutes"] = this.balanceMinutes;
        data["targetMinutes"] = this.targetMinutes;
        data["durationMinutes"] = this.durationMinutes;
        return data;
    }
}

export interface IWeekAppUserDay {
    date?: string;
    balanceMinutes?: number;
    targetMinutes?: number;
    durationMinutes?: number;
}

export class TimeAccountSummaryQuery implements ITimeAccountSummaryQuery {
    date?: string;
    appUserId?: number | undefined;

    constructor(data?: ITimeAccountSummaryQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.appUserId = _data["appUserId"];
        }
    }

    static fromJS(data: any): TimeAccountSummaryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAccountSummaryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["appUserId"] = this.appUserId;
        return data;
    }
}

export interface ITimeAccountSummaryQuery {
    date?: string;
    appUserId?: number | undefined;
}

export class TimeAccountTeamWeeklyOverviewModel implements ITimeAccountTeamWeeklyOverviewModel {
    appUserModels?: TimeAccountTeamAppUserModel[] | undefined;
    dateFrom?: string;
    dateTo?: string;
    weeks?: WeekModel[] | undefined;

    constructor(data?: ITimeAccountTeamWeeklyOverviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["appUserModels"])) {
                this.appUserModels = [] as any;
                for (let item of _data["appUserModels"])
                    this.appUserModels!.push(TimeAccountTeamAppUserModel.fromJS(item));
            }
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
            if (Array.isArray(_data["weeks"])) {
                this.weeks = [] as any;
                for (let item of _data["weeks"])
                    this.weeks!.push(WeekModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimeAccountTeamWeeklyOverviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAccountTeamWeeklyOverviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.appUserModels)) {
            data["appUserModels"] = [];
            for (let item of this.appUserModels)
                data["appUserModels"].push(item.toJSON());
        }
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        if (Array.isArray(this.weeks)) {
            data["weeks"] = [];
            for (let item of this.weeks)
                data["weeks"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITimeAccountTeamWeeklyOverviewModel {
    appUserModels?: TimeAccountTeamAppUserModel[] | undefined;
    dateFrom?: string;
    dateTo?: string;
    weeks?: WeekModel[] | undefined;
}

export class TimeAccountTeamAppUserModel implements ITimeAccountTeamAppUserModel {
    appUser?: AppUserViewModel | undefined;
    weeks?: TimeAccountTeamWeeklyOverviewWeekModel[] | undefined;
    overallBalance?: TimeAccountBalance | undefined;

    constructor(data?: ITimeAccountTeamAppUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appUser = _data["appUser"] ? AppUserViewModel.fromJS(_data["appUser"]) : <any>undefined;
            if (Array.isArray(_data["weeks"])) {
                this.weeks = [] as any;
                for (let item of _data["weeks"])
                    this.weeks!.push(TimeAccountTeamWeeklyOverviewWeekModel.fromJS(item));
            }
            this.overallBalance = _data["overallBalance"] ? TimeAccountBalance.fromJS(_data["overallBalance"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeAccountTeamAppUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAccountTeamAppUserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appUser"] = this.appUser ? this.appUser.toJSON() : <any>undefined;
        if (Array.isArray(this.weeks)) {
            data["weeks"] = [];
            for (let item of this.weeks)
                data["weeks"].push(item.toJSON());
        }
        data["overallBalance"] = this.overallBalance ? this.overallBalance.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITimeAccountTeamAppUserModel {
    appUser?: AppUserViewModel | undefined;
    weeks?: TimeAccountTeamWeeklyOverviewWeekModel[] | undefined;
    overallBalance?: TimeAccountBalance | undefined;
}

export class TimeAccountTeamWeeklyOverviewWeekModel implements ITimeAccountTeamWeeklyOverviewWeekModel {
    weekName?: string | undefined;
    balance?: TimeAccountBalance | undefined;
    overtimeIsApproved?: boolean;
    dateFrom?: string;
    dateTo?: string;
    hasWeekData?: boolean;
    overtimeIsApprovedComment?: string | undefined;
    displayOvertimeIsNotApprovedWarning?: boolean;

    constructor(data?: ITimeAccountTeamWeeklyOverviewWeekModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekName = _data["weekName"];
            this.balance = _data["balance"] ? TimeAccountBalance.fromJS(_data["balance"]) : <any>undefined;
            this.overtimeIsApproved = _data["overtimeIsApproved"];
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
            this.hasWeekData = _data["hasWeekData"];
            this.overtimeIsApprovedComment = _data["overtimeIsApprovedComment"];
            this.displayOvertimeIsNotApprovedWarning = _data["displayOvertimeIsNotApprovedWarning"];
        }
    }

    static fromJS(data: any): TimeAccountTeamWeeklyOverviewWeekModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAccountTeamWeeklyOverviewWeekModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekName"] = this.weekName;
        data["balance"] = this.balance ? this.balance.toJSON() : <any>undefined;
        data["overtimeIsApproved"] = this.overtimeIsApproved;
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        data["hasWeekData"] = this.hasWeekData;
        data["overtimeIsApprovedComment"] = this.overtimeIsApprovedComment;
        data["displayOvertimeIsNotApprovedWarning"] = this.displayOvertimeIsNotApprovedWarning;
        return data;
    }
}

export interface ITimeAccountTeamWeeklyOverviewWeekModel {
    weekName?: string | undefined;
    balance?: TimeAccountBalance | undefined;
    overtimeIsApproved?: boolean;
    dateFrom?: string;
    dateTo?: string;
    hasWeekData?: boolean;
    overtimeIsApprovedComment?: string | undefined;
    displayOvertimeIsNotApprovedWarning?: boolean;
}

export class WeekModel implements IWeekModel {
    weekStart?: string;
    weekEnd?: string;
    weekName?: string | undefined;

    constructor(data?: IWeekModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekStart = _data["weekStart"];
            this.weekEnd = _data["weekEnd"];
            this.weekName = _data["weekName"];
        }
    }

    static fromJS(data: any): WeekModel {
        data = typeof data === 'object' ? data : {};
        let result = new WeekModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekStart"] = this.weekStart;
        data["weekEnd"] = this.weekEnd;
        data["weekName"] = this.weekName;
        return data;
    }
}

export interface IWeekModel {
    weekStart?: string;
    weekEnd?: string;
    weekName?: string | undefined;
}

export class TimeAccountTeamWeeklyOverviewQuery implements ITimeAccountTeamWeeklyOverviewQuery {
    date?: string;

    constructor(data?: ITimeAccountTeamWeeklyOverviewQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
        }
    }

    static fromJS(data: any): TimeAccountTeamWeeklyOverviewQuery {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAccountTeamWeeklyOverviewQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        return data;
    }
}

export interface ITimeAccountTeamWeeklyOverviewQuery {
    date?: string;
}

export class TimeAccountWeekOvertimeApproveCommand implements ITimeAccountWeekOvertimeApproveCommand {
    weekStartDate?: string;
    appUserId?: number;
    comment?: string | undefined;

    constructor(data?: ITimeAccountWeekOvertimeApproveCommand) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.weekStartDate = _data["weekStartDate"];
            this.appUserId = _data["appUserId"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): TimeAccountWeekOvertimeApproveCommand {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAccountWeekOvertimeApproveCommand();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["weekStartDate"] = this.weekStartDate;
        data["appUserId"] = this.appUserId;
        data["comment"] = this.comment;
        return data;
    }
}

export interface ITimeAccountWeekOvertimeApproveCommand {
    weekStartDate?: string;
    appUserId?: number;
    comment?: string | undefined;
}

export class TimeAdjustmentEditModel implements ITimeAdjustmentEditModel {
    id?: number;
    entryDate?: string;
    durationMinutes?: number;
    comment?: string | undefined;
    appUserId?: number;

    constructor(data?: ITimeAdjustmentEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entryDate = _data["entryDate"];
            this.durationMinutes = _data["durationMinutes"];
            this.comment = _data["comment"];
            this.appUserId = _data["appUserId"];
        }
    }

    static fromJS(data: any): TimeAdjustmentEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAdjustmentEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entryDate"] = this.entryDate;
        data["durationMinutes"] = this.durationMinutes;
        data["comment"] = this.comment;
        data["appUserId"] = this.appUserId;
        return data;
    }
}

export interface ITimeAdjustmentEditModel {
    id?: number;
    entryDate?: string;
    durationMinutes?: number;
    comment?: string | undefined;
    appUserId?: number;
}

export class TimeAdjustmentFilter implements ITimeAdjustmentFilter {
    id?: number | undefined;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
    ids?: number[] | undefined;
    appUserIds?: number[] | undefined;

    constructor(data?: ITimeAdjustmentFilter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dateFrom = _data["dateFrom"];
            this.dateTo = _data["dateTo"];
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            if (Array.isArray(_data["appUserIds"])) {
                this.appUserIds = [] as any;
                for (let item of _data["appUserIds"])
                    this.appUserIds!.push(item);
            }
        }
    }

    static fromJS(data: any): TimeAdjustmentFilter {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAdjustmentFilter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dateFrom"] = this.dateFrom;
        data["dateTo"] = this.dateTo;
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        if (Array.isArray(this.appUserIds)) {
            data["appUserIds"] = [];
            for (let item of this.appUserIds)
                data["appUserIds"].push(item);
        }
        return data;
    }
}

export interface ITimeAdjustmentFilter {
    id?: number | undefined;
    dateFrom?: string | undefined;
    dateTo?: string | undefined;
    ids?: number[] | undefined;
    appUserIds?: number[] | undefined;
}

export class TimeEntrySelectLists implements ITimeEntrySelectLists {
    projects?: TimeEntrySelectListItemGroup[] | undefined;
    projectTasks?: TimeEntrySelectListItem[] | undefined;
    userRates?: StSelectListItem[] | undefined;
    globalRates?: StSelectListItem[] | undefined;

    constructor(data?: ITimeEntrySelectLists) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(TimeEntrySelectListItemGroup.fromJS(item));
            }
            if (Array.isArray(_data["projectTasks"])) {
                this.projectTasks = [] as any;
                for (let item of _data["projectTasks"])
                    this.projectTasks!.push(TimeEntrySelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["userRates"])) {
                this.userRates = [] as any;
                for (let item of _data["userRates"])
                    this.userRates!.push(StSelectListItem.fromJS(item));
            }
            if (Array.isArray(_data["globalRates"])) {
                this.globalRates = [] as any;
                for (let item of _data["globalRates"])
                    this.globalRates!.push(StSelectListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimeEntrySelectLists {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntrySelectLists();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item.toJSON());
        }
        if (Array.isArray(this.projectTasks)) {
            data["projectTasks"] = [];
            for (let item of this.projectTasks)
                data["projectTasks"].push(item.toJSON());
        }
        if (Array.isArray(this.userRates)) {
            data["userRates"] = [];
            for (let item of this.userRates)
                data["userRates"].push(item.toJSON());
        }
        if (Array.isArray(this.globalRates)) {
            data["globalRates"] = [];
            for (let item of this.globalRates)
                data["globalRates"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITimeEntrySelectLists {
    projects?: TimeEntrySelectListItemGroup[] | undefined;
    projectTasks?: TimeEntrySelectListItem[] | undefined;
    userRates?: StSelectListItem[] | undefined;
    globalRates?: StSelectListItem[] | undefined;
}

export class TimeEntrySelectListItemGroup implements ITimeEntrySelectListItemGroup {
    groupName?: string | undefined;
    items?: TimeEntrySelectListItem[] | undefined;

    constructor(data?: ITimeEntrySelectListItemGroup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.groupName = _data["groupName"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TimeEntrySelectListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimeEntrySelectListItemGroup {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntrySelectListItemGroup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["groupName"] = this.groupName;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITimeEntrySelectListItemGroup {
    groupName?: string | undefined;
    items?: TimeEntrySelectListItem[] | undefined;
}

export class TimeEntrySelectListItem implements ITimeEntrySelectListItem {
    id?: number;
    description?: string | undefined;
    rates?: StSelectListItem[] | undefined;

    constructor(data?: ITimeEntrySelectListItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
            if (Array.isArray(_data["rates"])) {
                this.rates = [] as any;
                for (let item of _data["rates"])
                    this.rates!.push(StSelectListItem.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimeEntrySelectListItem {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntrySelectListItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        if (Array.isArray(this.rates)) {
            data["rates"] = [];
            for (let item of this.rates)
                data["rates"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITimeEntrySelectListItem {
    id?: number;
    description?: string | undefined;
    rates?: StSelectListItem[] | undefined;
}

export class TimeEntryPauseRuleModel implements ITimeEntryPauseRuleModel {
    appUserId?: number;
    maxDurationMinutesPerDay?: number;
    pauseSingleRules?: TimeEntryPauseSingleRule[] | undefined;

    constructor(data?: ITimeEntryPauseRuleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.appUserId = _data["appUserId"];
            this.maxDurationMinutesPerDay = _data["maxDurationMinutesPerDay"];
            if (Array.isArray(_data["pauseSingleRules"])) {
                this.pauseSingleRules = [] as any;
                for (let item of _data["pauseSingleRules"])
                    this.pauseSingleRules!.push(TimeEntryPauseSingleRule.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TimeEntryPauseRuleModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryPauseRuleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["appUserId"] = this.appUserId;
        data["maxDurationMinutesPerDay"] = this.maxDurationMinutesPerDay;
        if (Array.isArray(this.pauseSingleRules)) {
            data["pauseSingleRules"] = [];
            for (let item of this.pauseSingleRules)
                data["pauseSingleRules"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITimeEntryPauseRuleModel {
    appUserId?: number;
    maxDurationMinutesPerDay?: number;
    pauseSingleRules?: TimeEntryPauseSingleRule[] | undefined;
}

export class TimeEntryPauseSingleRule implements ITimeEntryPauseSingleRule {
    durationMinutesFrom?: number;
    durationMinutesTo?: number;
    durationMinutesMinPause?: number;

    constructor(data?: ITimeEntryPauseSingleRule) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.durationMinutesFrom = _data["durationMinutesFrom"];
            this.durationMinutesTo = _data["durationMinutesTo"];
            this.durationMinutesMinPause = _data["durationMinutesMinPause"];
        }
    }

    static fromJS(data: any): TimeEntryPauseSingleRule {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryPauseSingleRule();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["durationMinutesFrom"] = this.durationMinutesFrom;
        data["durationMinutesTo"] = this.durationMinutesTo;
        data["durationMinutesMinPause"] = this.durationMinutesMinPause;
        return data;
    }
}

export interface ITimeEntryPauseSingleRule {
    durationMinutesFrom?: number;
    durationMinutesTo?: number;
    durationMinutesMinPause?: number;
}

export class TimeEntryDay implements ITimeEntryDay {
    entryDay?: string;
    durationMinutes?: number;
    revenue?: number;
    revenueNotBillable?: number;
    timeEntries?: TimeEntryViewModel[] | undefined;
    disabledReason?: string | undefined;
    isDisabled?: boolean;
    appUserDay?: AppUserDayViewModel | undefined;

    constructor(data?: ITimeEntryDay) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entryDay = _data["entryDay"];
            this.durationMinutes = _data["durationMinutes"];
            this.revenue = _data["revenue"];
            this.revenueNotBillable = _data["revenueNotBillable"];
            if (Array.isArray(_data["timeEntries"])) {
                this.timeEntries = [] as any;
                for (let item of _data["timeEntries"])
                    this.timeEntries!.push(TimeEntryViewModel.fromJS(item));
            }
            this.disabledReason = _data["disabledReason"];
            this.isDisabled = _data["isDisabled"];
            this.appUserDay = _data["appUserDay"] ? AppUserDayViewModel.fromJS(_data["appUserDay"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TimeEntryDay {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryDay();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entryDay"] = this.entryDay;
        data["durationMinutes"] = this.durationMinutes;
        data["revenue"] = this.revenue;
        data["revenueNotBillable"] = this.revenueNotBillable;
        if (Array.isArray(this.timeEntries)) {
            data["timeEntries"] = [];
            for (let item of this.timeEntries)
                data["timeEntries"].push(item.toJSON());
        }
        data["disabledReason"] = this.disabledReason;
        data["isDisabled"] = this.isDisabled;
        data["appUserDay"] = this.appUserDay ? this.appUserDay.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITimeEntryDay {
    entryDay?: string;
    durationMinutes?: number;
    revenue?: number;
    revenueNotBillable?: number;
    timeEntries?: TimeEntryViewModel[] | undefined;
    disabledReason?: string | undefined;
    isDisabled?: boolean;
    appUserDay?: AppUserDayViewModel | undefined;
}

export class TimeEntryDayApprovalEditModel implements ITimeEntryDayApprovalEditModel {
    date?: string;
    appUserId?: number;
    approvalEnum?: TimeEntryDayApprovalEnum;
    comment?: string | undefined;
    approvalMode?: string | undefined;

    constructor(data?: ITimeEntryDayApprovalEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"];
            this.appUserId = _data["appUserId"];
            this.approvalEnum = _data["approvalEnum"];
            this.comment = _data["comment"];
            this.approvalMode = _data["approvalMode"];
        }
    }

    static fromJS(data: any): TimeEntryDayApprovalEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryDayApprovalEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date;
        data["appUserId"] = this.appUserId;
        data["approvalEnum"] = this.approvalEnum;
        data["comment"] = this.comment;
        data["approvalMode"] = this.approvalMode;
        return data;
    }
}

export interface ITimeEntryDayApprovalEditModel {
    date?: string;
    appUserId?: number;
    approvalEnum?: TimeEntryDayApprovalEnum;
    comment?: string | undefined;
    approvalMode?: string | undefined;
}

export class TimeEntryExtraFieldDataTypeSelectItem implements ITimeEntryExtraFieldDataTypeSelectItem {
    enumVal?: TimeEntryExtraFieldDataTypeEnum;
    description?: string | undefined;

    constructor(data?: ITimeEntryExtraFieldDataTypeSelectItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.enumVal = _data["enumVal"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): TimeEntryExtraFieldDataTypeSelectItem {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryExtraFieldDataTypeSelectItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["enumVal"] = this.enumVal;
        data["description"] = this.description;
        return data;
    }
}

export interface ITimeEntryExtraFieldDataTypeSelectItem {
    enumVal?: TimeEntryExtraFieldDataTypeEnum;
    description?: string | undefined;
}

export class TimeEntryExtraFieldMetadataEditModel implements ITimeEntryExtraFieldMetadataEditModel {
    id?: number;
    isActive?: boolean;
    description?: string | undefined;
    toolTip?: string | undefined;
    dataType?: TimeEntryExtraFieldDataTypeEnum;
    isRequired?: boolean;
    selectionValues?: string | undefined;
    hideInDayView?: boolean;

    constructor(data?: ITimeEntryExtraFieldMetadataEditModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.description = _data["description"];
            this.toolTip = _data["toolTip"];
            this.dataType = _data["dataType"];
            this.isRequired = _data["isRequired"];
            this.selectionValues = _data["selectionValues"];
            this.hideInDayView = _data["hideInDayView"];
        }
    }

    static fromJS(data: any): TimeEntryExtraFieldMetadataEditModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryExtraFieldMetadataEditModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["description"] = this.description;
        data["toolTip"] = this.toolTip;
        data["dataType"] = this.dataType;
        data["isRequired"] = this.isRequired;
        data["selectionValues"] = this.selectionValues;
        data["hideInDayView"] = this.hideInDayView;
        return data;
    }
}

export interface ITimeEntryExtraFieldMetadataEditModel {
    id?: number;
    isActive?: boolean;
    description?: string | undefined;
    toolTip?: string | undefined;
    dataType?: TimeEntryExtraFieldDataTypeEnum;
    isRequired?: boolean;
    selectionValues?: string | undefined;
    hideInDayView?: boolean;
}

export class TimeEntryExtraFieldMetadataViewModel implements ITimeEntryExtraFieldMetadataViewModel {
    id?: number;
    isActive?: boolean;
    description?: string | undefined;
    toolTip?: string | undefined;
    dataType?: TimeEntryExtraFieldDataTypeEnum;
    dataTypeDescription?: string | undefined;
    isRequired?: boolean;
    hideInDayView?: boolean;

    constructor(data?: ITimeEntryExtraFieldMetadataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.isActive = _data["isActive"];
            this.description = _data["description"];
            this.toolTip = _data["toolTip"];
            this.dataType = _data["dataType"];
            this.dataTypeDescription = _data["dataTypeDescription"];
            this.isRequired = _data["isRequired"];
            this.hideInDayView = _data["hideInDayView"];
        }
    }

    static fromJS(data: any): TimeEntryExtraFieldMetadataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TimeEntryExtraFieldMetadataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["isActive"] = this.isActive;
        data["description"] = this.description;
        data["toolTip"] = this.toolTip;
        data["dataType"] = this.dataType;
        data["dataTypeDescription"] = this.dataTypeDescription;
        data["isRequired"] = this.isRequired;
        data["hideInDayView"] = this.hideInDayView;
        return data;
    }
}

export interface ITimeEntryExtraFieldMetadataViewModel {
    id?: number;
    isActive?: boolean;
    description?: string | undefined;
    toolTip?: string | undefined;
    dataType?: TimeEntryExtraFieldDataTypeEnum;
    dataTypeDescription?: string | undefined;
    isRequired?: boolean;
    hideInDayView?: boolean;
}

export class TransferAccountModel implements ITransferAccountModel {
    guid?: string;
    final?: boolean;

    constructor(data?: ITransferAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.guid = _data["guid"];
            this.final = _data["final"];
        }
    }

    static fromJS(data: any): TransferAccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransferAccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["guid"] = this.guid;
        data["final"] = this.final;
        return data;
    }
}

export interface ITransferAccountModel {
    guid?: string;
    final?: boolean;
}

export class LogModel implements ILogModel {
    logLevel?: string | undefined;
    message?: string | undefined;

    constructor(data?: ILogModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.logLevel = _data["logLevel"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): LogModel {
        data = typeof data === 'object' ? data : {};
        let result = new LogModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["logLevel"] = this.logLevel;
        data["message"] = this.message;
        return data;
    }
}

export interface ILogModel {
    logLevel?: string | undefined;
    message?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}